
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7a03"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7a03"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8JOml", function(module, exports) {
"use strict";
function $65c99708a69e8e0e$var$Vnode(tag, key, attrs, children, text, dom) {
    return {
        tag: tag,
        key: key,
        attrs: attrs,
        children: children,
        text: text,
        dom: dom,
        domSize: undefined,
        state: undefined,
        events: undefined,
        instance: undefined
    };
}
$65c99708a69e8e0e$var$Vnode.normalize = function(node) {
    if (Array.isArray(node)) return $65c99708a69e8e0e$var$Vnode("[", undefined, undefined, $65c99708a69e8e0e$var$Vnode.normalizeChildren(node), undefined, undefined);
    if (node == null || typeof node === "boolean") return null;
    if (typeof node === "object") return node;
    return $65c99708a69e8e0e$var$Vnode("#", undefined, undefined, String(node), undefined, undefined);
};
$65c99708a69e8e0e$var$Vnode.normalizeChildren = function(input) {
    var children = [];
    if (input.length) {
        var isKeyed = input[0] != null && input[0].key != null;
        // Note: this is a *very* perf-sensitive check.
        // Fun fact: merging the loop like this is somehow faster than splitting
        // it, noticeably so.
        for(var i = 1; i < input.length; i++){
            if ((input[i] != null && input[i].key != null) !== isKeyed) throw new TypeError(isKeyed && (input[i] != null || typeof input[i] === "boolean") ? "In fragments, vnodes must either all have keys or none have keys. You may wish to consider using an explicit keyed empty fragment, m.fragment({key: ...}), instead of a hole." : "In fragments, vnodes must either all have keys or none have keys.");
        }
        for(var i = 0; i < input.length; i++)children[i] = $65c99708a69e8e0e$var$Vnode.normalize(input[i]);
    }
    return children;
};
module.exports = $65c99708a69e8e0e$var$Vnode;

});

parcelRegister("gQsxe", function(module, exports) {
"use strict";

var $8JOml = parcelRequire("8JOml");
module.exports = function(html) {
    if (html == null) html = "";
    return $8JOml("<", undefined, undefined, html, undefined, undefined);
};

});

parcelRegister("pcZwJ", function(module, exports) {
"use strict";

var $8JOml = parcelRequire("8JOml");

var $jPPUy = parcelRequire("jPPUy");
module.exports = function() {
    var vnode = $jPPUy.apply(0, arguments);
    vnode.tag = "[";
    vnode.children = $8JOml.normalizeChildren(vnode.children);
    return vnode;
};

});
parcelRegister("jPPUy", function(module, exports) {
"use strict";

var $8JOml = parcelRequire("8JOml");
// Call via `hyperscriptVnode.apply(startOffset, arguments)`
//
// The reason I do it this way, forwarding the arguments and passing the start
// offset in `this`, is so I don't have to create a temporary array in a
// performance-critical path.
//
// In native ES6, I'd instead add a final `...args` parameter to the
// `hyperscript` and `fragment` factories and define this as
// `hyperscriptVnode(...args)`, since modern engines do optimize that away. But
// ES5 (what Mithril.js requires thanks to IE support) doesn't give me that luxury,
// and engines aren't nearly intelligent enough to do either of these:
//
// 1. Elide the allocation for `[].slice.call(arguments, 1)` when it's passed to
//    another function only to be indexed.
// 2. Elide an `arguments` allocation when it's passed to any function other
//    than `Function.prototype.apply` or `Reflect.apply`.
//
// In ES6, it'd probably look closer to this (I'd need to profile it, though):
// module.exports = function(attrs, ...children) {
//     if (attrs == null || typeof attrs === "object" && attrs.tag == null && !Array.isArray(attrs)) {
//         if (children.length === 1 && Array.isArray(children[0])) children = children[0]
//     } else {
//         children = children.length === 0 && Array.isArray(attrs) ? attrs : [attrs, ...children]
//         attrs = undefined
//     }
//
//     if (attrs == null) attrs = {}
//     return Vnode("", attrs.key, attrs, children)
// }
module.exports = function() {
    var attrs = arguments[this], start = this + 1, children;
    if (attrs == null) attrs = {};
    else if (typeof attrs !== "object" || attrs.tag != null || Array.isArray(attrs)) {
        attrs = {};
        start = this;
    }
    if (arguments.length === start + 1) {
        children = arguments[start];
        if (!Array.isArray(children)) children = [
            children
        ];
    } else {
        children = [];
        while(start < arguments.length)children.push(arguments[start++]);
    }
    return $8JOml("", attrs.key, attrs, children);
};

});


parcelRegister("c0EvV", function(module, exports) {
"use strict";
/** @constructor */ var $8be4e955ae324471$var$PromisePolyfill = function(executor) {
    if (!(this instanceof $8be4e955ae324471$var$PromisePolyfill)) throw new Error("Promise must be called with 'new'.");
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var self = this, resolvers = [], rejectors = [], resolveCurrent = handler(resolvers, true), rejectCurrent = handler(rejectors, false);
    var instance = self._instance = {
        resolvers: resolvers,
        rejectors: rejectors
    };
    var callAsync = typeof setImmediate === "function" ? setImmediate : setTimeout;
    function handler(list, shouldAbsorb) {
        return function execute(value) {
            var then;
            try {
                if (shouldAbsorb && value != null && (typeof value === "object" || typeof value === "function") && typeof (then = value.then) === "function") {
                    if (value === self) throw new TypeError("Promise can't be resolved with itself.");
                    executeOnce(then.bind(value));
                } else callAsync(function() {
                    if (!shouldAbsorb && list.length === 0) console.error("Possible unhandled promise rejection:", value);
                    for(var i = 0; i < list.length; i++)list[i](value);
                    resolvers.length = 0, rejectors.length = 0;
                    instance.state = shouldAbsorb;
                    instance.retry = function() {
                        execute(value);
                    };
                });
            } catch (e) {
                rejectCurrent(e);
            }
        };
    }
    function executeOnce(then) {
        var runs = 0;
        function run(fn) {
            return function(value) {
                if (runs++ > 0) return;
                fn(value);
            };
        }
        var onerror = run(rejectCurrent);
        try {
            then(run(resolveCurrent), onerror);
        } catch (e) {
            onerror(e);
        }
    }
    executeOnce(executor);
};
$8be4e955ae324471$var$PromisePolyfill.prototype.then = function(onFulfilled, onRejection) {
    var self = this, instance = self._instance;
    function handle(callback, list, next, state) {
        list.push(function(value) {
            if (typeof callback !== "function") next(value);
            else try {
                resolveNext(callback(value));
            } catch (e) {
                if (rejectNext) rejectNext(e);
            }
        });
        if (typeof instance.retry === "function" && state === instance.state) instance.retry();
    }
    var resolveNext, rejectNext;
    var promise = new $8be4e955ae324471$var$PromisePolyfill(function(resolve, reject) {
        resolveNext = resolve, rejectNext = reject;
    });
    handle(onFulfilled, instance.resolvers, resolveNext, true), handle(onRejection, instance.rejectors, rejectNext, false);
    return promise;
};
$8be4e955ae324471$var$PromisePolyfill.prototype.catch = function(onRejection) {
    return this.then(null, onRejection);
};
$8be4e955ae324471$var$PromisePolyfill.prototype.finally = function(callback) {
    return this.then(function(value) {
        return $8be4e955ae324471$var$PromisePolyfill.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        return $8be4e955ae324471$var$PromisePolyfill.resolve(callback()).then(function() {
            return $8be4e955ae324471$var$PromisePolyfill.reject(reason);
        });
    });
};
$8be4e955ae324471$var$PromisePolyfill.resolve = function(value) {
    if (value instanceof $8be4e955ae324471$var$PromisePolyfill) return value;
    return new $8be4e955ae324471$var$PromisePolyfill(function(resolve) {
        resolve(value);
    });
};
$8be4e955ae324471$var$PromisePolyfill.reject = function(value) {
    return new $8be4e955ae324471$var$PromisePolyfill(function(resolve, reject) {
        reject(value);
    });
};
$8be4e955ae324471$var$PromisePolyfill.all = function(list) {
    return new $8be4e955ae324471$var$PromisePolyfill(function(resolve, reject) {
        var total = list.length, count = 0, values = [];
        if (list.length === 0) resolve([]);
        else for(var i = 0; i < list.length; i++)(function(i) {
            function consume(value) {
                count++;
                values[i] = value;
                if (count === total) resolve(values);
            }
            if (list[i] != null && (typeof list[i] === "object" || typeof list[i] === "function") && typeof list[i].then === "function") list[i].then(consume, reject);
            else consume(list[i]);
        })(i);
    });
};
$8be4e955ae324471$var$PromisePolyfill.race = function(list) {
    return new $8be4e955ae324471$var$PromisePolyfill(function(resolve, reject) {
        for(var i = 0; i < list.length; i++)list[i].then(resolve, reject);
    });
};
module.exports = $8be4e955ae324471$var$PromisePolyfill;

});

parcelRegister("03gNt", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fJQVn"))(typeof window !== "undefined" ? window : null);

});
parcelRegister("fJQVn", function(module, exports) {
"use strict";

var $8JOml = parcelRequire("8JOml");
module.exports = function($window) {
    var $doc = $window && $window.document;
    var currentRedraw;
    var nameSpace = {
        svg: "http://www.w3.org/2000/svg",
        math: "http://www.w3.org/1998/Math/MathML"
    };
    function getNameSpace(vnode) {
        return vnode.attrs && vnode.attrs.xmlns || nameSpace[vnode.tag];
    }
    //sanity check to discourage people from doing `vnode.state = ...`
    function checkState(vnode, original) {
        if (vnode.state !== original) throw new Error("'vnode.state' must not be modified.");
    }
    //Note: the hook is passed as the `this` argument to allow proxying the
    //arguments without requiring a full array allocation to do so. It also
    //takes advantage of the fact the current `vnode` is the first argument in
    //all lifecycle methods.
    function callHook(vnode) {
        var original = vnode.state;
        try {
            return this.apply(original, arguments);
        } finally{
            checkState(vnode, original);
        }
    }
    // IE11 (at least) throws an UnspecifiedError when accessing document.activeElement when
    // inside an iframe. Catch and swallow this error, and heavy-handidly return null.
    function activeElement() {
        try {
            return $doc.activeElement;
        } catch (e) {
            return null;
        }
    }
    //create
    function createNodes(parent, vnodes, start, end, hooks, nextSibling, ns) {
        for(var i = start; i < end; i++){
            var vnode = vnodes[i];
            if (vnode != null) createNode(parent, vnode, hooks, ns, nextSibling);
        }
    }
    function createNode(parent, vnode, hooks, ns, nextSibling) {
        var tag = vnode.tag;
        if (typeof tag === "string") {
            vnode.state = {};
            if (vnode.attrs != null) initLifecycle(vnode.attrs, vnode, hooks);
            switch(tag){
                case "#":
                    createText(parent, vnode, nextSibling);
                    break;
                case "<":
                    createHTML(parent, vnode, ns, nextSibling);
                    break;
                case "[":
                    createFragment(parent, vnode, hooks, ns, nextSibling);
                    break;
                default:
                    createElement(parent, vnode, hooks, ns, nextSibling);
            }
        } else createComponent(parent, vnode, hooks, ns, nextSibling);
    }
    function createText(parent, vnode, nextSibling) {
        vnode.dom = $doc.createTextNode(vnode.children);
        insertNode(parent, vnode.dom, nextSibling);
    }
    var possibleParents = {
        caption: "table",
        thead: "table",
        tbody: "table",
        tfoot: "table",
        tr: "tbody",
        th: "tr",
        td: "tr",
        colgroup: "table",
        col: "colgroup"
    };
    function createHTML(parent, vnode, ns, nextSibling) {
        var match = vnode.children.match(/^\s*?<(\w+)/im) || [];
        // not using the proper parent makes the child element(s) vanish.
        //     var div = document.createElement("div")
        //     div.innerHTML = "<td>i</td><td>j</td>"
        //     console.log(div.innerHTML)
        // --> "ij", no <td> in sight.
        var temp = $doc.createElement(possibleParents[match[1]] || "div");
        if (ns === "http://www.w3.org/2000/svg") {
            temp.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg">' + vnode.children + "</svg>";
            temp = temp.firstChild;
        } else temp.innerHTML = vnode.children;
        vnode.dom = temp.firstChild;
        vnode.domSize = temp.childNodes.length;
        // Capture nodes to remove, so we don't confuse them.
        vnode.instance = [];
        var fragment = $doc.createDocumentFragment();
        var child;
        while(child = temp.firstChild){
            vnode.instance.push(child);
            fragment.appendChild(child);
        }
        insertNode(parent, fragment, nextSibling);
    }
    function createFragment(parent, vnode, hooks, ns, nextSibling) {
        var fragment = $doc.createDocumentFragment();
        if (vnode.children != null) {
            var children = vnode.children;
            createNodes(fragment, children, 0, children.length, hooks, null, ns);
        }
        vnode.dom = fragment.firstChild;
        vnode.domSize = fragment.childNodes.length;
        insertNode(parent, fragment, nextSibling);
    }
    function createElement(parent, vnode, hooks, ns, nextSibling) {
        var tag = vnode.tag;
        var attrs = vnode.attrs;
        var is = attrs && attrs.is;
        ns = getNameSpace(vnode) || ns;
        var element = ns ? is ? $doc.createElementNS(ns, tag, {
            is: is
        }) : $doc.createElementNS(ns, tag) : is ? $doc.createElement(tag, {
            is: is
        }) : $doc.createElement(tag);
        vnode.dom = element;
        if (attrs != null) setAttrs(vnode, attrs, ns);
        insertNode(parent, element, nextSibling);
        if (!maybeSetContentEditable(vnode)) {
            if (vnode.children != null) {
                var children = vnode.children;
                createNodes(element, children, 0, children.length, hooks, null, ns);
                if (vnode.tag === "select" && attrs != null) setLateSelectAttrs(vnode, attrs);
            }
        }
    }
    function initComponent(vnode, hooks) {
        var sentinel;
        if (typeof vnode.tag.view === "function") {
            vnode.state = Object.create(vnode.tag);
            sentinel = vnode.state.view;
            if (sentinel.$$reentrantLock$$ != null) return;
            sentinel.$$reentrantLock$$ = true;
        } else {
            vnode.state = void 0;
            sentinel = vnode.tag;
            if (sentinel.$$reentrantLock$$ != null) return;
            sentinel.$$reentrantLock$$ = true;
            vnode.state = vnode.tag.prototype != null && typeof vnode.tag.prototype.view === "function" ? new vnode.tag(vnode) : vnode.tag(vnode);
        }
        initLifecycle(vnode.state, vnode, hooks);
        if (vnode.attrs != null) initLifecycle(vnode.attrs, vnode, hooks);
        vnode.instance = $8JOml.normalize(callHook.call(vnode.state.view, vnode));
        if (vnode.instance === vnode) throw Error("A view cannot return the vnode it received as argument");
        sentinel.$$reentrantLock$$ = null;
    }
    function createComponent(parent, vnode, hooks, ns, nextSibling) {
        initComponent(vnode, hooks);
        if (vnode.instance != null) {
            createNode(parent, vnode.instance, hooks, ns, nextSibling);
            vnode.dom = vnode.instance.dom;
            vnode.domSize = vnode.dom != null ? vnode.instance.domSize : 0;
        } else vnode.domSize = 0;
    }
    //update
    /**
	 * @param {Element|Fragment} parent - the parent element
	 * @param {Vnode[] | null} old - the list of vnodes of the last `render()` call for
	 *                               this part of the tree
	 * @param {Vnode[] | null} vnodes - as above, but for the current `render()` call.
	 * @param {Function[]} hooks - an accumulator of post-render hooks (oncreate/onupdate)
	 * @param {Element | null} nextSibling - the next DOM node if we're dealing with a
	 *                                       fragment that is not the last item in its
	 *                                       parent
	 * @param {'svg' | 'math' | String | null} ns) - the current XML namespace, if any
	 * @returns void
	 */ // This function diffs and patches lists of vnodes, both keyed and unkeyed.
    //
    // We will:
    //
    // 1. describe its general structure
    // 2. focus on the diff algorithm optimizations
    // 3. discuss DOM node operations.
    // ## Overview:
    //
    // The updateNodes() function:
    // - deals with trivial cases
    // - determines whether the lists are keyed or unkeyed based on the first non-null node
    //   of each list.
    // - diffs them and patches the DOM if needed (that's the brunt of the code)
    // - manages the leftovers: after diffing, are there:
    //   - old nodes left to remove?
    // 	 - new nodes to insert?
    // 	 deal with them!
    //
    // The lists are only iterated over once, with an exception for the nodes in `old` that
    // are visited in the fourth part of the diff and in the `removeNodes` loop.
    // ## Diffing
    //
    // Reading https://github.com/localvoid/ivi/blob/ddc09d06abaef45248e6133f7040d00d3c6be853/packages/ivi/src/vdom/implementation.ts#L617-L837
    // may be good for context on longest increasing subsequence-based logic for moving nodes.
    //
    // In order to diff keyed lists, one has to
    //
    // 1) match nodes in both lists, per key, and update them accordingly
    // 2) create the nodes present in the new list, but absent in the old one
    // 3) remove the nodes present in the old list, but absent in the new one
    // 4) figure out what nodes in 1) to move in order to minimize the DOM operations.
    //
    // To achieve 1) one can create a dictionary of keys => index (for the old list), then iterate
    // over the new list and for each new vnode, find the corresponding vnode in the old list using
    // the map.
    // 2) is achieved in the same step: if a new node has no corresponding entry in the map, it is new
    // and must be created.
    // For the removals, we actually remove the nodes that have been updated from the old list.
    // The nodes that remain in that list after 1) and 2) have been performed can be safely removed.
    // The fourth step is a bit more complex and relies on the longest increasing subsequence (LIS)
    // algorithm.
    //
    // the longest increasing subsequence is the list of nodes that can remain in place. Imagine going
    // from `1,2,3,4,5` to `4,5,1,2,3` where the numbers are not necessarily the keys, but the indices
    // corresponding to the keyed nodes in the old list (keyed nodes `e,d,c,b,a` => `b,a,e,d,c` would
    //  match the above lists, for example).
    //
    // In there are two increasing subsequences: `4,5` and `1,2,3`, the latter being the longest. We
    // can update those nodes without moving them, and only call `insertNode` on `4` and `5`.
    //
    // @localvoid adapted the algo to also support node deletions and insertions (the `lis` is actually
    // the longest increasing subsequence *of old nodes still present in the new list*).
    //
    // It is a general algorithm that is fireproof in all circumstances, but it requires the allocation
    // and the construction of a `key => oldIndex` map, and three arrays (one with `newIndex => oldIndex`,
    // the `LIS` and a temporary one to create the LIS).
    //
    // So we cheat where we can: if the tails of the lists are identical, they are guaranteed to be part of
    // the LIS and can be updated without moving them.
    //
    // If two nodes are swapped, they are guaranteed not to be part of the LIS, and must be moved (with
    // the exception of the last node if the list is fully reversed).
    //
    // ## Finding the next sibling.
    //
    // `updateNode()` and `createNode()` expect a nextSibling parameter to perform DOM operations.
    // When the list is being traversed top-down, at any index, the DOM nodes up to the previous
    // vnode reflect the content of the new list, whereas the rest of the DOM nodes reflect the old
    // list. The next sibling must be looked for in the old list using `getNextSibling(... oldStart + 1 ...)`.
    //
    // In the other scenarios (swaps, upwards traversal, map-based diff),
    // the new vnodes list is traversed upwards. The DOM nodes at the bottom of the list reflect the
    // bottom part of the new vnodes list, and we can use the `v.dom`  value of the previous node
    // as the next sibling (cached in the `nextSibling` variable).
    // ## DOM node moves
    //
    // In most scenarios `updateNode()` and `createNode()` perform the DOM operations. However,
    // this is not the case if the node moved (second and fourth part of the diff algo). We move
    // the old DOM nodes before updateNode runs because it enables us to use the cached `nextSibling`
    // variable rather than fetching it using `getNextSibling()`.
    //
    // The fourth part of the diff currently inserts nodes unconditionally, leading to issues
    // like #1791 and #1999. We need to be smarter about those situations where adjascent old
    // nodes remain together in the new list in a way that isn't covered by parts one and
    // three of the diff algo.
    function updateNodes(parent, old, vnodes, hooks, nextSibling, ns) {
        if (old === vnodes || old == null && vnodes == null) return;
        else if (old == null || old.length === 0) createNodes(parent, vnodes, 0, vnodes.length, hooks, nextSibling, ns);
        else if (vnodes == null || vnodes.length === 0) removeNodes(parent, old, 0, old.length);
        else {
            var isOldKeyed = old[0] != null && old[0].key != null;
            var isKeyed = vnodes[0] != null && vnodes[0].key != null;
            var start = 0, oldStart = 0;
            if (!isOldKeyed) while(oldStart < old.length && old[oldStart] == null)oldStart++;
            if (!isKeyed) while(start < vnodes.length && vnodes[start] == null)start++;
            if (isOldKeyed !== isKeyed) {
                removeNodes(parent, old, oldStart, old.length);
                createNodes(parent, vnodes, start, vnodes.length, hooks, nextSibling, ns);
            } else if (!isKeyed) {
                // Don't index past the end of either list (causes deopts).
                var commonLength = old.length < vnodes.length ? old.length : vnodes.length;
                // Rewind if necessary to the first non-null index on either side.
                // We could alternatively either explicitly create or remove nodes when `start !== oldStart`
                // but that would be optimizing for sparse lists which are more rare than dense ones.
                start = start < oldStart ? start : oldStart;
                for(; start < commonLength; start++){
                    o = old[start];
                    v = vnodes[start];
                    if (o === v || o == null && v == null) continue;
                    else if (o == null) createNode(parent, v, hooks, ns, getNextSibling(old, start + 1, nextSibling));
                    else if (v == null) removeNode(parent, o);
                    else updateNode(parent, o, v, hooks, getNextSibling(old, start + 1, nextSibling), ns);
                }
                if (old.length > commonLength) removeNodes(parent, old, start, old.length);
                if (vnodes.length > commonLength) createNodes(parent, vnodes, start, vnodes.length, hooks, nextSibling, ns);
            } else {
                // keyed diff
                var oldEnd = old.length - 1, end = vnodes.length - 1, map, o, v, oe, ve, topSibling;
                // bottom-up
                while(oldEnd >= oldStart && end >= start){
                    oe = old[oldEnd];
                    ve = vnodes[end];
                    if (oe.key !== ve.key) break;
                    if (oe !== ve) updateNode(parent, oe, ve, hooks, nextSibling, ns);
                    if (ve.dom != null) nextSibling = ve.dom;
                    oldEnd--, end--;
                }
                // top-down
                while(oldEnd >= oldStart && end >= start){
                    o = old[oldStart];
                    v = vnodes[start];
                    if (o.key !== v.key) break;
                    oldStart++, start++;
                    if (o !== v) updateNode(parent, o, v, hooks, getNextSibling(old, oldStart, nextSibling), ns);
                }
                // swaps and list reversals
                while(oldEnd >= oldStart && end >= start){
                    if (start === end) break;
                    if (o.key !== ve.key || oe.key !== v.key) break;
                    topSibling = getNextSibling(old, oldStart, nextSibling);
                    moveNodes(parent, oe, topSibling);
                    if (oe !== v) updateNode(parent, oe, v, hooks, topSibling, ns);
                    if (++start <= --end) moveNodes(parent, o, nextSibling);
                    if (o !== ve) updateNode(parent, o, ve, hooks, nextSibling, ns);
                    if (ve.dom != null) nextSibling = ve.dom;
                    oldStart++;
                    oldEnd--;
                    oe = old[oldEnd];
                    ve = vnodes[end];
                    o = old[oldStart];
                    v = vnodes[start];
                }
                // bottom up once again
                while(oldEnd >= oldStart && end >= start){
                    if (oe.key !== ve.key) break;
                    if (oe !== ve) updateNode(parent, oe, ve, hooks, nextSibling, ns);
                    if (ve.dom != null) nextSibling = ve.dom;
                    oldEnd--, end--;
                    oe = old[oldEnd];
                    ve = vnodes[end];
                }
                if (start > end) removeNodes(parent, old, oldStart, oldEnd + 1);
                else if (oldStart > oldEnd) createNodes(parent, vnodes, start, end + 1, hooks, nextSibling, ns);
                else {
                    // inspired by ivi https://github.com/ivijs/ivi/ by Boris Kaul
                    var originalNextSibling = nextSibling, vnodesLength = end - start + 1, oldIndices = new Array(vnodesLength), li = 0, i = 0, pos = 2147483647, matched = 0, map, lisIndices;
                    for(i = 0; i < vnodesLength; i++)oldIndices[i] = -1;
                    for(i = end; i >= start; i--){
                        if (map == null) map = getKeyMap(old, oldStart, oldEnd + 1);
                        ve = vnodes[i];
                        var oldIndex = map[ve.key];
                        if (oldIndex != null) {
                            pos = oldIndex < pos ? oldIndex : -1 // becomes -1 if nodes were re-ordered
                            ;
                            oldIndices[i - start] = oldIndex;
                            oe = old[oldIndex];
                            old[oldIndex] = null;
                            if (oe !== ve) updateNode(parent, oe, ve, hooks, nextSibling, ns);
                            if (ve.dom != null) nextSibling = ve.dom;
                            matched++;
                        }
                    }
                    nextSibling = originalNextSibling;
                    if (matched !== oldEnd - oldStart + 1) removeNodes(parent, old, oldStart, oldEnd + 1);
                    if (matched === 0) createNodes(parent, vnodes, start, end + 1, hooks, nextSibling, ns);
                    else {
                        if (pos === -1) {
                            // the indices of the indices of the items that are part of the
                            // longest increasing subsequence in the oldIndices list
                            lisIndices = makeLisIndices(oldIndices);
                            li = lisIndices.length - 1;
                            for(i = end; i >= start; i--){
                                v = vnodes[i];
                                if (oldIndices[i - start] === -1) createNode(parent, v, hooks, ns, nextSibling);
                                else if (lisIndices[li] === i - start) li--;
                                else moveNodes(parent, v, nextSibling);
                                if (v.dom != null) nextSibling = vnodes[i].dom;
                            }
                        } else for(i = end; i >= start; i--){
                            v = vnodes[i];
                            if (oldIndices[i - start] === -1) createNode(parent, v, hooks, ns, nextSibling);
                            if (v.dom != null) nextSibling = vnodes[i].dom;
                        }
                    }
                }
            }
        }
    }
    function updateNode(parent, old, vnode, hooks, nextSibling, ns) {
        var oldTag = old.tag, tag = vnode.tag;
        if (oldTag === tag) {
            vnode.state = old.state;
            vnode.events = old.events;
            if (shouldNotUpdate(vnode, old)) return;
            if (typeof oldTag === "string") {
                if (vnode.attrs != null) updateLifecycle(vnode.attrs, vnode, hooks);
                switch(oldTag){
                    case "#":
                        updateText(old, vnode);
                        break;
                    case "<":
                        updateHTML(parent, old, vnode, ns, nextSibling);
                        break;
                    case "[":
                        updateFragment(parent, old, vnode, hooks, nextSibling, ns);
                        break;
                    default:
                        updateElement(old, vnode, hooks, ns);
                }
            } else updateComponent(parent, old, vnode, hooks, nextSibling, ns);
        } else {
            removeNode(parent, old);
            createNode(parent, vnode, hooks, ns, nextSibling);
        }
    }
    function updateText(old, vnode) {
        if (old.children.toString() !== vnode.children.toString()) old.dom.nodeValue = vnode.children;
        vnode.dom = old.dom;
    }
    function updateHTML(parent, old, vnode, ns, nextSibling) {
        if (old.children !== vnode.children) {
            removeHTML(parent, old);
            createHTML(parent, vnode, ns, nextSibling);
        } else {
            vnode.dom = old.dom;
            vnode.domSize = old.domSize;
            vnode.instance = old.instance;
        }
    }
    function updateFragment(parent, old, vnode, hooks, nextSibling, ns) {
        updateNodes(parent, old.children, vnode.children, hooks, nextSibling, ns);
        var domSize = 0, children = vnode.children;
        vnode.dom = null;
        if (children != null) {
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child != null && child.dom != null) {
                    if (vnode.dom == null) vnode.dom = child.dom;
                    domSize += child.domSize || 1;
                }
            }
            if (domSize !== 1) vnode.domSize = domSize;
        }
    }
    function updateElement(old, vnode, hooks, ns) {
        var element = vnode.dom = old.dom;
        ns = getNameSpace(vnode) || ns;
        if (vnode.tag === "textarea") {
            if (vnode.attrs == null) vnode.attrs = {};
        }
        updateAttrs(vnode, old.attrs, vnode.attrs, ns);
        if (!maybeSetContentEditable(vnode)) updateNodes(element, old.children, vnode.children, hooks, null, ns);
    }
    function updateComponent(parent, old, vnode, hooks, nextSibling, ns) {
        vnode.instance = $8JOml.normalize(callHook.call(vnode.state.view, vnode));
        if (vnode.instance === vnode) throw Error("A view cannot return the vnode it received as argument");
        updateLifecycle(vnode.state, vnode, hooks);
        if (vnode.attrs != null) updateLifecycle(vnode.attrs, vnode, hooks);
        if (vnode.instance != null) {
            if (old.instance == null) createNode(parent, vnode.instance, hooks, ns, nextSibling);
            else updateNode(parent, old.instance, vnode.instance, hooks, nextSibling, ns);
            vnode.dom = vnode.instance.dom;
            vnode.domSize = vnode.instance.domSize;
        } else if (old.instance != null) {
            removeNode(parent, old.instance);
            vnode.dom = undefined;
            vnode.domSize = 0;
        } else {
            vnode.dom = old.dom;
            vnode.domSize = old.domSize;
        }
    }
    function getKeyMap(vnodes, start, end) {
        var map = Object.create(null);
        for(; start < end; start++){
            var vnode = vnodes[start];
            if (vnode != null) {
                var key = vnode.key;
                if (key != null) map[key] = start;
            }
        }
        return map;
    }
    // Lifted from ivi https://github.com/ivijs/ivi/
    // takes a list of unique numbers (-1 is special and can
    // occur multiple times) and returns an array with the indices
    // of the items that are part of the longest increasing
    // subsequence
    var lisTemp = [];
    function makeLisIndices(a) {
        var result = [
            0
        ];
        var u = 0, v = 0, i = 0;
        var il = lisTemp.length = a.length;
        for(var i = 0; i < il; i++)lisTemp[i] = a[i];
        for(var i = 0; i < il; ++i){
            if (a[i] === -1) continue;
            var j = result[result.length - 1];
            if (a[j] < a[i]) {
                lisTemp[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v = result.length - 1;
            while(u < v){
                // Fast integer average without overflow.
                // eslint-disable-next-line no-bitwise
                var c = (u >>> 1) + (v >>> 1) + (u & v & 1);
                if (a[result[c]] < a[i]) u = c + 1;
                else v = c;
            }
            if (a[i] < a[result[u]]) {
                if (u > 0) lisTemp[i] = result[u - 1];
                result[u] = i;
            }
        }
        u = result.length;
        v = result[u - 1];
        while(u-- > 0){
            result[u] = v;
            v = lisTemp[v];
        }
        lisTemp.length = 0;
        return result;
    }
    function getNextSibling(vnodes, i, nextSibling) {
        for(; i < vnodes.length; i++){
            if (vnodes[i] != null && vnodes[i].dom != null) return vnodes[i].dom;
        }
        return nextSibling;
    }
    // This covers a really specific edge case:
    // - Parent node is keyed and contains child
    // - Child is removed, returns unresolved promise in `onbeforeremove`
    // - Parent node is moved in keyed diff
    // - Remaining children still need moved appropriately
    //
    // Ideally, I'd track removed nodes as well, but that introduces a lot more
    // complexity and I'm not exactly interested in doing that.
    function moveNodes(parent, vnode, nextSibling) {
        var frag = $doc.createDocumentFragment();
        moveChildToFrag(parent, frag, vnode);
        insertNode(parent, frag, nextSibling);
    }
    function moveChildToFrag(parent, frag, vnode) {
        // Dodge the recursion overhead in a few of the most common cases.
        while(vnode.dom != null && vnode.dom.parentNode === parent){
            if (typeof vnode.tag !== "string") {
                vnode = vnode.instance;
                if (vnode != null) continue;
            } else if (vnode.tag === "<") for(var i = 0; i < vnode.instance.length; i++)frag.appendChild(vnode.instance[i]);
            else if (vnode.tag !== "[") // Don't recurse for text nodes *or* elements, just fragments
            frag.appendChild(vnode.dom);
            else if (vnode.children.length === 1) {
                vnode = vnode.children[0];
                if (vnode != null) continue;
            } else for(var i = 0; i < vnode.children.length; i++){
                var child = vnode.children[i];
                if (child != null) moveChildToFrag(parent, frag, child);
            }
            break;
        }
    }
    function insertNode(parent, dom, nextSibling) {
        if (nextSibling != null) parent.insertBefore(dom, nextSibling);
        else parent.appendChild(dom);
    }
    function maybeSetContentEditable(vnode) {
        if (vnode.attrs == null || vnode.attrs.contenteditable == null && // attribute
        vnode.attrs.contentEditable == null // property
        ) return false;
        var children = vnode.children;
        if (children != null && children.length === 1 && children[0].tag === "<") {
            var content = children[0].children;
            if (vnode.dom.innerHTML !== content) vnode.dom.innerHTML = content;
        } else if (children != null && children.length !== 0) throw new Error("Child node of a contenteditable must be trusted.");
        return true;
    }
    //remove
    function removeNodes(parent, vnodes, start, end) {
        for(var i = start; i < end; i++){
            var vnode = vnodes[i];
            if (vnode != null) removeNode(parent, vnode);
        }
    }
    function removeNode(parent, vnode) {
        var mask = 0;
        var original = vnode.state;
        var stateResult, attrsResult;
        if (typeof vnode.tag !== "string" && typeof vnode.state.onbeforeremove === "function") {
            var result = callHook.call(vnode.state.onbeforeremove, vnode);
            if (result != null && typeof result.then === "function") {
                mask = 1;
                stateResult = result;
            }
        }
        if (vnode.attrs && typeof vnode.attrs.onbeforeremove === "function") {
            var result = callHook.call(vnode.attrs.onbeforeremove, vnode);
            if (result != null && typeof result.then === "function") {
                // eslint-disable-next-line no-bitwise
                mask |= 2;
                attrsResult = result;
            }
        }
        checkState(vnode, original);
        // If we can, try to fast-path it and avoid all the overhead of awaiting
        if (!mask) {
            onremove(vnode);
            removeChild(parent, vnode);
        } else {
            if (stateResult != null) {
                var next = function() {
                    // eslint-disable-next-line no-bitwise
                    if (mask & 1) {
                        mask &= 2;
                        if (!mask) reallyRemove();
                    }
                };
                stateResult.then(next, next);
            }
            if (attrsResult != null) {
                var next = function() {
                    // eslint-disable-next-line no-bitwise
                    if (mask & 2) {
                        mask &= 1;
                        if (!mask) reallyRemove();
                    }
                };
                attrsResult.then(next, next);
            }
        }
        function reallyRemove() {
            checkState(vnode, original);
            onremove(vnode);
            removeChild(parent, vnode);
        }
    }
    function removeHTML(parent, vnode) {
        for(var i = 0; i < vnode.instance.length; i++)parent.removeChild(vnode.instance[i]);
    }
    function removeChild(parent, vnode) {
        // Dodge the recursion overhead in a few of the most common cases.
        while(vnode.dom != null && vnode.dom.parentNode === parent){
            if (typeof vnode.tag !== "string") {
                vnode = vnode.instance;
                if (vnode != null) continue;
            } else if (vnode.tag === "<") removeHTML(parent, vnode);
            else {
                if (vnode.tag !== "[") {
                    parent.removeChild(vnode.dom);
                    if (!Array.isArray(vnode.children)) break;
                }
                if (vnode.children.length === 1) {
                    vnode = vnode.children[0];
                    if (vnode != null) continue;
                } else for(var i = 0; i < vnode.children.length; i++){
                    var child = vnode.children[i];
                    if (child != null) removeChild(parent, child);
                }
            }
            break;
        }
    }
    function onremove(vnode) {
        if (typeof vnode.tag !== "string" && typeof vnode.state.onremove === "function") callHook.call(vnode.state.onremove, vnode);
        if (vnode.attrs && typeof vnode.attrs.onremove === "function") callHook.call(vnode.attrs.onremove, vnode);
        if (typeof vnode.tag !== "string") {
            if (vnode.instance != null) onremove(vnode.instance);
        } else {
            var children = vnode.children;
            if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child != null) onremove(child);
            }
        }
    }
    //attrs
    function setAttrs(vnode, attrs, ns) {
        // If you assign an input type that is not supported by IE 11 with an assignment expression, an error will occur.
        //
        // Also, the DOM does things to inputs based on the value, so it needs set first.
        // See: https://github.com/MithrilJS/mithril.js/issues/2622
        if (vnode.tag === "input" && attrs.type != null) vnode.dom.setAttribute("type", attrs.type);
        var isFileInput = attrs != null && vnode.tag === "input" && attrs.type === "file";
        for(var key in attrs)setAttr(vnode, key, null, attrs[key], ns, isFileInput);
    }
    function setAttr(vnode, key, old, value, ns, isFileInput) {
        if (key === "key" || key === "is" || value == null || isLifecycleMethod(key) || old === value && !isFormAttribute(vnode, key) && typeof value !== "object" || key === "type" && vnode.tag === "input") return;
        if (key[0] === "o" && key[1] === "n") return updateEvent(vnode, key, value);
        if (key.slice(0, 6) === "xlink:") vnode.dom.setAttributeNS("http://www.w3.org/1999/xlink", key.slice(6), value);
        else if (key === "style") updateStyle(vnode.dom, old, value);
        else if (hasPropertyKey(vnode, key, ns)) {
            if (key === "value") {
                // Only do the coercion if we're actually going to check the value.
                /* eslint-disable no-implicit-coercion */ //setting input[value] to same value by typing on focused element moves cursor to end in Chrome
                //setting input[type=file][value] to same value causes an error to be generated if it's non-empty
                if ((vnode.tag === "input" || vnode.tag === "textarea") && vnode.dom.value === "" + value && (isFileInput || vnode.dom === activeElement())) return;
                //setting select[value] to same value while having select open blinks select dropdown in Chrome
                if (vnode.tag === "select" && old !== null && vnode.dom.value === "" + value) return;
                //setting option[value] to same value while having select open blinks select dropdown in Chrome
                if (vnode.tag === "option" && old !== null && vnode.dom.value === "" + value) return;
                //setting input[type=file][value] to different value is an error if it's non-empty
                // Not ideal, but it at least works around the most common source of uncaught exceptions for now.
                if (isFileInput && "" + value !== "") {
                    console.error("`value` is read-only on file inputs!");
                    return;
                }
            /* eslint-enable no-implicit-coercion */ }
            vnode.dom[key] = value;
        } else if (typeof value === "boolean") {
            if (value) vnode.dom.setAttribute(key, "");
            else vnode.dom.removeAttribute(key);
        } else vnode.dom.setAttribute(key === "className" ? "class" : key, value);
    }
    function removeAttr(vnode, key, old, ns) {
        if (key === "key" || key === "is" || old == null || isLifecycleMethod(key)) return;
        if (key[0] === "o" && key[1] === "n") updateEvent(vnode, key, undefined);
        else if (key === "style") updateStyle(vnode.dom, old, null);
        else if (hasPropertyKey(vnode, key, ns) && key !== "className" && key !== "title" // creates "null" as title
         && !(key === "value" && (vnode.tag === "option" || vnode.tag === "select" && vnode.dom.selectedIndex === -1 && vnode.dom === activeElement())) && !(vnode.tag === "input" && key === "type")) vnode.dom[key] = null;
        else {
            var nsLastIndex = key.indexOf(":");
            if (nsLastIndex !== -1) key = key.slice(nsLastIndex + 1);
            if (old !== false) vnode.dom.removeAttribute(key === "className" ? "class" : key);
        }
    }
    function setLateSelectAttrs(vnode, attrs) {
        if ("value" in attrs) {
            if (attrs.value === null) {
                if (vnode.dom.selectedIndex !== -1) vnode.dom.value = null;
            } else {
                var normalized = "" + attrs.value // eslint-disable-line no-implicit-coercion
                ;
                if (vnode.dom.value !== normalized || vnode.dom.selectedIndex === -1) vnode.dom.value = normalized;
            }
        }
        if ("selectedIndex" in attrs) setAttr(vnode, "selectedIndex", null, attrs.selectedIndex, undefined);
    }
    function updateAttrs(vnode, old, attrs, ns) {
        if (old && old === attrs) console.warn("Don't reuse attrs object, use new object for every redraw, this will throw in next major");
        if (attrs != null) {
            // If you assign an input type that is not supported by IE 11 with an assignment expression, an error will occur.
            //
            // Also, the DOM does things to inputs based on the value, so it needs set first.
            // See: https://github.com/MithrilJS/mithril.js/issues/2622
            if (vnode.tag === "input" && attrs.type != null) vnode.dom.setAttribute("type", attrs.type);
            var isFileInput = vnode.tag === "input" && attrs.type === "file";
            for(var key in attrs)setAttr(vnode, key, old && old[key], attrs[key], ns, isFileInput);
        }
        var val;
        if (old != null) {
            for(var key in old)if ((val = old[key]) != null && (attrs == null || attrs[key] == null)) removeAttr(vnode, key, val, ns);
        }
    }
    function isFormAttribute(vnode, attr) {
        return attr === "value" || attr === "checked" || attr === "selectedIndex" || attr === "selected" && vnode.dom === activeElement() || vnode.tag === "option" && vnode.dom.parentNode === $doc.activeElement;
    }
    function isLifecycleMethod(attr) {
        return attr === "oninit" || attr === "oncreate" || attr === "onupdate" || attr === "onremove" || attr === "onbeforeremove" || attr === "onbeforeupdate";
    }
    function hasPropertyKey(vnode, key, ns) {
        // Filter out namespaced keys
        return ns === undefined && // If it's a custom element, just keep it.
        (vnode.tag.indexOf("-") > -1 || vnode.attrs != null && vnode.attrs.is || // If it's a normal element, let's try to avoid a few browser bugs.
        key !== "href" && key !== "list" && key !== "form" && key !== "width" && key !== "height" // && key !== "type"
        ) && key in vnode.dom;
    }
    //style
    var uppercaseRegex = /[A-Z]/g;
    function toLowerCase(capital) {
        return "-" + capital.toLowerCase();
    }
    function normalizeKey(key) {
        return key[0] === "-" && key[1] === "-" ? key : key === "cssFloat" ? "float" : key.replace(uppercaseRegex, toLowerCase);
    }
    function updateStyle(element, old, style) {
        if (old === style) ;
        else if (style == null) // New style is missing, just clear it.
        element.style.cssText = "";
        else if (typeof style !== "object") // New style is a string, let engine deal with patching.
        element.style.cssText = style;
        else if (old == null || typeof old !== "object") {
            // `old` is missing or a string, `style` is an object.
            element.style.cssText = "";
            // Add new style properties
            for(var key in style){
                var value = style[key];
                if (value != null) element.style.setProperty(normalizeKey(key), String(value));
            }
        } else {
            // Both old & new are (different) objects.
            // Update style properties that have changed
            for(var key in style){
                var value = style[key];
                if (value != null && (value = String(value)) !== String(old[key])) element.style.setProperty(normalizeKey(key), value);
            }
            // Remove style properties that no longer exist
            for(var key in old)if (old[key] != null && style[key] == null) element.style.removeProperty(normalizeKey(key));
        }
    }
    // Here's an explanation of how this works:
    // 1. The event names are always (by design) prefixed by `on`.
    // 2. The EventListener interface accepts either a function or an object
    //    with a `handleEvent` method.
    // 3. The object does not inherit from `Object.prototype`, to avoid
    //    any potential interference with that (e.g. setters).
    // 4. The event name is remapped to the handler before calling it.
    // 5. In function-based event handlers, `ev.target === this`. We replicate
    //    that below.
    // 6. In function-based event handlers, `return false` prevents the default
    //    action and stops event propagation. We replicate that below.
    function EventDict() {
        // Save this, so the current redraw is correctly tracked.
        this._ = currentRedraw;
    }
    EventDict.prototype = Object.create(null);
    EventDict.prototype.handleEvent = function(ev) {
        var handler = this["on" + ev.type];
        var result;
        if (typeof handler === "function") result = handler.call(ev.currentTarget, ev);
        else if (typeof handler.handleEvent === "function") handler.handleEvent(ev);
        if (this._ && ev.redraw !== false) (0, this._)();
        if (result === false) {
            ev.preventDefault();
            ev.stopPropagation();
        }
    };
    //event
    function updateEvent(vnode, key, value) {
        if (vnode.events != null) {
            vnode.events._ = currentRedraw;
            if (vnode.events[key] === value) return;
            if (value != null && (typeof value === "function" || typeof value === "object")) {
                if (vnode.events[key] == null) vnode.dom.addEventListener(key.slice(2), vnode.events, false);
                vnode.events[key] = value;
            } else {
                if (vnode.events[key] != null) vnode.dom.removeEventListener(key.slice(2), vnode.events, false);
                vnode.events[key] = undefined;
            }
        } else if (value != null && (typeof value === "function" || typeof value === "object")) {
            vnode.events = new EventDict();
            vnode.dom.addEventListener(key.slice(2), vnode.events, false);
            vnode.events[key] = value;
        }
    }
    //lifecycle
    function initLifecycle(source, vnode, hooks) {
        if (typeof source.oninit === "function") callHook.call(source.oninit, vnode);
        if (typeof source.oncreate === "function") hooks.push(callHook.bind(source.oncreate, vnode));
    }
    function updateLifecycle(source, vnode, hooks) {
        if (typeof source.onupdate === "function") hooks.push(callHook.bind(source.onupdate, vnode));
    }
    function shouldNotUpdate(vnode, old) {
        do {
            if (vnode.attrs != null && typeof vnode.attrs.onbeforeupdate === "function") {
                var force = callHook.call(vnode.attrs.onbeforeupdate, vnode, old);
                if (force !== undefined && !force) break;
            }
            if (typeof vnode.tag !== "string" && typeof vnode.state.onbeforeupdate === "function") {
                var force = callHook.call(vnode.state.onbeforeupdate, vnode, old);
                if (force !== undefined && !force) break;
            }
            return false;
        }while (false); // eslint-disable-line no-constant-condition
        vnode.dom = old.dom;
        vnode.domSize = old.domSize;
        vnode.instance = old.instance;
        // One would think having the actual latest attributes would be ideal,
        // but it doesn't let us properly diff based on our current internal
        // representation. We have to save not only the old DOM info, but also
        // the attributes used to create it, as we diff *that*, not against the
        // DOM directly (with a few exceptions in `setAttr`). And, of course, we
        // need to save the children and text as they are conceptually not
        // unlike special "attributes" internally.
        vnode.attrs = old.attrs;
        vnode.children = old.children;
        vnode.text = old.text;
        return true;
    }
    var currentDOM;
    return function(dom, vnodes, redraw) {
        if (!dom) throw new TypeError("DOM element being rendered to does not exist.");
        if (currentDOM != null && dom.contains(currentDOM)) throw new TypeError("Node is currently being rendered to and thus is locked.");
        var prevRedraw = currentRedraw;
        var prevDOM = currentDOM;
        var hooks = [];
        var active = activeElement();
        var namespace = dom.namespaceURI;
        currentDOM = dom;
        currentRedraw = typeof redraw === "function" ? redraw : undefined;
        try {
            // First time rendering into a node clears it out
            if (dom.vnodes == null) dom.textContent = "";
            vnodes = $8JOml.normalizeChildren(Array.isArray(vnodes) ? vnodes : [
                vnodes
            ]);
            updateNodes(dom, dom.vnodes, vnodes, hooks, null, namespace === "http://www.w3.org/1999/xhtml" ? undefined : namespace);
            dom.vnodes = vnodes;
            // `document.activeElement` can return null: https://html.spec.whatwg.org/multipage/interaction.html#dom-document-activeelement
            if (active != null && activeElement() !== active && typeof active.focus === "function") active.focus();
            for(var i = 0; i < hooks.length; i++)hooks[i]();
        } finally{
            currentRedraw = prevRedraw;
            currentDOM = prevDOM;
        }
    };
};

});


parcelRegister("fTDI2", function(module, exports) {
"use strict";

var $8JOml = parcelRequire("8JOml");
module.exports = function(render, schedule, console) {
    var subscriptions = [];
    var pending = false;
    var offset = -1;
    function sync() {
        for(offset = 0; offset < subscriptions.length; offset += 2)try {
            render(subscriptions[offset], $8JOml(subscriptions[offset + 1]), redraw);
        } catch (e) {
            console.error(e);
        }
        offset = -1;
    }
    function redraw() {
        if (!pending) {
            pending = true;
            schedule(function() {
                pending = false;
                sync();
            });
        }
    }
    redraw.sync = sync;
    function mount(root, component) {
        if (component != null && component.view == null && typeof component !== "function") throw new TypeError("m.mount expects a component, not a vnode.");
        var index = subscriptions.indexOf(root);
        if (index >= 0) {
            subscriptions.splice(index, 2);
            if (index <= offset) offset -= 2;
            render(root, []);
        }
        if (component != null) {
            subscriptions.push(root, component);
            render(root, $8JOml(component), redraw);
        }
    }
    return {
        mount: mount,
        redraw: redraw
    };
};

});

parcelRegister("6ePE9", function(module, exports) {
"use strict";

var $dVi4w = parcelRequire("dVi4w");

var $iMmVV = parcelRequire("iMmVV");
module.exports = function($window, Promise, oncompletion) {
    var callbackCount = 0;
    function PromiseProxy(executor) {
        return new Promise(executor);
    }
    // In case the global Promise is some userland library's where they rely on
    // `foo instanceof this.constructor`, `this.constructor.resolve(value)`, or
    // similar. Let's *not* break them.
    PromiseProxy.prototype = Promise.prototype;
    PromiseProxy.__proto__ = Promise // eslint-disable-line no-proto
    ;
    function makeRequest(factory) {
        return function(url, args) {
            if (typeof url !== "string") {
                args = url;
                url = url.url;
            } else if (args == null) args = {};
            var promise = new Promise(function(resolve, reject) {
                factory($dVi4w(url, args.params), args, function(data) {
                    if (typeof args.type === "function") {
                        if (Array.isArray(data)) for(var i = 0; i < data.length; i++)data[i] = new args.type(data[i]);
                        else data = new args.type(data);
                    }
                    resolve(data);
                }, reject);
            });
            if (args.background === true) return promise;
            var count = 0;
            function complete() {
                if (--count === 0 && typeof oncompletion === "function") oncompletion();
            }
            return wrap(promise);
            function wrap(promise) {
                var then = promise.then;
                // Set the constructor, so engines know to not await or resolve
                // this as a native promise. At the time of writing, this is
                // only necessary for V8, but their behavior is the correct
                // behavior per spec. See this spec issue for more details:
                // https://github.com/tc39/ecma262/issues/1577. Also, see the
                // corresponding comment in `request/tests/test-request.js` for
                // a bit more background on the issue at hand.
                promise.constructor = PromiseProxy;
                promise.then = function() {
                    count++;
                    var next = then.apply(promise, arguments);
                    next.then(complete, function(e) {
                        complete();
                        if (count === 0) throw e;
                    });
                    return wrap(next);
                };
                return promise;
            }
        };
    }
    function hasHeader(args, name) {
        for(var key in args.headers){
            if ($iMmVV.call(args.headers, key) && key.toLowerCase() === name) return true;
        }
        return false;
    }
    return {
        request: makeRequest(function(url, args, resolve, reject) {
            var method = args.method != null ? args.method.toUpperCase() : "GET";
            var body = args.body;
            var assumeJSON = (args.serialize == null || args.serialize === JSON.serialize) && !(body instanceof $window.FormData || body instanceof $window.URLSearchParams);
            var responseType = args.responseType || (typeof args.extract === "function" ? "" : "json");
            var xhr = new $window.XMLHttpRequest(), aborted = false, isTimeout = false;
            var original = xhr, replacedAbort;
            var abort = xhr.abort;
            xhr.abort = function() {
                aborted = true;
                abort.call(this);
            };
            xhr.open(method, url, args.async !== false, typeof args.user === "string" ? args.user : undefined, typeof args.password === "string" ? args.password : undefined);
            if (assumeJSON && body != null && !hasHeader(args, "content-type")) xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
            if (typeof args.deserialize !== "function" && !hasHeader(args, "accept")) xhr.setRequestHeader("Accept", "application/json, text/*");
            if (args.withCredentials) xhr.withCredentials = args.withCredentials;
            if (args.timeout) xhr.timeout = args.timeout;
            xhr.responseType = responseType;
            for(var key in args.headers)if ($iMmVV.call(args.headers, key)) xhr.setRequestHeader(key, args.headers[key]);
            xhr.onreadystatechange = function(ev) {
                // Don't throw errors on xhr.abort().
                if (aborted) return;
                if (ev.target.readyState === 4) try {
                    var success = ev.target.status >= 200 && ev.target.status < 300 || ev.target.status === 304 || /^file:\/\//i.test(url);
                    // When the response type isn't "" or "text",
                    // `xhr.responseText` is the wrong thing to use.
                    // Browsers do the right thing and throw here, and we
                    // should honor that and do the right thing by
                    // preferring `xhr.response` where possible/practical.
                    var response = ev.target.response, message;
                    if (responseType === "json") {
                        // For IE and Edge, which don't implement
                        // `responseType: "json"`.
                        if (!ev.target.responseType && typeof args.extract !== "function") // Handle no-content which will not parse.
                        try {
                            response = JSON.parse(ev.target.responseText);
                        } catch (e) {
                            response = null;
                        }
                    } else if (!responseType || responseType === "text") // Only use this default if it's text. If a parsed
                    // document is needed on old IE and friends (all
                    // unsupported), the user should use a custom
                    // `config` instead. They're already using this at
                    // their own risk.
                    {
                        if (response == null) response = ev.target.responseText;
                    }
                    if (typeof args.extract === "function") {
                        response = args.extract(ev.target, args);
                        success = true;
                    } else if (typeof args.deserialize === "function") response = args.deserialize(response);
                    if (success) resolve(response);
                    else {
                        var completeErrorResponse = function() {
                            try {
                                message = ev.target.responseText;
                            } catch (e) {
                                message = response;
                            }
                            var error = new Error(message);
                            error.code = ev.target.status;
                            error.response = response;
                            reject(error);
                        };
                        if (xhr.status === 0) // Use setTimeout to push this code block onto the event queue
                        // This allows `xhr.ontimeout` to run in the case that there is a timeout
                        // Without this setTimeout, `xhr.ontimeout` doesn't have a chance to reject
                        // as `xhr.onreadystatechange` will run before it
                        setTimeout(function() {
                            if (isTimeout) return;
                            completeErrorResponse();
                        });
                        else completeErrorResponse();
                    }
                } catch (e) {
                    reject(e);
                }
            };
            xhr.ontimeout = function(ev) {
                isTimeout = true;
                var error = new Error("Request timed out");
                error.code = ev.target.status;
                reject(error);
            };
            if (typeof args.config === "function") {
                xhr = args.config(xhr, args, url) || xhr;
                // Propagate the `abort` to any replacement XHR as well.
                if (xhr !== original) {
                    replacedAbort = xhr.abort;
                    xhr.abort = function() {
                        aborted = true;
                        replacedAbort.call(this);
                    };
                }
            }
            if (body == null) xhr.send();
            else if (typeof args.serialize === "function") xhr.send(args.serialize(body));
            else if (body instanceof $window.FormData || body instanceof $window.URLSearchParams) xhr.send(body);
            else xhr.send(JSON.stringify(body));
        }),
        jsonp: makeRequest(function(url, args, resolve, reject) {
            var callbackName = args.callbackName || "_mithril_" + Math.round(Math.random() * 1e16) + "_" + callbackCount++;
            var script = $window.document.createElement("script");
            $window[callbackName] = function(data) {
                delete $window[callbackName];
                script.parentNode.removeChild(script);
                resolve(data);
            };
            script.onerror = function() {
                delete $window[callbackName];
                script.parentNode.removeChild(script);
                reject(new Error("JSONP request failed"));
            };
            script.src = url + (url.indexOf("?") < 0 ? "?" : "&") + encodeURIComponent(args.callbackKey || "callback") + "=" + encodeURIComponent(callbackName);
            $window.document.documentElement.appendChild(script);
        })
    };
};

});
parcelRegister("dVi4w", function(module, exports) {
"use strict";

var $4TqxV = parcelRequire("4TqxV");

var $h7Myx = parcelRequire("h7Myx");
// Returns `path` from `template` + `params`
module.exports = function(template, params) {
    if (/:([^\/\.-]+)(\.{3})?:/.test(template)) throw new SyntaxError("Template parameter names must be separated by either a '/', '-', or '.'.");
    if (params == null) return template;
    var queryIndex = template.indexOf("?");
    var hashIndex = template.indexOf("#");
    var queryEnd = hashIndex < 0 ? template.length : hashIndex;
    var pathEnd = queryIndex < 0 ? queryEnd : queryIndex;
    var path = template.slice(0, pathEnd);
    var query = {};
    $h7Myx(query, params);
    var resolved = path.replace(/:([^\/\.-]+)(\.{3})?/g, function(m, key, variadic) {
        delete query[key];
        // If no such parameter exists, don't interpolate it.
        if (params[key] == null) return m;
        // Escape normal parameters, but not variadic ones.
        return variadic ? params[key] : encodeURIComponent(String(params[key]));
    });
    // In case the template substitution adds new query/hash parameters.
    var newQueryIndex = resolved.indexOf("?");
    var newHashIndex = resolved.indexOf("#");
    var newQueryEnd = newHashIndex < 0 ? resolved.length : newHashIndex;
    var newPathEnd = newQueryIndex < 0 ? newQueryEnd : newQueryIndex;
    var result = resolved.slice(0, newPathEnd);
    if (queryIndex >= 0) result += template.slice(queryIndex, queryEnd);
    if (newQueryIndex >= 0) result += (queryIndex < 0 ? "?" : "&") + resolved.slice(newQueryIndex, newQueryEnd);
    var querystring = $4TqxV(query);
    if (querystring) result += (queryIndex < 0 && newQueryIndex < 0 ? "?" : "&") + querystring;
    if (hashIndex >= 0) result += template.slice(hashIndex);
    if (newHashIndex >= 0) result += (hashIndex < 0 ? "" : "&") + resolved.slice(newHashIndex);
    return result;
};

});
parcelRegister("4TqxV", function(module, exports) {
"use strict";
module.exports = function(object) {
    if (Object.prototype.toString.call(object) !== "[object Object]") return "";
    var args = [];
    for(var key in object)destructure(key, object[key]);
    return args.join("&");
    function destructure(key, value) {
        if (Array.isArray(value)) for(var i = 0; i < value.length; i++)destructure(key + "[" + i + "]", value[i]);
        else if (Object.prototype.toString.call(value) === "[object Object]") for(var i in value)destructure(key + "[" + i + "]", value[i]);
        else args.push(encodeURIComponent(key) + (value != null && value !== "" ? "=" + encodeURIComponent(value) : ""));
    }
};

});

parcelRegister("h7Myx", function(module, exports) {
// This exists so I'm only saving it once.
"use strict";

var $iMmVV = parcelRequire("iMmVV");
module.exports = Object.assign || function(target, source) {
    for(var key in source)if ($iMmVV.call(source, key)) target[key] = source[key];
};

});
parcelRegister("iMmVV", function(module, exports) {
// This exists so I'm only saving it once.
"use strict";
module.exports = ({}).hasOwnProperty;

});




parcelRegister("5NN5g", function(module, exports) {
"use strict";

var $gA8yJ = parcelRequire("gA8yJ");

module.exports = (parcelRequire("ePx9u"))(typeof window !== "undefined" ? window : null, $gA8yJ);

});
parcelRegister("gA8yJ", function(module, exports) {
"use strict";

var $03gNt = parcelRequire("03gNt");

module.exports = (parcelRequire("fTDI2"))($03gNt, typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : null, typeof console !== "undefined" ? console : null);

});

parcelRegister("ePx9u", function(module, exports) {
"use strict";

var $8JOml = parcelRequire("8JOml");

var $fMiaA = parcelRequire("fMiaA");

var $9JY0H = parcelRequire("9JY0H");

var $dVi4w = parcelRequire("dVi4w");

var $rLlma = parcelRequire("rLlma");

var $7QD8F = parcelRequire("7QD8F");

var $h7Myx = parcelRequire("h7Myx");

var $g0xgq = parcelRequire("g0xgq");
var $acbf8b64f436baf6$var$sentinel = {};
function $acbf8b64f436baf6$var$decodeURIComponentSave(component) {
    try {
        return decodeURIComponent(component);
    } catch (e) {
        return component;
    }
}
module.exports = function($window, mountRedraw) {
    var callAsync = $window == null ? null : typeof $window.setImmediate === "function" ? $window.setImmediate : $window.setTimeout;
    var p = $9JY0H.resolve();
    var scheduled = false;
    // state === 0: init
    // state === 1: scheduled
    // state === 2: done
    var ready = false;
    var state = 0;
    var compiled, fallbackRoute;
    var currentResolver = $acbf8b64f436baf6$var$sentinel, component, attrs, currentPath, lastUpdate;
    var RouterRoot = {
        onbeforeupdate: function() {
            state = state ? 2 : 1;
            return !(!state || $acbf8b64f436baf6$var$sentinel === currentResolver);
        },
        onremove: function() {
            $window.removeEventListener("popstate", fireAsync, false);
            $window.removeEventListener("hashchange", resolveRoute, false);
        },
        view: function() {
            if (!state || $acbf8b64f436baf6$var$sentinel === currentResolver) return;
            // Wrap in a fragment to preserve existing key semantics
            var vnode = [
                $8JOml(component, attrs.key, attrs)
            ];
            if (currentResolver) vnode = currentResolver.render(vnode[0]);
            return vnode;
        }
    };
    var SKIP = route.SKIP = {};
    function resolveRoute() {
        scheduled = false;
        // Consider the pathname holistically. The prefix might even be invalid,
        // but that's not our problem.
        var prefix = $window.location.hash;
        if (route.prefix[0] !== "#") {
            prefix = $window.location.search + prefix;
            if (route.prefix[0] !== "?") {
                prefix = $window.location.pathname + prefix;
                if (prefix[0] !== "/") prefix = "/" + prefix;
            }
        }
        // This seemingly useless `.concat()` speeds up the tests quite a bit,
        // since the representation is consistently a relatively poorly
        // optimized cons string.
        var path = prefix.concat().replace(/(?:%[a-f89][a-f0-9])+/gim, $acbf8b64f436baf6$var$decodeURIComponentSave).slice(route.prefix.length);
        var data = $rLlma(path);
        $h7Myx(data.params, $window.history.state);
        function reject(e) {
            console.error(e);
            setPath(fallbackRoute, null, {
                replace: true
            });
        }
        loop(0);
        function loop(i) {
            // state === 0: init
            // state === 1: scheduled
            // state === 2: done
            for(; i < compiled.length; i++)if (compiled[i].check(data)) {
                var payload = compiled[i].component;
                var matchedRoute = compiled[i].route;
                var localComp = payload;
                var update = lastUpdate = function(comp) {
                    if (update !== lastUpdate) return;
                    if (comp === SKIP) return loop(i + 1);
                    component = comp != null && (typeof comp.view === "function" || typeof comp === "function") ? comp : "div";
                    attrs = data.params, currentPath = path, lastUpdate = null;
                    currentResolver = payload.render ? payload : null;
                    if (state === 2) mountRedraw.redraw();
                    else {
                        state = 2;
                        mountRedraw.redraw.sync();
                    }
                };
                // There's no understating how much I *wish* I could
                // use `async`/`await` here...
                if (payload.view || typeof payload === "function") {
                    payload = {};
                    update(localComp);
                } else if (payload.onmatch) p.then(function() {
                    return payload.onmatch(data.params, path, matchedRoute);
                }).then(update, path === fallbackRoute ? null : reject);
                else update("div");
                return;
            }
            if (path === fallbackRoute) throw new Error("Could not resolve default route " + fallbackRoute + ".");
            setPath(fallbackRoute, null, {
                replace: true
            });
        }
    }
    // Set it unconditionally so `m.route.set` and `m.route.Link` both work,
    // even if neither `pushState` nor `hashchange` are supported. It's
    // cleared if `hashchange` is used, since that makes it automatically
    // async.
    function fireAsync() {
        if (!scheduled) {
            scheduled = true;
            // TODO: just do `mountRedraw.redraw()` here and elide the timer
            // dependency. Note that this will muck with tests a *lot*, so it's
            // not as easy of a change as it sounds.
            callAsync(resolveRoute);
        }
    }
    function setPath(path, data, options) {
        path = $dVi4w(path, data);
        if (ready) {
            fireAsync();
            var state = options ? options.state : null;
            var title = options ? options.title : null;
            if (options && options.replace) $window.history.replaceState(state, title, route.prefix + path);
            else $window.history.pushState(state, title, route.prefix + path);
        } else $window.location.href = route.prefix + path;
    }
    function route(root, defaultRoute, routes) {
        if (!root) throw new TypeError("DOM element being rendered to does not exist.");
        compiled = Object.keys(routes).map(function(route) {
            if (route[0] !== "/") throw new SyntaxError("Routes must start with a '/'.");
            if (/:([^\/\.-]+)(\.{3})?:/.test(route)) throw new SyntaxError("Route parameter names must be separated with either '/', '.', or '-'.");
            return {
                route: route,
                component: routes[route],
                check: $7QD8F(route)
            };
        });
        fallbackRoute = defaultRoute;
        if (defaultRoute != null) {
            var defaultData = $rLlma(defaultRoute);
            if (!compiled.some(function(i) {
                return i.check(defaultData);
            })) throw new ReferenceError("Default route doesn't match any known routes.");
        }
        if (typeof $window.history.pushState === "function") $window.addEventListener("popstate", fireAsync, false);
        else if (route.prefix[0] === "#") $window.addEventListener("hashchange", resolveRoute, false);
        ready = true;
        mountRedraw.mount(root, RouterRoot);
        resolveRoute();
    }
    route.set = function(path, data, options) {
        if (lastUpdate != null) {
            options = options || {};
            options.replace = true;
        }
        lastUpdate = null;
        setPath(path, data, options);
    };
    route.get = function() {
        return currentPath;
    };
    route.prefix = "#!";
    route.Link = {
        view: function(vnode) {
            // Omit the used parameters from the rendered element - they are
            // internal. Also, censor the various lifecycle methods.
            //
            // We don't strip the other parameters because for convenience we
            // let them be specified in the selector as well.
            var child = $fMiaA(vnode.attrs.selector || "a", $g0xgq(vnode.attrs, [
                "options",
                "params",
                "selector",
                "onclick"
            ]), vnode.children);
            var options, onclick, href;
            // Let's provide a *right* way to disable a route link, rather than
            // letting people screw up accessibility on accident.
            //
            // The attribute is coerced so users don't get surprised over
            // `disabled: 0` resulting in a button that's somehow routable
            // despite being visibly disabled.
            if (child.attrs.disabled = Boolean(child.attrs.disabled)) {
                child.attrs.href = null;
                child.attrs["aria-disabled"] = "true";
            // If you *really* do want add `onclick` on a disabled link, use
            // an `oncreate` hook to add it.
            } else {
                options = vnode.attrs.options;
                onclick = vnode.attrs.onclick;
                // Easier to build it now to keep it isomorphic.
                href = $dVi4w(child.attrs.href, vnode.attrs.params);
                child.attrs.href = route.prefix + href;
                child.attrs.onclick = function(e) {
                    var result;
                    if (typeof onclick === "function") result = onclick.call(e.currentTarget, e);
                    else if (onclick == null || typeof onclick !== "object") ;
                    else if (typeof onclick.handleEvent === "function") onclick.handleEvent(e);
                    // Adapted from React Router's implementation:
                    // https://github.com/ReactTraining/react-router/blob/520a0acd48ae1b066eb0b07d6d4d1790a1d02482/packages/react-router-dom/modules/Link.js
                    //
                    // Try to be flexible and intuitive in how we handle links.
                    // Fun fact: links aren't as obvious to get right as you
                    // would expect. There's a lot more valid ways to click a
                    // link than this, and one might want to not simply click a
                    // link, but right click or command-click it to copy the
                    // link target, etc. Nope, this isn't just for blind people.
                    if (// Skip if `onclick` prevented default
                    result !== false && !e.defaultPrevented && // Ignore everything but left clicks
                    (e.button === 0 || e.which === 0 || e.which === 1) && // Let the browser handle `target=_blank`, etc.
                    (!e.currentTarget.target || e.currentTarget.target === "_self") && // No modifier keys
                    !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey) {
                        e.preventDefault();
                        e.redraw = false;
                        route.set(href, null, options);
                    }
                };
            }
            return child;
        }
    };
    route.param = function(key) {
        return attrs && key != null ? attrs[key] : attrs;
    };
    return route;
};

});
parcelRegister("fMiaA", function(module, exports) {
"use strict";

var $8JOml = parcelRequire("8JOml");

var $jPPUy = parcelRequire("jPPUy");

var $iMmVV = parcelRequire("iMmVV");
var $b7c96ede0f95238b$var$selectorParser = /(?:(^|#|\.)([^#\.\[\]]+))|(\[(.+?)(?:\s*=\s*("|'|)((?:\\["'\]]|.)*?)\5)?\])/g;
var $b7c96ede0f95238b$var$selectorCache = {};
function $b7c96ede0f95238b$var$isEmpty(object) {
    for(var key in object)if ($iMmVV.call(object, key)) return false;
    return true;
}
function $b7c96ede0f95238b$var$compileSelector(selector) {
    var match, tag = "div", classes = [], attrs = {};
    while(match = $b7c96ede0f95238b$var$selectorParser.exec(selector)){
        var type = match[1], value = match[2];
        if (type === "" && value !== "") tag = value;
        else if (type === "#") attrs.id = value;
        else if (type === ".") classes.push(value);
        else if (match[3][0] === "[") {
            var attrValue = match[6];
            if (attrValue) attrValue = attrValue.replace(/\\(["'])/g, "$1").replace(/\\\\/g, "\\");
            if (match[4] === "class") classes.push(attrValue);
            else attrs[match[4]] = attrValue === "" ? attrValue : attrValue || true;
        }
    }
    if (classes.length > 0) attrs.className = classes.join(" ");
    return $b7c96ede0f95238b$var$selectorCache[selector] = {
        tag: tag,
        attrs: attrs
    };
}
function $b7c96ede0f95238b$var$execSelector(state, vnode) {
    var attrs = vnode.attrs;
    var hasClass = $iMmVV.call(attrs, "class");
    var className = hasClass ? attrs.class : attrs.className;
    vnode.tag = state.tag;
    vnode.attrs = {};
    if (!$b7c96ede0f95238b$var$isEmpty(state.attrs) && !$b7c96ede0f95238b$var$isEmpty(attrs)) {
        var newAttrs = {};
        for(var key in attrs)if ($iMmVV.call(attrs, key)) newAttrs[key] = attrs[key];
        attrs = newAttrs;
    }
    for(var key in state.attrs)if ($iMmVV.call(state.attrs, key) && key !== "className" && !$iMmVV.call(attrs, key)) attrs[key] = state.attrs[key];
    if (className != null || state.attrs.className != null) attrs.className = className != null ? state.attrs.className != null ? String(state.attrs.className) + " " + String(className) : className : state.attrs.className != null ? state.attrs.className : null;
    if (hasClass) attrs.class = null;
    for(var key in attrs)if ($iMmVV.call(attrs, key) && key !== "key") {
        vnode.attrs = attrs;
        break;
    }
    return vnode;
}
function $b7c96ede0f95238b$var$hyperscript(selector) {
    if (selector == null || typeof selector !== "string" && typeof selector !== "function" && typeof selector.view !== "function") throw Error("The selector must be either a string or a component.");
    var vnode = $jPPUy.apply(1, arguments);
    if (typeof selector === "string") {
        vnode.children = $8JOml.normalizeChildren(vnode.children);
        if (selector !== "[") return $b7c96ede0f95238b$var$execSelector($b7c96ede0f95238b$var$selectorCache[selector] || $b7c96ede0f95238b$var$compileSelector(selector), vnode);
    }
    vnode.tag = selector;
    return vnode;
}
module.exports = $b7c96ede0f95238b$var$hyperscript;

});

parcelRegister("9JY0H", function(module, exports) {
/* global window */ "use strict";

var $c0EvV = parcelRequire("c0EvV");
if (typeof window !== "undefined") {
    if (typeof window.Promise === "undefined") window.Promise = $c0EvV;
    else if (!window.Promise.prototype.finally) window.Promise.prototype.finally = $c0EvV.prototype.finally;
    module.exports = window.Promise;
} else if (typeof $parcel$global !== "undefined") {
    if (typeof $parcel$global.Promise === "undefined") $parcel$global.Promise = $c0EvV;
    else if (!$parcel$global.Promise.prototype.finally) $parcel$global.Promise.prototype.finally = $c0EvV.prototype.finally;
    module.exports = $parcel$global.Promise;
} else module.exports = $c0EvV;

});

parcelRegister("rLlma", function(module, exports) {
"use strict";

var $kRquH = parcelRequire("kRquH");
// Returns `{path, params}` from `url`
module.exports = function(url) {
    var queryIndex = url.indexOf("?");
    var hashIndex = url.indexOf("#");
    var queryEnd = hashIndex < 0 ? url.length : hashIndex;
    var pathEnd = queryIndex < 0 ? queryEnd : queryIndex;
    var path = url.slice(0, pathEnd).replace(/\/{2,}/g, "/");
    if (!path) path = "/";
    else {
        if (path[0] !== "/") path = "/" + path;
        if (path.length > 1 && path[path.length - 1] === "/") path = path.slice(0, -1);
    }
    return {
        path: path,
        params: queryIndex < 0 ? {} : $kRquH(url.slice(queryIndex + 1, queryEnd))
    };
};

});
parcelRegister("kRquH", function(module, exports) {
"use strict";
function $f2fd4f186228b319$var$decodeURIComponentSave(str) {
    try {
        return decodeURIComponent(str);
    } catch (err) {
        return str;
    }
}
module.exports = function(string) {
    if (string === "" || string == null) return {};
    if (string.charAt(0) === "?") string = string.slice(1);
    var entries = string.split("&"), counters = {}, data = {};
    for(var i = 0; i < entries.length; i++){
        var entry = entries[i].split("=");
        var key = $f2fd4f186228b319$var$decodeURIComponentSave(entry[0]);
        var value = entry.length === 2 ? $f2fd4f186228b319$var$decodeURIComponentSave(entry[1]) : "";
        if (value === "true") value = true;
        else if (value === "false") value = false;
        var levels = key.split(/\]\[?|\[/);
        var cursor = data;
        if (key.indexOf("[") > -1) levels.pop();
        for(var j = 0; j < levels.length; j++){
            var level = levels[j], nextLevel = levels[j + 1];
            var isNumber = nextLevel == "" || !isNaN(parseInt(nextLevel, 10));
            if (level === "") {
                var key = levels.slice(0, j).join();
                if (counters[key] == null) counters[key] = Array.isArray(cursor) ? cursor.length : 0;
                level = counters[key]++;
            } else if (level === "__proto__") break;
            if (j === levels.length - 1) cursor[level] = value;
            else {
                // Read own properties exclusively to disallow indirect
                // prototype pollution
                var desc = Object.getOwnPropertyDescriptor(cursor, level);
                if (desc != null) desc = desc.value;
                if (desc == null) cursor[level] = desc = isNumber ? [] : {};
                cursor = desc;
            }
        }
    }
    return data;
};

});


parcelRegister("7QD8F", function(module, exports) {
"use strict";

var $rLlma = parcelRequire("rLlma");
// Compiles a template into a function that takes a resolved path (without query
// strings) and returns an object containing the template parameters with their
// parsed values. This expects the input of the compiled template to be the
// output of `parsePathname`. Note that it does *not* remove query parameters
// specified in the template.
module.exports = function(template) {
    var templateData = $rLlma(template);
    var templateKeys = Object.keys(templateData.params);
    var keys = [];
    var regexp = new RegExp("^" + templateData.path.replace(// I escape literal text so people can use things like `:file.:ext` or
    // `:lang-:locale` in routes. This is all merged into one pass so I
    // don't also accidentally escape `-` and make it harder to detect it to
    // ban it from template parameters.
    /:([^\/.-]+)(\.{3}|\.(?!\.)|-)?|[\\^$*+.()|\[\]{}]/g, function(m, key, extra) {
        if (key == null) return "\\" + m;
        keys.push({
            k: key,
            r: extra === "..."
        });
        if (extra === "...") return "(.*)";
        if (extra === ".") return "([^/]+)\\.";
        return "([^/]+)" + (extra || "");
    }) + "$");
    return function(data) {
        // First, check the params. Usually, there isn't any, and it's just
        // checking a static set.
        for(var i = 0; i < templateKeys.length; i++){
            if (templateData.params[templateKeys[i]] !== data.params[templateKeys[i]]) return false;
        }
        // If no interpolations exist, let's skip all the ceremony
        if (!keys.length) return regexp.test(data.path);
        var values = regexp.exec(data.path);
        if (values == null) return false;
        for(var i = 0; i < keys.length; i++)data.params[keys[i].k] = keys[i].r ? values[i + 1] : decodeURIComponent(values[i + 1]);
        return true;
    };
};

});

parcelRegister("g0xgq", function(module, exports) {
"use strict";

var $iMmVV = parcelRequire("iMmVV");
// Words in RegExp literals are sometimes mangled incorrectly by the internal bundler, so use RegExp().
var $ba7672f68f21621e$var$magic = new RegExp("^(?:key|oninit|oncreate|onbeforeupdate|onupdate|onbeforeremove|onremove)$");
module.exports = function(attrs, extras) {
    var result = {};
    if (extras != null) {
        for(var key in attrs)if ($iMmVV.call(attrs, key) && !$ba7672f68f21621e$var$magic.test(key) && extras.indexOf(key) < 0) result[key] = attrs[key];
    } else {
        for(var key in attrs)if ($iMmVV.call(attrs, key) && !$ba7672f68f21621e$var$magic.test(key)) result[key] = attrs[key];
    }
    return result;
};

});



parcelRegister("f1bNS", function(module, exports) {
(function() {
    "use strict";
    /* eslint-enable */ Stream.SKIP = {};
    Stream.lift = lift;
    Stream.scan = scan;
    Stream.merge = merge;
    Stream.combine = combine;
    Stream.scanMerge = scanMerge;
    Stream["fantasy-land/of"] = Stream;
    var warnedHalt = false;
    Object.defineProperty(Stream, "HALT", {
        get: function() {
            warnedHalt || console.log("HALT is deprecated and has been renamed to SKIP");
            warnedHalt = true;
            return Stream.SKIP;
        }
    });
    function Stream(value) {
        var dependentStreams = [];
        var dependentFns = [];
        function stream(v) {
            if (arguments.length && v !== Stream.SKIP) {
                value = v;
                if (open(stream)) {
                    stream._changing();
                    stream._state = "active";
                    // Cloning the list to ensure it's still iterated in intended
                    // order
                    dependentStreams.slice().forEach(function(s, i) {
                        if (open(s)) s(this[i](value));
                    }, dependentFns.slice());
                }
            }
            return value;
        }
        stream.constructor = Stream;
        stream._state = arguments.length && value !== Stream.SKIP ? "active" : "pending";
        stream._parents = [];
        stream._changing = function() {
            if (open(stream)) stream._state = "changing";
            dependentStreams.forEach(function(s) {
                s._changing();
            });
        };
        stream._map = function(fn, ignoreInitial) {
            var target = ignoreInitial ? Stream() : Stream(fn(value));
            target._parents.push(stream);
            dependentStreams.push(target);
            dependentFns.push(fn);
            return target;
        };
        stream.map = function(fn) {
            return stream._map(fn, stream._state !== "active");
        };
        var end;
        function createEnd() {
            end = Stream();
            end.map(function(value) {
                if (value === true) {
                    stream._parents.forEach(function(p) {
                        p._unregisterChild(stream);
                    });
                    stream._state = "ended";
                    stream._parents.length = dependentStreams.length = dependentFns.length = 0;
                }
                return value;
            });
            return end;
        }
        stream.toJSON = function() {
            return value != null && typeof value.toJSON === "function" ? value.toJSON() : value;
        };
        stream["fantasy-land/map"] = stream.map;
        stream["fantasy-land/ap"] = function(x) {
            return combine(function(s1, s2) {
                return s1()(s2());
            }, [
                x,
                stream
            ]);
        };
        stream._unregisterChild = function(child) {
            var childIndex = dependentStreams.indexOf(child);
            if (childIndex !== -1) {
                dependentStreams.splice(childIndex, 1);
                dependentFns.splice(childIndex, 1);
            }
        };
        Object.defineProperty(stream, "end", {
            get: function() {
                return end || createEnd();
            }
        });
        return stream;
    }
    function combine(fn, streams) {
        var ready = streams.every(function(s) {
            if (s.constructor !== Stream) throw new Error("Ensure that each item passed to stream.combine/stream.merge/lift is a stream.");
            return s._state === "active";
        });
        var stream = ready ? Stream(fn.apply(null, streams.concat([
            streams
        ]))) : Stream();
        var changed = [];
        var mappers = streams.map(function(s) {
            return s._map(function(value) {
                changed.push(s);
                if (ready || streams.every(function(s) {
                    return s._state !== "pending";
                })) {
                    ready = true;
                    stream(fn.apply(null, streams.concat([
                        changed
                    ])));
                    changed = [];
                }
                return value;
            }, true);
        });
        var endStream = stream.end.map(function(value) {
            if (value === true) {
                mappers.forEach(function(mapper) {
                    mapper.end(true);
                });
                endStream.end(true);
            }
            return undefined;
        });
        return stream;
    }
    function merge(streams) {
        return combine(function() {
            return streams.map(function(s) {
                return s();
            });
        }, streams);
    }
    function scan(fn, acc, origin) {
        var stream = origin.map(function(v) {
            var next = fn(acc, v);
            if (next !== Stream.SKIP) acc = next;
            return next;
        });
        stream(acc);
        return stream;
    }
    function scanMerge(tuples, seed) {
        var streams = tuples.map(function(tuple) {
            return tuple[0];
        });
        var stream = combine(function() {
            var changed = arguments[arguments.length - 1];
            streams.forEach(function(stream, i) {
                if (changed.indexOf(stream) > -1) seed = tuples[i][1](seed, stream());
            });
            return seed;
        }, streams);
        stream(seed);
        return stream;
    }
    function lift() {
        var fn = arguments[0];
        var streams = Array.prototype.slice.call(arguments, 1);
        return merge(streams).map(function(streams) {
            return fn.apply(undefined, streams);
        });
    }
    function open(s) {
        return s._state === "pending" || s._state === "active" || s._state === "changing";
    }
    module.exports = Stream;
})();

});

parcelRegister("kWuxe", function(module, exports) {
/**
 * WEBMIDI.js v3.1.6
 * A JavaScript library to kickstart your MIDI projects
 * https://webmidijs.org
 * Build generated on June 4th, 2023.
 *
 * © Copyright 2015-2023, Jean-Philippe Côté.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */ 
var $17tgv = parcelRequire("17tgv");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
});
class EventEmitter {
    constructor(e = !1){
        this.eventMap = {}, this.eventsSuspended = 1 == e;
    }
    addListener(e, t, n = {}) {
        if ("string" == typeof e && e.length < 1 || e instanceof String && e.length < 1 || "string" != typeof e && !(e instanceof String) && e !== EventEmitter.ANY_EVENT) throw new TypeError("The 'event' parameter must be a string or EventEmitter.ANY_EVENT.");
        if ("function" != typeof t) throw new TypeError("The callback must be a function.");
        const r = new Listener(e, this, t, n);
        return this.eventMap[e] || (this.eventMap[e] = []), n.prepend ? this.eventMap[e].unshift(r) : this.eventMap[e].push(r), r;
    }
    addOneTimeListener(e, t, n = {}) {
        n.remaining = 1, this.addListener(e, t, n);
    }
    static get ANY_EVENT() {
        return Symbol.for("Any event");
    }
    hasListener(e, t) {
        if (void 0 === e) return !!(this.eventMap[EventEmitter.ANY_EVENT] && this.eventMap[EventEmitter.ANY_EVENT].length > 0) || Object.entries(this.eventMap).some(([, e])=>e.length > 0);
        if (this.eventMap[e] && this.eventMap[e].length > 0) {
            if (t instanceof Listener) return this.eventMap[e].filter((e)=>e === t).length > 0;
            if ("function" == typeof t) return this.eventMap[e].filter((e)=>e.callback === t).length > 0;
            return null == t;
        }
        return !1;
    }
    get eventNames() {
        return Object.keys(this.eventMap);
    }
    getListeners(e) {
        return this.eventMap[e] || [];
    }
    suspendEvent(e) {
        this.getListeners(e).forEach((e)=>{
            e.suspended = !0;
        });
    }
    unsuspendEvent(e) {
        this.getListeners(e).forEach((e)=>{
            e.suspended = !1;
        });
    }
    getListenerCount(e) {
        return this.getListeners(e).length;
    }
    emit(e, ...t) {
        if ("string" != typeof e && !(e instanceof String)) throw new TypeError("The 'event' parameter must be a string.");
        if (this.eventsSuspended) return;
        let n = [], r = this.eventMap[EventEmitter.ANY_EVENT] || [];
        return this.eventMap[e] && (r = r.concat(this.eventMap[e])), r.forEach((e)=>{
            if (e.suspended) return;
            let r = [
                ...t
            ];
            Array.isArray(e.arguments) && (r = r.concat(e.arguments)), e.remaining > 0 && (n.push(e.callback.apply(e.context, r)), e.count++), --e.remaining < 1 && e.remove();
        }), n;
    }
    removeListener(e, t, n = {}) {
        if (void 0 === e) return void (this.eventMap = {});
        if (!this.eventMap[e]) return;
        let r = this.eventMap[e].filter((e)=>t && e.callback !== t || n.remaining && n.remaining !== e.remaining || n.context && n.context !== e.context);
        r.length ? this.eventMap[e] = r : delete this.eventMap[e];
    }
    async waitFor(e, t = {}) {
        return t.duration = parseInt(t.duration), (isNaN(t.duration) || t.duration <= 0) && (t.duration = 1 / 0), new Promise((n, r)=>{
            let i, s = this.addListener(e, ()=>{
                clearTimeout(i), n();
            }, {
                remaining: 1
            });
            t.duration !== 1 / 0 && (i = setTimeout(()=>{
                s.remove(), r("The duration expired before the event was emitted.");
            }, t.duration));
        });
    }
    get eventCount() {
        return Object.keys(this.eventMap).length;
    }
}
class Listener {
    constructor(e, t, n, r = {}){
        if ("string" != typeof e && !(e instanceof String) && e !== EventEmitter.ANY_EVENT) throw new TypeError("The 'event' parameter must be a string or EventEmitter.ANY_EVENT.");
        if (!t) throw new ReferenceError("The 'target' parameter is mandatory.");
        if ("function" != typeof n) throw new TypeError("The 'callback' must be a function.");
        void 0 === r.arguments || Array.isArray(r.arguments) || (r.arguments = [
            r.arguments
        ]), (r = Object.assign({
            context: t,
            remaining: 1 / 0,
            arguments: void 0,
            duration: 1 / 0
        }, r)).duration !== 1 / 0 && setTimeout(()=>this.remove(), r.duration), this.arguments = r.arguments, this.callback = n, this.context = r.context, this.count = 0, this.event = e, this.remaining = parseInt(r.remaining) >= 1 ? parseInt(r.remaining) : 1 / 0, this.suspended = !1, this.target = t;
    }
    remove() {
        this.target.removeListener(this.event, this.callback, {
            context: this.context,
            remaining: this.remaining
        });
    }
}
/**
 * The `Enumerations` class contains enumerations and arrays of elements used throughout the
 * library. All its properties are static and should be referenced using the class name. For
 * example: `Enumerations.CHANNEL_MESSAGES`.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Enumerations {
    static get MIDI_CHANNEL_MESSAGES() {
        return this.validation && console.warn("The MIDI_CHANNEL_MESSAGES enum has been deprecated. Use the Enumerations.CHANNEL_MESSAGES enum instead."), Enumerations.CHANNEL_MESSAGES;
    }
    static get CHANNEL_MESSAGES() {
        return {
            noteoff: 8,
            noteon: 9,
            keyaftertouch: 10,
            controlchange: 11,
            programchange: 12,
            channelaftertouch: 13,
            pitchbend: 14
        };
    }
    static get CHANNEL_NUMBERS() {
        return [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16
        ];
    }
    static get MIDI_CHANNEL_NUMBERS() {
        return this.validation && console.warn("The MIDI_CHANNEL_NUMBERS array has been deprecated. Use the Enumerations.CHANNEL_NUMBERS array instead."), [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16
        ];
    }
    static get CHANNEL_MODE_MESSAGES() {
        return {
            allsoundoff: 120,
            resetallcontrollers: 121,
            localcontrol: 122,
            allnotesoff: 123,
            omnimodeoff: 124,
            omnimodeon: 125,
            monomodeon: 126,
            polymodeon: 127
        };
    }
    static get MIDI_CHANNEL_MODE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CHANNEL_MODE_MESSAGES enum has been deprecated. Use the Enumerations.CHANNEL_MODE_MESSAGES enum instead."), Enumerations.CHANNEL_MODE_MESSAGES;
    }
    static get MIDI_CONTROL_CHANGE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CONTROL_CHANGE_MESSAGES enum has been deprecated. Use the Enumerations.CONTROL_CHANGE_MESSAGES array instead."), {
            bankselectcoarse: 0,
            modulationwheelcoarse: 1,
            breathcontrollercoarse: 2,
            controller3: 3,
            footcontrollercoarse: 4,
            portamentotimecoarse: 5,
            dataentrycoarse: 6,
            volumecoarse: 7,
            balancecoarse: 8,
            controller9: 9,
            pancoarse: 10,
            expressioncoarse: 11,
            effectcontrol1coarse: 12,
            effectcontrol2coarse: 13,
            controller14: 14,
            controller15: 15,
            generalpurposeslider1: 16,
            generalpurposeslider2: 17,
            generalpurposeslider3: 18,
            generalpurposeslider4: 19,
            controller20: 20,
            controller21: 21,
            controller22: 22,
            controller23: 23,
            controller24: 24,
            controller25: 25,
            controller26: 26,
            controller27: 27,
            controller28: 28,
            controller29: 29,
            controller30: 30,
            controller31: 31,
            bankselectfine: 32,
            modulationwheelfine: 33,
            breathcontrollerfine: 34,
            controller35: 35,
            footcontrollerfine: 36,
            portamentotimefine: 37,
            dataentryfine: 38,
            volumefine: 39,
            balancefine: 40,
            controller41: 41,
            panfine: 42,
            expressionfine: 43,
            effectcontrol1fine: 44,
            effectcontrol2fine: 45,
            controller46: 46,
            controller47: 47,
            controller48: 48,
            controller49: 49,
            controller50: 50,
            controller51: 51,
            controller52: 52,
            controller53: 53,
            controller54: 54,
            controller55: 55,
            controller56: 56,
            controller57: 57,
            controller58: 58,
            controller59: 59,
            controller60: 60,
            controller61: 61,
            controller62: 62,
            controller63: 63,
            holdpedal: 64,
            portamento: 65,
            sustenutopedal: 66,
            softpedal: 67,
            legatopedal: 68,
            hold2pedal: 69,
            soundvariation: 70,
            resonance: 71,
            soundreleasetime: 72,
            soundattacktime: 73,
            brightness: 74,
            soundcontrol6: 75,
            soundcontrol7: 76,
            soundcontrol8: 77,
            soundcontrol9: 78,
            soundcontrol10: 79,
            generalpurposebutton1: 80,
            generalpurposebutton2: 81,
            generalpurposebutton3: 82,
            generalpurposebutton4: 83,
            controller84: 84,
            controller85: 85,
            controller86: 86,
            controller87: 87,
            controller88: 88,
            controller89: 89,
            controller90: 90,
            reverblevel: 91,
            tremololevel: 92,
            choruslevel: 93,
            celestelevel: 94,
            phaserlevel: 95,
            databuttonincrement: 96,
            databuttondecrement: 97,
            nonregisteredparametercoarse: 98,
            nonregisteredparameterfine: 99,
            registeredparametercoarse: 100,
            registeredparameterfine: 101,
            controller102: 102,
            controller103: 103,
            controller104: 104,
            controller105: 105,
            controller106: 106,
            controller107: 107,
            controller108: 108,
            controller109: 109,
            controller110: 110,
            controller111: 111,
            controller112: 112,
            controller113: 113,
            controller114: 114,
            controller115: 115,
            controller116: 116,
            controller117: 117,
            controller118: 118,
            controller119: 119,
            allsoundoff: 120,
            resetallcontrollers: 121,
            localcontrol: 122,
            allnotesoff: 123,
            omnimodeoff: 124,
            omnimodeon: 125,
            monomodeon: 126,
            polymodeon: 127
        };
    }
    static get CONTROL_CHANGE_MESSAGES() {
        return [
            {
                number: 0,
                name: "bankselectcoarse",
                description: "Bank Select (Coarse)",
                position: "msb"
            },
            {
                number: 1,
                name: "modulationwheelcoarse",
                description: "Modulation Wheel (Coarse)",
                position: "msb"
            },
            {
                number: 2,
                name: "breathcontrollercoarse",
                description: "Breath Controller (Coarse)",
                position: "msb"
            },
            {
                number: 3,
                name: "controller3",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 4,
                name: "footcontrollercoarse",
                description: "Foot Controller (Coarse)",
                position: "msb"
            },
            {
                number: 5,
                name: "portamentotimecoarse",
                description: "Portamento Time (Coarse)",
                position: "msb"
            },
            {
                number: 6,
                name: "dataentrycoarse",
                description: "Data Entry (Coarse)",
                position: "msb"
            },
            {
                number: 7,
                name: "volumecoarse",
                description: "Channel Volume (Coarse)",
                position: "msb"
            },
            {
                number: 8,
                name: "balancecoarse",
                description: "Balance (Coarse)",
                position: "msb"
            },
            {
                number: 9,
                name: "controller9",
                description: "Controller 9 (Coarse)",
                position: "msb"
            },
            {
                number: 10,
                name: "pancoarse",
                description: "Pan (Coarse)",
                position: "msb"
            },
            {
                number: 11,
                name: "expressioncoarse",
                description: "Expression Controller (Coarse)",
                position: "msb"
            },
            {
                number: 12,
                name: "effectcontrol1coarse",
                description: "Effect Control 1 (Coarse)",
                position: "msb"
            },
            {
                number: 13,
                name: "effectcontrol2coarse",
                description: "Effect Control 2 (Coarse)",
                position: "msb"
            },
            {
                number: 14,
                name: "controller14",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 15,
                name: "controller15",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 16,
                name: "generalpurposecontroller1",
                description: "General Purpose Controller 1 (Coarse)",
                position: "msb"
            },
            {
                number: 17,
                name: "generalpurposecontroller2",
                description: "General Purpose Controller 2 (Coarse)",
                position: "msb"
            },
            {
                number: 18,
                name: "generalpurposecontroller3",
                description: "General Purpose Controller 3 (Coarse)",
                position: "msb"
            },
            {
                number: 19,
                name: "generalpurposecontroller4",
                description: "General Purpose Controller 4 (Coarse)",
                position: "msb"
            },
            {
                number: 20,
                name: "controller20",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 21,
                name: "controller21",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 22,
                name: "controller22",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 23,
                name: "controller23",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 24,
                name: "controller24",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 25,
                name: "controller25",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 26,
                name: "controller26",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 27,
                name: "controller27",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 28,
                name: "controller28",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 29,
                name: "controller29",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 30,
                name: "controller30",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 31,
                name: "controller31",
                description: "Undefined",
                position: "msb"
            },
            {
                number: 32,
                name: "bankselectfine",
                description: "Bank Select (Fine)",
                position: "lsb"
            },
            {
                number: 33,
                name: "modulationwheelfine",
                description: "Modulation Wheel (Fine)",
                position: "lsb"
            },
            {
                number: 34,
                name: "breathcontrollerfine",
                description: "Breath Controller (Fine)",
                position: "lsb"
            },
            {
                number: 35,
                name: "controller35",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 36,
                name: "footcontrollerfine",
                description: "Foot Controller (Fine)",
                position: "lsb"
            },
            {
                number: 37,
                name: "portamentotimefine",
                description: "Portamento Time (Fine)",
                position: "lsb"
            },
            {
                number: 38,
                name: "dataentryfine",
                description: "Data Entry (Fine)",
                position: "lsb"
            },
            {
                number: 39,
                name: "channelvolumefine",
                description: "Channel Volume (Fine)",
                position: "lsb"
            },
            {
                number: 40,
                name: "balancefine",
                description: "Balance (Fine)",
                position: "lsb"
            },
            {
                number: 41,
                name: "controller41",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 42,
                name: "panfine",
                description: "Pan (Fine)",
                position: "lsb"
            },
            {
                number: 43,
                name: "expressionfine",
                description: "Expression Controller (Fine)",
                position: "lsb"
            },
            {
                number: 44,
                name: "effectcontrol1fine",
                description: "Effect control 1 (Fine)",
                position: "lsb"
            },
            {
                number: 45,
                name: "effectcontrol2fine",
                description: "Effect control 2 (Fine)",
                position: "lsb"
            },
            {
                number: 46,
                name: "controller46",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 47,
                name: "controller47",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 48,
                name: "controller48",
                description: "General Purpose Controller 1 (Fine)",
                position: "lsb"
            },
            {
                number: 49,
                name: "controller49",
                description: "General Purpose Controller 2 (Fine)",
                position: "lsb"
            },
            {
                number: 50,
                name: "controller50",
                description: "General Purpose Controller 3 (Fine)",
                position: "lsb"
            },
            {
                number: 51,
                name: "controller51",
                description: "General Purpose Controller 4 (Fine)",
                position: "lsb"
            },
            {
                number: 52,
                name: "controller52",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 53,
                name: "controller53",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 54,
                name: "controller54",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 55,
                name: "controller55",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 56,
                name: "controller56",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 57,
                name: "controller57",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 58,
                name: "controller58",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 59,
                name: "controller59",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 60,
                name: "controller60",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 61,
                name: "controller61",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 62,
                name: "controller62",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 63,
                name: "controller63",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 64,
                name: "damperpedal",
                description: "Damper Pedal On/Off"
            },
            {
                number: 65,
                name: "portamento",
                description: "Portamento On/Off"
            },
            {
                number: 66,
                name: "sostenuto",
                description: "Sostenuto On/Off"
            },
            {
                number: 67,
                name: "softpedal",
                description: "Soft Pedal On/Off"
            },
            {
                number: 68,
                name: "legatopedal",
                description: "Legato Pedal On/Off"
            },
            {
                number: 69,
                name: "hold2",
                description: "Hold 2 On/Off"
            },
            {
                number: 70,
                name: "soundvariation",
                description: "Sound Variation",
                position: "lsb"
            },
            {
                number: 71,
                name: "resonance",
                description: "Resonance",
                position: "lsb"
            },
            {
                number: 72,
                name: "releasetime",
                description: "Release Time",
                position: "lsb"
            },
            {
                number: 73,
                name: "attacktime",
                description: "Attack Time",
                position: "lsb"
            },
            {
                number: 74,
                name: "brightness",
                description: "Brightness",
                position: "lsb"
            },
            {
                number: 75,
                name: "decaytime",
                description: "Decay Time",
                position: "lsb"
            },
            {
                number: 76,
                name: "vibratorate",
                description: "Vibrato Rate",
                position: "lsb"
            },
            {
                number: 77,
                name: "vibratodepth",
                description: "Vibrato Depth",
                position: "lsb"
            },
            {
                number: 78,
                name: "vibratodelay",
                description: "Vibrato Delay",
                position: "lsb"
            },
            {
                number: 79,
                name: "controller79",
                description: "Undefined",
                position: "lsb"
            },
            {
                number: 80,
                name: "generalpurposecontroller5",
                description: "General Purpose Controller 5",
                position: "lsb"
            },
            {
                number: 81,
                name: "generalpurposecontroller6",
                description: "General Purpose Controller 6",
                position: "lsb"
            },
            {
                number: 82,
                name: "generalpurposecontroller7",
                description: "General Purpose Controller 7",
                position: "lsb"
            },
            {
                number: 83,
                name: "generalpurposecontroller8",
                description: "General Purpose Controller 8",
                position: "lsb"
            },
            {
                number: 84,
                name: "portamentocontrol",
                description: "Portamento Control",
                position: "lsb"
            },
            {
                number: 85,
                name: "controller85",
                description: "Undefined"
            },
            {
                number: 86,
                name: "controller86",
                description: "Undefined"
            },
            {
                number: 87,
                name: "controller87",
                description: "Undefined"
            },
            {
                number: 88,
                name: "highresolutionvelocityprefix",
                description: "High Resolution Velocity Prefix",
                position: "lsb"
            },
            {
                number: 89,
                name: "controller89",
                description: "Undefined"
            },
            {
                number: 90,
                name: "controller90",
                description: "Undefined"
            },
            {
                number: 91,
                name: "effect1depth",
                description: "Effects 1 Depth (Reverb Send Level)"
            },
            {
                number: 92,
                name: "effect2depth",
                description: "Effects 2 Depth"
            },
            {
                number: 93,
                name: "effect3depth",
                description: "Effects 3 Depth (Chorus Send Level)"
            },
            {
                number: 94,
                name: "effect4depth",
                description: "Effects 4 Depth"
            },
            {
                number: 95,
                name: "effect5depth",
                description: "Effects 5 Depth"
            },
            {
                number: 96,
                name: "dataincrement",
                description: "Data Increment"
            },
            {
                number: 97,
                name: "datadecrement",
                description: "Data Decrement"
            },
            {
                number: 98,
                name: "nonregisteredparameterfine",
                description: "Non-Registered Parameter Number (Fine)",
                position: "lsb"
            },
            {
                number: 99,
                name: "nonregisteredparametercoarse",
                description: "Non-Registered Parameter Number (Coarse)",
                position: "msb"
            },
            {
                number: 100,
                name: "registeredparameterfine",
                description: "Registered Parameter Number (Fine)",
                position: "lsb"
            },
            {
                number: 101,
                name: "registeredparametercoarse",
                description: "Registered Parameter Number (Coarse)",
                position: "msb"
            },
            {
                number: 102,
                name: "controller102",
                description: "Undefined"
            },
            {
                number: 103,
                name: "controller103",
                description: "Undefined"
            },
            {
                number: 104,
                name: "controller104",
                description: "Undefined"
            },
            {
                number: 105,
                name: "controller105",
                description: "Undefined"
            },
            {
                number: 106,
                name: "controller106",
                description: "Undefined"
            },
            {
                number: 107,
                name: "controller107",
                description: "Undefined"
            },
            {
                number: 108,
                name: "controller108",
                description: "Undefined"
            },
            {
                number: 109,
                name: "controller109",
                description: "Undefined"
            },
            {
                number: 110,
                name: "controller110",
                description: "Undefined"
            },
            {
                number: 111,
                name: "controller111",
                description: "Undefined"
            },
            {
                number: 112,
                name: "controller112",
                description: "Undefined"
            },
            {
                number: 113,
                name: "controller113",
                description: "Undefined"
            },
            {
                number: 114,
                name: "controller114",
                description: "Undefined"
            },
            {
                number: 115,
                name: "controller115",
                description: "Undefined"
            },
            {
                number: 116,
                name: "controller116",
                description: "Undefined"
            },
            {
                number: 117,
                name: "controller117",
                description: "Undefined"
            },
            {
                number: 118,
                name: "controller118",
                description: "Undefined"
            },
            {
                number: 119,
                name: "controller119",
                description: "Undefined"
            },
            {
                number: 120,
                name: "allsoundoff",
                description: "All Sound Off"
            },
            {
                number: 121,
                name: "resetallcontrollers",
                description: "Reset All Controllers"
            },
            {
                number: 122,
                name: "localcontrol",
                description: "Local Control On/Off"
            },
            {
                number: 123,
                name: "allnotesoff",
                description: "All Notes Off"
            },
            {
                number: 124,
                name: "omnimodeoff",
                description: "Omni Mode Off"
            },
            {
                number: 125,
                name: "omnimodeon",
                description: "Omni Mode On"
            },
            {
                number: 126,
                name: "monomodeon",
                description: "Mono Mode On"
            },
            {
                number: 127,
                name: "polymodeon",
                description: "Poly Mode On"
            }
        ];
    }
    static get REGISTERED_PARAMETERS() {
        return {
            pitchbendrange: [
                0,
                0
            ],
            channelfinetuning: [
                0,
                1
            ],
            channelcoarsetuning: [
                0,
                2
            ],
            tuningprogram: [
                0,
                3
            ],
            tuningbank: [
                0,
                4
            ],
            modulationrange: [
                0,
                5
            ],
            azimuthangle: [
                61,
                0
            ],
            elevationangle: [
                61,
                1
            ],
            gain: [
                61,
                2
            ],
            distanceratio: [
                61,
                3
            ],
            maximumdistance: [
                61,
                4
            ],
            maximumdistancegain: [
                61,
                5
            ],
            referencedistanceratio: [
                61,
                6
            ],
            panspreadangle: [
                61,
                7
            ],
            rollangle: [
                61,
                8
            ]
        };
    }
    static get MIDI_REGISTERED_PARAMETERS() {
        return this.validation && console.warn("The MIDI_REGISTERED_PARAMETERS enum has been deprecated. Use the Enumerations.REGISTERED_PARAMETERS enum instead."), Enumerations.MIDI_REGISTERED_PARAMETERS;
    }
    static get SYSTEM_MESSAGES() {
        return {
            sysex: 240,
            timecode: 241,
            songposition: 242,
            songselect: 243,
            tunerequest: 246,
            tuningrequest: 246,
            sysexend: 247,
            clock: 248,
            start: 250,
            continue: 251,
            stop: 252,
            activesensing: 254,
            reset: 255,
            midimessage: 0,
            unknownsystemmessage: -1
        };
    }
    static get MIDI_SYSTEM_MESSAGES() {
        return this.validation && console.warn("The MIDI_SYSTEM_MESSAGES enum has been deprecated. Use the Enumerations.SYSTEM_MESSAGES enum instead."), Enumerations.SYSTEM_MESSAGES;
    }
    static get CHANNEL_EVENTS() {
        return [
            "noteoff",
            "controlchange",
            "noteon",
            "keyaftertouch",
            "programchange",
            "channelaftertouch",
            "pitchbend",
            "allnotesoff",
            "allsoundoff",
            "localcontrol",
            "monomode",
            "omnimode",
            "resetallcontrollers",
            "nrpn",
            "nrpn-dataentrycoarse",
            "nrpn-dataentryfine",
            "nrpn-dataincrement",
            "nrpn-datadecrement",
            "rpn",
            "rpn-dataentrycoarse",
            "rpn-dataentryfine",
            "rpn-dataincrement",
            "rpn-datadecrement",
            "nrpn-databuttonincrement",
            "nrpn-databuttondecrement",
            "rpn-databuttonincrement",
            "rpn-databuttondecrement"
        ];
    }
}
/**
 * The `Note` class represents a single musical note such as `"D3"`, `"G#4"`, `"F-1"`, `"Gb7"`, etc.
 *
 * `Note` objects can be played back on a single channel by calling
 * [`OutputChannel.playNote()`]{@link OutputChannel#playNote} or, on multiple channels of the same
 * output, by calling [`Output.playNote()`]{@link Output#playNote}.
 *
 * The note has [`attack`](#attack) and [`release`](#release) velocities set at `0.5` by default.
 * These can be changed by passing in the appropriate option. It is also possible to set a
 * system-wide default for attack and release velocities by using the
 * [`WebMidi.defaults`](WebMidi#defaults) property.
 *
 * If you prefer to work with raw MIDI values (`0` to `127`), you can use [`rawAttack`](#rawAttack) and
 * [`rawRelease`](#rawRelease) to both get and set the values.
 *
 * The note may have a [`duration`](#duration). If it does, playback will be automatically stopped
 * when the duration has elapsed by sending a `"noteoff"` event. By default, the duration is set to
 * `Infinity`. In this case, it will never stop playing unless explicitly stopped by calling a
 * method such as [`OutputChannel.stopNote()`]{@link OutputChannel#stopNote},
 * [`Output.stopNote()`]{@link Output#stopNote} or similar.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Note {
    constructor(e, t = {}){
        this.duration = wm.defaults.note.duration, this.attack = wm.defaults.note.attack, this.release = wm.defaults.note.release, null != t.duration && (this.duration = t.duration), null != t.attack && (this.attack = t.attack), null != t.rawAttack && (this.attack = Utilities.from7bitToFloat(t.rawAttack)), null != t.release && (this.release = t.release), null != t.rawRelease && (this.release = Utilities.from7bitToFloat(t.rawRelease)), Number.isInteger(e) ? this.identifier = Utilities.toNoteIdentifier(e) : this.identifier = e;
    }
    get identifier() {
        return this._name + (this._accidental || "") + this._octave;
    }
    set identifier(e) {
        const t = Utilities.getNoteDetails(e);
        if (wm.validation && !e) throw new Error("Invalid note identifier");
        this._name = t.name, this._accidental = t.accidental, this._octave = t.octave;
    }
    get name() {
        return this._name;
    }
    set name(e) {
        if (wm.validation && (e = e.toUpperCase(), ![
            "C",
            "D",
            "E",
            "F",
            "G",
            "A",
            "B"
        ].includes(e))) throw new Error("Invalid name value");
        this._name = e;
    }
    get accidental() {
        return this._accidental;
    }
    set accidental(e) {
        if (wm.validation && (e = e.toLowerCase(), ![
            "#",
            "##",
            "b",
            "bb"
        ].includes(e))) throw new Error("Invalid accidental value");
        this._accidental = e;
    }
    get octave() {
        return this._octave;
    }
    set octave(e) {
        if (wm.validation && (e = parseInt(e), isNaN(e))) throw new Error("Invalid octave value");
        this._octave = e;
    }
    get duration() {
        return this._duration;
    }
    set duration(e) {
        if (wm.validation && (e = parseFloat(e), isNaN(e) || null === e || e < 0)) throw new RangeError("Invalid duration value.");
        this._duration = e;
    }
    get attack() {
        return this._attack;
    }
    set attack(e) {
        if (wm.validation && (e = parseFloat(e), isNaN(e) || !(e >= 0 && e <= 1))) throw new RangeError("Invalid attack value.");
        this._attack = e;
    }
    get release() {
        return this._release;
    }
    set release(e) {
        if (wm.validation && (e = parseFloat(e), isNaN(e) || !(e >= 0 && e <= 1))) throw new RangeError("Invalid release value.");
        this._release = e;
    }
    get rawAttack() {
        return Utilities.fromFloatTo7Bit(this._attack);
    }
    set rawAttack(e) {
        this._attack = Utilities.from7bitToFloat(e);
    }
    get rawRelease() {
        return Utilities.fromFloatTo7Bit(this._release);
    }
    set rawRelease(e) {
        this._release = Utilities.from7bitToFloat(e);
    }
    get number() {
        return Utilities.toNoteNumber(this.identifier);
    }
    getOffsetNumber(e = 0, t = 0) {
        return wm.validation && (e = parseInt(e) || 0, t = parseInt(t) || 0), Math.min(Math.max(this.number + 12 * e + t, 0), 127);
    }
}
/**
 * The `Utilities` class contains general-purpose utility methods. All methods are static and
 * should be called using the class name. For example: `Utilities.getNoteDetails("C4")`.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Utilities {
    /**
   * Returns a MIDI note number matching the identifier passed in the form of a string. The
   * identifier must include the octave number. The identifier also optionally include a sharp (#),
   * a double sharp (##), a flat (b) or a double flat (bb) symbol. For example, these are all valid
   * identifiers: C5, G4, D#-1, F0, Gb7, Eb-1, Abb4, B##6, etc.
   *
   * When converting note identifiers to numbers, C4 is considered to be middle C (MIDI note number
   * 60) as per the scientific pitch notation standard.
   *
   * The resulting note number can be offset by using the `octaveOffset` parameter.
   *
   * @param identifier {string} The identifier in the form of a letter, followed by an optional "#",
   * "##", "b" or "bb" followed by the octave number. For exemple: C5, G4, D#-1, F0, Gb7, Eb-1,
   * Abb4, B##6, etc.
   *
   * @param {number} [octaveOffset=0] A integer to offset the octave by.
   *
   * @returns {number} The MIDI note number (an integer between 0 and 127).
   *
   * @throws RangeError Invalid 'octaveOffset' value
   *
   * @throws TypeError Invalid note identifier
   *
   * @license Apache-2.0
   * @since 3.0.0
   * @static
   */ static toNoteNumber(e, t = 0) {
        if (t = null == t ? 0 : parseInt(t), isNaN(t)) throw new RangeError("Invalid 'octaveOffset' value");
        "string" != typeof e && (e = "");
        const n = this.getNoteDetails(e);
        if (!n) throw new TypeError("Invalid note identifier");
        let r = 12 * (n.octave + 1 + t);
        if (r += ({
            C: 0,
            D: 2,
            E: 4,
            F: 5,
            G: 7,
            A: 9,
            B: 11
        })[n.name], n.accidental && (n.accidental.startsWith("b") ? r -= n.accidental.length : r += n.accidental.length), r < 0 || r > 127) throw new RangeError("Invalid octaveOffset value");
        return r;
    }
    static getNoteDetails(e) {
        Number.isInteger(e) && (e = this.toNoteIdentifier(e));
        const t = e.match(/^([CDEFGAB])(#{0,2}|b{0,2})(-?\d+)$/i);
        if (!t) throw new TypeError("Invalid note identifier");
        const n = t[1].toUpperCase(), r = parseInt(t[3]);
        let i = t[2].toLowerCase();
        i = "" === i ? void 0 : i;
        return {
            accidental: i,
            identifier: n + (i || "") + r,
            name: n,
            octave: r
        };
    }
    static sanitizeChannels(e) {
        let t;
        if (wm.validation) {
            if ("all" === e) t = [
                "all"
            ];
            else if ("none" === e) return [];
        }
        return t = Array.isArray(e) ? e : [
            e
        ], t.indexOf("all") > -1 && (t = Enumerations.MIDI_CHANNEL_NUMBERS), t.map(function(e) {
            return parseInt(e);
        }).filter(function(e) {
            return e >= 1 && e <= 16;
        });
    }
    static toTimestamp(e) {
        let t = !1;
        const n = parseFloat(e);
        return !isNaN(n) && ("string" == typeof e && "+" === e.substring(0, 1) ? n >= 0 && (t = wm.time + n) : n >= 0 && (t = n), t);
    }
    static guessNoteNumber(e, t) {
        t = parseInt(t) || 0;
        let n = !1;
        if (Number.isInteger(e) && e >= 0 && e <= 127) n = parseInt(e);
        else if (parseInt(e) >= 0 && parseInt(e) <= 127) n = parseInt(e);
        else if ("string" == typeof e || e instanceof String) try {
            n = this.toNoteNumber(e.trim(), t);
        } catch (e) {
            return !1;
        }
        return n;
    }
    static toNoteIdentifier(e, t) {
        if (e = parseInt(e), isNaN(e) || e < 0 || e > 127) throw new RangeError("Invalid note number");
        if (t = null == t ? 0 : parseInt(t), isNaN(t)) throw new RangeError("Invalid octaveOffset value");
        const n = Math.floor(e / 12 - 1) + t;
        return [
            "C",
            "C#",
            "D",
            "D#",
            "E",
            "F",
            "F#",
            "G",
            "G#",
            "A",
            "A#",
            "B"
        ][e % 12] + n.toString();
    }
    static buildNote(e, t = {}) {
        if (t.octaveOffset = parseInt(t.octaveOffset) || 0, e instanceof Note) return e;
        let n = this.guessNoteNumber(e, t.octaveOffset);
        if (!1 === n) throw new TypeError(`The input could not be parsed as a note (${e})`);
        return t.octaveOffset = void 0, new Note(n, t);
    }
    static buildNoteArray(e, t = {}) {
        let n = [];
        return Array.isArray(e) || (e = [
            e
        ]), e.forEach((e)=>{
            n.push(this.buildNote(e, t));
        }), n;
    }
    static from7bitToFloat(e) {
        return e === 1 / 0 && (e = 127), e = parseInt(e) || 0, Math.min(Math.max(e / 127, 0), 1);
    }
    static fromFloatTo7Bit(e) {
        return e === 1 / 0 && (e = 1), e = parseFloat(e) || 0, Math.min(Math.max(Math.round(127 * e), 0), 127);
    }
    static fromMsbLsbToFloat(e, t = 0) {
        wm.validation && (e = Math.min(Math.max(parseInt(e) || 0, 0), 127), t = Math.min(Math.max(parseInt(t) || 0, 0), 127));
        const n = ((e << 7) + t) / 16383;
        return Math.min(Math.max(n, 0), 1);
    }
    static fromFloatToMsbLsb(e) {
        wm.validation && (e = Math.min(Math.max(parseFloat(e) || 0, 0), 1));
        const t = Math.round(16383 * e);
        return {
            msb: t >> 7,
            lsb: 127 & t
        };
    }
    static offsetNumber(e, t = 0, n = 0) {
        if (wm.validation) {
            if (e = parseInt(e), isNaN(e)) throw new Error("Invalid note number");
            t = parseInt(t) || 0, n = parseInt(n) || 0;
        }
        return Math.min(Math.max(e + 12 * t + n, 0), 127);
    }
    static getPropertyByValue(e, t) {
        return Object.keys(e).find((n)=>e[n] === t);
    }
    static getCcNameByNumber(e) {
        if (!wm.validation || (e = parseInt(e)) >= 0 && e <= 127) return Enumerations.CONTROL_CHANGE_MESSAGES[e].name;
    }
    static getCcNumberByName(e) {
        let t = Enumerations.CONTROL_CHANGE_MESSAGES.find((t)=>t.name === e);
        return t ? t.number : Enumerations.MIDI_CONTROL_CHANGE_MESSAGES[e];
    }
    static getChannelModeByNumber(e) {
        if (!(e >= 120 && e <= 127)) return !1;
        for(let t in Enumerations.CHANNEL_MODE_MESSAGES)if (Enumerations.CHANNEL_MODE_MESSAGES.hasOwnProperty(t) && e === Enumerations.CHANNEL_MODE_MESSAGES[t]) return t;
        return !1;
    }
    static get isNode() {
        return "undefined" != typeof $17tgv && null != $17tgv.versions && null != $17tgv.versions.node;
    }
    static get isBrowser() {
        return "undefined" != typeof window && void 0 !== window.document;
    }
}
/**
 * The `OutputChannel` class represents a single output MIDI channel. `OutputChannel` objects are
 * provided by an [`Output`](Output) port which, itself, is made available by a device. The
 * `OutputChannel` object is derived from the host's MIDI subsystem and should not be instantiated
 * directly.
 *
 * All 16 `OutputChannel` objects can be found inside the parent output's
 * [`channels`]{@link Output#channels} property.
 *
 * @param {Output} output The [`Output`](Output) this channel belongs to.
 * @param {number} number The MIDI channel number (`1` - `16`).
 *
 * @extends EventEmitter
 * @license Apache-2.0
 * @since 3.0.0
 */ class OutputChannel extends EventEmitter {
    constructor(e, t){
        super(), this._output = e, this._number = t, this._octaveOffset = 0;
    }
    destroy() {
        this._output = null, this._number = null, this._octaveOffset = 0, this.removeListener();
    }
    send(e, t = {
        time: 0
    }) {
        return this.output.send(e, t), this;
    }
    sendKeyAftertouch(e, t, n = {}) {
        if (wm.validation) {
            if (n.useRawValue && (n.rawValue = n.useRawValue), isNaN(parseFloat(t))) throw new RangeError("Invalid key aftertouch value.");
            if (n.rawValue) {
                if (!(t >= 0 && t <= 127 && Number.isInteger(t))) throw new RangeError("Key aftertouch raw value must be an integer between 0 and 127.");
            } else if (!(t >= 0 && t <= 1)) throw new RangeError("Key aftertouch value must be a float between 0 and 1.");
        }
        n.rawValue || (t = Utilities.fromFloatTo7Bit(t));
        const r = wm.octaveOffset + this.output.octaveOffset + this.octaveOffset;
        return Array.isArray(e) || (e = [
            e
        ]), Utilities.buildNoteArray(e).forEach((e)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.keyaftertouch << 4) + (this.number - 1),
                e.getOffsetNumber(r),
                t
            ], {
                time: Utilities.toTimestamp(n.time)
            });
        }), this;
    }
    /**
   * Sends a MIDI **control change** message to the channel at the scheduled time. The control
   * change message to send can be specified numerically (`0` to `127`) or by using one of the
   * following common names:
   *
   * | Number | Name                          |
   * |--------|-------------------------------|
   * | 0      |`bankselectcoarse`             |
   * | 1      |`modulationwheelcoarse`        |
   * | 2      |`breathcontrollercoarse`       |
   * | 4      |`footcontrollercoarse`         |
   * | 5      |`portamentotimecoarse`         |
   * | 6      |`dataentrycoarse`              |
   * | 7      |`volumecoarse`                 |
   * | 8      |`balancecoarse`                |
   * | 10     |`pancoarse`                    |
   * | 11     |`expressioncoarse`             |
   * | 12     |`effectcontrol1coarse`         |
   * | 13     |`effectcontrol2coarse`         |
   * | 18     |`generalpurposeslider3`        |
   * | 19     |`generalpurposeslider4`        |
   * | 32     |`bankselectfine`               |
   * | 33     |`modulationwheelfine`          |
   * | 34     |`breathcontrollerfine`         |
   * | 36     |`footcontrollerfine`           |
   * | 37     |`portamentotimefine`           |
   * | 38     |`dataentryfine`                |
   * | 39     |`volumefine`                   |
   * | 40     |`balancefine`                  |
   * | 42     |`panfine`                      |
   * | 43     |`expressionfine`               |
   * | 44     |`effectcontrol1fine`           |
   * | 45     |`effectcontrol2fine`           |
   * | 64     |`holdpedal`                    |
   * | 65     |`portamento`                   |
   * | 66     |`sustenutopedal`               |
   * | 67     |`softpedal`                    |
   * | 68     |`legatopedal`                  |
   * | 69     |`hold2pedal`                   |
   * | 70     |`soundvariation`               |
   * | 71     |`resonance`                    |
   * | 72     |`soundreleasetime`             |
   * | 73     |`soundattacktime`              |
   * | 74     |`brightness`                   |
   * | 75     |`soundcontrol6`                |
   * | 76     |`soundcontrol7`                |
   * | 77     |`soundcontrol8`                |
   * | 78     |`soundcontrol9`                |
   * | 79     |`soundcontrol10`               |
   * | 80     |`generalpurposebutton1`        |
   * | 81     |`generalpurposebutton2`        |
   * | 82     |`generalpurposebutton3`        |
   * | 83     |`generalpurposebutton4`        |
   * | 91     |`reverblevel`                  |
   * | 92     |`tremololevel`                 |
   * | 93     |`choruslevel`                  |
   * | 94     |`celestelevel`                 |
   * | 95     |`phaserlevel`                  |
   * | 96     |`dataincrement`                |
   * | 97     |`datadecrement`                |
   * | 98     |`nonregisteredparametercoarse` |
   * | 99     |`nonregisteredparameterfine`   |
   * | 100    |`registeredparametercoarse`    |
   * | 101    |`registeredparameterfine`      |
   * | 120    |`allsoundoff`                  |
   * | 121    |`resetallcontrollers`          |
   * | 122    |`localcontrol`                 |
   * | 123    |`allnotesoff`                  |
   * | 124    |`omnimodeoff`                  |
   * | 125    |`omnimodeon`                   |
   * | 126    |`monomodeon`                   |
   * | 127    |`polymodeon`                   |
   *
   * As you can see above, not all control change message have a matching name. This does not mean
   * you cannot use the others. It simply means you will need to use their number
   * (`0` to `127`) instead of their name. While you can still use them, numbers `120` to `127` are
   * usually reserved for *channel mode* messages. See
   * [`sendChannelMode()`]{@link OutputChannel#sendChannelMode} method for more info.
   *
   * To view a detailed list of all available **control change** messages, please consult "Table 3 -
   * Control Change Messages" from the [MIDI Messages](
   * https://www.midi.org/specifications/item/table-3-control-change-messages-data-bytes-2)
   * specification.
   *
   * **Note**: messages #0-31 (MSB) are paired with messages #32-63 (LSB). For example, message #1
   * (`modulationwheelcoarse`) can be accompanied by a second control change message for
   * `modulationwheelfine` to achieve a greater level of precision. if you want to specify both MSB
   * and LSB for messages between `0` and `31`, you can do so by passing a 2-value array as the
   * second parameter.
   *
   * @param {number|string} controller The MIDI controller name or number (`0` - `127`).
   *
   * @param {number|number[]} value The value to send (0-127). You can also use a two-position array
   * for controllers 0 to 31. In this scenario, the first value will be sent as usual and the second
   * value will be sent to the matching LSB controller (which is obtained by adding 32 to the first
   * controller)
   *
   * @param {object} [options={}]
   *
   * @param {number|string} [options.time=(now)] If `time` is a string prefixed with `"+"` and
   * followed by a number, the message will be delayed by that many milliseconds. If the value is a
   * positive number
   * ([`DOMHighResTimeStamp`]{@link https://developer.mozilla.org/docs/Web/API/DOMHighResTimeStamp}),
   * the operation will be scheduled for that time. The current time can be retrieved with
   * [`WebMidi.time`]{@link WebMidi#time}. If `options.time` is omitted, or in the past, the
   * operation will be carried out as soon as possible.
   *
   * @throws {RangeError} Controller numbers must be between 0 and 127.
   * @throws {RangeError} Invalid controller name.
   * @throws {TypeError} The value array must have a length of 2.
   *
   * @returns {OutputChannel} Returns the `OutputChannel` object so methods can be chained.
   *
   * @license Apache-2.0
   * @since 3.0.0
   */ sendControlChange(e, t, n = {}) {
        if ("string" == typeof e && (e = Utilities.getCcNumberByName(e)), Array.isArray(t) || (t = [
            t
        ]), wm.validation) {
            if (void 0 === e) throw new TypeError("Control change must be identified with a valid name or an integer between 0 and 127.");
            if (!Number.isInteger(e) || !(e >= 0 && e <= 127)) throw new TypeError("Control change number must be an integer between 0 and 127.");
            if (2 === (t = t.map((e)=>{
                const t = Math.min(Math.max(parseInt(e), 0), 127);
                if (isNaN(t)) throw new TypeError("Values must be integers between 0 and 127");
                return t;
            })).length && e >= 32) throw new TypeError("To use a value array, the controller must be between 0 and 31");
        }
        return t.forEach((r, i)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.controlchange << 4) + (this.number - 1),
                e + 32 * i,
                t[i]
            ], {
                time: Utilities.toTimestamp(n.time)
            });
        }), this;
    }
    _selectNonRegisteredParameter(e, t = {}) {
        return this.sendControlChange(99, e[0], t), this.sendControlChange(98, e[1], t), this;
    }
    _deselectRegisteredParameter(e = {}) {
        return this.sendControlChange(101, 127, e), this.sendControlChange(100, 127, e), this;
    }
    _deselectNonRegisteredParameter(e = {}) {
        return this.sendControlChange(101, 127, e), this.sendControlChange(100, 127, e), this;
    }
    _selectRegisteredParameter(e, t = {}) {
        return this.sendControlChange(101, e[0], t), this.sendControlChange(100, e[1], t), this;
    }
    _setCurrentParameter(e, t = {}) {
        return e = [].concat(e), this.sendControlChange(6, e[0], t), e.length < 2 || this.sendControlChange(38, e[1], t), this;
    }
    sendRpnDecrement(e, t = {}) {
        if (Array.isArray(e) || (e = Enumerations.REGISTERED_PARAMETERS[e]), wm.validation) {
            if (void 0 === e) throw new TypeError("The specified registered parameter is invalid.");
            let t = !1;
            if (Object.getOwnPropertyNames(Enumerations.REGISTERED_PARAMETERS).forEach((n)=>{
                Enumerations.REGISTERED_PARAMETERS[n][0] === e[0] && Enumerations.REGISTERED_PARAMETERS[n][1] === e[1] && (t = !0);
            }), !t) throw new TypeError("The specified registered parameter is invalid.");
        }
        return this._selectRegisteredParameter(e, t), this.sendControlChange(97, 0, t), this._deselectRegisteredParameter(t), this;
    }
    sendRpnIncrement(e, t = {}) {
        if (Array.isArray(e) || (e = Enumerations.REGISTERED_PARAMETERS[e]), wm.validation) {
            if (void 0 === e) throw new TypeError("The specified registered parameter is invalid.");
            let t = !1;
            if (Object.getOwnPropertyNames(Enumerations.REGISTERED_PARAMETERS).forEach((n)=>{
                Enumerations.REGISTERED_PARAMETERS[n][0] === e[0] && Enumerations.REGISTERED_PARAMETERS[n][1] === e[1] && (t = !0);
            }), !t) throw new TypeError("The specified registered parameter is invalid.");
        }
        return this._selectRegisteredParameter(e, t), this.sendControlChange(96, 0, t), this._deselectRegisteredParameter(t), this;
    }
    playNote(e, t = {}) {
        this.sendNoteOn(e, t);
        const n = Array.isArray(e) ? e : [
            e
        ];
        for (let e of n)if (parseInt(e.duration) > 0) {
            const n = {
                time: (Utilities.toTimestamp(t.time) || wm.time) + parseInt(e.duration),
                release: e.release,
                rawRelease: e.rawRelease
            };
            this.sendNoteOff(e, n);
        } else if (parseInt(t.duration) > 0) {
            const n = {
                time: (Utilities.toTimestamp(t.time) || wm.time) + parseInt(t.duration),
                release: t.release,
                rawRelease: t.rawRelease
            };
            this.sendNoteOff(e, n);
        }
        return this;
    }
    sendNoteOff(e, t = {}) {
        if (wm.validation) {
            if (null != t.rawRelease && !(t.rawRelease >= 0 && t.rawRelease <= 127)) throw new RangeError("The 'rawRelease' option must be an integer between 0 and 127");
            if (null != t.release && !(t.release >= 0 && t.release <= 1)) throw new RangeError("The 'release' option must be an number between 0 and 1");
            t.rawVelocity && (t.rawRelease = t.velocity, console.warn("The 'rawVelocity' option is deprecated. Use 'rawRelease' instead.")), t.velocity && (t.release = t.velocity, console.warn("The 'velocity' option is deprecated. Use 'attack' instead."));
        }
        let n = 64;
        null != t.rawRelease ? n = t.rawRelease : isNaN(t.release) || (n = Math.round(127 * t.release));
        const r = wm.octaveOffset + this.output.octaveOffset + this.octaveOffset;
        return Utilities.buildNoteArray(e, {
            rawRelease: parseInt(n)
        }).forEach((e)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.noteoff << 4) + (this.number - 1),
                e.getOffsetNumber(r),
                e.rawRelease
            ], {
                time: Utilities.toTimestamp(t.time)
            });
        }), this;
    }
    stopNote(e, t = {}) {
        return this.sendNoteOff(e, t);
    }
    sendNoteOn(e, t = {}) {
        if (wm.validation) {
            if (null != t.rawAttack && !(t.rawAttack >= 0 && t.rawAttack <= 127)) throw new RangeError("The 'rawAttack' option must be an integer between 0 and 127");
            if (null != t.attack && !(t.attack >= 0 && t.attack <= 1)) throw new RangeError("The 'attack' option must be an number between 0 and 1");
            t.rawVelocity && (t.rawAttack = t.velocity, t.rawRelease = t.release, console.warn("The 'rawVelocity' option is deprecated. Use 'rawAttack' or 'rawRelease'.")), t.velocity && (t.attack = t.velocity, console.warn("The 'velocity' option is deprecated. Use 'attack' instead."));
        }
        let n = 64;
        null != t.rawAttack ? n = t.rawAttack : isNaN(t.attack) || (n = Math.round(127 * t.attack));
        const r = wm.octaveOffset + this.output.octaveOffset + this.octaveOffset;
        return Utilities.buildNoteArray(e, {
            rawAttack: n
        }).forEach((e)=>{
            this.send([
                (Enumerations.CHANNEL_MESSAGES.noteon << 4) + (this.number - 1),
                e.getOffsetNumber(r),
                e.rawAttack
            ], {
                time: Utilities.toTimestamp(t.time)
            });
        }), this;
    }
    sendChannelMode(e, t = 0, n = {}) {
        if ("string" == typeof e && (e = Enumerations.CHANNEL_MODE_MESSAGES[e]), wm.validation) {
            if (void 0 === e) throw new TypeError("Invalid channel mode message name or number.");
            if (isNaN(e) || !(e >= 120 && e <= 127)) throw new TypeError("Invalid channel mode message number.");
            if (isNaN(parseInt(t)) || t < 0 || t > 127) throw new RangeError("Value must be an integer between 0 and 127.");
        }
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.controlchange << 4) + (this.number - 1),
            e,
            t
        ], {
            time: Utilities.toTimestamp(n.time)
        }), this;
    }
    sendOmniMode(e, t = {}) {
        return void 0 === e || e ? this.sendChannelMode("omnimodeon", 0, t) : this.sendChannelMode("omnimodeoff", 0, t), this;
    }
    sendChannelAftertouch(e, t = {}) {
        if (wm.validation) {
            if (isNaN(parseFloat(e))) throw new RangeError("Invalid channel aftertouch value.");
            if (t.rawValue) {
                if (!(e >= 0 && e <= 127 && Number.isInteger(e))) throw new RangeError("Channel aftertouch raw value must be an integer between 0 and 127.");
            } else if (!(e >= 0 && e <= 1)) throw new RangeError("Channel aftertouch value must be a float between 0 and 1.");
        }
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.channelaftertouch << 4) + (this.number - 1),
            Math.round(127 * e)
        ], {
            time: Utilities.toTimestamp(t.time)
        }), this;
    }
    sendMasterTuning(e, t = {}) {
        if (e = parseFloat(e) || 0, wm.validation && !(e > -65 && e < 64)) throw new RangeError("The value must be a decimal number larger than -65 and smaller than 64.");
        let n = Math.floor(e) + 64, r = e - Math.floor(e);
        r = Math.round((r + 1) / 2 * 16383);
        let i = r >> 7 & 127, s = 127 & r;
        return this.sendRpnValue("channelcoarsetuning", n, t), this.sendRpnValue("channelfinetuning", [
            i,
            s
        ], t), this;
    }
    sendModulationRange(e, t, n = {}) {
        if (wm.validation) {
            if (!Number.isInteger(e) || !(e >= 0 && e <= 127)) throw new RangeError("The semitones value must be an integer between 0 and 127.");
            if (!(null == t || Number.isInteger(t) && t >= 0 && t <= 127)) throw new RangeError("If specified, the cents value must be an integer between 0 and 127.");
        }
        return t >= 0 && t <= 127 || (t = 0), this.sendRpnValue("modulationrange", [
            e,
            t
        ], n), this;
    }
    sendNrpnValue(e, t, n = {}) {
        if (t = [].concat(t), wm.validation) {
            if (!Array.isArray(e) || !Number.isInteger(e[0]) || !Number.isInteger(e[1])) throw new TypeError("The specified NRPN is invalid.");
            if (!(e[0] >= 0 && e[0] <= 127)) throw new RangeError("The first byte of the NRPN must be between 0 and 127.");
            if (!(e[1] >= 0 && e[1] <= 127)) throw new RangeError("The second byte of the NRPN must be between 0 and 127.");
            t.forEach((e)=>{
                if (!(e >= 0 && e <= 127)) throw new RangeError("The data bytes of the NRPN must be between 0 and 127.");
            });
        }
        return this._selectNonRegisteredParameter(e, n), this._setCurrentParameter(t, n), this._deselectNonRegisteredParameter(n), this;
    }
    sendPitchBend(e, t = {}) {
        if (wm.validation) {
            if (t.rawValue && Array.isArray(e)) {
                if (!(e[0] >= 0 && e[0] <= 127)) throw new RangeError("The pitch bend MSB must be an integer between 0 and 127.");
                if (!(e[1] >= 0 && e[1] <= 127)) throw new RangeError("The pitch bend LSB must be an integer between 0 and 127.");
            } else if (t.rawValue && !Array.isArray(e)) {
                if (!(e >= 0 && e <= 127)) throw new RangeError("The pitch bend MSB must be an integer between 0 and 127.");
            } else {
                if (isNaN(e) || null === e) throw new RangeError("Invalid pitch bend value.");
                if (!(e >= -1 && e <= 1)) throw new RangeError("The pitch bend value must be a float between -1 and 1.");
            }
        }
        let n = 0, r = 0;
        if (t.rawValue && Array.isArray(e)) n = e[0], r = e[1];
        else if (t.rawValue && !Array.isArray(e)) n = e;
        else {
            const t = Utilities.fromFloatToMsbLsb((e + 1) / 2);
            n = t.msb, r = t.lsb;
        }
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.pitchbend << 4) + (this.number - 1),
            r,
            n
        ], {
            time: Utilities.toTimestamp(t.time)
        }), this;
    }
    sendPitchBendRange(e, t, n = {}) {
        if (wm.validation) {
            if (!Number.isInteger(e) || !(e >= 0 && e <= 127)) throw new RangeError("The semitones value must be an integer between 0 and 127.");
            if (!Number.isInteger(t) || !(t >= 0 && t <= 127)) throw new RangeError("The cents value must be an integer between 0 and 127.");
        }
        return this.sendRpnValue("pitchbendrange", [
            e,
            t
        ], n), this;
    }
    sendProgramChange(e, t = {}) {
        if (e = parseInt(e) || 0, wm.validation && !(e >= 0 && e <= 127)) throw new RangeError("The program number must be between 0 and 127.");
        return this.send([
            (Enumerations.CHANNEL_MESSAGES.programchange << 4) + (this.number - 1),
            e
        ], {
            time: Utilities.toTimestamp(t.time)
        }), this;
    }
    sendRpnValue(e, t, n = {}) {
        if (Array.isArray(e) || (e = Enumerations.REGISTERED_PARAMETERS[e]), wm.validation) {
            if (!Number.isInteger(e[0]) || !Number.isInteger(e[1])) throw new TypeError("The specified NRPN is invalid.");
            if (!(e[0] >= 0 && e[0] <= 127)) throw new RangeError("The first byte of the RPN must be between 0 and 127.");
            if (!(e[1] >= 0 && e[1] <= 127)) throw new RangeError("The second byte of the RPN must be between 0 and 127.");
            [].concat(t).forEach((e)=>{
                if (!(e >= 0 && e <= 127)) throw new RangeError("The data bytes of the RPN must be between 0 and 127.");
            });
        }
        return this._selectRegisteredParameter(e, n), this._setCurrentParameter(t, n), this._deselectRegisteredParameter(n), this;
    }
    sendTuningBank(e, t = {}) {
        if (wm.validation && (!Number.isInteger(e) || !(e >= 0 && e <= 127))) throw new RangeError("The tuning bank number must be between 0 and 127.");
        return this.sendRpnValue("tuningbank", e, t), this;
    }
    sendTuningProgram(e, t = {}) {
        if (wm.validation && (!Number.isInteger(e) || !(e >= 0 && e <= 127))) throw new RangeError("The tuning program number must be between 0 and 127.");
        return this.sendRpnValue("tuningprogram", e, t), this;
    }
    sendLocalControl(e, t = {}) {
        return e ? this.sendChannelMode("localcontrol", 127, t) : this.sendChannelMode("localcontrol", 0, t);
    }
    sendAllNotesOff(e = {}) {
        return this.sendChannelMode("allnotesoff", 0, e);
    }
    sendAllSoundOff(e = {}) {
        return this.sendChannelMode("allsoundoff", 0, e);
    }
    sendResetAllControllers(e = {}) {
        return this.sendChannelMode("resetallcontrollers", 0, e);
    }
    sendPolyphonicMode(e, t = {}) {
        return "mono" === e ? this.sendChannelMode("monomodeon", 0, t) : this.sendChannelMode("polymodeon", 0, t);
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e) {
        if (this.validation && (e = parseInt(e), isNaN(e))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e;
    }
    get output() {
        return this._output;
    }
    get number() {
        return this._number;
    }
}
/**
 * The `Output` class represents a single MIDI output port (not to be confused with a MIDI channel).
 * A port is made available by a MIDI device. A MIDI device can advertise several input and output
 * ports. Each port has 16 MIDI channels which can be accessed via the [`channels`](#channels)
 * property.
 *
 * The `Output` object is automatically instantiated by the library according to the host's MIDI
 * subsystem and should not be directly instantiated.
 *
 * You can access all available `Output` objects by referring to the
 * [`WebMidi.outputs`](WebMidi#outputs) array or by using methods such as
 * [`WebMidi.getOutputByName()`](WebMidi#getOutputByName) or
 * [`WebMidi.getOutputById()`](WebMidi#getOutputById).
 *
 * @fires Output#opened
 * @fires Output#disconnected
 * @fires Output#closed
 *
 * @extends EventEmitter
 * @license Apache-2.0
 */ class Output extends EventEmitter {
    constructor(e){
        super(), this._midiOutput = e, this._octaveOffset = 0, this.channels = [];
        for(let e = 1; e <= 16; e++)this.channels[e] = new OutputChannel(this, e);
        this._midiOutput.onstatechange = this._onStateChange.bind(this);
    }
    async destroy() {
        this.removeListener(), this.channels.forEach((e)=>e.destroy()), this.channels = [], this._midiOutput && (this._midiOutput.onstatechange = null), await this.close(), this._midiOutput = null;
    }
    _onStateChange(e) {
        let t = {
            timestamp: wm.time
        };
        "open" === e.port.connection ? (t.type = "opened", t.target = this, t.port = t.target, this.emit("opened", t)) : "closed" === e.port.connection && "connected" === e.port.state ? (t.type = "closed", t.target = this, t.port = t.target, this.emit("closed", t)) : "closed" === e.port.connection && "disconnected" === e.port.state ? (t.type = "disconnected", t.port = {
            connection: e.port.connection,
            id: e.port.id,
            manufacturer: e.port.manufacturer,
            name: e.port.name,
            state: e.port.state,
            type: e.port.type
        }, this.emit("disconnected", t)) : "pending" === e.port.connection && "disconnected" === e.port.state || console.warn("This statechange event was not caught:", e.port.connection, e.port.state);
    }
    async open() {
        try {
            return await this._midiOutput.open(), Promise.resolve(this);
        } catch (e) {
            return Promise.reject(e);
        }
    }
    async close() {
        this._midiOutput ? await this._midiOutput.close() : await Promise.resolve();
    }
    /**
   * Sends a MIDI message on the MIDI output port. If no time is specified, the message will be
   * sent immediately. The message should be an array of 8 bit unsigned integers (0-225), a
   * [`Uint8Array`]{@link https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Uint8Array}
   * object or a [`Message`](Message) object.
   *
   * It is usually not necessary to use this method directly as you can use one of the simpler
   * helper methods such as [`playNote()`](#playNote), [`stopNote()`](#stopNote),
   * [`sendControlChange()`](#sendControlChange), etc.
   *
   * Details on the format of MIDI messages are available in the summary of
   * [MIDI messages]{@link https://www.midi.org/specifications-old/item/table-1-summary-of-midi-message}
   * from the MIDI Manufacturers Association.
   *
   * @param message {number[]|Uint8Array|Message} An array of 8bit unsigned integers, a `Uint8Array`
   * object (not available in Node.js) containing the message bytes or a `Message` object.
   *
   * @param {object} [options={}]
   *
   * @param {number|string} [options.time=(now)] If `time` is a string prefixed with `"+"` and
   * followed by a number, the message will be delayed by that many milliseconds. If the value is a
   * positive number
   * ([`DOMHighResTimeStamp`]{@link https://developer.mozilla.org/docs/Web/API/DOMHighResTimeStamp}),
   * the operation will be scheduled for that time. The current time can be retrieved with
   * [`WebMidi.time`]{@link WebMidi#time}. If `options.time` is omitted, or in the past, the
   * operation will be carried out as soon as possible.
   *
   * @throws {RangeError} The first byte (status) must be an integer between 128 and 255.
   *
   * @returns {Output} Returns the `Output` object so methods can be chained.
   *
   * @license Apache-2.0
   */ send(e, t = {
        time: 0
    }, n = 0) {
        if (e instanceof Message && (e = Utilities.isNode ? e.data : e.rawData), e instanceof Uint8Array && Utilities.isNode && (e = Array.from(e)), wm.validation) {
            if (Array.isArray(e) || e instanceof Uint8Array || (e = [
                e
            ], Array.isArray(t) && (e = e.concat(t)), t = isNaN(n) ? {
                time: 0
            } : {
                time: n
            }), !(parseInt(e[0]) >= 128 && parseInt(e[0]) <= 255)) throw new RangeError("The first byte (status) must be an integer between 128 and 255.");
            e.slice(1).forEach((e)=>{
                if (!((e = parseInt(e)) >= 0 && e <= 255)) throw new RangeError("Data bytes must be integers between 0 and 255.");
            }), t || (t = {
                time: 0
            });
        }
        return this._midiOutput.send(e, Utilities.toTimestamp(t.time)), this;
    }
    sendSysex(e, t = [], n = {}) {
        if (e = [].concat(e), t instanceof Uint8Array) {
            const r = new Uint8Array(1 + e.length + t.length + 1);
            r[0] = Enumerations.SYSTEM_MESSAGES.sysex, r.set(Uint8Array.from(e), 1), r.set(t, 1 + e.length), r[r.length - 1] = Enumerations.SYSTEM_MESSAGES.sysexend, this.send(r, {
                time: n.time
            });
        } else {
            const r = e.concat(t, Enumerations.SYSTEM_MESSAGES.sysexend);
            this.send([
                Enumerations.SYSTEM_MESSAGES.sysex
            ].concat(r), {
                time: n.time
            });
        }
        return this;
    }
    clear() {
        return this._midiOutput.clear ? this._midiOutput.clear() : wm.validation && console.warn("The 'clear()' method has not yet been implemented in your environment."), this;
    }
    sendTimecodeQuarterFrame(e, t = {}) {
        if (wm.validation && (e = parseInt(e), isNaN(e) || !(e >= 0 && e <= 127))) throw new RangeError("The value must be an integer between 0 and 127.");
        return this.send([
            Enumerations.SYSTEM_MESSAGES.timecode,
            e
        ], {
            time: t.time
        }), this;
    }
    sendSongPosition(e = 0, t = {}) {
        var n = (e = Math.floor(e) || 0) >> 7 & 127, r = 127 & e;
        return this.send([
            Enumerations.SYSTEM_MESSAGES.songposition,
            n,
            r
        ], {
            time: t.time
        }), this;
    }
    sendSongSelect(e = 0, t = {}) {
        if (wm.validation && (e = parseInt(e), isNaN(e) || !(e >= 0 && e <= 127))) throw new RangeError("The program value must be between 0 and 127");
        return this.send([
            Enumerations.SYSTEM_MESSAGES.songselect,
            e
        ], {
            time: t.time
        }), this;
    }
    sendTuneRequest(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.tunerequest
        ], {
            time: e.time
        }), this;
    }
    sendClock(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.clock
        ], {
            time: e.time
        }), this;
    }
    sendStart(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.start
        ], {
            time: e.time
        }), this;
    }
    sendContinue(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.continue
        ], {
            time: e.time
        }), this;
    }
    sendStop(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.stop
        ], {
            time: e.time
        }), this;
    }
    sendActiveSensing(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.activesensing
        ], {
            time: e.time
        }), this;
    }
    sendReset(e = {}) {
        return this.send([
            Enumerations.SYSTEM_MESSAGES.reset
        ], {
            time: e.time
        }), this;
    }
    sendTuningRequest(e = {}) {
        return wm.validation && console.warn("The sendTuningRequest() method has been deprecated. Use sendTuningRequest() instead."), this.sendTuneRequest(e);
    }
    sendKeyAftertouch(e, t, n = {}) {
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendKeyAftertouch(e, t, n);
        }), this;
    }
    sendControlChange(e, t, n = {}, r = {}) {
        if (wm.validation && (Array.isArray(n) || Number.isInteger(n) || "all" === n)) {
            const e = n;
            (n = r).channels = e, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendControlChange(e, t, n);
        }), this;
    }
    sendPitchBendRange(e = 0, t = 0, n = {}) {
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendPitchBendRange(e, t, n);
        }), this;
    }
    setPitchBendRange(e = 0, t = 0, n = "all", r = {}) {
        return wm.validation && (console.warn("The setPitchBendRange() method is deprecated. Use sendPitchBendRange() instead."), r.channels = n, "all" === r.channels && (r.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendPitchBendRange(e, t, r);
    }
    sendRpnValue(e, t, n = {}) {
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendRpnValue(e, t, n);
        }), this;
    }
    setRegisteredParameter(e, t = [], n = "all", r = {}) {
        return wm.validation && (console.warn("The setRegisteredParameter() method is deprecated. Use sendRpnValue() instead."), r.channels = n, "all" === r.channels && (r.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendRpnValue(e, t, r);
    }
    sendChannelAftertouch(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendChannelAftertouch(e, t);
        }), this;
    }
    sendPitchBend(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendPitchBend(e, t);
        }), this;
    }
    sendProgramChange(e = 0, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendProgramChange(e, t);
        }), this;
    }
    sendModulationRange(e, t, n = {}) {
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendModulationRange(e, t, n);
        }), this;
    }
    setModulationRange(e = 0, t = 0, n = "all", r = {}) {
        return wm.validation && (console.warn("The setModulationRange() method is deprecated. Use sendModulationRange() instead."), r.channels = n, "all" === r.channels && (r.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendModulationRange(e, t, r);
    }
    sendMasterTuning(e, t = {}) {
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendMasterTuning(e, t);
        }), this;
    }
    setMasterTuning(e, t = {}, n = {}) {
        return wm.validation && (console.warn("The setMasterTuning() method is deprecated. Use sendMasterTuning() instead."), n.channels = t, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendMasterTuning(e, n);
    }
    sendTuningProgram(e, t = {}) {
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendTuningProgram(e, t);
        }), this;
    }
    setTuningProgram(e, t = "all", n = {}) {
        return wm.validation && (console.warn("The setTuningProgram() method is deprecated. Use sendTuningProgram() instead."), n.channels = t, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendTuningProgram(e, n);
    }
    sendTuningBank(e = 0, t = {}) {
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendTuningBank(e, t);
        }), this;
    }
    setTuningBank(e, t = "all", n = {}) {
        return wm.validation && (console.warn("The setTuningBank() method is deprecated. Use sendTuningBank() instead."), n.channels = t, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendTuningBank(e, n);
    }
    sendChannelMode(e, t = 0, n = {}, r = {}) {
        if (wm.validation && (Array.isArray(n) || Number.isInteger(n) || "all" === n)) {
            const e = n;
            (n = r).channels = e, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendChannelMode(e, t, n);
        }), this;
    }
    sendAllSoundOff(e = {}) {
        return null == e.channels && (e.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(e.channels).forEach((t)=>{
            this.channels[t].sendAllSoundOff(e);
        }), this;
    }
    sendAllNotesOff(e = {}) {
        return null == e.channels && (e.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(e.channels).forEach((t)=>{
            this.channels[t].sendAllNotesOff(e);
        }), this;
    }
    sendResetAllControllers(e = {}, t = {}) {
        if (wm.validation && (Array.isArray(e) || Number.isInteger(e) || "all" === e)) {
            const n = e;
            (e = t).channels = n, "all" === e.channels && (e.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == e.channels && (e.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(e.channels).forEach((t)=>{
            this.channels[t].sendResetAllControllers(e);
        }), this;
    }
    sendPolyphonicMode(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendPolyphonicMode(e, t);
        }), this;
    }
    sendLocalControl(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendLocalControl(e, t);
        }), this;
    }
    sendOmniMode(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendOmniMode(e, t);
        }), this;
    }
    sendNrpnValue(e, t, n = {}) {
        return null == n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].sendNrpnValue(e, t, n);
        }), this;
    }
    setNonRegisteredParameter(e, t = [], n = "all", r = {}) {
        return wm.validation && (console.warn("The setNonRegisteredParameter() method is deprecated. Use sendNrpnValue() instead."), r.channels = n, "all" === r.channels && (r.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendNrpnValue(e, t, r);
    }
    sendRpnIncrement(e, t = {}) {
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendRpnIncrement(e, t);
        }), this;
    }
    incrementRegisteredParameter(e, t = "all", n = {}) {
        return wm.validation && (console.warn("The incrementRegisteredParameter() method is deprecated. Use sendRpnIncrement() instead."), n.channels = t, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendRpnIncrement(e, n);
    }
    sendRpnDecrement(e, t = {}) {
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendRpnDecrement(e, t);
        }), this;
    }
    decrementRegisteredParameter(e, t = "all", n = {}) {
        return wm.validation && (console.warn("The decrementRegisteredParameter() method is deprecated. Use sendRpnDecrement() instead."), n.channels = t, "all" === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS)), this.sendRpnDecrement(e, n);
    }
    sendNoteOff(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendNoteOff(e, t);
        }), this;
    }
    stopNote(e, t) {
        return this.sendNoteOff(e, t);
    }
    playNote(e, t = {}, n = {}) {
        if (wm.validation && (t.rawVelocity && console.warn("The 'rawVelocity' option is deprecated. Use 'rawAttack' instead."), t.velocity && console.warn("The 'velocity' option is deprecated. Use 'velocity' instead."), Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].playNote(e, t);
        }), this;
    }
    sendNoteOn(e, t = {}, n = {}) {
        if (wm.validation && (Array.isArray(t) || Number.isInteger(t) || "all" === t)) {
            const e = t;
            (t = n).channels = e, "all" === t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
        }
        return null == t.channels && (t.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(t.channels).forEach((n)=>{
            this.channels[n].sendNoteOn(e, t);
        }), this;
    }
    get name() {
        return this._midiOutput.name;
    }
    get id() {
        return this._midiOutput.id;
    }
    get connection() {
        return this._midiOutput.connection;
    }
    get manufacturer() {
        return this._midiOutput.manufacturer;
    }
    get state() {
        return this._midiOutput.state;
    }
    get type() {
        return this._midiOutput.type;
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e) {
        if (this.validation && (e = parseInt(e), isNaN(e))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e;
    }
}
/**
 * The `Forwarder` class allows the forwarding of MIDI messages to predetermined outputs. When you
 * call its [`forward()`](#forward) method, it will send the specified [`Message`](Message) object
 * to all the outputs listed in its [`destinations`](#destinations) property.
 *
 * If specific channels or message types have been defined in the [`channels`](#channels) or
 * [`types`](#types) properties, only messages matching the channels/types will be forwarded.
 *
 * While it can be manually instantiated, you are more likely to come across a `Forwarder` object as
 * the return value of the [`Input.addForwarder()`](Input#addForwarder) method.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Forwarder {
    constructor(e = [], t = {}){
        this.destinations = [], this.types = [
            ...Object.keys(Enumerations.SYSTEM_MESSAGES),
            ...Object.keys(Enumerations.CHANNEL_MESSAGES)
        ], this.channels = Enumerations.MIDI_CHANNEL_NUMBERS, this.suspended = !1, Array.isArray(e) || (e = [
            e
        ]), t.types && !Array.isArray(t.types) && (t.types = [
            t.types
        ]), t.channels && !Array.isArray(t.channels) && (t.channels = [
            t.channels
        ]), wm.validation && (e.forEach((e)=>{
            if (!(e instanceof Output)) throw new TypeError("Destinations must be of type 'Output'.");
        }), void 0 !== t.types && t.types.forEach((e)=>{
            if (!Enumerations.SYSTEM_MESSAGES.hasOwnProperty(e) && !Enumerations.CHANNEL_MESSAGES.hasOwnProperty(e)) throw new TypeError("Type must be a valid message type.");
        }), void 0 !== t.channels && t.channels.forEach((e)=>{
            if (!Enumerations.MIDI_CHANNEL_NUMBERS.includes(e)) throw new TypeError("MIDI channel must be between 1 and 16.");
        })), this.destinations = e, t.types && (this.types = t.types), t.channels && (this.channels = t.channels);
    }
    forward(e) {
        this.suspended || this.types.includes(e.type) && (e.channel && !this.channels.includes(e.channel) || this.destinations.forEach((t)=>{
            (!wm.validation || t instanceof Output) && t.send(e);
        }));
    }
}
/**
 * The `InputChannel` class represents a single MIDI input channel (1-16) from a single input
 * device. This object is derived from the host's MIDI subsystem and should not be instantiated
 * directly.
 *
 * All 16 `InputChannel` objects can be found inside the input's [`channels`](Input#channels)
 * property.
 *
 * @fires InputChannel#midimessage
 * @fires InputChannel#unknownmessage
 *
 * @fires InputChannel#noteoff
 * @fires InputChannel#noteon
 * @fires InputChannel#keyaftertouch
 * @fires InputChannel#programchange
 * @fires InputChannel#channelaftertouch
 * @fires InputChannel#pitchbend
 *
 * @fires InputChannel#allnotesoff
 * @fires InputChannel#allsoundoff
 * @fires InputChannel#localcontrol
 * @fires InputChannel#monomode
 * @fires InputChannel#omnimode
 * @fires InputChannel#resetallcontrollers
 *
 * @fires InputChannel#event:nrpn
 * @fires InputChannel#event:nrpn-dataentrycoarse
 * @fires InputChannel#event:nrpn-dataentryfine
 * @fires InputChannel#event:nrpn-dataincrement
 * @fires InputChannel#event:nrpn-datadecrement
 * @fires InputChannel#event:rpn
 * @fires InputChannel#event:rpn-dataentrycoarse
 * @fires InputChannel#event:rpn-dataentryfine
 * @fires InputChannel#event:rpn-dataincrement
 * @fires InputChannel#event:rpn-datadecrement
 *
 * @fires InputChannel#controlchange
 * @fires InputChannel#event:controlchange-controllerxxx
 * @fires InputChannel#event:controlchange-bankselectcoarse
 * @fires InputChannel#event:controlchange-modulationwheelcoarse
 * @fires InputChannel#event:controlchange-breathcontrollercoarse
 * @fires InputChannel#event:controlchange-footcontrollercoarse
 * @fires InputChannel#event:controlchange-portamentotimecoarse
 * @fires InputChannel#event:controlchange-dataentrycoarse
 * @fires InputChannel#event:controlchange-volumecoarse
 * @fires InputChannel#event:controlchange-balancecoarse
 * @fires InputChannel#event:controlchange-pancoarse
 * @fires InputChannel#event:controlchange-expressioncoarse
 * @fires InputChannel#event:controlchange-effectcontrol1coarse
 * @fires InputChannel#event:controlchange-effectcontrol2coarse
 * @fires InputChannel#event:controlchange-generalpurposecontroller1
 * @fires InputChannel#event:controlchange-generalpurposecontroller2
 * @fires InputChannel#event:controlchange-generalpurposecontroller3
 * @fires InputChannel#event:controlchange-generalpurposecontroller4
 * @fires InputChannel#event:controlchange-bankselectfine
 * @fires InputChannel#event:controlchange-modulationwheelfine
 * @fires InputChannel#event:controlchange-breathcontrollerfine
 * @fires InputChannel#event:controlchange-footcontrollerfine
 * @fires InputChannel#event:controlchange-portamentotimefine
 * @fires InputChannel#event:controlchange-dataentryfine
 * @fires InputChannel#event:controlchange-channelvolumefine
 * @fires InputChannel#event:controlchange-balancefine
 * @fires InputChannel#event:controlchange-panfine
 * @fires InputChannel#event:controlchange-expressionfine
 * @fires InputChannel#event:controlchange-effectcontrol1fine
 * @fires InputChannel#event:controlchange-effectcontrol2fine
 * @fires InputChannel#event:controlchange-damperpedal
 * @fires InputChannel#event:controlchange-portamento
 * @fires InputChannel#event:controlchange-sostenuto
 * @fires InputChannel#event:controlchange-softpedal
 * @fires InputChannel#event:controlchange-legatopedal
 * @fires InputChannel#event:controlchange-hold2
 * @fires InputChannel#event:controlchange-soundvariation
 * @fires InputChannel#event:controlchange-resonance
 * @fires InputChannel#event:controlchange-releasetime
 * @fires InputChannel#event:controlchange-attacktime
 * @fires InputChannel#event:controlchange-brightness
 * @fires InputChannel#event:controlchange-decaytime
 * @fires InputChannel#event:controlchange-vibratorate
 * @fires InputChannel#event:controlchange-vibratodepth
 * @fires InputChannel#event:controlchange-vibratodelay
 * @fires InputChannel#event:controlchange-generalpurposecontroller5
 * @fires InputChannel#event:controlchange-generalpurposecontroller6
 * @fires InputChannel#event:controlchange-generalpurposecontroller7
 * @fires InputChannel#event:controlchange-generalpurposecontroller8
 * @fires InputChannel#event:controlchange-portamentocontrol
 * @fires InputChannel#event:controlchange-highresolutionvelocityprefix
 * @fires InputChannel#event:controlchange-effect1depth
 * @fires InputChannel#event:controlchange-effect2depth
 * @fires InputChannel#event:controlchange-effect3depth
 * @fires InputChannel#event:controlchange-effect4depth
 * @fires InputChannel#event:controlchange-effect5depth
 * @fires InputChannel#event:controlchange-dataincrement
 * @fires InputChannel#event:controlchange-datadecrement
 * @fires InputChannel#event:controlchange-nonregisteredparameterfine
 * @fires InputChannel#event:controlchange-nonregisteredparametercoarse
 * @fires InputChannel#event:controlchange-registeredparameterfine
 * @fires InputChannel#event:controlchange-registeredparametercoarse
 * @fires InputChannel#event:controlchange-allsoundoff
 * @fires InputChannel#event:controlchange-resetallcontrollers
 * @fires InputChannel#event:controlchange-localcontrol
 * @fires InputChannel#event:controlchange-allnotesoff
 * @fires InputChannel#event:controlchange-omnimodeoff
 * @fires InputChannel#event:controlchange-omnimodeon
 * @fires InputChannel#event:controlchange-monomodeon
 * @fires InputChannel#event:controlchange-polymodeon
 * @fires InputChannel#event:
 *
 * @extends EventEmitter
 * @license Apache-2.0
 * @since 3.0.0
 */ class InputChannel extends EventEmitter {
    constructor(e, t){
        super(), this._input = e, this._number = t, this._octaveOffset = 0, this._nrpnBuffer = [], this._rpnBuffer = [], this.parameterNumberEventsEnabled = !0, this.notesState = new Array(128).fill(!1);
    }
    destroy() {
        this._input = null, this._number = null, this._octaveOffset = 0, this._nrpnBuffer = [], this.notesState = new Array(128).fill(!1), this.parameterNumberEventsEnabled = !1, this.removeListener();
    }
    _processMidiMessageEvent(e) {
        const t = Object.assign({}, e);
        t.port = this.input, t.target = this, t.type = "midimessage", this.emit(t.type, t), this._parseEventForStandardMessages(t);
    }
    _parseEventForStandardMessages(e) {
        const t = Object.assign({}, e);
        t.type = t.message.type || "unknownmessage";
        const n = e.message.dataBytes[0], r = e.message.dataBytes[1];
        if ("noteoff" === t.type || "noteon" === t.type && 0 === r) this.notesState[n] = !1, t.type = "noteoff", t.note = new Note(Utilities.offsetNumber(n, this.octaveOffset + this.input.octaveOffset + wm.octaveOffset), {
            rawAttack: 0,
            rawRelease: r
        }), t.value = Utilities.from7bitToFloat(r), t.rawValue = r, t.velocity = t.note.release, t.rawVelocity = t.note.rawRelease;
        else if ("noteon" === t.type) this.notesState[n] = !0, t.note = new Note(Utilities.offsetNumber(n, this.octaveOffset + this.input.octaveOffset + wm.octaveOffset), {
            rawAttack: r
        }), t.value = Utilities.from7bitToFloat(r), t.rawValue = r, t.velocity = t.note.attack, t.rawVelocity = t.note.rawAttack;
        else if ("keyaftertouch" === t.type) t.note = new Note(Utilities.offsetNumber(n, this.octaveOffset + this.input.octaveOffset + wm.octaveOffset)), t.value = Utilities.from7bitToFloat(r), t.rawValue = r, t.identifier = t.note.identifier, t.key = t.note.number, t.rawKey = n;
        else if ("controlchange" === t.type) {
            t.controller = {
                number: n,
                name: Enumerations.CONTROL_CHANGE_MESSAGES[n].name,
                description: Enumerations.CONTROL_CHANGE_MESSAGES[n].description,
                position: Enumerations.CONTROL_CHANGE_MESSAGES[n].position
            }, t.subtype = t.controller.name || "controller" + n, t.value = Utilities.from7bitToFloat(r), t.rawValue = r;
            const e = Object.assign({}, t);
            e.type = `${t.type}-controller${n}`, delete e.subtype, this.emit(e.type, e);
            const i = Object.assign({}, t);
            i.type = t.type + "-" + Enumerations.CONTROL_CHANGE_MESSAGES[n].name, delete i.subtype, 0 !== i.type.indexOf("controller") && this.emit(i.type, i), t.message.dataBytes[0] >= 120 && this._parseChannelModeMessage(t), this.parameterNumberEventsEnabled && this._isRpnOrNrpnController(t.message.dataBytes[0]) && this._parseEventForParameterNumber(t);
        } else "programchange" === t.type ? (t.value = n, t.rawValue = t.value) : "channelaftertouch" === t.type ? (t.value = Utilities.from7bitToFloat(n), t.rawValue = n) : "pitchbend" === t.type ? (t.value = ((r << 7) + n - 8192) / 8192, t.rawValue = (r << 7) + n) : t.type = "unknownmessage";
        this.emit(t.type, t);
    }
    _parseChannelModeMessage(e) {
        const t = Object.assign({}, e);
        t.type = t.controller.name, "localcontrol" === t.type && (t.value = 127 === t.message.data[2], t.rawValue = t.message.data[2]), "omnimodeon" === t.type ? (t.type = "omnimode", t.value = !0, t.rawValue = t.message.data[2]) : "omnimodeoff" === t.type && (t.type = "omnimode", t.value = !1, t.rawValue = t.message.data[2]), "monomodeon" === t.type ? (t.type = "monomode", t.value = !0, t.rawValue = t.message.data[2]) : "polymodeon" === t.type && (t.type = "monomode", t.value = !1, t.rawValue = t.message.data[2]), this.emit(t.type, t);
    }
    _parseEventForParameterNumber(e) {
        const t = e.message.dataBytes[0], n = e.message.dataBytes[1];
        99 === t || 101 === t ? (this._nrpnBuffer = [], this._rpnBuffer = [], 99 === t ? this._nrpnBuffer = [
            e.message
        ] : 127 !== n && (this._rpnBuffer = [
            e.message
        ])) : 98 === t || 100 === t ? 98 === t ? (this._rpnBuffer = [], 1 === this._nrpnBuffer.length ? this._nrpnBuffer.push(e.message) : this._nrpnBuffer = []) : (this._nrpnBuffer = [], 1 === this._rpnBuffer.length && 127 !== n ? this._rpnBuffer.push(e.message) : this._rpnBuffer = []) : 6 !== t && 38 !== t && 96 !== t && 97 !== t || (2 === this._rpnBuffer.length ? this._dispatchParameterNumberEvent("rpn", this._rpnBuffer[0].dataBytes[1], this._rpnBuffer[1].dataBytes[1], e) : 2 === this._nrpnBuffer.length ? this._dispatchParameterNumberEvent("nrpn", this._nrpnBuffer[0].dataBytes[1], this._nrpnBuffer[1].dataBytes[1], e) : (this._nrpnBuffer = [], this._rpnBuffer = []));
    }
    _isRpnOrNrpnController(e) {
        return 6 === e || 38 === e || 96 === e || 97 === e || 98 === e || 99 === e || 100 === e || 101 === e;
    }
    _dispatchParameterNumberEvent(e, t, n, r) {
        e = "nrpn" === e ? "nrpn" : "rpn";
        const i = {
            target: r.target,
            timestamp: r.timestamp,
            message: r.message,
            parameterMsb: t,
            parameterLsb: n,
            value: Utilities.from7bitToFloat(r.message.dataBytes[1]),
            rawValue: r.message.dataBytes[1]
        };
        i.parameter = "rpn" === e ? Object.keys(Enumerations.REGISTERED_PARAMETERS).find((e)=>Enumerations.REGISTERED_PARAMETERS[e][0] === t && Enumerations.REGISTERED_PARAMETERS[e][1] === n) : (t << 7) + n;
        const s = Enumerations.CONTROL_CHANGE_MESSAGES[r.message.dataBytes[0]].name;
        i.type = `${e}-${s}`, this.emit(i.type, i);
        const a = Object.assign({}, i);
        "nrpn-dataincrement" === a.type ? a.type = "nrpn-databuttonincrement" : "nrpn-datadecrement" === a.type ? a.type = "nrpn-databuttondecrement" : "rpn-dataincrement" === a.type ? a.type = "rpn-databuttonincrement" : "rpn-datadecrement" === a.type && (a.type = "rpn-databuttondecrement"), this.emit(a.type, a), i.type = e, i.subtype = s, this.emit(i.type, i);
    }
    getChannelModeByNumber(e) {
        return wm.validation && (console.warn("The 'getChannelModeByNumber()' method has been moved to the 'Utilities' class."), e = Math.floor(e)), Utilities.getChannelModeByNumber(e);
    }
    getCcNameByNumber(e) {
        if (wm.validation && (console.warn("The 'getCcNameByNumber()' method has been moved to the 'Utilities' class."), !((e = parseInt(e)) >= 0 && e <= 127))) throw new RangeError("Invalid control change number.");
        return Utilities.getCcNameByNumber(e);
    }
    getNoteState(e) {
        e instanceof Note && (e = e.identifier);
        const t = Utilities.guessNoteNumber(e, wm.octaveOffset + this.input.octaveOffset + this.octaveOffset);
        return this.notesState[t];
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e) {
        if (this.validation && (e = parseInt(e), isNaN(e))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e;
    }
    get input() {
        return this._input;
    }
    get number() {
        return this._number;
    }
    get nrpnEventsEnabled() {
        return this.parameterNumberEventsEnabled;
    }
    set nrpnEventsEnabled(e) {
        this.validation && (e = !!e), this.parameterNumberEventsEnabled = e;
    }
}
/**
 * The `Message` class represents a single MIDI message. It has several properties that make it
 * easy to make sense of the binary data it contains.
 *
 * @license Apache-2.0
 * @since 3.0.0
 */ class Message {
    constructor(e){
        this.rawData = e, this.data = Array.from(this.rawData), this.statusByte = this.rawData[0], this.rawDataBytes = this.rawData.slice(1), this.dataBytes = this.data.slice(1), this.isChannelMessage = !1, this.isSystemMessage = !1, this.command = void 0, this.channel = void 0, this.manufacturerId = void 0, this.type = void 0, this.statusByte < 240 ? (this.isChannelMessage = !0, this.command = this.statusByte >> 4, this.channel = 1 + (15 & this.statusByte)) : (this.isSystemMessage = !0, this.command = this.statusByte), this.isChannelMessage ? this.type = Utilities.getPropertyByValue(Enumerations.CHANNEL_MESSAGES, this.command) : this.isSystemMessage && (this.type = Utilities.getPropertyByValue(Enumerations.SYSTEM_MESSAGES, this.command)), this.statusByte === Enumerations.SYSTEM_MESSAGES.sysex && (0 === this.dataBytes[0] ? (this.manufacturerId = this.dataBytes.slice(0, 3), this.dataBytes = this.dataBytes.slice(3, this.rawDataBytes.length - 1), this.rawDataBytes = this.rawDataBytes.slice(3, this.rawDataBytes.length - 1)) : (this.manufacturerId = [
            this.dataBytes[0]
        ], this.dataBytes = this.dataBytes.slice(1, this.dataBytes.length - 1), this.rawDataBytes = this.rawDataBytes.slice(1, this.rawDataBytes.length - 1)));
    }
}
/**
 * The `Input` class represents a single MIDI input port. This object is automatically instantiated
 * by the library according to the host's MIDI subsystem and does not need to be directly
 * instantiated. Instead, you can access all `Input` objects by referring to the
 * [`WebMidi.inputs`](WebMidi#inputs) array. You can also retrieve inputs by using methods such as
 * [`WebMidi.getInputByName()`](WebMidi#getInputByName) and
 * [`WebMidi.getInputById()`](WebMidi#getInputById).
 *
 * Note that a single MIDI device may expose several inputs and/or outputs.
 *
 * **Important**: the `Input` class does not directly fire channel-specific MIDI messages
 * (such as [`noteon`](InputChannel#event:noteon) or
 * [`controlchange`](InputChannel#event:controlchange), etc.). The [`InputChannel`](InputChannel)
 * object does that. However, you can still use the
 * [`Input.addListener()`](#addListener) method to listen to channel-specific events on multiple
 * [`InputChannel`](InputChannel) objects at once.
 *
 * @fires Input#opened
 * @fires Input#disconnected
 * @fires Input#closed
 * @fires Input#midimessage
 *
 * @fires Input#sysex
 * @fires Input#timecode
 * @fires Input#songposition
 * @fires Input#songselect
 * @fires Input#tunerequest
 * @fires Input#clock
 * @fires Input#start
 * @fires Input#continue
 * @fires Input#stop
 * @fires Input#activesensing
 * @fires Input#reset
 *
 * @fires Input#unknownmidimessage
 *
 * @extends EventEmitter
 * @license Apache-2.0
 */ class Input extends EventEmitter {
    constructor(e){
        super(), this._midiInput = e, this._octaveOffset = 0, this.channels = [];
        for(let e = 1; e <= 16; e++)this.channels[e] = new InputChannel(this, e);
        this._forwarders = [], this._midiInput.onstatechange = this._onStateChange.bind(this), this._midiInput.onmidimessage = this._onMidiMessage.bind(this);
    }
    async destroy() {
        this.removeListener(), this.channels.forEach((e)=>e.destroy()), this.channels = [], this._forwarders = [], this._midiInput && (this._midiInput.onstatechange = null, this._midiInput.onmidimessage = null), await this.close(), this._midiInput = null;
    }
    _onStateChange(e) {
        let t = {
            timestamp: wm.time,
            target: this,
            port: this
        };
        "open" === e.port.connection ? (t.type = "opened", this.emit("opened", t)) : "closed" === e.port.connection && "connected" === e.port.state ? (t.type = "closed", this.emit("closed", t)) : "closed" === e.port.connection && "disconnected" === e.port.state ? (t.type = "disconnected", t.port = {
            connection: e.port.connection,
            id: e.port.id,
            manufacturer: e.port.manufacturer,
            name: e.port.name,
            state: e.port.state,
            type: e.port.type
        }, this.emit("disconnected", t)) : "pending" === e.port.connection && "disconnected" === e.port.state || console.warn("This statechange event was not caught: ", e.port.connection, e.port.state);
    }
    _onMidiMessage(e) {
        const t = new Message(e.data), n = {
            port: this,
            target: this,
            message: t,
            timestamp: e.timeStamp,
            type: "midimessage",
            data: t.data,
            rawData: t.data,
            statusByte: t.data[0],
            dataBytes: t.dataBytes
        };
        this.emit("midimessage", n), t.isSystemMessage ? this._parseEvent(n) : t.isChannelMessage && this.channels[t.channel]._processMidiMessageEvent(n), this._forwarders.forEach((e)=>e.forward(t));
    }
    _parseEvent(e) {
        const t = Object.assign({}, e);
        t.type = t.message.type || "unknownmidimessage", "songselect" === t.type && (t.song = e.data[1] + 1, t.value = e.data[1], t.rawValue = t.value), this.emit(t.type, t);
    }
    async open() {
        try {
            await this._midiInput.open();
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(this);
    }
    async close() {
        if (!this._midiInput) return Promise.resolve(this);
        try {
            await this._midiInput.close();
        } catch (e) {
            return Promise.reject(e);
        }
        return Promise.resolve(this);
    }
    getChannelModeByNumber() {
        wm.validation && console.warn("The 'getChannelModeByNumber()' method has been moved to the 'Utilities' class.");
    }
    addListener(e, t, n = {}) {
        if (wm.validation && "function" == typeof n) {
            let e = null != t ? [].concat(t) : void 0;
            t = n, n = {
                channels: e
            };
        }
        if (Enumerations.CHANNEL_EVENTS.includes(e)) {
            void 0 === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS);
            let r = [];
            return Utilities.sanitizeChannels(n.channels).forEach((i)=>{
                r.push(this.channels[i].addListener(e, t, n));
            }), r;
        }
        return super.addListener(e, t, n);
    }
    addOneTimeListener(e, t, n = {}) {
        return n.remaining = 1, this.addListener(e, t, n);
    }
    on(e, t, n, r) {
        return this.addListener(e, t, n, r);
    }
    hasListener(e, t, n = {}) {
        if (wm.validation && "function" == typeof n) {
            let e = [].concat(t);
            t = n, n = {
                channels: e
            };
        }
        return Enumerations.CHANNEL_EVENTS.includes(e) ? (void 0 === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), Utilities.sanitizeChannels(n.channels).every((n)=>this.channels[n].hasListener(e, t))) : super.hasListener(e, t);
    }
    removeListener(e, t, n = {}) {
        if (wm.validation && "function" == typeof n) {
            let e = [].concat(t);
            t = n, n = {
                channels: e
            };
        }
        if (void 0 === n.channels && (n.channels = Enumerations.MIDI_CHANNEL_NUMBERS), null == e) return Utilities.sanitizeChannels(n.channels).forEach((e)=>{
            this.channels[e] && this.channels[e].removeListener();
        }), super.removeListener();
        Enumerations.CHANNEL_EVENTS.includes(e) ? Utilities.sanitizeChannels(n.channels).forEach((r)=>{
            this.channels[r].removeListener(e, t, n);
        }) : super.removeListener(e, t, n);
    }
    addForwarder(e, t = {}) {
        let n;
        return n = e instanceof Forwarder ? e : new Forwarder(e, t), this._forwarders.push(n), n;
    }
    removeForwarder(e) {
        this._forwarders = this._forwarders.filter((t)=>t !== e);
    }
    hasForwarder(e) {
        return this._forwarders.includes(e);
    }
    get name() {
        return this._midiInput.name;
    }
    get id() {
        return this._midiInput.id;
    }
    get connection() {
        return this._midiInput.connection;
    }
    get manufacturer() {
        return this._midiInput.manufacturer;
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e) {
        if (this.validation && (e = parseInt(e), isNaN(e))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e;
    }
    get state() {
        return this._midiInput.state;
    }
    get type() {
        return this._midiInput.type;
    }
    get nrpnEventsEnabled() {
        return wm.validation && console.warn("The 'nrpnEventsEnabled' property has been moved to the 'InputChannel' class."), !1;
    }
}
if (Utilities.isNode) {
    try {
        window.navigator;
    } catch (err) {
        let jzz;
        eval('jzz = require("jzz")'), $parcel$global.navigator = jzz;
    }
    try {
        performance;
    } catch (err) {
        let performance1;
        eval('performance = require("perf_hooks").performance'), $parcel$global.performance = performance1;
    }
}
/**
 * The `WebMidi` object makes it easier to work with the low-level Web MIDI API. Basically, it
 * simplifies sending outgoing MIDI messages and reacting to incoming MIDI messages.
 *
 * When using the WebMidi.js library, you should know that the `WebMidi` class has already been
 * instantiated. You cannot instantiate it yourself. If you use the **IIFE** version, you should
 * simply use the global object called `WebMidi`. If you use the **CJS** (CommonJS) or **ESM** (ES6
 * module) version, you get an already-instantiated object when you import the module.
 *
 * @fires WebMidi#connected
 * @fires WebMidi#disabled
 * @fires WebMidi#disconnected
 * @fires WebMidi#enabled
 * @fires WebMidi#error
 * @fires WebMidi#midiaccessgranted
 * @fires WebMidi#portschanged
 *
 * @extends EventEmitter
 * @license Apache-2.0
 */ class WebMidi extends EventEmitter {
    constructor(){
        super(), this.defaults = {
            note: {
                attack: Utilities.from7bitToFloat(64),
                release: Utilities.from7bitToFloat(64),
                duration: 1 / 0
            }
        }, this.interface = null, this.validation = !0, this._inputs = [], this._disconnectedInputs = [], this._outputs = [], this._disconnectedOutputs = [], this._stateChangeQueue = [], this._octaveOffset = 0;
    }
    async enable(e = {}, t = !1) {
        if (this.validation = !1 !== e.validation, this.validation && ("function" == typeof e && (e = {
            callback: e,
            sysex: t
        }), t && (e.sysex = !0)), this.enabled) return "function" == typeof e.callback && e.callback(), Promise.resolve();
        const n = {
            timestamp: this.time,
            target: this,
            type: "error",
            error: void 0
        }, r = {
            timestamp: this.time,
            target: this,
            type: "midiaccessgranted"
        }, i = {
            timestamp: this.time,
            target: this,
            type: "enabled"
        };
        try {
            "function" == typeof e.requestMIDIAccessFunction ? this.interface = await e.requestMIDIAccessFunction({
                sysex: e.sysex,
                software: e.software
            }) : this.interface = await navigator.requestMIDIAccess({
                sysex: e.sysex,
                software: e.software
            });
        } catch (t) {
            return n.error = t, this.emit("error", n), "function" == typeof e.callback && e.callback(t), Promise.reject(t);
        }
        this.emit("midiaccessgranted", r), this.interface.onstatechange = this._onInterfaceStateChange.bind(this);
        try {
            await this._updateInputsAndOutputs();
        } catch (t) {
            return n.error = t, this.emit("error", n), "function" == typeof e.callback && e.callback(t), Promise.reject(t);
        }
        return this.emit("enabled", i), "function" == typeof e.callback && e.callback(), Promise.resolve(this);
    }
    async disable() {
        return this.interface && (this.interface.onstatechange = void 0), this._destroyInputsAndOutputs().then(()=>{
            navigator && "function" == typeof navigator.close && navigator.close(), this.interface = null;
            let e = {
                timestamp: this.time,
                target: this,
                type: "disabled"
            };
            this.emit("disabled", e), this.removeListener();
        });
    }
    getInputById(e, t = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e) return;
        }
        if (t.disconnected) {
            for(let t = 0; t < this._disconnectedInputs.length; t++)if (this._disconnectedInputs[t].id === e.toString()) return this._disconnectedInputs[t];
        } else for(let t = 0; t < this.inputs.length; t++)if (this.inputs[t].id === e.toString()) return this.inputs[t];
    }
    getInputByName(e, t = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e) return;
            e = e.toString();
        }
        if (t.disconnected) {
            for(let t = 0; t < this._disconnectedInputs.length; t++)if (~this._disconnectedInputs[t].name.indexOf(e)) return this._disconnectedInputs[t];
        } else for(let t = 0; t < this.inputs.length; t++)if (~this.inputs[t].name.indexOf(e)) return this.inputs[t];
    }
    getOutputByName(e, t = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e) return;
            e = e.toString();
        }
        if (t.disconnected) {
            for(let t = 0; t < this._disconnectedOutputs.length; t++)if (~this._disconnectedOutputs[t].name.indexOf(e)) return this._disconnectedOutputs[t];
        } else for(let t = 0; t < this.outputs.length; t++)if (~this.outputs[t].name.indexOf(e)) return this.outputs[t];
    }
    getOutputById(e, t = {
        disconnected: !1
    }) {
        if (this.validation) {
            if (!this.enabled) throw new Error("WebMidi is not enabled.");
            if (!e) return;
        }
        if (t.disconnected) {
            for(let t = 0; t < this._disconnectedOutputs.length; t++)if (this._disconnectedOutputs[t].id === e.toString()) return this._disconnectedOutputs[t];
        } else for(let t = 0; t < this.outputs.length; t++)if (this.outputs[t].id === e.toString()) return this.outputs[t];
    }
    noteNameToNumber(e) {
        return this.validation && console.warn("The noteNameToNumber() method is deprecated. Use Utilities.toNoteNumber() instead."), Utilities.toNoteNumber(e, this.octaveOffset);
    }
    getOctave(e) {
        return this.validation && (console.warn("The getOctave()is deprecated. Use Utilities.getNoteDetails() instead"), e = parseInt(e)), !isNaN(e) && e >= 0 && e <= 127 && Utilities.getNoteDetails(Utilities.offsetNumber(e, this.octaveOffset)).octave;
    }
    sanitizeChannels(e) {
        return this.validation && console.warn("The sanitizeChannels() method has been moved to the utilities class."), Utilities.sanitizeChannels(e);
    }
    toMIDIChannels(e) {
        return this.validation && console.warn("The toMIDIChannels() method has been deprecated. Use Utilities.sanitizeChannels() instead."), Utilities.sanitizeChannels(e);
    }
    guessNoteNumber(e) {
        return this.validation && console.warn("The guessNoteNumber() method has been deprecated. Use Utilities.guessNoteNumber() instead."), Utilities.guessNoteNumber(e, this.octaveOffset);
    }
    getValidNoteArray(e, t = {}) {
        return this.validation && console.warn("The getValidNoteArray() method has been moved to the Utilities.buildNoteArray()"), Utilities.buildNoteArray(e, t);
    }
    convertToTimestamp(e) {
        return this.validation && console.warn("The convertToTimestamp() method has been moved to Utilities.toTimestamp()."), Utilities.toTimestamp(e);
    }
    async _destroyInputsAndOutputs() {
        let e = [];
        return this.inputs.forEach((t)=>e.push(t.destroy())), this.outputs.forEach((t)=>e.push(t.destroy())), Promise.all(e).then(()=>{
            this._inputs = [], this._outputs = [];
        });
    }
    _onInterfaceStateChange(e) {
        this._updateInputsAndOutputs();
        let t = {
            timestamp: e.timeStamp,
            type: e.port.state,
            target: this
        };
        if ("connected" === e.port.state && "open" === e.port.connection) {
            "output" === e.port.type ? t.port = this.getOutputById(e.port.id) : "input" === e.port.type && (t.port = this.getInputById(e.port.id)), this.emit(e.port.state, t);
            const n = Object.assign({}, t);
            n.type = "portschanged", this.emit(n.type, n);
        } else if ("disconnected" === e.port.state && "pending" === e.port.connection) {
            "input" === e.port.type ? t.port = this.getInputById(e.port.id, {
                disconnected: !0
            }) : "output" === e.port.type && (t.port = this.getOutputById(e.port.id, {
                disconnected: !0
            })), this.emit(e.port.state, t);
            const n = Object.assign({}, t);
            n.type = "portschanged", this.emit(n.type, n);
        }
    }
    async _updateInputsAndOutputs() {
        return Promise.all([
            this._updateInputs(),
            this._updateOutputs()
        ]);
    }
    async _updateInputs() {
        if (!this.interface) return;
        for(let e = this._inputs.length - 1; e >= 0; e--){
            const t = this._inputs[e];
            Array.from(this.interface.inputs.values()).find((e)=>e === t._midiInput) || (this._disconnectedInputs.push(t), this._inputs.splice(e, 1));
        }
        let e = [];
        return this.interface.inputs.forEach((t)=>{
            if (!this._inputs.find((e)=>e._midiInput === t)) {
                let n = this._disconnectedInputs.find((e)=>e._midiInput === t);
                n || (n = new Input(t)), this._inputs.push(n), e.push(n.open());
            }
        }), Promise.all(e);
    }
    async _updateOutputs() {
        if (!this.interface) return;
        for(let e = this._outputs.length - 1; e >= 0; e--){
            const t = this._outputs[e];
            Array.from(this.interface.outputs.values()).find((e)=>e === t._midiOutput) || (this._disconnectedOutputs.push(t), this._outputs.splice(e, 1));
        }
        let e = [];
        return this.interface.outputs.forEach((t)=>{
            if (!this._outputs.find((e)=>e._midiOutput === t)) {
                let n = this._disconnectedOutputs.find((e)=>e._midiOutput === t);
                n || (n = new Output(t)), this._outputs.push(n), e.push(n.open());
            }
        }), Promise.all(e);
    }
    get enabled() {
        return null !== this.interface;
    }
    get inputs() {
        return this._inputs;
    }
    get isNode() {
        return this.validation && console.warn("WebMidi.isNode has been deprecated. Use Utilities.isNode instead."), Utilities.isNode;
    }
    get isBrowser() {
        return this.validation && console.warn("WebMidi.isBrowser has been deprecated. Use Utilities.isBrowser instead."), Utilities.isBrowser;
    }
    get octaveOffset() {
        return this._octaveOffset;
    }
    set octaveOffset(e) {
        if (this.validation && (e = parseInt(e), isNaN(e))) throw new TypeError("The 'octaveOffset' property must be an integer.");
        this._octaveOffset = e;
    }
    get outputs() {
        return this._outputs;
    }
    get supported() {
        return "undefined" != typeof navigator && navigator.requestMIDIAccess;
    }
    get sysexEnabled() {
        return !(!this.interface || !this.interface.sysexEnabled);
    }
    get time() {
        return performance.now();
    }
    get version() {
        return "3.1.6";
    }
    get flavour() {
        return "cjs";
    }
    get CHANNEL_EVENTS() {
        return this.validation && console.warn("The CHANNEL_EVENTS enum has been moved to Enumerations.CHANNEL_EVENTS."), Enumerations.CHANNEL_EVENTS;
    }
    get MIDI_SYSTEM_MESSAGES() {
        return this.validation && console.warn("The MIDI_SYSTEM_MESSAGES enum has been moved to Enumerations.SYSTEM_MESSAGES."), Enumerations.SYSTEM_MESSAGES;
    }
    get MIDI_CHANNEL_MODE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CHANNEL_MODE_MESSAGES enum has been moved to Enumerations.CHANNEL_MODE_MESSAGES."), Enumerations.CHANNEL_MODE_MESSAGES;
    }
    get MIDI_CONTROL_CHANGE_MESSAGES() {
        return this.validation && console.warn("The MIDI_CONTROL_CHANGE_MESSAGES enum has been replaced by the Enumerations.CONTROL_CHANGE_MESSAGES array."), Enumerations.MIDI_CONTROL_CHANGE_MESSAGES;
    }
    get MIDI_REGISTERED_PARAMETER() {
        return this.validation && console.warn("The MIDI_REGISTERED_PARAMETER enum has been moved to Enumerations.REGISTERED_PARAMETERS."), Enumerations.REGISTERED_PARAMETERS;
    }
    get NOTES() {
        return this.validation && console.warn("The NOTES enum has been deprecated."), [
            "C",
            "C#",
            "D",
            "D#",
            "E",
            "F",
            "F#",
            "G",
            "G#",
            "A",
            "A#",
            "B"
        ];
    }
}
const wm = new WebMidi;
wm.constructor = null, exports.Enumerations = Enumerations, exports.Forwarder = Forwarder, exports.Input = Input, exports.InputChannel = InputChannel, exports.Message = Message, exports.Note = Note, exports.Output = Output, exports.OutputChannel = OutputChannel, exports.Utilities = Utilities, exports.WebMidi = wm;

});
parcelRegister("17tgv", function(module, exports) {
// shim for using process in browser
var $0d0d255e14f785b6$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $0d0d255e14f785b6$var$cachedSetTimeout;
var $0d0d255e14f785b6$var$cachedClearTimeout;
function $0d0d255e14f785b6$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $0d0d255e14f785b6$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $0d0d255e14f785b6$var$cachedSetTimeout = setTimeout;
        else $0d0d255e14f785b6$var$cachedSetTimeout = $0d0d255e14f785b6$var$defaultSetTimout;
    } catch (e) {
        $0d0d255e14f785b6$var$cachedSetTimeout = $0d0d255e14f785b6$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $0d0d255e14f785b6$var$cachedClearTimeout = clearTimeout;
        else $0d0d255e14f785b6$var$cachedClearTimeout = $0d0d255e14f785b6$var$defaultClearTimeout;
    } catch (e) {
        $0d0d255e14f785b6$var$cachedClearTimeout = $0d0d255e14f785b6$var$defaultClearTimeout;
    }
})();
function $0d0d255e14f785b6$var$runTimeout(fun) {
    if ($0d0d255e14f785b6$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($0d0d255e14f785b6$var$cachedSetTimeout === $0d0d255e14f785b6$var$defaultSetTimout || !$0d0d255e14f785b6$var$cachedSetTimeout) && setTimeout) {
        $0d0d255e14f785b6$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0d0d255e14f785b6$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $0d0d255e14f785b6$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $0d0d255e14f785b6$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $0d0d255e14f785b6$var$runClearTimeout(marker) {
    if ($0d0d255e14f785b6$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($0d0d255e14f785b6$var$cachedClearTimeout === $0d0d255e14f785b6$var$defaultClearTimeout || !$0d0d255e14f785b6$var$cachedClearTimeout) && clearTimeout) {
        $0d0d255e14f785b6$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0d0d255e14f785b6$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $0d0d255e14f785b6$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $0d0d255e14f785b6$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $0d0d255e14f785b6$var$queue = [];
var $0d0d255e14f785b6$var$draining = false;
var $0d0d255e14f785b6$var$currentQueue;
var $0d0d255e14f785b6$var$queueIndex = -1;
function $0d0d255e14f785b6$var$cleanUpNextTick() {
    if (!$0d0d255e14f785b6$var$draining || !$0d0d255e14f785b6$var$currentQueue) return;
    $0d0d255e14f785b6$var$draining = false;
    if ($0d0d255e14f785b6$var$currentQueue.length) $0d0d255e14f785b6$var$queue = $0d0d255e14f785b6$var$currentQueue.concat($0d0d255e14f785b6$var$queue);
    else $0d0d255e14f785b6$var$queueIndex = -1;
    if ($0d0d255e14f785b6$var$queue.length) $0d0d255e14f785b6$var$drainQueue();
}
function $0d0d255e14f785b6$var$drainQueue() {
    if ($0d0d255e14f785b6$var$draining) return;
    var timeout = $0d0d255e14f785b6$var$runTimeout($0d0d255e14f785b6$var$cleanUpNextTick);
    $0d0d255e14f785b6$var$draining = true;
    var len = $0d0d255e14f785b6$var$queue.length;
    while(len){
        $0d0d255e14f785b6$var$currentQueue = $0d0d255e14f785b6$var$queue;
        $0d0d255e14f785b6$var$queue = [];
        while(++$0d0d255e14f785b6$var$queueIndex < len)if ($0d0d255e14f785b6$var$currentQueue) $0d0d255e14f785b6$var$currentQueue[$0d0d255e14f785b6$var$queueIndex].run();
        $0d0d255e14f785b6$var$queueIndex = -1;
        len = $0d0d255e14f785b6$var$queue.length;
    }
    $0d0d255e14f785b6$var$currentQueue = null;
    $0d0d255e14f785b6$var$draining = false;
    $0d0d255e14f785b6$var$runClearTimeout(timeout);
}
$0d0d255e14f785b6$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $0d0d255e14f785b6$var$queue.push(new $0d0d255e14f785b6$var$Item(fun, args));
    if ($0d0d255e14f785b6$var$queue.length === 1 && !$0d0d255e14f785b6$var$draining) $0d0d255e14f785b6$var$runTimeout($0d0d255e14f785b6$var$drainQueue);
};
// v8 likes predictible objects
function $0d0d255e14f785b6$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$0d0d255e14f785b6$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$0d0d255e14f785b6$var$process.title = "browser";
$0d0d255e14f785b6$var$process.browser = true;
$0d0d255e14f785b6$var$process.env = {};
$0d0d255e14f785b6$var$process.argv = [];
$0d0d255e14f785b6$var$process.version = ""; // empty string to avoid regexp issues
$0d0d255e14f785b6$var$process.versions = {};
function $0d0d255e14f785b6$var$noop() {}
$0d0d255e14f785b6$var$process.on = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.addListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.once = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.off = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.removeListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.removeAllListeners = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.emit = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.prependListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.prependOnceListener = $0d0d255e14f785b6$var$noop;
$0d0d255e14f785b6$var$process.listeners = function(name) {
    return [];
};
$0d0d255e14f785b6$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$0d0d255e14f785b6$var$process.cwd = function() {
    return "/";
};
$0d0d255e14f785b6$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$0d0d255e14f785b6$var$process.umask = function() {
    return 0;
};

});


var $231519b62b676521$exports = {};
"use strict";
var $a520a033728d73e4$exports = {};
"use strict";

var $fMiaA = parcelRequire("fMiaA");

$fMiaA.trust = (parcelRequire("gQsxe"));

$fMiaA.fragment = (parcelRequire("pcZwJ"));
$a520a033728d73e4$exports = $fMiaA;


var $de539031959a0ca1$exports = {};
"use strict";

var $9JY0H = parcelRequire("9JY0H");

var $gA8yJ = parcelRequire("gA8yJ");

$de539031959a0ca1$exports = (parcelRequire("6ePE9"))(typeof window !== "undefined" ? window : null, $9JY0H, $gA8yJ.redraw);



var $gA8yJ = parcelRequire("gA8yJ");
var $231519b62b676521$var$m = function m() {
    return $a520a033728d73e4$exports.apply(this, arguments);
};
$231519b62b676521$var$m.m = $a520a033728d73e4$exports;
$231519b62b676521$var$m.trust = $a520a033728d73e4$exports.trust;
$231519b62b676521$var$m.fragment = $a520a033728d73e4$exports.fragment;
$231519b62b676521$var$m.Fragment = "[";
$231519b62b676521$var$m.mount = $gA8yJ.mount;

$231519b62b676521$var$m.route = (parcelRequire("5NN5g"));

$231519b62b676521$var$m.render = (parcelRequire("03gNt"));
$231519b62b676521$var$m.redraw = $gA8yJ.redraw;
$231519b62b676521$var$m.request = $de539031959a0ca1$exports.request;
$231519b62b676521$var$m.jsonp = $de539031959a0ca1$exports.jsonp;

$231519b62b676521$var$m.parseQueryString = (parcelRequire("kRquH"));

$231519b62b676521$var$m.buildQueryString = (parcelRequire("4TqxV"));

$231519b62b676521$var$m.parsePathname = (parcelRequire("rLlma"));

$231519b62b676521$var$m.buildPathname = (parcelRequire("dVi4w"));

$231519b62b676521$var$m.vnode = (parcelRequire("8JOml"));

$231519b62b676521$var$m.PromisePolyfill = (parcelRequire("c0EvV"));

$231519b62b676521$var$m.censor = (parcelRequire("g0xgq"));
$231519b62b676521$exports = $231519b62b676521$var$m;




var $3895aa91744b6895$exports = {};
/**
 * alertifyjs 1.13.1 http://alertifyjs.com
 * AlertifyJS is a javascript framework for developing pretty browser dialogs and notifications.
 * Copyright 2019 Mohammad Younes <Mohammad@alertifyjs.com> (http://alertifyjs.com) 
 * Licensed under GPL 3 <https://opensource.org/licenses/gpl-3.0>*/ (function(window1) {
    "use strict";
    var NOT_DISABLED_NOT_RESET = ":not(:disabled):not(.ajs-reset)";
    /**
     * Keys enum
     * @type {Object}
     */ var keys = {
        ENTER: 13,
        ESC: 27,
        F1: 112,
        F12: 123,
        LEFT: 37,
        RIGHT: 39,
        TAB: 9
    };
    /**
     * Default options 
     * @type {Object}
     */ var defaults = {
        autoReset: true,
        basic: false,
        closable: true,
        closableByDimmer: true,
        invokeOnCloseOff: false,
        frameless: false,
        defaultFocusOff: false,
        maintainFocus: true,
        maximizable: true,
        modal: true,
        movable: true,
        moveBounded: false,
        overflow: true,
        padding: true,
        pinnable: true,
        pinned: true,
        preventBodyShift: false,
        resizable: true,
        startMaximized: false,
        transition: "pulse",
        transitionOff: false,
        tabbable: [
            "button",
            "[href]",
            "input",
            "select",
            "textarea",
            '[tabindex]:not([tabindex^="-"])' + NOT_DISABLED_NOT_RESET
        ].join(NOT_DISABLED_NOT_RESET + ","),
        notifier: {
            delay: 5,
            position: "bottom-right",
            closeButton: false,
            classes: {
                base: "alertify-notifier",
                prefix: "ajs-",
                message: "ajs-message",
                top: "ajs-top",
                right: "ajs-right",
                bottom: "ajs-bottom",
                left: "ajs-left",
                center: "ajs-center",
                visible: "ajs-visible",
                hidden: "ajs-hidden",
                close: "ajs-close"
            }
        },
        glossary: {
            title: "AlertifyJS",
            ok: "OK",
            cancel: "Cancel",
            acccpt: "Accept",
            deny: "Deny",
            confirm: "Confirm",
            decline: "Decline",
            close: "Close",
            maximize: "Maximize",
            restore: "Restore"
        },
        theme: {
            input: "ajs-input",
            ok: "ajs-ok",
            cancel: "ajs-cancel"
        },
        hooks: {
            preinit: function() {},
            postinit: function() {}
        }
    };
    //holds open dialogs instances
    var openDialogs = [];
    /**
     * [Helper]  Adds the specified class(es) to the element.
     *
     * @element {node}      The element
     * @className {string}  One or more space-separated classes to be added to the class attribute of the element.
     * 
     * @return {undefined}
     */ function addClass(element, classNames) {
        element.className += " " + classNames;
    }
    /**
     * [Helper]  Removes the specified class(es) from the element.
     *
     * @element {node}      The element
     * @className {string}  One or more space-separated classes to be removed from the class attribute of the element.
     * 
     * @return {undefined}
     */ function removeClass(element, classNames) {
        var original = element.className.split(" ");
        var toBeRemoved = classNames.split(" ");
        for(var x = 0; x < toBeRemoved.length; x += 1){
            var index = original.indexOf(toBeRemoved[x]);
            if (index > -1) original.splice(index, 1);
        }
        element.className = original.join(" ");
    }
    /**
     * [Helper]  Checks if the document is RTL
     *
     * @return {Boolean} True if the document is RTL, false otherwise.
     */ function isRightToLeft() {
        return window1.getComputedStyle(document.body).direction === "rtl";
    }
    /**
     * [Helper]  Get the document current scrollTop
     *
     * @return {Number} current document scrollTop value
     */ function getScrollTop() {
        return document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
    }
    /**
     * [Helper]  Get the document current scrollLeft
     *
     * @return {Number} current document scrollLeft value
     */ function getScrollLeft() {
        return document.documentElement && document.documentElement.scrollLeft || document.body.scrollLeft;
    }
    /**
    * Helper: clear contents
    *
    */ function clearContents(element) {
        while(element.lastChild)element.removeChild(element.lastChild);
    }
    /**
     * Extends a given prototype by merging properties from base into sub.
     *
     * @sub {Object} sub The prototype being overwritten.
     * @base {Object} base The prototype being written.
     *
     * @return {Object} The extended prototype.
     */ function copy(src) {
        if (null === src) return src;
        var cpy;
        if (Array.isArray(src)) {
            cpy = [];
            for(var x = 0; x < src.length; x += 1)cpy.push(copy(src[x]));
            return cpy;
        }
        if (src instanceof Date) return new Date(src.getTime());
        if (src instanceof RegExp) {
            cpy = new RegExp(src.source);
            cpy.global = src.global;
            cpy.ignoreCase = src.ignoreCase;
            cpy.multiline = src.multiline;
            cpy.lastIndex = src.lastIndex;
            return cpy;
        }
        if (typeof src === "object") {
            cpy = {};
            // copy dialog pototype over definition.
            for(var prop in src)if (src.hasOwnProperty(prop)) cpy[prop] = copy(src[prop]);
            return cpy;
        }
        return src;
    }
    /**
      * Helper: destruct the dialog
      *
      */ function destruct(instance, initialize) {
        if (instance.elements) {
            //delete the dom and it's references.
            var root = instance.elements.root;
            root.parentNode.removeChild(root);
            delete instance.elements;
            //copy back initial settings.
            instance.settings = copy(instance.__settings);
            //re-reference init function.
            instance.__init = initialize;
            //delete __internal variable to allow re-initialization.
            delete instance.__internal;
        }
    }
    /**
     * Test to check if passive event listeners are supported.
     */ var IsPassiveSupported = false;
    try {
        var options = Object.defineProperty({}, "passive", {
            get: function() {
                IsPassiveSupported = true;
            }
        });
        window1.addEventListener("test", options, options);
        window1.removeEventListener("test", options, options);
    } catch (e) {}
    /**
     * Removes an event listener
     *
     * @param {HTMLElement} el The EventTarget to register the listenr on.
     * @param {string} event The event type to listen for.
     * @param {Function} handler The function to handle the event.
     * @param {boolean} useCapture Specifices if the event to be dispatched to the registered listener before being dispatched to any EventTarget beneath it in the DOM tree.
     * @param {boolean} passive A Boolean which, if true, indicates that the function specified by listener will never call preventDefault().
     */ var on = function(el, event, fn, useCapture, passive) {
        el.addEventListener(event, fn, IsPassiveSupported ? {
            capture: useCapture,
            passive: passive
        } : useCapture === true);
    };
    /**
     * Removes an event listener
     *
     * @param {HTMLElement} el The EventTarget to unregister the listenr from.
     * @param {string} event The event type to remove.
     * @param {Function} fn The event handler to remove.
     * @param {boolean} useCapture Specifices if the event to be dispatched to the registered listener before being dispatched to any EventTarget beneath it in the DOM tree.
     * @param {boolean} passive A Boolean which, if true, indicates that the function specified by listener will never call preventDefault().
     */ var off = function(el, event, fn, useCapture, passive) {
        el.removeEventListener(event, fn, IsPassiveSupported ? {
            capture: useCapture,
            passive: passive
        } : useCapture === true);
    };
    /**
     * Prevent default event from firing
     *
     * @param  {Event} event Event object
     * @return {undefined}

    function prevent ( event ) {
        if ( event ) {
            if ( event.preventDefault ) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }
        }
    }
    */ var transition = function() {
        var t, type;
        var supported = false;
        var transitions = {
            "animation": "animationend",
            "OAnimation": "oAnimationEnd oanimationend",
            "msAnimation": "MSAnimationEnd",
            "MozAnimation": "animationend",
            "WebkitAnimation": "webkitAnimationEnd"
        };
        for(t in transitions)if (document.documentElement.style[t] !== undefined) {
            type = transitions[t];
            supported = true;
            break;
        }
        return {
            type: type,
            supported: supported
        };
    }();
    /**
    * Creates event handler delegate that sends the instance as last argument.
    * 
    * @return {Function}    a function wrapper which sends the instance as last argument.
    */ function delegate(context, method) {
        return function() {
            if (arguments.length > 0) {
                var args = [];
                for(var x = 0; x < arguments.length; x += 1)args.push(arguments[x]);
                args.push(context);
                return method.apply(context, args);
            }
            return method.apply(context, [
                null,
                context
            ]);
        };
    }
    /**
    * Helper for creating a dialog close event.
    * 
    * @return {object}
    */ function createCloseEvent(index, button) {
        return {
            index: index,
            button: button,
            cancel: false
        };
    }
    /**
    * Helper for dispatching events.
    *
    * @param  {string} evenType The type of the event to disptach.
    * @param  {object} instance The dialog instance disptaching the event.
    *
    * @return   {any}   The result of the invoked function.
    */ function dispatchEvent(eventType, instance) {
        if (typeof instance.get(eventType) === "function") return instance.get(eventType).call(instance);
    }
    /**
     * Super class for all dialogs
     *
     * @return {Object}		base dialog prototype
     */ var dialog = function() {
        var usedKeys = [], //dummy variable, used to trigger dom reflow.
        reflow = null, //holds body tab index in case it has any.
        tabindex = false, //condition for detecting safari
        isSafari = window1.navigator.userAgent.indexOf("Safari") > -1 && window1.navigator.userAgent.indexOf("Chrome") < 0, //dialog building blocks
        templates = {
            dimmer: '<div class="ajs-dimmer"></div>',
            /*tab index required to fire click event before body focus*/ modal: '<div class="ajs-modal" tabindex="0"></div>',
            dialog: '<div class="ajs-dialog" tabindex="0"></div>',
            reset: '<button class="ajs-reset"></button>',
            commands: '<div class="ajs-commands"><button class="ajs-pin"></button><button class="ajs-maximize"></button><button class="ajs-close"></button></div>',
            header: '<div class="ajs-header"></div>',
            body: '<div class="ajs-body"></div>',
            content: '<div class="ajs-content"></div>',
            footer: '<div class="ajs-footer"></div>',
            buttons: {
                primary: '<div class="ajs-primary ajs-buttons"></div>',
                auxiliary: '<div class="ajs-auxiliary ajs-buttons"></div>'
            },
            button: '<button class="ajs-button"></button>',
            resizeHandle: '<div class="ajs-handle"></div>'
        }, //common class names
        classes = {
            animationIn: "ajs-in",
            animationOut: "ajs-out",
            base: "alertify",
            basic: "ajs-basic",
            capture: "ajs-capture",
            closable: "ajs-closable",
            fixed: "ajs-fixed",
            frameless: "ajs-frameless",
            hidden: "ajs-hidden",
            maximize: "ajs-maximize",
            maximized: "ajs-maximized",
            maximizable: "ajs-maximizable",
            modeless: "ajs-modeless",
            movable: "ajs-movable",
            noSelection: "ajs-no-selection",
            noOverflow: "ajs-no-overflow",
            noPadding: "ajs-no-padding",
            pin: "ajs-pin",
            pinnable: "ajs-pinnable",
            prefix: "ajs-",
            resizable: "ajs-resizable",
            restore: "ajs-restore",
            shake: "ajs-shake",
            unpinned: "ajs-unpinned",
            noTransition: "ajs-no-transition"
        };
        /**
         * Helper: initializes the dialog instance
         * 
         * @return	{Number}	The total count of currently open modals.
         */ function initialize(instance) {
            if (!instance.__internal) {
                //invoke preinit global hook
                alertify.defaults.hooks.preinit(instance);
                //no need to expose init after this.
                delete instance.__init;
                //keep a copy of initial dialog settings
                if (!instance.__settings) instance.__settings = copy(instance.settings);
                //get dialog buttons/focus setup
                var setup;
                if (typeof instance.setup === "function") {
                    setup = instance.setup();
                    setup.options = setup.options || {};
                    setup.focus = setup.focus || {};
                } else setup = {
                    buttons: [],
                    focus: {
                        element: null,
                        select: false
                    },
                    options: {}
                };
                //initialize hooks object.
                if (typeof instance.hooks !== "object") instance.hooks = {};
                //copy buttons defintion
                var buttonsDefinition = [];
                if (Array.isArray(setup.buttons)) for(var b = 0; b < setup.buttons.length; b += 1){
                    var ref = setup.buttons[b], cpy = {};
                    for(var i in ref)if (ref.hasOwnProperty(i)) cpy[i] = ref[i];
                    buttonsDefinition.push(cpy);
                }
                var internal = instance.__internal = {
                    /**
                     * Flag holding the open state of the dialog
                     * 
                     * @type {Boolean}
                     */ isOpen: false,
                    /**
                     * Active element is the element that will receive focus after
                     * closing the dialog. It defaults as the body tag, but gets updated
                     * to the last focused element before the dialog was opened.
                     *
                     * @type {Node}
                     */ activeElement: document.body,
                    timerIn: undefined,
                    timerOut: undefined,
                    buttons: buttonsDefinition,
                    focus: setup.focus,
                    options: {
                        title: undefined,
                        modal: undefined,
                        basic: undefined,
                        frameless: undefined,
                        defaultFocusOff: undefined,
                        pinned: undefined,
                        movable: undefined,
                        moveBounded: undefined,
                        resizable: undefined,
                        autoReset: undefined,
                        closable: undefined,
                        closableByDimmer: undefined,
                        invokeOnCloseOff: undefined,
                        maximizable: undefined,
                        startMaximized: undefined,
                        pinnable: undefined,
                        transition: undefined,
                        transitionOff: undefined,
                        padding: undefined,
                        overflow: undefined,
                        onshow: undefined,
                        onclosing: undefined,
                        onclose: undefined,
                        onfocus: undefined,
                        onmove: undefined,
                        onmoved: undefined,
                        onresize: undefined,
                        onresized: undefined,
                        onmaximize: undefined,
                        onmaximized: undefined,
                        onrestore: undefined,
                        onrestored: undefined
                    },
                    resetHandler: undefined,
                    beginMoveHandler: undefined,
                    beginResizeHandler: undefined,
                    bringToFrontHandler: undefined,
                    modalClickHandler: undefined,
                    buttonsClickHandler: undefined,
                    commandsClickHandler: undefined,
                    transitionInHandler: undefined,
                    transitionOutHandler: undefined,
                    destroy: undefined
                };
                var elements = {};
                //root node
                elements.root = document.createElement("div");
                //prevent FOUC in case of async styles loading.
                elements.root.style.display = "none";
                elements.root.className = classes.base + " " + classes.hidden + " ";
                elements.root.innerHTML = templates.dimmer + templates.modal;
                //dimmer
                elements.dimmer = elements.root.firstChild;
                //dialog
                elements.modal = elements.root.lastChild;
                elements.modal.innerHTML = templates.dialog;
                elements.dialog = elements.modal.firstChild;
                elements.dialog.innerHTML = templates.reset + templates.commands + templates.header + templates.body + templates.footer + templates.resizeHandle + templates.reset;
                //reset links
                elements.reset = [];
                elements.reset.push(elements.dialog.firstChild);
                elements.reset.push(elements.dialog.lastChild);
                //commands
                elements.commands = {};
                elements.commands.container = elements.reset[0].nextSibling;
                elements.commands.pin = elements.commands.container.firstChild;
                elements.commands.maximize = elements.commands.pin.nextSibling;
                elements.commands.close = elements.commands.maximize.nextSibling;
                //header
                elements.header = elements.commands.container.nextSibling;
                //body
                elements.body = elements.header.nextSibling;
                elements.body.innerHTML = templates.content;
                elements.content = elements.body.firstChild;
                //footer
                elements.footer = elements.body.nextSibling;
                elements.footer.innerHTML = templates.buttons.auxiliary + templates.buttons.primary;
                //resize handle
                elements.resizeHandle = elements.footer.nextSibling;
                //buttons
                elements.buttons = {};
                elements.buttons.auxiliary = elements.footer.firstChild;
                elements.buttons.primary = elements.buttons.auxiliary.nextSibling;
                elements.buttons.primary.innerHTML = templates.button;
                elements.buttonTemplate = elements.buttons.primary.firstChild;
                //remove button template
                elements.buttons.primary.removeChild(elements.buttonTemplate);
                for(var x = 0; x < instance.__internal.buttons.length; x += 1){
                    var button = instance.__internal.buttons[x];
                    // add to the list of used keys.
                    if (usedKeys.indexOf(button.key) < 0) usedKeys.push(button.key);
                    button.element = elements.buttonTemplate.cloneNode();
                    button.element.innerHTML = button.text;
                    if (typeof button.className === "string" && button.className !== "") addClass(button.element, button.className);
                    for(var key in button.attrs)if (key !== "className" && button.attrs.hasOwnProperty(key)) button.element.setAttribute(key, button.attrs[key]);
                    if (button.scope === "auxiliary") elements.buttons.auxiliary.appendChild(button.element);
                    else elements.buttons.primary.appendChild(button.element);
                }
                //make elements pubic
                instance.elements = elements;
                //save event handlers delegates
                internal.resetHandler = delegate(instance, onReset);
                internal.beginMoveHandler = delegate(instance, beginMove);
                internal.beginResizeHandler = delegate(instance, beginResize);
                internal.bringToFrontHandler = delegate(instance, bringToFront);
                internal.modalClickHandler = delegate(instance, modalClickHandler);
                internal.buttonsClickHandler = delegate(instance, buttonsClickHandler);
                internal.commandsClickHandler = delegate(instance, commandsClickHandler);
                internal.transitionInHandler = delegate(instance, handleTransitionInEvent);
                internal.transitionOutHandler = delegate(instance, handleTransitionOutEvent);
                //settings
                for(var opKey in internal.options){
                    if (setup.options[opKey] !== undefined) // if found in user options
                    instance.set(opKey, setup.options[opKey]);
                    else if (alertify.defaults.hasOwnProperty(opKey)) // else if found in defaults options
                    instance.set(opKey, alertify.defaults[opKey]);
                    else if (opKey === "title") // else if title key, use alertify.defaults.glossary
                    instance.set(opKey, alertify.defaults.glossary[opKey]);
                }
                // allow dom customization
                if (typeof instance.build === "function") instance.build();
                //invoke postinit global hook
                alertify.defaults.hooks.postinit(instance);
            }
            //add to the end of the DOM tree.
            document.body.appendChild(instance.elements.root);
        }
        /**
         * Helper: maintains scroll position
         *
         */ var scrollX, scrollY;
        function saveScrollPosition() {
            scrollX = getScrollLeft();
            scrollY = getScrollTop();
        }
        function restoreScrollPosition() {
            window1.scrollTo(scrollX, scrollY);
        }
        /**
         * Helper: adds/removes no-overflow class from body
         *
         */ function ensureNoOverflow() {
            var requiresNoOverflow = 0;
            for(var x = 0; x < openDialogs.length; x += 1){
                var instance = openDialogs[x];
                if (instance.isModal() || instance.isMaximized()) requiresNoOverflow += 1;
            }
            if (requiresNoOverflow === 0 && document.body.className.indexOf(classes.noOverflow) >= 0) {
                //last open modal or last maximized one
                removeClass(document.body, classes.noOverflow);
                preventBodyShift(false);
            } else if (requiresNoOverflow > 0 && document.body.className.indexOf(classes.noOverflow) < 0) {
                //first open modal or first maximized one
                preventBodyShift(true);
                addClass(document.body, classes.noOverflow);
            }
        }
        var top = "", topScroll = 0;
        /**
         * Helper: prevents body shift.
         *
         */ function preventBodyShift(add) {
            if (alertify.defaults.preventBodyShift) {
                if (add && document.documentElement.scrollHeight > document.documentElement.clientHeight) {
                    topScroll = scrollY;
                    top = window1.getComputedStyle(document.body).top;
                    addClass(document.body, classes.fixed);
                    document.body.style.top = -scrollY + "px";
                } else if (!add) {
                    scrollY = topScroll;
                    document.body.style.top = top;
                    removeClass(document.body, classes.fixed);
                    restoreScrollPosition();
                }
            }
        }
        /**
         * Sets the name of the transition used to show/hide the dialog
         * 
         * @param {Object} instance The dilog instance.
         *
         */ function updateTransition(instance, value, oldValue) {
            if (typeof oldValue === "string") removeClass(instance.elements.root, classes.prefix + oldValue);
            addClass(instance.elements.root, classes.prefix + value);
            reflow = instance.elements.root.offsetWidth;
        }
        /**
         * Toggles the dialog no transition 
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function updateTransitionOff(instance) {
            if (instance.get("transitionOff")) // add class
            addClass(instance.elements.root, classes.noTransition);
            else // remove class
            removeClass(instance.elements.root, classes.noTransition);
        }
        /**
         * Toggles the dialog display mode
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function updateDisplayMode(instance) {
            if (instance.get("modal")) {
                //make modal
                removeClass(instance.elements.root, classes.modeless);
                //only if open
                if (instance.isOpen()) {
                    unbindModelessEvents(instance);
                    //in case a pinned modless dialog was made modal while open.
                    updateAbsPositionFix(instance);
                    ensureNoOverflow();
                }
            } else {
                //make modelss
                addClass(instance.elements.root, classes.modeless);
                //only if open
                if (instance.isOpen()) {
                    bindModelessEvents(instance);
                    //in case pin/unpin was called while a modal is open
                    updateAbsPositionFix(instance);
                    ensureNoOverflow();
                }
            }
        }
        /**
         * Toggles the dialog basic view mode 
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function updateBasicMode(instance) {
            if (instance.get("basic")) // add class
            addClass(instance.elements.root, classes.basic);
            else // remove class
            removeClass(instance.elements.root, classes.basic);
        }
        /**
         * Toggles the dialog frameless view mode 
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function updateFramelessMode(instance) {
            if (instance.get("frameless")) // add class
            addClass(instance.elements.root, classes.frameless);
            else // remove class
            removeClass(instance.elements.root, classes.frameless);
        }
        /**
         * Helper: Brings the modeless dialog to front, attached to modeless dialogs.
         *
         * @param {Event} event Focus event
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function bringToFront(event, instance) {
            // Do not bring to front if preceeded by an open modal
            var index = openDialogs.indexOf(instance);
            for(var x = index + 1; x < openDialogs.length; x += 1){
                if (openDialogs[x].isModal()) return;
            }
            // Bring to front by making it the last child.
            if (document.body.lastChild !== instance.elements.root) {
                document.body.appendChild(instance.elements.root);
                //also make sure its at the end of the list
                openDialogs.splice(openDialogs.indexOf(instance), 1);
                openDialogs.push(instance);
                setFocus(instance);
            }
            return false;
        }
        /**
         * Helper: reflects dialogs options updates
         *
         * @param {Object} instance The dilog instance.
         * @param {String} option The updated option name.
         *
         * @return	{undefined}	
         */ function optionUpdated(instance, option, oldValue, newValue) {
            switch(option){
                case "title":
                    instance.setHeader(newValue);
                    break;
                case "modal":
                    updateDisplayMode(instance);
                    break;
                case "basic":
                    updateBasicMode(instance);
                    break;
                case "frameless":
                    updateFramelessMode(instance);
                    break;
                case "pinned":
                    updatePinned(instance);
                    break;
                case "closable":
                    updateClosable(instance);
                    break;
                case "maximizable":
                    updateMaximizable(instance);
                    break;
                case "pinnable":
                    updatePinnable(instance);
                    break;
                case "movable":
                    updateMovable(instance);
                    break;
                case "resizable":
                    updateResizable(instance);
                    break;
                case "padding":
                    if (newValue) removeClass(instance.elements.root, classes.noPadding);
                    else if (instance.elements.root.className.indexOf(classes.noPadding) < 0) addClass(instance.elements.root, classes.noPadding);
                    break;
                case "overflow":
                    if (newValue) removeClass(instance.elements.root, classes.noOverflow);
                    else if (instance.elements.root.className.indexOf(classes.noOverflow) < 0) addClass(instance.elements.root, classes.noOverflow);
                    break;
                case "transition":
                    updateTransition(instance, newValue, oldValue);
                    break;
                case "transitionOff":
                    updateTransitionOff(instance);
                    break;
            }
            // internal on option updated event
            if (typeof instance.hooks.onupdate === "function") instance.hooks.onupdate.call(instance, option, oldValue, newValue);
        }
        /**
         * Helper: reflects dialogs options updates
         *
         * @param {Object} instance The dilog instance.
         * @param {Object} obj The object to set/get a value on/from.
         * @param {Function} callback The callback function to call if the key was found.
         * @param {String|Object} key A string specifying a propery name or a collection of key value pairs.
         * @param {Object} value Optional, the value associated with the key (in case it was a string).
         * @param {String} option The updated option name.
         *
         * @return	{Object} result object 
         *	The result objects has an 'op' property, indicating of this is a SET or GET operation.
         *		GET: 
         *		- found: a flag indicating if the key was found or not.
         *		- value: the property value.
         *		SET:
         *		- items: a list of key value pairs of the properties being set.
         *				each contains:
         *					- found: a flag indicating if the key was found or not.
         *					- key: the property key.
         *					- value: the property value.
         */ function update(instance, obj, callback, key, value) {
            var result = {
                op: undefined,
                items: []
            };
            if (typeof value === "undefined" && typeof key === "string") {
                //get
                result.op = "get";
                if (obj.hasOwnProperty(key)) {
                    result.found = true;
                    result.value = obj[key];
                } else {
                    result.found = false;
                    result.value = undefined;
                }
            } else {
                var old;
                //set
                result.op = "set";
                if (typeof key === "object") {
                    //set multiple
                    var args = key;
                    for(var prop in args)if (obj.hasOwnProperty(prop)) {
                        if (obj[prop] !== args[prop]) {
                            old = obj[prop];
                            obj[prop] = args[prop];
                            callback.call(instance, prop, old, args[prop]);
                        }
                        result.items.push({
                            "key": prop,
                            "value": args[prop],
                            "found": true
                        });
                    } else result.items.push({
                        "key": prop,
                        "value": args[prop],
                        "found": false
                    });
                } else if (typeof key === "string") {
                    //set single
                    if (obj.hasOwnProperty(key)) {
                        if (obj[key] !== value) {
                            old = obj[key];
                            obj[key] = value;
                            callback.call(instance, key, old, value);
                        }
                        result.items.push({
                            "key": key,
                            "value": value,
                            "found": true
                        });
                    } else result.items.push({
                        "key": key,
                        "value": value,
                        "found": false
                    });
                } else //invalid params
                throw new Error("args must be a string or object");
            }
            return result;
        }
        /**
         * Triggers a close event.
         *
         * @param {Object} instance	The dilog instance.
         * 
         * @return {undefined}
         */ function triggerClose(instance) {
            var found;
            triggerCallback(instance, function(button) {
                return found = instance.get("invokeOnCloseOff") !== true && button.invokeOnClose === true;
            });
            //none of the buttons registered as onclose callback
            //close the dialog
            if (!found && instance.isOpen()) instance.close();
        }
        /**
         * Dialogs commands event handler, attached to the dialog commands element.
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance	The dilog instance.
         * 
         * @return {undefined}
         */ function commandsClickHandler(event, instance) {
            var target = event.srcElement || event.target;
            switch(target){
                case instance.elements.commands.pin:
                    if (!instance.isPinned()) pin(instance);
                    else unpin(instance);
                    break;
                case instance.elements.commands.maximize:
                    if (!instance.isMaximized()) maximize(instance);
                    else restore(instance);
                    break;
                case instance.elements.commands.close:
                    triggerClose(instance);
                    break;
            }
            return false;
        }
        /**
         * Helper: pins the modeless dialog.
         *
         * @param {Object} instance	The dialog instance.
         * 
         * @return {undefined}
         */ function pin(instance) {
            //pin the dialog
            instance.set("pinned", true);
        }
        /**
         * Helper: unpins the modeless dialog.
         *
         * @param {Object} instance	The dilog instance.
         * 
         * @return {undefined}
         */ function unpin(instance) {
            //unpin the dialog 
            instance.set("pinned", false);
        }
        /**
         * Helper: enlarges the dialog to fill the entire screen.
         *
         * @param {Object} instance	The dilog instance.
         * 
         * @return {undefined}
         */ function maximize(instance) {
            // allow custom `onmaximize` method
            dispatchEvent("onmaximize", instance);
            //maximize the dialog 
            addClass(instance.elements.root, classes.maximized);
            if (instance.isOpen()) ensureNoOverflow();
            // allow custom `onmaximized` method
            dispatchEvent("onmaximized", instance);
        }
        /**
         * Helper: returns the dialog to its former size.
         *
         * @param {Object} instance	The dilog instance.
         * 
         * @return {undefined}
         */ function restore(instance) {
            // allow custom `onrestore` method
            dispatchEvent("onrestore", instance);
            //maximize the dialog 
            removeClass(instance.elements.root, classes.maximized);
            if (instance.isOpen()) ensureNoOverflow();
            // allow custom `onrestored` method
            dispatchEvent("onrestored", instance);
        }
        /**
         * Show or hide the maximize box.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */ function updatePinnable(instance) {
            if (instance.get("pinnable")) // add class
            addClass(instance.elements.root, classes.pinnable);
            else // remove class
            removeClass(instance.elements.root, classes.pinnable);
        }
        /**
         * Helper: Fixes the absolutly positioned modal div position.
         *
         * @param {Object} instance The dialog instance.
         *
         * @return {undefined}
         */ function addAbsPositionFix(instance) {
            var scrollLeft = getScrollLeft();
            instance.elements.modal.style.marginTop = getScrollTop() + "px";
            instance.elements.modal.style.marginLeft = scrollLeft + "px";
            instance.elements.modal.style.marginRight = -scrollLeft + "px";
        }
        /**
         * Helper: Removes the absolutly positioned modal div position fix.
         *
         * @param {Object} instance The dialog instance.
         *
         * @return {undefined}
         */ function removeAbsPositionFix(instance) {
            var marginTop = parseInt(instance.elements.modal.style.marginTop, 10);
            var marginLeft = parseInt(instance.elements.modal.style.marginLeft, 10);
            instance.elements.modal.style.marginTop = "";
            instance.elements.modal.style.marginLeft = "";
            instance.elements.modal.style.marginRight = "";
            if (instance.isOpen()) {
                var top = 0, left = 0;
                if (instance.elements.dialog.style.top !== "") top = parseInt(instance.elements.dialog.style.top, 10);
                instance.elements.dialog.style.top = top + (marginTop - getScrollTop()) + "px";
                if (instance.elements.dialog.style.left !== "") left = parseInt(instance.elements.dialog.style.left, 10);
                instance.elements.dialog.style.left = left + (marginLeft - getScrollLeft()) + "px";
            }
        }
        /**
         * Helper: Adds/Removes the absolutly positioned modal div position fix based on its pinned setting.
         *
         * @param {Object} instance The dialog instance.
         *
         * @return {undefined}
         */ function updateAbsPositionFix(instance) {
            // if modeless and unpinned add fix
            if (!instance.get("modal") && !instance.get("pinned")) addAbsPositionFix(instance);
            else removeAbsPositionFix(instance);
        }
        /**
         * Toggles the dialog position lock | modeless only.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to make it modal, false otherwise.
         *
         * @return {undefined}
         */ function updatePinned(instance) {
            if (instance.get("pinned")) {
                removeClass(instance.elements.root, classes.unpinned);
                if (instance.isOpen()) removeAbsPositionFix(instance);
            } else {
                addClass(instance.elements.root, classes.unpinned);
                if (instance.isOpen() && !instance.isModal()) addAbsPositionFix(instance);
            }
        }
        /**
         * Show or hide the maximize box.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */ function updateMaximizable(instance) {
            if (instance.get("maximizable")) // add class
            addClass(instance.elements.root, classes.maximizable);
            else // remove class
            removeClass(instance.elements.root, classes.maximizable);
        }
        /**
         * Show or hide the close box.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */ function updateClosable(instance) {
            if (instance.get("closable")) {
                // add class
                addClass(instance.elements.root, classes.closable);
                bindClosableEvents(instance);
            } else {
                // remove class
                removeClass(instance.elements.root, classes.closable);
                unbindClosableEvents(instance);
            }
        }
        var cancelClick = false, modalClickHandlerTS = 0 // stores last click timestamp to prevent executing the handler twice on double click.
        ;
        /**
         * Helper: closes the modal dialog when clicking the modal
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function modalClickHandler(event, instance) {
            if (event.timeStamp - modalClickHandlerTS > 200 && (modalClickHandlerTS = event.timeStamp) && !cancelClick) {
                var target = event.srcElement || event.target;
                if (instance.get("closableByDimmer") === true && target === instance.elements.modal) triggerClose(instance);
            }
            cancelClick = false;
        }
        // stores last call timestamp to prevent triggering the callback twice.
        var callbackTS = 0;
        // flag to cancel keyup event if already handled by click event (pressing Enter on a focusted button).
        var cancelKeyup = false;
        /** 
         * Helper: triggers a button callback
         *
         * @param {Object}		The dilog instance.
         * @param {Function}	Callback to check which button triggered the event.
         *
         * @return {undefined}
         */ function triggerCallback(instance, check) {
            if (Date.now() - callbackTS > 200 && (callbackTS = Date.now())) for(var idx = 0; idx < instance.__internal.buttons.length; idx += 1){
                var button = instance.__internal.buttons[idx];
                if (!button.element.disabled && check(button)) {
                    var closeEvent = createCloseEvent(idx, button);
                    if (typeof instance.callback === "function") instance.callback.apply(instance, [
                        closeEvent
                    ]);
                    //close the dialog only if not canceled.
                    if (closeEvent.cancel === false) instance.close();
                    break;
                }
            }
        }
        /**
         * Clicks event handler, attached to the dialog footer.
         *
         * @param {Event}		DOM event object.
         * @param {Object}		The dilog instance.
         * 
         * @return {undefined}
         */ function buttonsClickHandler(event, instance) {
            var target = event.srcElement || event.target;
            triggerCallback(instance, function(button) {
                // if this button caused the click, cancel keyup event
                return button.element === target && (cancelKeyup = true);
            });
        }
        /**
         * Keyup event handler, attached to the document.body
         *
         * @param {Event}		DOM event object.
         * @param {Object}		The dilog instance.
         * 
         * @return {undefined}
         */ function keyupHandler(event) {
            //hitting enter while button has focus will trigger keyup too.
            //ignore if handled by clickHandler
            if (cancelKeyup) {
                cancelKeyup = false;
                return;
            }
            var instance = openDialogs[openDialogs.length - 1];
            var keyCode = event.keyCode;
            if (instance.__internal.buttons.length === 0 && keyCode === keys.ESC && instance.get("closable") === true) {
                triggerClose(instance);
                return false;
            } else if (usedKeys.indexOf(keyCode) > -1) {
                triggerCallback(instance, function(button) {
                    return button.key === keyCode;
                });
                return false;
            }
        }
        /**
        * Keydown event handler, attached to the document.body
        *
        * @param {Event}		DOM event object.
        * @param {Object}		The dilog instance.
        * 
        * @return {undefined}
        */ function keydownHandler(event) {
            var instance = openDialogs[openDialogs.length - 1];
            var keyCode = event.keyCode;
            if (keyCode === keys.LEFT || keyCode === keys.RIGHT) {
                var buttons = instance.__internal.buttons;
                for(var x = 0; x < buttons.length; x += 1)if (document.activeElement === buttons[x].element) switch(keyCode){
                    case keys.LEFT:
                        buttons[(x || buttons.length) - 1].element.focus();
                        return;
                    case keys.RIGHT:
                        buttons[(x + 1) % buttons.length].element.focus();
                        return;
                }
            } else if (keyCode < keys.F12 + 1 && keyCode > keys.F1 - 1 && usedKeys.indexOf(keyCode) > -1) {
                event.preventDefault();
                event.stopPropagation();
                triggerCallback(instance, function(button) {
                    return button.key === keyCode;
                });
                return false;
            }
        }
        /**
         * Sets focus to proper dialog element
         *
         * @param {Object} instance The dilog instance.
         * @param {Node} [resetTarget=undefined] DOM element to reset focus to.
         *
         * @return {undefined}
         */ function setFocus(instance, resetTarget) {
            // reset target has already been determined.
            if (resetTarget) resetTarget.focus();
            else {
                // current instance focus settings
                var focus = instance.__internal.focus;
                // the focus element.
                var element = focus.element;
                switch(typeof focus.element){
                    // a number means a button index
                    case "number":
                        if (instance.__internal.buttons.length > focus.element) {
                            //in basic view, skip focusing the buttons.
                            if (instance.get("basic") === true) element = instance.elements.reset[0];
                            else element = instance.__internal.buttons[focus.element].element;
                        }
                        break;
                    // a string means querySelector to select from dialog body contents.
                    case "string":
                        element = instance.elements.body.querySelector(focus.element);
                        break;
                    // a function should return the focus element.
                    case "function":
                        element = focus.element.call(instance);
                        break;
                }
                // if no focus element, default to first reset element.
                if (instance.get("defaultFocusOff") === true || (typeof element === "undefined" || element === null) && instance.__internal.buttons.length === 0) element = instance.elements.reset[0];
                // focus
                if (element && element.focus) {
                    element.focus();
                    // if selectable
                    if (focus.select && element.select) element.select();
                }
            }
        }
        /**
         * Focus event handler, attached to document.body and dialogs own reset links.
         * handles the focus for modal dialogs only.
         *
         * @param {Event} event DOM focus event object.
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function onReset(event, instance) {
            // should work on last modal if triggered from document.body 
            if (!instance) {
                for(var x = openDialogs.length - 1; x > -1; x -= 1)if (openDialogs[x].isModal()) {
                    instance = openDialogs[x];
                    break;
                }
            }
            if (instance) // if modal
            {
                if (instance.isModal()) {
                    // determine reset target to enable forward/backward tab cycle.
                    var firstReset = instance.elements.reset[0], lastReset = instance.elements.reset[1], lastFocusedElement = event.relatedTarget, within = instance.elements.root.contains(lastFocusedElement), target = event.srcElement || event.target, resetTarget;
                    //if the previous focused element element was outside the modal do nthing
                    if (/*first show */ target === firstReset && !within || /*focus cycle */ target === lastReset && lastFocusedElement === firstReset) return;
                    else if (target === lastReset || target === document.body) resetTarget = firstReset;
                    else if (target === firstReset && lastFocusedElement === lastReset) resetTarget = findTabbable(instance);
                    else if (target === firstReset && within) resetTarget = findTabbable(instance, true);
                    // focus
                    setFocus(instance, resetTarget);
                }
            }
        }
        function findTabbable(instance, last) {
            var tabbables = [].slice.call(instance.elements.dialog.querySelectorAll(defaults.tabbable));
            if (last) tabbables.reverse();
            for(var x = 0; x < tabbables.length; x += 1){
                var tabbable = tabbables[x];
                //check if visible
                if (!!(tabbable.offsetParent || tabbable.offsetWidth || tabbable.offsetHeight || tabbable.getClientRects().length)) return tabbable;
            }
        }
        function recycleTab(event) {
            var instance = openDialogs[openDialogs.length - 1];
            if (instance && event.shiftKey && event.keyCode === keys.TAB) instance.elements.reset[1].focus();
        }
        /**
         * Transition in transitionend event handler. 
         *
         * @param {Event}		TransitionEnd event object.
         * @param {Object}		The dilog instance.
         *
         * @return {undefined}
         */ function handleTransitionInEvent(event, instance) {
            // clear the timer
            clearTimeout(instance.__internal.timerIn);
            // once transition is complete, set focus
            setFocus(instance);
            // allow handling key up after transition ended.
            cancelKeyup = false;
            // allow custom `onfocus` method
            dispatchEvent("onfocus", instance);
            // unbind the event
            off(instance.elements.dialog, transition.type, instance.__internal.transitionInHandler);
            removeClass(instance.elements.root, classes.animationIn);
        }
        /**
         * Transition out transitionend event handler. 
         *
         * @param {Event}		TransitionEnd event object.
         * @param {Object}		The dilog instance.
         *
         * @return {undefined}
         */ function handleTransitionOutEvent(event, instance) {
            // clear the timer
            clearTimeout(instance.__internal.timerOut);
            // unbind the event
            off(instance.elements.dialog, transition.type, instance.__internal.transitionOutHandler);
            // reset move updates
            resetMove(instance);
            // reset resize updates
            resetResize(instance);
            // restore if maximized
            if (instance.isMaximized() && !instance.get("startMaximized")) restore(instance);
            //destory the instance
            if (typeof instance.__internal.destroy === "function") instance.__internal.destroy.apply(instance);
        }
        /* Controls moving a dialog around */ //holde the current moving instance
        var movable = null, //holds the current X offset when move starts
        offsetX = 0, //holds the current Y offset when move starts
        offsetY = 0, xProp = "pageX", yProp = "pageY", bounds = null, refreshTop = false, moveDelegate = null;
        /**
         * Helper: sets the element top/left coordinates
         *
         * @param {Event} event	DOM event object.
         * @param {Node} element The element being moved.
         * 
         * @return {undefined}
         */ function moveElement(event, element) {
            var left = event[xProp] - offsetX, top = event[yProp] - offsetY;
            if (refreshTop) top -= document.body.scrollTop;
            element.style.left = left + "px";
            element.style.top = top + "px";
        }
        /**
         * Helper: sets the element top/left coordinates within screen bounds
         *
         * @param {Event} event	DOM event object.
         * @param {Node} element The element being moved.
         * 
         * @return {undefined}
         */ function moveElementBounded(event, element) {
            var left = event[xProp] - offsetX, top = event[yProp] - offsetY;
            if (refreshTop) top -= document.body.scrollTop;
            element.style.left = Math.min(bounds.maxLeft, Math.max(bounds.minLeft, left)) + "px";
            if (refreshTop) element.style.top = Math.min(bounds.maxTop, Math.max(bounds.minTop, top)) + "px";
            else element.style.top = Math.max(bounds.minTop, top) + "px";
        }
        /**
         * Triggers the start of a move event, attached to the header element mouse down event.
         * Adds no-selection class to the body, disabling selection while moving.
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance The dilog instance.
         * 
         * @return {Boolean} false
         */ function beginMove(event, instance) {
            if (resizable === null && !instance.isMaximized() && instance.get("movable")) {
                var eventSrc, left = 0, top = 0;
                if (event.type === "touchstart") {
                    event.preventDefault();
                    eventSrc = event.targetTouches[0];
                    xProp = "clientX";
                    yProp = "clientY";
                } else if (event.button === 0) eventSrc = event;
                if (eventSrc) {
                    var element = instance.elements.dialog;
                    addClass(element, classes.capture);
                    if (element.style.left) left = parseInt(element.style.left, 10);
                    if (element.style.top) top = parseInt(element.style.top, 10);
                    offsetX = eventSrc[xProp] - left;
                    offsetY = eventSrc[yProp] - top;
                    if (instance.isModal()) offsetY += instance.elements.modal.scrollTop;
                    else if (instance.isPinned()) offsetY -= document.body.scrollTop;
                    if (instance.get("moveBounded")) {
                        var current = element, offsetLeft = -left, offsetTop = -top;
                        //calc offset
                        do {
                            offsetLeft += current.offsetLeft;
                            offsetTop += current.offsetTop;
                        }while (current = current.offsetParent);
                        bounds = {
                            maxLeft: offsetLeft,
                            minLeft: -offsetLeft,
                            maxTop: document.documentElement.clientHeight - element.clientHeight - offsetTop,
                            minTop: -offsetTop
                        };
                        moveDelegate = moveElementBounded;
                    } else {
                        bounds = null;
                        moveDelegate = moveElement;
                    }
                    // allow custom `onmove` method
                    dispatchEvent("onmove", instance);
                    refreshTop = !instance.isModal() && instance.isPinned();
                    movable = instance;
                    moveDelegate(eventSrc, element);
                    addClass(document.body, classes.noSelection);
                    return false;
                }
            }
        }
        /**
         * The actual move handler,  attached to document.body mousemove event.
         *
         * @param {Event} event	DOM event object.
         * 
         * @return {undefined}
         */ function move(event) {
            if (movable) {
                var eventSrc;
                if (event.type === "touchmove") {
                    event.preventDefault();
                    eventSrc = event.targetTouches[0];
                } else if (event.button === 0) eventSrc = event;
                if (eventSrc) moveDelegate(eventSrc, movable.elements.dialog);
            }
        }
        /**
         * Triggers the end of a move event,  attached to document.body mouseup event.
         * Removes no-selection class from document.body, allowing selection.
         *
         * @return {undefined}
         */ function endMove() {
            if (movable) {
                var instance = movable;
                movable = bounds = null;
                removeClass(document.body, classes.noSelection);
                removeClass(instance.elements.dialog, classes.capture);
                // allow custom `onmoved` method
                dispatchEvent("onmoved", instance);
            }
        }
        /**
         * Resets any changes made by moving the element to its original state,
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function resetMove(instance) {
            movable = null;
            var element = instance.elements.dialog;
            element.style.left = element.style.top = "";
        }
        /**
         * Updates the dialog move behavior.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */ function updateMovable(instance) {
            if (instance.get("movable")) {
                // add class
                addClass(instance.elements.root, classes.movable);
                if (instance.isOpen()) bindMovableEvents(instance);
            } else {
                //reset
                resetMove(instance);
                // remove class
                removeClass(instance.elements.root, classes.movable);
                if (instance.isOpen()) unbindMovableEvents(instance);
            }
        }
        /* Controls moving a dialog around */ //holde the current instance being resized		
        var resizable = null, //holds the staring left offset when resize starts.
        startingLeft = Number.Nan, //holds the staring width when resize starts.
        startingWidth = 0, //holds the initial width when resized for the first time.
        minWidth = 0, //holds the offset of the resize handle.
        handleOffset = 0;
        /**
         * Helper: sets the element width/height and updates left coordinate if neccessary.
         *
         * @param {Event} event	DOM mousemove event object.
         * @param {Node} element The element being moved.
         * @param {Boolean} pinned A flag indicating if the element being resized is pinned to the screen.
         * 
         * @return {undefined}
         */ function resizeElement(event, element, pageRelative) {
            //calculate offsets from 0,0
            var current = element;
            var offsetLeft = 0;
            var offsetTop = 0;
            do {
                offsetLeft += current.offsetLeft;
                offsetTop += current.offsetTop;
            }while (current = current.offsetParent);
            // determine X,Y coordinates.
            var X, Y;
            if (pageRelative === true) {
                X = event.pageX;
                Y = event.pageY;
            } else {
                X = event.clientX;
                Y = event.clientY;
            }
            // rtl handling
            var isRTL = isRightToLeft();
            if (isRTL) {
                // reverse X 
                X = document.body.offsetWidth - X;
                // if has a starting left, calculate offsetRight
                if (!isNaN(startingLeft)) offsetLeft = document.body.offsetWidth - offsetLeft - element.offsetWidth;
            }
            // set width/height
            element.style.height = Y - offsetTop + handleOffset + "px";
            element.style.width = X - offsetLeft + handleOffset + "px";
            // if the element being resized has a starting left, maintain it.
            // the dialog is centered, divide by half the offset to maintain the margins.
            if (!isNaN(startingLeft)) {
                var diff = Math.abs(element.offsetWidth - startingWidth) * 0.5;
                if (isRTL) //negate the diff, why?
                //when growing it should decrease left
                //when shrinking it should increase left
                diff *= -1;
                if (element.offsetWidth > startingWidth) //growing
                element.style.left = startingLeft + diff + "px";
                else if (element.offsetWidth >= minWidth) //shrinking
                element.style.left = startingLeft - diff + "px";
            }
        }
        /**
         * Triggers the start of a resize event, attached to the resize handle element mouse down event.
         * Adds no-selection class to the body, disabling selection while moving.
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance The dilog instance.
         * 
         * @return {Boolean} false
         */ function beginResize(event, instance) {
            if (!instance.isMaximized()) {
                var eventSrc;
                if (event.type === "touchstart") {
                    event.preventDefault();
                    eventSrc = event.targetTouches[0];
                } else if (event.button === 0) eventSrc = event;
                if (eventSrc) {
                    // allow custom `onresize` method
                    dispatchEvent("onresize", instance);
                    resizable = instance;
                    handleOffset = instance.elements.resizeHandle.offsetHeight / 2;
                    var element = instance.elements.dialog;
                    addClass(element, classes.capture);
                    startingLeft = parseInt(element.style.left, 10);
                    element.style.height = element.offsetHeight + "px";
                    element.style.minHeight = instance.elements.header.offsetHeight + instance.elements.footer.offsetHeight + "px";
                    element.style.width = (startingWidth = element.offsetWidth) + "px";
                    if (element.style.maxWidth !== "none") element.style.minWidth = (minWidth = element.offsetWidth) + "px";
                    element.style.maxWidth = "none";
                    addClass(document.body, classes.noSelection);
                    return false;
                }
            }
        }
        /**
         * The actual resize handler,  attached to document.body mousemove event.
         *
         * @param {Event} event	DOM event object.
         * 
         * @return {undefined}
         */ function resize(event) {
            if (resizable) {
                var eventSrc;
                if (event.type === "touchmove") {
                    event.preventDefault();
                    eventSrc = event.targetTouches[0];
                } else if (event.button === 0) eventSrc = event;
                if (eventSrc) resizeElement(eventSrc, resizable.elements.dialog, !resizable.get("modal") && !resizable.get("pinned"));
            }
        }
        /**
         * Triggers the end of a resize event,  attached to document.body mouseup event.
         * Removes no-selection class from document.body, allowing selection.
         *
         * @return {undefined}
         */ function endResize() {
            if (resizable) {
                var instance = resizable;
                resizable = null;
                removeClass(document.body, classes.noSelection);
                removeClass(instance.elements.dialog, classes.capture);
                cancelClick = true;
                // allow custom `onresized` method
                dispatchEvent("onresized", instance);
            }
        }
        /**
         * Resets any changes made by resizing the element to its original state.
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function resetResize(instance) {
            resizable = null;
            var element = instance.elements.dialog;
            if (element.style.maxWidth === "none") {
                //clear inline styles.
                element.style.maxWidth = element.style.minWidth = element.style.width = element.style.height = element.style.minHeight = element.style.left = "";
                //reset variables.
                startingLeft = Number.Nan;
                startingWidth = minWidth = handleOffset = 0;
            }
        }
        /**
         * Updates the dialog move behavior.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */ function updateResizable(instance) {
            if (instance.get("resizable")) {
                // add class
                addClass(instance.elements.root, classes.resizable);
                if (instance.isOpen()) bindResizableEvents(instance);
            } else {
                //reset
                resetResize(instance);
                // remove class
                removeClass(instance.elements.root, classes.resizable);
                if (instance.isOpen()) unbindResizableEvents(instance);
            }
        }
        /**
         * Reset move/resize on window resize.
         *
         * @param {Event} event	window resize event object.
         *
         * @return {undefined}
         */ function windowResize() {
            for(var x = 0; x < openDialogs.length; x += 1){
                var instance = openDialogs[x];
                if (instance.get("autoReset")) {
                    resetMove(instance);
                    resetResize(instance);
                }
            }
        }
        /**
         * Bind dialogs events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function bindEvents(instance) {
            // if first dialog, hook global handlers
            if (openDialogs.length === 1) {
                //global
                on(window1, "resize", windowResize);
                on(document.body, "keyup", keyupHandler);
                on(document.body, "keydown", keydownHandler);
                on(document.body, "focus", onReset);
                //move
                on(document.documentElement, "mousemove", move);
                on(document.documentElement, "touchmove", move, false, false);
                on(document.documentElement, "mouseup", endMove);
                on(document.documentElement, "touchend", endMove);
                //resize
                on(document.documentElement, "mousemove", resize);
                on(document.documentElement, "touchmove", resize, false, false);
                on(document.documentElement, "mouseup", endResize);
                on(document.documentElement, "touchend", endResize);
            }
            // common events
            on(instance.elements.commands.container, "click", instance.__internal.commandsClickHandler);
            on(instance.elements.footer, "click", instance.__internal.buttonsClickHandler);
            on(instance.elements.reset[0], "focusin", instance.__internal.resetHandler);
            on(instance.elements.reset[0], "keydown", recycleTab);
            on(instance.elements.reset[1], "focusin", instance.__internal.resetHandler);
            //prevent handling key up when dialog is being opened by a key stroke.
            cancelKeyup = true;
            // hook in transition handler
            on(instance.elements.dialog, transition.type, instance.__internal.transitionInHandler);
            // modelss only events
            if (!instance.get("modal")) bindModelessEvents(instance);
            // resizable
            if (instance.get("resizable")) bindResizableEvents(instance);
            // movable
            if (instance.get("movable")) bindMovableEvents(instance);
        }
        /**
         * Unbind dialogs events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function unbindEvents(instance) {
            // if last dialog, remove global handlers
            if (openDialogs.length === 1) {
                //global
                off(window1, "resize", windowResize);
                off(document.body, "keyup", keyupHandler);
                off(document.body, "keydown", keydownHandler);
                off(document.body, "focus", onReset);
                //move
                off(document.documentElement, "mousemove", move);
                off(document.documentElement, "mouseup", endMove);
                //resize
                off(document.documentElement, "mousemove", resize);
                off(document.documentElement, "mouseup", endResize);
            }
            // common events
            off(instance.elements.commands.container, "click", instance.__internal.commandsClickHandler);
            off(instance.elements.footer, "click", instance.__internal.buttonsClickHandler);
            off(instance.elements.reset[0], "focusin", instance.__internal.resetHandler);
            off(instance.elements.reset[0], "keydown", recycleTab);
            off(instance.elements.reset[1], "focusin", instance.__internal.resetHandler);
            // hook out transition handler
            on(instance.elements.dialog, transition.type, instance.__internal.transitionOutHandler);
            // modelss only events
            if (!instance.get("modal")) unbindModelessEvents(instance);
            // movable
            if (instance.get("movable")) unbindMovableEvents(instance);
            // resizable
            if (instance.get("resizable")) unbindResizableEvents(instance);
        }
        /**
         * Bind modeless specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function bindModelessEvents(instance) {
            on(instance.elements.dialog, "focus", instance.__internal.bringToFrontHandler, true);
        }
        /**
         * Unbind modeless specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function unbindModelessEvents(instance) {
            off(instance.elements.dialog, "focus", instance.__internal.bringToFrontHandler, true);
        }
        /**
         * Bind movable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function bindMovableEvents(instance) {
            on(instance.elements.header, "mousedown", instance.__internal.beginMoveHandler);
            on(instance.elements.header, "touchstart", instance.__internal.beginMoveHandler, false, false);
        }
        /**
         * Unbind movable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function unbindMovableEvents(instance) {
            off(instance.elements.header, "mousedown", instance.__internal.beginMoveHandler);
            off(instance.elements.header, "touchstart", instance.__internal.beginMoveHandler, false, false);
        }
        /**
         * Bind resizable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function bindResizableEvents(instance) {
            on(instance.elements.resizeHandle, "mousedown", instance.__internal.beginResizeHandler);
            on(instance.elements.resizeHandle, "touchstart", instance.__internal.beginResizeHandler, false, false);
        }
        /**
         * Unbind resizable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function unbindResizableEvents(instance) {
            off(instance.elements.resizeHandle, "mousedown", instance.__internal.beginResizeHandler);
            off(instance.elements.resizeHandle, "touchstart", instance.__internal.beginResizeHandler, false, false);
        }
        /**
         * Bind closable events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function bindClosableEvents(instance) {
            on(instance.elements.modal, "click", instance.__internal.modalClickHandler);
        }
        /**
         * Unbind closable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */ function unbindClosableEvents(instance) {
            off(instance.elements.modal, "click", instance.__internal.modalClickHandler);
        }
        // dialog API
        return {
            __init: initialize,
            /**
             * Check if dialog is currently open
             *
             * @return {Boolean}
             */ isOpen: function() {
                return this.__internal.isOpen;
            },
            isModal: function() {
                return this.elements.root.className.indexOf(classes.modeless) < 0;
            },
            isMaximized: function() {
                return this.elements.root.className.indexOf(classes.maximized) > -1;
            },
            isPinned: function() {
                return this.elements.root.className.indexOf(classes.unpinned) < 0;
            },
            maximize: function() {
                if (!this.isMaximized()) maximize(this);
                return this;
            },
            restore: function() {
                if (this.isMaximized()) restore(this);
                return this;
            },
            pin: function() {
                if (!this.isPinned()) pin(this);
                return this;
            },
            unpin: function() {
                if (this.isPinned()) unpin(this);
                return this;
            },
            bringToFront: function() {
                bringToFront(null, this);
                return this;
            },
            /**
             * Move the dialog to a specific x/y coordinates
             *
             * @param {Number} x    The new dialog x coordinate in pixels.
             * @param {Number} y    The new dialog y coordinate in pixels.
             *
             * @return {Object} The dialog instance.
             */ moveTo: function(x, y) {
                if (!isNaN(x) && !isNaN(y)) {
                    // allow custom `onmove` method
                    dispatchEvent("onmove", this);
                    var element = this.elements.dialog, current = element, offsetLeft = 0, offsetTop = 0;
                    //subtract existing left,top
                    if (element.style.left) offsetLeft -= parseInt(element.style.left, 10);
                    if (element.style.top) offsetTop -= parseInt(element.style.top, 10);
                    //calc offset
                    do {
                        offsetLeft += current.offsetLeft;
                        offsetTop += current.offsetTop;
                    }while (current = current.offsetParent);
                    //calc left, top
                    var left = x - offsetLeft;
                    var top = y - offsetTop;
                    //// rtl handling
                    if (isRightToLeft()) left *= -1;
                    element.style.left = left + "px";
                    element.style.top = top + "px";
                    // allow custom `onmoved` method
                    dispatchEvent("onmoved", this);
                }
                return this;
            },
            /**
             * Resize the dialog to a specific width/height (the dialog must be 'resizable').
             * The dialog can be resized to:
             *  A minimum width equal to the initial display width
             *  A minimum height equal to the sum of header/footer heights.
             *
             *
             * @param {Number or String} width    The new dialog width in pixels or in percent.
             * @param {Number or String} height   The new dialog height in pixels or in percent.
             *
             * @return {Object} The dialog instance.
             */ resizeTo: function(width, height) {
                var w = parseFloat(width), h = parseFloat(height), regex = /(\d*\.\d+|\d+)%/;
                if (!isNaN(w) && !isNaN(h) && this.get("resizable") === true) {
                    // allow custom `onresize` method
                    dispatchEvent("onresize", this);
                    if (("" + width).match(regex)) w = w / 100 * document.documentElement.clientWidth;
                    if (("" + height).match(regex)) h = h / 100 * document.documentElement.clientHeight;
                    var element = this.elements.dialog;
                    if (element.style.maxWidth !== "none") element.style.minWidth = (minWidth = element.offsetWidth) + "px";
                    element.style.maxWidth = "none";
                    element.style.minHeight = this.elements.header.offsetHeight + this.elements.footer.offsetHeight + "px";
                    element.style.width = w + "px";
                    element.style.height = h + "px";
                    // allow custom `onresized` method
                    dispatchEvent("onresized", this);
                }
                return this;
            },
            /**
             * Gets or Sets dialog settings/options 
             *
             * @param {String|Object} key A string specifying a propery name or a collection of key/value pairs.
             * @param {Object} value Optional, the value associated with the key (in case it was a string).
             *
             * @return {undefined}
             */ setting: function(key, value) {
                var self = this;
                var result = update(this, this.__internal.options, function(k, o, n) {
                    optionUpdated(self, k, o, n);
                }, key, value);
                if (result.op === "get") {
                    if (result.found) return result.value;
                    else if (typeof this.settings !== "undefined") return update(this, this.settings, this.settingUpdated || function() {}, key, value).value;
                    else return undefined;
                } else if (result.op === "set") {
                    if (result.items.length > 0) {
                        var callback = this.settingUpdated || function() {};
                        for(var x = 0; x < result.items.length; x += 1){
                            var item = result.items[x];
                            if (!item.found && typeof this.settings !== "undefined") update(this, this.settings, callback, item.key, item.value);
                        }
                    }
                    return this;
                }
            },
            /**
             * [Alias] Sets dialog settings/options 
             */ set: function(key, value) {
                this.setting(key, value);
                return this;
            },
            /**
             * [Alias] Gets dialog settings/options 
             */ get: function(key) {
                return this.setting(key);
            },
            /**
            * Sets dialog header
            * @content {string or element}
            *
            * @return {undefined}
            */ setHeader: function(content) {
                if (typeof content === "string") {
                    clearContents(this.elements.header);
                    this.elements.header.innerHTML = content;
                } else if (content instanceof window1.HTMLElement && this.elements.header.firstChild !== content) {
                    clearContents(this.elements.header);
                    this.elements.header.appendChild(content);
                }
                return this;
            },
            /**
            * Sets dialog contents
            * @content {string or element}
            *
            * @return {undefined}
            */ setContent: function(content) {
                if (typeof content === "string") {
                    clearContents(this.elements.content);
                    this.elements.content.innerHTML = content;
                } else if (content instanceof window1.HTMLElement && this.elements.content.firstChild !== content) {
                    clearContents(this.elements.content);
                    this.elements.content.appendChild(content);
                }
                return this;
            },
            /**
             * Show the dialog as modal
             *
             * @return {Object} the dialog instance.
             */ showModal: function(className) {
                return this.show(true, className);
            },
            /**
             * Show the dialog
             *
             * @return {Object} the dialog instance.
             */ show: function(modal, className) {
                // ensure initialization
                initialize(this);
                if (!this.__internal.isOpen) {
                    // add to open dialogs
                    this.__internal.isOpen = true;
                    openDialogs.push(this);
                    // save last focused element
                    if (alertify.defaults.maintainFocus) this.__internal.activeElement = document.activeElement;
                    // set tabindex attribute on body element this allows script to give it focusable
                    if (!document.body.hasAttribute("tabindex")) document.body.setAttribute("tabindex", tabindex = "0");
                    //allow custom dom manipulation updates before showing the dialog.
                    if (typeof this.prepare === "function") this.prepare();
                    bindEvents(this);
                    if (modal !== undefined) this.set("modal", modal);
                    //save scroll to prevent document jump
                    saveScrollPosition();
                    ensureNoOverflow();
                    // allow custom dialog class on show
                    if (typeof className === "string" && className !== "") {
                        this.__internal.className = className;
                        addClass(this.elements.root, className);
                    }
                    // maximize if start maximized
                    if (this.get("startMaximized")) this.maximize();
                    else if (this.isMaximized()) restore(this);
                    updateAbsPositionFix(this);
                    this.elements.root.removeAttribute("style");
                    removeClass(this.elements.root, classes.animationOut);
                    addClass(this.elements.root, classes.animationIn);
                    // set 1s fallback in case transition event doesn't fire
                    clearTimeout(this.__internal.timerIn);
                    this.__internal.timerIn = setTimeout(this.__internal.transitionInHandler, transition.supported ? 1000 : 100);
                    if (isSafari) {
                        // force desktop safari reflow
                        var root = this.elements.root;
                        root.style.display = "none";
                        setTimeout(function() {
                            root.style.display = "block";
                        }, 0);
                    }
                    //reflow
                    reflow = this.elements.root.offsetWidth;
                    // show dialog
                    removeClass(this.elements.root, classes.hidden);
                    //restore scroll to prevent document jump
                    restoreScrollPosition();
                    // internal on show event
                    if (typeof this.hooks.onshow === "function") this.hooks.onshow.call(this);
                    // allow custom `onshow` method
                    dispatchEvent("onshow", this);
                } else {
                    // reset move updates
                    resetMove(this);
                    // reset resize updates
                    resetResize(this);
                    // shake the dialog to indicate its already open
                    addClass(this.elements.dialog, classes.shake);
                    var self = this;
                    setTimeout(function() {
                        removeClass(self.elements.dialog, classes.shake);
                    }, 200);
                }
                return this;
            },
            /**
             * Close the dialog
             *
             * @return {Object} The dialog instance
             */ close: function() {
                if (this.__internal.isOpen) // custom `onclosing` event
                {
                    if (dispatchEvent("onclosing", this) !== false) {
                        unbindEvents(this);
                        removeClass(this.elements.root, classes.animationIn);
                        addClass(this.elements.root, classes.animationOut);
                        // set 1s fallback in case transition event doesn't fire
                        clearTimeout(this.__internal.timerOut);
                        this.__internal.timerOut = setTimeout(this.__internal.transitionOutHandler, transition.supported ? 1000 : 100);
                        // hide dialog
                        addClass(this.elements.root, classes.hidden);
                        //reflow
                        reflow = this.elements.modal.offsetWidth;
                        // return focus to the last active element
                        if (alertify.defaults.maintainFocus && this.__internal.activeElement) {
                            this.__internal.activeElement.focus();
                            this.__internal.activeElement = null;
                        }
                        // remove custom dialog class on hide
                        if (typeof this.__internal.className !== "undefined" && this.__internal.className !== "") removeClass(this.elements.root, this.__internal.className);
                        // internal on close event
                        if (typeof this.hooks.onclose === "function") this.hooks.onclose.call(this);
                        // allow custom `onclose` method
                        dispatchEvent("onclose", this);
                        //remove from open dialogs
                        openDialogs.splice(openDialogs.indexOf(this), 1);
                        this.__internal.isOpen = false;
                        ensureNoOverflow();
                    }
                }
                // last dialog and tab index was set by us, remove it.
                if (!openDialogs.length && tabindex === "0") document.body.removeAttribute("tabindex");
                return this;
            },
            /**
             * Close all open dialogs except this.
             *
             * @return {undefined}
             */ closeOthers: function() {
                alertify.closeAll(this);
                return this;
            },
            /**
             * Destroys this dialog instance
             *
             * @return {undefined}
             */ destroy: function() {
                if (this.__internal) {
                    if (this.__internal.isOpen) {
                        //mark dialog for destruction, this will be called on tranistionOut event.
                        this.__internal.destroy = function() {
                            destruct(this, initialize);
                        };
                        //close the dialog to unbind all events.
                        this.close();
                    } else if (!this.__internal.destroy) destruct(this, initialize);
                }
                return this;
            }
        };
    }();
    var notifier = function() {
        var reflow, element, openInstances = [], classes = defaults.notifier.classes, baseClass = classes.base;
        /**
         * Helper: initializes the notifier instance
         *
         */ function initialize(instance) {
            if (!instance.__internal) {
                instance.__internal = {
                    position: alertify.defaults.notifier.position,
                    delay: alertify.defaults.notifier.delay
                };
                element = document.createElement("DIV");
                var transitionOff = "transitionOff" in defaults.notifier ? defaults.notifier.transitionOff : defaults.transitionOff;
                if (transitionOff) baseClass = classes.base + " ajs-no-transition";
                updatePosition(instance);
            }
            //add to DOM tree.
            if (element.parentNode !== document.body) document.body.appendChild(element);
        }
        function pushInstance(instance) {
            instance.__internal.pushed = true;
            openInstances.push(instance);
        }
        function popInstance(instance) {
            openInstances.splice(openInstances.indexOf(instance), 1);
            instance.__internal.pushed = false;
        }
        /**
         * Helper: update the notifier instance position
         *
         */ function updatePosition(instance) {
            element.className = baseClass;
            switch(instance.__internal.position){
                case "top-right":
                    addClass(element, classes.top + " " + classes.right);
                    break;
                case "top-left":
                    addClass(element, classes.top + " " + classes.left);
                    break;
                case "top-center":
                    addClass(element, classes.top + " " + classes.center);
                    break;
                case "bottom-left":
                    addClass(element, classes.bottom + " " + classes.left);
                    break;
                case "bottom-center":
                    addClass(element, classes.bottom + " " + classes.center);
                    break;
                default:
                case "bottom-right":
                    addClass(element, classes.bottom + " " + classes.right);
                    break;
            }
        }
        /**
        * creates a new notification message
        *
        * @param  {DOMElement} message	The notifier message element
        * @param  {Number} wait   Time (in ms) to wait before the message is dismissed, a value of 0 means keep open till clicked.
        * @param  {Function} callback A callback function to be invoked when the message is dismissed.
        *
        * @return {undefined}
        */ function create(div, callback) {
            function clickDelegate(event, instance) {
                if (!instance.__internal.closeButton || event.target.getAttribute("data-close") === "true") instance.dismiss(true);
            }
            function transitionDone(event, instance) {
                // unbind event
                off(instance.element, transition.type, transitionDone);
                // remove the message
                element.removeChild(instance.element);
            }
            function initialize(instance) {
                if (!instance.__internal) {
                    instance.__internal = {
                        pushed: false,
                        delay: undefined,
                        timer: undefined,
                        clickHandler: undefined,
                        transitionEndHandler: undefined,
                        transitionTimeout: undefined
                    };
                    instance.__internal.clickHandler = delegate(instance, clickDelegate);
                    instance.__internal.transitionEndHandler = delegate(instance, transitionDone);
                }
                return instance;
            }
            function clearTimers(instance) {
                clearTimeout(instance.__internal.timer);
                clearTimeout(instance.__internal.transitionTimeout);
            }
            return initialize({
                /* notification DOM element*/ element: div,
                /*
                 * Pushes a notification message
                 * @param {string or DOMElement} content The notification message content
                 * @param {Number} wait The time (in seconds) to wait before the message is dismissed, a value of 0 means keep open till clicked.
                 *
                 */ push: function(_content, _wait) {
                    if (!this.__internal.pushed) {
                        pushInstance(this);
                        clearTimers(this);
                        var content, wait;
                        switch(arguments.length){
                            case 0:
                                wait = this.__internal.delay;
                                break;
                            case 1:
                                if (typeof _content === "number") wait = _content;
                                else {
                                    content = _content;
                                    wait = this.__internal.delay;
                                }
                                break;
                            case 2:
                                content = _content;
                                wait = _wait;
                                break;
                        }
                        this.__internal.closeButton = alertify.defaults.notifier.closeButton;
                        // set contents
                        if (typeof content !== "undefined") this.setContent(content);
                        // append or insert
                        if (notifier.__internal.position.indexOf("top") < 0) element.appendChild(this.element);
                        else element.insertBefore(this.element, element.firstChild);
                        reflow = this.element.offsetWidth;
                        addClass(this.element, classes.visible);
                        // attach click event
                        on(this.element, "click", this.__internal.clickHandler);
                        return this.delay(wait);
                    }
                    return this;
                },
                /*
                 * {Function} callback function to be invoked before dismissing the notification message.
                 * Remarks: A return value === 'false' will cancel the dismissal
                 *
                 */ ondismiss: function() {},
                /*
                 * {Function} callback function to be invoked when the message is dismissed.
                 *
                 */ callback: callback,
                /*
                 * Dismisses the notification message
                 * @param {Boolean} clicked A flag indicating if the dismissal was caused by a click.
                 *
                 */ dismiss: function(clicked) {
                    if (this.__internal.pushed) {
                        clearTimers(this);
                        if (!(typeof this.ondismiss === "function" && this.ondismiss.call(this) === false)) {
                            //detach click event
                            off(this.element, "click", this.__internal.clickHandler);
                            // ensure element exists
                            if (typeof this.element !== "undefined" && this.element.parentNode === element) {
                                //transition end or fallback
                                this.__internal.transitionTimeout = setTimeout(this.__internal.transitionEndHandler, transition.supported ? 1000 : 100);
                                removeClass(this.element, classes.visible);
                                // custom callback on dismiss
                                if (typeof this.callback === "function") this.callback.call(this, clicked);
                            }
                            popInstance(this);
                        }
                    }
                    return this;
                },
                /*
                 * Delays the notification message dismissal
                 * @param {Number} wait The time (in seconds) to wait before the message is dismissed, a value of 0 means keep open till clicked.
                 *
                 */ delay: function(wait) {
                    clearTimers(this);
                    this.__internal.delay = typeof wait !== "undefined" && !isNaN(+wait) ? +wait : notifier.__internal.delay;
                    if (this.__internal.delay > 0) {
                        var self = this;
                        this.__internal.timer = setTimeout(function() {
                            self.dismiss();
                        }, this.__internal.delay * 1000);
                    }
                    return this;
                },
                /*
                 * Sets the notification message contents
                 * @param {string or DOMElement} content The notification message content
                 *
                 */ setContent: function(content) {
                    if (typeof content === "string") {
                        clearContents(this.element);
                        this.element.innerHTML = content;
                    } else if (content instanceof window1.HTMLElement && this.element.firstChild !== content) {
                        clearContents(this.element);
                        this.element.appendChild(content);
                    }
                    if (this.__internal.closeButton) {
                        var close = document.createElement("span");
                        addClass(close, classes.close);
                        close.setAttribute("data-close", true);
                        this.element.appendChild(close);
                    }
                    return this;
                },
                /*
                 * Dismisses all open notifications except this.
                 *
                 */ dismissOthers: function() {
                    notifier.dismissAll(this);
                    return this;
                }
            });
        }
        //notifier api
        return {
            /**
             * Gets or Sets notifier settings.
             *
             * @param {string} key The setting name
             * @param {Variant} value The setting value.
             *
             * @return {Object}	if the called as a setter, return the notifier instance.
             */ setting: function(key, value) {
                //ensure init
                initialize(this);
                if (typeof value === "undefined") //get
                return this.__internal[key];
                else //set
                switch(key){
                    case "position":
                        this.__internal.position = value;
                        updatePosition(this);
                        break;
                    case "delay":
                        this.__internal.delay = value;
                        break;
                }
                return this;
            },
            /**
             * [Alias] Sets dialog settings/options
             */ set: function(key, value) {
                this.setting(key, value);
                return this;
            },
            /**
             * [Alias] Gets dialog settings/options
             */ get: function(key) {
                return this.setting(key);
            },
            /**
             * Creates a new notification message
             *
             * @param {string} type The type of notification message (simply a CSS class name 'ajs-{type}' to be added).
             * @param {Function} callback  A callback function to be invoked when the message is dismissed.
             *
             * @return {undefined}
             */ create: function(type, callback) {
                //ensure notifier init
                initialize(this);
                //create new notification message
                var div = document.createElement("div");
                div.className = classes.message + (typeof type === "string" && type !== "" ? " " + classes.prefix + type : "");
                return create(div, callback);
            },
            /**
             * Dismisses all open notifications.
             *
             * @param {Object} excpet [optional] The notification object to exclude from dismissal.
             *
             */ dismissAll: function(except) {
                var clone = openInstances.slice(0);
                for(var x = 0; x < clone.length; x += 1){
                    var instance = clone[x];
                    if (except === undefined || except !== instance) instance.dismiss();
                }
            }
        };
    }();
    /**
     * Alertify public API
     * This contains everything that is exposed through the alertify object.
     *
     * @return {Object}
     */ function Alertify() {
        // holds a references of created dialogs
        var dialogs = {};
        /**
         * Extends a given prototype by merging properties from base into sub.
         *
         * @sub {Object} sub The prototype being overwritten.
         * @base {Object} base The prototype being written.
         *
         * @return {Object} The extended prototype.
         */ function extend(sub, base) {
            // copy dialog pototype over definition.
            for(var prop in base)if (base.hasOwnProperty(prop)) sub[prop] = base[prop];
            return sub;
        }
        /**
        * Helper: returns a dialog instance from saved dialogs.
        * and initializes the dialog if its not already initialized.
        *
        * @name {String} name The dialog name.
        *
        * @return {Object} The dialog instance.
        */ function get_dialog(name) {
            var dialog = dialogs[name].dialog;
            //initialize the dialog if its not already initialized.
            if (dialog && typeof dialog.__init === "function") dialog.__init(dialog);
            return dialog;
        }
        /**
         * Helper:  registers a new dialog definition.
         *
         * @name {String} name The dialog name.
         * @Factory {Function} Factory a function resposible for creating dialog prototype.
         * @transient {Boolean} transient True to create a new dialog instance each time the dialog is invoked, false otherwise.
         * @base {String} base the name of another dialog to inherit from.
         *
         * @return {Object} The dialog definition.
         */ function register(name, Factory, transient, base) {
            var definition = {
                dialog: null,
                factory: Factory
            };
            //if this is based on an existing dialog, create a new definition
            //by applying the new protoype over the existing one.
            if (base !== undefined) definition.factory = function() {
                return extend(new dialogs[base].factory(), new Factory());
            };
            if (!transient) //create a new definition based on dialog
            definition.dialog = extend(new definition.factory(), dialog);
            return dialogs[name] = definition;
        }
        return {
            /**
             * Alertify defaults
             * 
             * @type {Object}
             */ defaults: defaults,
            /**
             * Dialogs factory 
             *
             * @param {string}      Dialog name.
             * @param {Function}    A Dialog factory function.
             * @param {Boolean}     Indicates whether to create a singleton or transient dialog.
             * @param {String}      The name of the base type to inherit from.
             */ dialog: function(name, Factory, transient, base) {
                // get request, create a new instance and return it.
                if (typeof Factory !== "function") return get_dialog(name);
                if (this.hasOwnProperty(name)) throw new Error("alertify.dialog: name already exists");
                // register the dialog
                var definition = register(name, Factory, transient, base);
                if (transient) // make it public
                this[name] = function() {
                    //if passed with no params, consider it a get request
                    if (arguments.length === 0) return definition.dialog;
                    else {
                        var instance = extend(new definition.factory(), dialog);
                        //ensure init
                        if (instance && typeof instance.__init === "function") instance.__init(instance);
                        instance["main"].apply(instance, arguments);
                        return instance["show"].apply(instance);
                    }
                };
                else // make it public
                this[name] = function() {
                    //ensure init
                    if (definition.dialog && typeof definition.dialog.__init === "function") definition.dialog.__init(definition.dialog);
                    //if passed with no params, consider it a get request
                    if (arguments.length === 0) return definition.dialog;
                    else {
                        var dialog = definition.dialog;
                        dialog["main"].apply(definition.dialog, arguments);
                        return dialog["show"].apply(definition.dialog);
                    }
                };
            },
            /**
             * Close all open dialogs.
             *
             * @param {Object} excpet [optional] The dialog object to exclude from closing.
             *
             * @return {undefined}
             */ closeAll: function(except) {
                var clone = openDialogs.slice(0);
                for(var x = 0; x < clone.length; x += 1){
                    var instance = clone[x];
                    if (except === undefined || except !== instance) instance.close();
                }
            },
            /**
             * Gets or Sets dialog settings/options. if the dialog is transient, this call does nothing.
             *
             * @param {string} name The dialog name.
             * @param {String|Object} key A string specifying a propery name or a collection of key/value pairs.
             * @param {Variant} value Optional, the value associated with the key (in case it was a string).
             *
             * @return {undefined}
             */ setting: function(name, key, value) {
                if (name === "notifier") return notifier.setting(key, value);
                var dialog = get_dialog(name);
                if (dialog) return dialog.setting(key, value);
            },
            /**
             * [Alias] Sets dialog settings/options 
             */ set: function(name, key, value) {
                return this.setting(name, key, value);
            },
            /**
             * [Alias] Gets dialog settings/options 
             */ get: function(name, key) {
                return this.setting(name, key);
            },
            /**
             * Creates a new notification message.
             * If a type is passed, a class name "ajs-{type}" will be added.
             * This allows for custom look and feel for various types of notifications.
             *
             * @param  {String | DOMElement}    [message=undefined]		Message text
             * @param  {String}                 [type='']				Type of log message
             * @param  {String}                 [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}               [callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */ notify: function(message, type, wait, callback) {
                return notifier.create(type, callback).push(message, wait);
            },
            /**
             * Creates a new notification message.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */ message: function(message, wait, callback) {
                return notifier.create(null, callback).push(message, wait);
            },
            /**
             * Creates a new notification message of type 'success'.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */ success: function(message, wait, callback) {
                return notifier.create("success", callback).push(message, wait);
            },
            /**
             * Creates a new notification message of type 'error'.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */ error: function(message, wait, callback) {
                return notifier.create("error", callback).push(message, wait);
            },
            /**
             * Creates a new notification message of type 'warning'.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */ warning: function(message, wait, callback) {
                return notifier.create("warning", callback).push(message, wait);
            },
            /**
             * Dismisses all open notifications
             *
             * @return {undefined}
             */ dismissAll: function() {
                notifier.dismissAll();
            }
        };
    }
    var alertify = new Alertify();
    /**
    * Alert dialog definition
    *
    * invoked by:
    *	alertify.alert(message);
    *	alertify.alert(title, message);
    *	alertify.alert(message, onok);
    *	alertify.alert(title, message, onok);
     */ alertify.dialog("alert", function() {
        return {
            main: function(_title, _message, _onok) {
                var title, message, onok;
                switch(arguments.length){
                    case 1:
                        message = _title;
                        break;
                    case 2:
                        if (typeof _message === "function") {
                            message = _title;
                            onok = _message;
                        } else {
                            title = _title;
                            message = _message;
                        }
                        break;
                    case 3:
                        title = _title;
                        message = _message;
                        onok = _onok;
                        break;
                }
                this.set("title", title);
                this.set("message", message);
                this.set("onok", onok);
                return this;
            },
            setup: function() {
                return {
                    buttons: [
                        {
                            text: alertify.defaults.glossary.ok,
                            key: keys.ESC,
                            invokeOnClose: true,
                            className: alertify.defaults.theme.ok
                        }
                    ],
                    focus: {
                        element: 0,
                        select: false
                    },
                    options: {
                        maximizable: false,
                        resizable: false
                    }
                };
            },
            build: function() {
            // nothing
            },
            prepare: function() {
            //nothing
            },
            setMessage: function(message) {
                this.setContent(message);
            },
            settings: {
                message: undefined,
                onok: undefined,
                label: undefined
            },
            settingUpdated: function(key, oldValue, newValue) {
                switch(key){
                    case "message":
                        this.setMessage(newValue);
                        break;
                    case "label":
                        if (this.__internal.buttons[0].element) this.__internal.buttons[0].element.innerHTML = newValue;
                        break;
                }
            },
            callback: function(closeEvent) {
                if (typeof this.get("onok") === "function") {
                    var returnValue = this.get("onok").call(this, closeEvent);
                    if (typeof returnValue !== "undefined") closeEvent.cancel = !returnValue;
                }
            }
        };
    });
    /**
     * Confirm dialog object
     *
     *	alertify.confirm(message);
     *	alertify.confirm(message, onok);
     *	alertify.confirm(message, onok, oncancel);
     *	alertify.confirm(title, message, onok, oncancel);
     */ alertify.dialog("confirm", function() {
        var autoConfirm = {
            timer: null,
            index: null,
            text: null,
            duration: null,
            task: function(event, self) {
                if (self.isOpen()) {
                    self.__internal.buttons[autoConfirm.index].element.innerHTML = autoConfirm.text + " (&#8207;" + autoConfirm.duration + "&#8207;) ";
                    autoConfirm.duration -= 1;
                    if (autoConfirm.duration === -1) {
                        clearAutoConfirm(self);
                        var button = self.__internal.buttons[autoConfirm.index];
                        var closeEvent = createCloseEvent(autoConfirm.index, button);
                        if (typeof self.callback === "function") self.callback.apply(self, [
                            closeEvent
                        ]);
                        //close the dialog.
                        if (closeEvent.close !== false) self.close();
                    }
                } else clearAutoConfirm(self);
            }
        };
        function clearAutoConfirm(self) {
            if (autoConfirm.timer !== null) {
                clearInterval(autoConfirm.timer);
                autoConfirm.timer = null;
                self.__internal.buttons[autoConfirm.index].element.innerHTML = autoConfirm.text;
            }
        }
        function startAutoConfirm(self, index, duration) {
            clearAutoConfirm(self);
            autoConfirm.duration = duration;
            autoConfirm.index = index;
            autoConfirm.text = self.__internal.buttons[index].element.innerHTML;
            autoConfirm.timer = setInterval(delegate(self, autoConfirm.task), 1000);
            autoConfirm.task(null, self);
        }
        return {
            main: function(_title, _message, _onok, _oncancel) {
                var title, message, onok, oncancel;
                switch(arguments.length){
                    case 1:
                        message = _title;
                        break;
                    case 2:
                        message = _title;
                        onok = _message;
                        break;
                    case 3:
                        message = _title;
                        onok = _message;
                        oncancel = _onok;
                        break;
                    case 4:
                        title = _title;
                        message = _message;
                        onok = _onok;
                        oncancel = _oncancel;
                        break;
                }
                this.set("title", title);
                this.set("message", message);
                this.set("onok", onok);
                this.set("oncancel", oncancel);
                return this;
            },
            setup: function() {
                return {
                    buttons: [
                        {
                            text: alertify.defaults.glossary.ok,
                            key: keys.ENTER,
                            className: alertify.defaults.theme.ok
                        },
                        {
                            text: alertify.defaults.glossary.cancel,
                            key: keys.ESC,
                            invokeOnClose: true,
                            className: alertify.defaults.theme.cancel
                        }
                    ],
                    focus: {
                        element: 0,
                        select: false
                    },
                    options: {
                        maximizable: false,
                        resizable: false
                    }
                };
            },
            build: function() {
            //nothing
            },
            prepare: function() {
            //nothing
            },
            setMessage: function(message) {
                this.setContent(message);
            },
            settings: {
                message: null,
                labels: null,
                onok: null,
                oncancel: null,
                defaultFocus: null,
                reverseButtons: null
            },
            settingUpdated: function(key, oldValue, newValue) {
                switch(key){
                    case "message":
                        this.setMessage(newValue);
                        break;
                    case "labels":
                        if ("ok" in newValue && this.__internal.buttons[0].element) {
                            this.__internal.buttons[0].text = newValue.ok;
                            this.__internal.buttons[0].element.innerHTML = newValue.ok;
                        }
                        if ("cancel" in newValue && this.__internal.buttons[1].element) {
                            this.__internal.buttons[1].text = newValue.cancel;
                            this.__internal.buttons[1].element.innerHTML = newValue.cancel;
                        }
                        break;
                    case "reverseButtons":
                        if (newValue === true) this.elements.buttons.primary.appendChild(this.__internal.buttons[0].element);
                        else this.elements.buttons.primary.appendChild(this.__internal.buttons[1].element);
                        break;
                    case "defaultFocus":
                        this.__internal.focus.element = newValue === "ok" ? 0 : 1;
                        break;
                }
            },
            callback: function(closeEvent) {
                clearAutoConfirm(this);
                var returnValue;
                switch(closeEvent.index){
                    case 0:
                        if (typeof this.get("onok") === "function") {
                            returnValue = this.get("onok").call(this, closeEvent);
                            if (typeof returnValue !== "undefined") closeEvent.cancel = !returnValue;
                        }
                        break;
                    case 1:
                        if (typeof this.get("oncancel") === "function") {
                            returnValue = this.get("oncancel").call(this, closeEvent);
                            if (typeof returnValue !== "undefined") closeEvent.cancel = !returnValue;
                        }
                        break;
                }
            },
            autoOk: function(duration) {
                startAutoConfirm(this, 0, duration);
                return this;
            },
            autoCancel: function(duration) {
                startAutoConfirm(this, 1, duration);
                return this;
            }
        };
    });
    /**
     * Prompt dialog object
     *
     * invoked by:
     *	alertify.prompt(message);
     *	alertify.prompt(message, value);
     *	alertify.prompt(message, value, onok);
     *	alertify.prompt(message, value, onok, oncancel);
     *	alertify.prompt(title, message, value, onok, oncancel);
     */ alertify.dialog("prompt", function() {
        var input = document.createElement("INPUT");
        var p = document.createElement("P");
        return {
            main: function(_title, _message, _value, _onok, _oncancel) {
                var title, message, value, onok, oncancel;
                switch(arguments.length){
                    case 1:
                        message = _title;
                        break;
                    case 2:
                        message = _title;
                        value = _message;
                        break;
                    case 3:
                        message = _title;
                        value = _message;
                        onok = _value;
                        break;
                    case 4:
                        message = _title;
                        value = _message;
                        onok = _value;
                        oncancel = _onok;
                        break;
                    case 5:
                        title = _title;
                        message = _message;
                        value = _value;
                        onok = _onok;
                        oncancel = _oncancel;
                        break;
                }
                this.set("title", title);
                this.set("message", message);
                this.set("value", value);
                this.set("onok", onok);
                this.set("oncancel", oncancel);
                return this;
            },
            setup: function() {
                return {
                    buttons: [
                        {
                            text: alertify.defaults.glossary.ok,
                            key: keys.ENTER,
                            className: alertify.defaults.theme.ok
                        },
                        {
                            text: alertify.defaults.glossary.cancel,
                            key: keys.ESC,
                            invokeOnClose: true,
                            className: alertify.defaults.theme.cancel
                        }
                    ],
                    focus: {
                        element: input,
                        select: true
                    },
                    options: {
                        maximizable: false,
                        resizable: false
                    }
                };
            },
            build: function() {
                input.className = alertify.defaults.theme.input;
                input.setAttribute("type", "text");
                input.value = this.get("value");
                this.elements.content.appendChild(p);
                this.elements.content.appendChild(input);
            },
            prepare: function() {
            //nothing
            },
            setMessage: function(message) {
                if (typeof message === "string") {
                    clearContents(p);
                    p.innerHTML = message;
                } else if (message instanceof window1.HTMLElement && p.firstChild !== message) {
                    clearContents(p);
                    p.appendChild(message);
                }
            },
            settings: {
                message: undefined,
                labels: undefined,
                onok: undefined,
                oncancel: undefined,
                value: "",
                type: "text",
                reverseButtons: undefined
            },
            settingUpdated: function(key, oldValue, newValue) {
                switch(key){
                    case "message":
                        this.setMessage(newValue);
                        break;
                    case "value":
                        input.value = newValue;
                        break;
                    case "type":
                        switch(newValue){
                            case "text":
                            case "color":
                            case "date":
                            case "datetime-local":
                            case "email":
                            case "month":
                            case "number":
                            case "password":
                            case "search":
                            case "tel":
                            case "time":
                            case "week":
                                input.type = newValue;
                                break;
                            default:
                                input.type = "text";
                                break;
                        }
                        break;
                    case "labels":
                        if (newValue.ok && this.__internal.buttons[0].element) this.__internal.buttons[0].element.innerHTML = newValue.ok;
                        if (newValue.cancel && this.__internal.buttons[1].element) this.__internal.buttons[1].element.innerHTML = newValue.cancel;
                        break;
                    case "reverseButtons":
                        if (newValue === true) this.elements.buttons.primary.appendChild(this.__internal.buttons[0].element);
                        else this.elements.buttons.primary.appendChild(this.__internal.buttons[1].element);
                        break;
                }
            },
            callback: function(closeEvent) {
                var returnValue;
                switch(closeEvent.index){
                    case 0:
                        this.settings.value = input.value;
                        if (typeof this.get("onok") === "function") {
                            returnValue = this.get("onok").call(this, closeEvent, this.settings.value);
                            if (typeof returnValue !== "undefined") closeEvent.cancel = !returnValue;
                        }
                        break;
                    case 1:
                        if (typeof this.get("oncancel") === "function") {
                            returnValue = this.get("oncancel").call(this, closeEvent);
                            if (typeof returnValue !== "undefined") closeEvent.cancel = !returnValue;
                        }
                        if (!closeEvent.cancel) input.value = this.settings.value;
                        break;
                }
            }
        };
    });
    // CommonJS
    if (typeof $3895aa91744b6895$exports === "object") $3895aa91744b6895$exports = alertify;
    else if (typeof define === "function" && define.amd) define([], function() {
        return alertify;
    });
    else if (!window1.alertify) window1.alertify = alertify;
})(typeof window !== "undefined" ? window : $3895aa91744b6895$exports);



var $724bee09b1b3e2c4$exports = {};
$724bee09b1b3e2c4$exports = new URL("Chess_tile_ql.f2411ff1.svg", import.meta.url).toString();


const $ef84d931ff2e086e$export$b131c49b26d3f427 = (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".status", {
        class: state.connected ? "connected" : "disconnected",
        title: state.connected ? "connected" : "disconnected"
    }, "");
const $ef84d931ff2e086e$export$f4a3eee8e2b83eb0 = (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("p.turn", {
        class: state.chess.turn(),
        title: state.chess.turn() == "w" ? "white's turn" : "black's turn"
    }, state.chess.turn());
const $ef84d931ff2e086e$export$fece60e3d5e7dfdb = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("i.material-icons", {
        title: state.connected ? "disconnect" : "connect",
        onclick: (e)=>{
            if (state.connected) {
                console.log("disconnecting");
                actions.disconnect();
            } else {
                console.log("connecting");
                actions.connect();
            }
        }
    }, state.connected ? "power_off" : "power");
const $ef84d931ff2e086e$export$d9c8f749b6c1c3da = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("i.material-icons", {
        title: "flip board",
        onclick: (e)=>{
            actions.flipBoard();
        }
    }, "wifi_protected_setup");
const $ef84d931ff2e086e$export$1c2b660b9d689dfc = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("i.material-icons", {
        title: state.influence ? "hide influence" : "show influence",
        onclick: (e)=>{
            actions.toggleInfluence();
        }
    }, "compare_arrows");
const $ef84d931ff2e086e$export$2bbe6b4c555f9803 = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("i.material-icons", {
        title: "takeback",
        onclick: (e)=>{
            actions.takeback();
        }
    }, "arrow_left");
const $ef84d931ff2e086e$export$a083a1058128fafe = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("i.material-icons", {
        title: "does nothing",
        onclick: (e)=>{}
    }, "arrow_right");
const $ef84d931ff2e086e$export$324fa128a6a8d5eb = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("i.material-icons", {
        title: state.grid ? "hide grid" : "show grid",
        onclick: (e)=>{
            state.grid = !state.grid;
            actions.lightBoard();
        }
    }, state.grid ? "grid_off" : "grid_on");
const $ef84d931ff2e086e$export$72b8a1821a6af290 = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("i.material-icons", {
        title: state.pieces ? "hide pieces" : "show pieces",
        onclick: (e)=>actions.togglePieces()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("img.svgicon", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($724bee09b1b3e2c4$exports)))
    }));
const $ef84d931ff2e086e$export$46e774049323b8a5 = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("i.material-icons", {
        title: "increace history",
        onclick: actions.incrementHistory
    }, "history");
const $ef84d931ff2e086e$export$99e4fe05899c2070 = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("i.material-icons", {
        title: "decreace history",
        onclick: (e)=>{
            actions.decrementHistory();
        }
    }, "history_toggle_off");
const $ef84d931ff2e086e$export$e7e20814fadcf6e = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("i", {
        onclick: (e)=>{
            (0, $3895aa91744b6895$exports.confirm)("New game?", (yes)=>{
                actions.newGame();
            }, (no)=>{
                console.log("cancelling");
            });
        }
    }, "start new game");
const $ef84d931ff2e086e$export$390d11d353c16e49 = (state, actions)=>[
        $ef84d931ff2e086e$export$46e774049323b8a5(state, actions),
        $ef84d931ff2e086e$export$99e4fe05899c2070(state, actions),
        $ef84d931ff2e086e$export$2bbe6b4c555f9803(state, actions),
        $ef84d931ff2e086e$export$a083a1058128fafe(state, actions),
        $ef84d931ff2e086e$export$d9c8f749b6c1c3da(state, actions),
        $ef84d931ff2e086e$export$324fa128a6a8d5eb(state, actions),
        $ef84d931ff2e086e$export$72b8a1821a6af290(state, actions),
        $ef84d931ff2e086e$export$1c2b660b9d689dfc(state, actions),
        $ef84d931ff2e086e$export$f4a3eee8e2b83eb0(state)
    ];
const $ef84d931ff2e086e$export$4c260019440d418f = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("span.toolbar", {}, [
        // StatusIcon(state),
        // ConnectToggle(state, actions),
        ...$ef84d931ff2e086e$export$390d11d353c16e49(state, actions)
    ]);
const $ef84d931ff2e086e$export$69d4e78a69e95731 = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".toolbar", {}, [
        ...$ef84d931ff2e086e$export$390d11d353c16e49(state, actions)
    ]);



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $17f1b9f8ce16014e$var$extendStatics = function(d, b) {
    $17f1b9f8ce16014e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $17f1b9f8ce16014e$var$extendStatics(d, b);
};
function $17f1b9f8ce16014e$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $17f1b9f8ce16014e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $17f1b9f8ce16014e$export$18ce0697a983be9b = function() {
    $17f1b9f8ce16014e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $17f1b9f8ce16014e$export$18ce0697a983be9b.apply(this, arguments);
};
function $17f1b9f8ce16014e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $17f1b9f8ce16014e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $17f1b9f8ce16014e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $17f1b9f8ce16014e$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $17f1b9f8ce16014e$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $17f1b9f8ce16014e$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $17f1b9f8ce16014e$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $17f1b9f8ce16014e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $17f1b9f8ce16014e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $17f1b9f8ce16014e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $17f1b9f8ce16014e$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $17f1b9f8ce16014e$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $17f1b9f8ce16014e$export$45d3717a4c69092e(o, m, p);
}
function $17f1b9f8ce16014e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $17f1b9f8ce16014e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $17f1b9f8ce16014e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($17f1b9f8ce16014e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $17f1b9f8ce16014e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $17f1b9f8ce16014e$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $17f1b9f8ce16014e$export$10c90e4f7922046c(v) {
    return this instanceof $17f1b9f8ce16014e$export$10c90e4f7922046c ? (this.v = v, this) : new $17f1b9f8ce16014e$export$10c90e4f7922046c(v);
}
function $17f1b9f8ce16014e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $17f1b9f8ce16014e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $17f1b9f8ce16014e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $17f1b9f8ce16014e$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $17f1b9f8ce16014e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $17f1b9f8ce16014e$export$19a8beecd37a4c45 === "function" ? $17f1b9f8ce16014e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $17f1b9f8ce16014e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $17f1b9f8ce16014e$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $17f1b9f8ce16014e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $17f1b9f8ce16014e$export$45d3717a4c69092e(result, mod, k);
    }
    $17f1b9f8ce16014e$var$__setModuleDefault(result, mod);
    return result;
}
function $17f1b9f8ce16014e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $17f1b9f8ce16014e$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $17f1b9f8ce16014e$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $17f1b9f8ce16014e$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $17f1b9f8ce16014e$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $17f1b9f8ce16014e$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $17f1b9f8ce16014e$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $17f1b9f8ce16014e$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $17f1b9f8ce16014e$export$2e2bcd8739ae039 = {
    __extends: $17f1b9f8ce16014e$export$a8ba968b8961cb8a,
    __assign: $17f1b9f8ce16014e$export$18ce0697a983be9b,
    __rest: $17f1b9f8ce16014e$export$3c9a16f847548506,
    __decorate: $17f1b9f8ce16014e$export$29e00dfd3077644b,
    __param: $17f1b9f8ce16014e$export$d5ad3fd78186038f,
    __metadata: $17f1b9f8ce16014e$export$f1db080c865becb9,
    __awaiter: $17f1b9f8ce16014e$export$1050f835b63b671e,
    __generator: $17f1b9f8ce16014e$export$67ebef60e6f28a6,
    __createBinding: $17f1b9f8ce16014e$export$45d3717a4c69092e,
    __exportStar: $17f1b9f8ce16014e$export$f33643c0debef087,
    __values: $17f1b9f8ce16014e$export$19a8beecd37a4c45,
    __read: $17f1b9f8ce16014e$export$8d051b38c9118094,
    __spread: $17f1b9f8ce16014e$export$afc72e2116322959,
    __spreadArrays: $17f1b9f8ce16014e$export$6388937ca91ccae8,
    __spreadArray: $17f1b9f8ce16014e$export$1216008129fb82ed,
    __await: $17f1b9f8ce16014e$export$10c90e4f7922046c,
    __asyncGenerator: $17f1b9f8ce16014e$export$e427f37a30a4de9b,
    __asyncDelegator: $17f1b9f8ce16014e$export$bbd80228419bb833,
    __asyncValues: $17f1b9f8ce16014e$export$e3b29a3d6162315f,
    __makeTemplateObject: $17f1b9f8ce16014e$export$4fb47efe1390b86f,
    __importStar: $17f1b9f8ce16014e$export$c21735bcef00d192,
    __importDefault: $17f1b9f8ce16014e$export$da59b14a69baef04,
    __classPrivateFieldGet: $17f1b9f8ce16014e$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $17f1b9f8ce16014e$export$d40a35129aaff81f,
    __classPrivateFieldIn: $17f1b9f8ce16014e$export$81fdc39f203e4e04,
    __addDisposableResource: $17f1b9f8ce16014e$export$88ac25d8e944e405,
    __disposeResources: $17f1b9f8ce16014e$export$8f076105dc360e92
};



var $e4aeb149e284da0d$export$4dbe3495bda74f11 = {
    // Modifiers
    XS: "cui-xs",
    SM: "cui-sm",
    LG: "cui-lg",
    XL: "cui-xl",
    PRIMARY: "cui-primary",
    NEGATIVE: "cui-negative",
    POSITIVE: "cui-positive",
    WARNING: "cui-warning",
    ACTIVE: "cui-active",
    DISABLED: "cui-disabled",
    LOADING: "cui-loading",
    BASIC: "cui-basic",
    OUTLINED: "cui-outlined",
    ROUNDED: "cui-rounded",
    READONLY: "cui-readonly",
    SELECTED: "cui-selected",
    INTERACTIVE: "cui-interactive",
    ELEVATION: "cui-elevation",
    HIDDEN: "cui-hidden",
    // Headings
    H1: "cui-h1",
    H2: "cui-h2",
    H3: "cui-h3",
    H4: "cui-h4",
    H5: "cui-h5",
    H6: "cui-h6",
    // Utility
    ALIGN: "cui-align",
    ALIGN_RIGHT: "cui-align-right",
    ALIGN_LEFT: "cui-align-left",
    FLUID: "cui-fluid",
    TEXT_MUTED: "cui-text-muted",
    TEXT_DISABLED: "cui-text-disabled",
    FOCUS_DISABLED: "cui-focus-disabled",
    COMPACT: "cui-compact",
    // Component
    BREADCRUMB: "cui-breadcrumb",
    BREADCRUMB_ITEM: "cui-breadcrumb-item",
    BREADCRUMB_SEPERATOR: "cui-breadcrumb-seperator",
    BUTTON: "cui-button",
    BUTTON_LABEL: "cui-button-label",
    BUTTON_SUBLABEL: "cui-button-sublabel",
    BUTTON_GROUP: "cui-button-group",
    BUTTON_ICON: "cui-button-icon",
    CARD: "cui-card",
    CARD_INTERACTIVE: "cui-card-interactive",
    CALLOUT: "cui-callout",
    CALLOUT_HEADER: "cui-callout-header",
    CALLOUT_CONTENT: "cui-callout-content",
    CALLOUT_ICON: "cui-callout-icon",
    CALLOUT_DISMISS_ICON: "cui-callout-dismiss",
    CHECKBOX: "cui-checkbox",
    COLLAPSE: "cui-collapse",
    COLLAPSE_BODY: "cui-collapse-body",
    CONTEXT_MENU: "cui-context-menu",
    CONTROL: "cui-control",
    CONTROL_INDICATOR: "cui-control-indicator",
    CONTROL_GROUP: "cui-control-group",
    CUSTOM_SELECT: "cui-custom-select",
    CUSTOM_SELECT_TRIGGER: "cui-custom-select-trigger",
    CUSTOM_SELECT_INPUT: "cui-custom-select-input",
    CUSTOM_SELECT_HIDDEN: "cui-custom-select-hidden",
    DIALOG: "cui-dialog",
    DIALOG_CLOSE_BUTTON: "cui-dialog-close-button",
    DIALOG_CONTENT: "cui-dialog-content",
    DIALOG_HEADER: "cui-dialog-header",
    DIALOG_BODY: "cui-dialog-body",
    DIALOG_FOOTER: "cui-dialog-footer",
    DRAWER: "cui-drawer",
    DRAWER_CONTENT: "cui-drawer-content",
    EMPTY_STATE: "cui-empty-state",
    EMPTY_STATE_ICON: "cui-empty-state-icon",
    EMPTY_STATE_CONTENT: "cui-empty-state-content",
    EMPTY_STATE_HEADER: "cui-empty-state-header",
    EMPTY_STATE_FILL: "cui-empty-state-fill",
    FORM: "cui-form",
    FORM_GROUP: "cui-form-group",
    FORM_LABEL: "cui-form-label",
    GRID: "cui-grid",
    COL: "cui-col",
    INPUT_FILE: "cui-input-file",
    INPUT_FILE_CONTENT: "cui-input-file-content",
    INPUT_FILE_TEXT: "cui-input-file-text",
    INPUT_FILE_BUTTON: "cui-input-file-button",
    ICON: "cui-icon",
    ICON_ACTION: "cui-icon-action",
    INPUT: "cui-input",
    INPUT_GROUP: "cui-input-group",
    INPUT_POPOVER: "cui-input-popover",
    INPUT_POPOVER_CONTENT: "cui-input-popover-content",
    INPUT_SELECT: "cui-input-select",
    LIST: "cui-list",
    LIST_ITEM: "cui-list-item",
    LIST_ITEM_LABEL: "cui-list-item-label",
    LIST_ITEM_CONTENT_LEFT: "cui-list-item-content-left",
    LIST_ITEM_CONTENT_RIGHT: "cui-list-item-content-right",
    MENU: "cui-menu",
    MENU_ITEM: "cui-menu-item",
    MENU_DIVIDER: "cui-menu-divider",
    MENU_HEADING: "cui-menu-heading",
    OVERLAY: "cui-overlay",
    OVERLAY_CONTENT: "cui-overlay-content",
    OVERLAY_BACKDROP: "cui-overlay-backdrop",
    OVERLAY_OPEN: "cui-overlay-open",
    OVERLAY_INLINE: "cui-overlay-inline",
    OVERLAY_SCROLL_CONTAINER: "cui-overlay-scroll-container",
    POPOVER: "cui-popover",
    POPOVER_OPEN: "cui-popover-open",
    POPOVER_CONTENT: "cui-popover-content",
    POPOVER_ARROW: "cui-popover-arrow",
    POPOVER_TRIGGER_ACTIVE: "cui-popover-trigger-active",
    POPOVER_BACKDROP: "cui-popover-backdrop",
    POPOVER_DISSMISS: "cui-popover-dismiss",
    POPOVER_MENU: "cui-popover-menu",
    PORTAL: "cui-portal",
    QUERY_LIST: "cui-query-list",
    QUERY_LIST_CHECKMARK: "cui-query-list-checkmark",
    QUERY_LIST_EMPTY: "cui-query-list-empty",
    QUERY_LIST_INITIAL: "cui-query-list-initial",
    QUERY_LIST_MESSAGE: "cui-query-list-message",
    RADIO: "cui-radio",
    RADIO_GROUP: "cui-radio-group",
    SELECT: "cui-select",
    SELECT_ARROW: "cui-select-arrow",
    SELECT_LIST: "cui-select-list",
    SPINNER: "cui-spinner",
    SPINNER_CONTENT: "cui-spinner-content",
    SPINNER_ICON: "cui-spinner-icon",
    SPINNER_MESSAGE: "cui-spinner-message",
    SPINNER_FILL: "cui-spinner-fill",
    SPINNER_ACTIVE: "cui-spinner-active",
    SPINNER_BG: "cui-spinner-bg",
    SWITCH: "cui-switch",
    TABLE: "cui-table",
    TABLE_BORDERED: "cui-table-bordered",
    TABLE_STRIPED: "cui-table-striped",
    TABLE_INTERACTIVE: "cui-table-interactive",
    TAG: "cui-tag",
    TAG_REMOVABLE: "cui-tag-removable",
    TAG_INPUT: "cui-tag-input",
    TAG_INPUT_VALUES: "cui-tag-input-values",
    TABS: "cui-tabs",
    TABS_BORDERED: "cui-tabs-bordered",
    TABS_ITEM: "cui-tabs-item",
    TEXT_AREA: "cui-text-area",
    TOAST: "cui-toast",
    TOAST_MESSAGE: "cui-toast-message",
    TOASTER: "cui-toaster",
    TOASTER_INLINE: "cui-toaster-inline",
    TOOLTIP: "cui-tooltip",
    TREE: "cui-tree",
    TREE_NODE: "cui-tree-node",
    TREE_NODE_LIST: "cui-tree-node-list",
    TREE_NODE_CONTENT: "cui-tree-node-content",
    TREE_NODE_CARET: "cui-tree-node-caret",
    TREE_NODE_CARET_OPEN: "cui-tree-node-caret-open",
    TREE_NODE_CARET_CLOSED: "cui-tree-node-caret-closed",
    TREE_NODE_CARET_NONE: "cui-tree-node-caret-none",
    TREE_NODE_SELECTED: "cui-tree-node-selected",
    TREE_NODE_EXPANDED: "cui-tree-node-expanded",
    TREE_NODE_LABEL: "cui-tree-node-label",
    TREE_NODE_CONTENT_RIGHT: "cui-tree-node-content-right",
    TREE_NODE_CONTENT_LEFT: "cui-tree-node-content-left"
};



var $fcc1f848a67e05c0$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $fcc1f848a67e05c0$exports) {
        classNames.default = classNames;
        $fcc1f848a67e05c0$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();




var $efcb3a78c45dc171$export$ef524c8d8e02fd08 = /** @class */ function() {
    function BaseControl() {}
    BaseControl.prototype.view = function(_a) {
        var attrs = _a.attrs;
        var className = attrs.class, _b = attrs.containerAttrs, containerAttrs = _b === void 0 ? {} : _b, intent = attrs.intent, label = attrs.label, size = attrs.size, type = attrs.type, typeClass = attrs.typeClass, style = attrs.style, htmlAttrs = (0, $17f1b9f8ce16014e$export$3c9a16f847548506)(attrs, [
            "class",
            "containerAttrs",
            "intent",
            "label",
            "size",
            "type",
            "typeClass",
            "style"
        ]);
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($fcc1f848a67e05c0$exports)))((0, $e4aeb149e284da0d$export$4dbe3495bda74f11).CONTROL, typeClass, htmlAttrs.disabled && (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).DISABLED, intent && "cui-".concat(intent), size && "cui-".concat(size), className);
        var content = [
            (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("input", (0, $17f1b9f8ce16014e$export$18ce0697a983be9b)((0, $17f1b9f8ce16014e$export$18ce0697a983be9b)({}, htmlAttrs), {
                disabled: htmlAttrs.disabled || htmlAttrs.readonly,
                type: type
            })),
            (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("span.".concat((0, $e4aeb149e284da0d$export$4dbe3495bda74f11).CONTROL_INDICATOR)),
            label
        ];
        return (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("label", (0, $17f1b9f8ce16014e$export$18ce0697a983be9b)({
            class: classes,
            style: style
        }, containerAttrs), content);
    };
    return BaseControl;
}();


var $1c56324fc02e153f$export$b5d5cf8927ab7262 = /** @class */ function() {
    function Switch() {}
    Switch.prototype.view = function(_a) {
        var attrs = _a.attrs;
        return (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))((0, $efcb3a78c45dc171$export$ef524c8d8e02fd08), (0, $17f1b9f8ce16014e$export$18ce0697a983be9b)((0, $17f1b9f8ce16014e$export$18ce0697a983be9b)({}, attrs), {
            type: "checkbox",
            typeClass: (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).SWITCH
        }));
    };
    return Switch;
}();


var $09c7c301f2267c48$exports = {};
$09c7c301f2267c48$exports = new URL("logo.4474c526.svg", import.meta.url).toString();


const $3f934752a4447ac8$export$a6c7ac8248d6e38a = ()=>({
        view: (vnode)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".menu-item", [
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.Link, vnode.attrs, vnode.children)
            ]);
        }
    });
const $3f934752a4447ac8$export$b2e089eb3692b073 = (state)=>[
        (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))($3f934752a4447ac8$export$a6c7ac8248d6e38a, {
            href: "/connect",
            id: "connectButton"
        }, (0, $ef84d931ff2e086e$export$b131c49b26d3f427)(state)),
        (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))($3f934752a4447ac8$export$a6c7ac8248d6e38a, {
            href: "/otb",
            id: "otbButton"
        }, "Local"),
        (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))($3f934752a4447ac8$export$a6c7ac8248d6e38a, {
            href: "/games",
            id: "gamesButton"
        }, "Online"),
        (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))((0, $1c56324fc02e153f$export$b5d5cf8927ab7262), {
            checked: state.theme,
            onclick: (e)=>{
                console.log("switched", e);
                if (state.theme) {
                    document.body.className = document.body.className.replace("dark", "");
                    state.theme = null;
                } else {
                    state.theme = "dark";
                    document.body.className += state.theme;
                }
            }
        }),
        // ,
        state.user.username ? (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))($3f934752a4447ac8$export$a6c7ac8248d6e38a, {
            href: "/profile"
        }, state.user.username) : (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))($3f934752a4447ac8$export$a6c7ac8248d6e38a, {
            href: "/login",
            id: "loginButton"
        }, "Login")
    ];
const $3f934752a4447ac8$export$d9b273488cd8ce6f = (state)=>[
        (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))($3f934752a4447ac8$export$a6c7ac8248d6e38a, {
            href: "/"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("img.logo#logo", {
            src: "logo.svg"
        })),
        $3f934752a4447ac8$export$b2e089eb3692b073(state)
    ];
const $3f934752a4447ac8$export$c84671f46d6a1ca = (state)=>({
        view: (vnode)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("main.layout", {}, [
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("nav.menu", {}, $3f934752a4447ac8$export$d9b273488cd8ce6f(state)),
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("section#main", vnode.attrs)
            ]);
        }
    });



/**
 * @license
 * Copyright (c) 2023, Jeff Hlywa (jhlywa@gmail.com)
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 *    this list of conditions and the following disclaimer.
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */ const $6eb582f9081eb7e5$export$29814851e0aa981f = "w";
const $6eb582f9081eb7e5$export$7a91b0fde7ec420f = "b";
const $6eb582f9081eb7e5$export$4c32fd1f222ff2b0 = "p";
const $6eb582f9081eb7e5$export$ce32bc8c2a29bae6 = "n";
const $6eb582f9081eb7e5$export$54a167f801c5dba3 = "b";
const $6eb582f9081eb7e5$export$68d4c913908dc245 = "r";
const $6eb582f9081eb7e5$export$36a8946792f13ec9 = "q";
const $6eb582f9081eb7e5$export$42387107bb0d6206 = "k";
const $6eb582f9081eb7e5$export$1264a6620073cfaa = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1";
const $6eb582f9081eb7e5$var$EMPTY = -1;
const $6eb582f9081eb7e5$var$FLAGS = {
    NORMAL: "n",
    CAPTURE: "c",
    BIG_PAWN: "b",
    EP_CAPTURE: "e",
    PROMOTION: "p",
    KSIDE_CASTLE: "k",
    QSIDE_CASTLE: "q"
};
const $6eb582f9081eb7e5$export$5fc67852ab417150 = [
    "a8",
    "b8",
    "c8",
    "d8",
    "e8",
    "f8",
    "g8",
    "h8",
    "a7",
    "b7",
    "c7",
    "d7",
    "e7",
    "f7",
    "g7",
    "h7",
    "a6",
    "b6",
    "c6",
    "d6",
    "e6",
    "f6",
    "g6",
    "h6",
    "a5",
    "b5",
    "c5",
    "d5",
    "e5",
    "f5",
    "g5",
    "h5",
    "a4",
    "b4",
    "c4",
    "d4",
    "e4",
    "f4",
    "g4",
    "h4",
    "a3",
    "b3",
    "c3",
    "d3",
    "e3",
    "f3",
    "g3",
    "h3",
    "a2",
    "b2",
    "c2",
    "d2",
    "e2",
    "f2",
    "g2",
    "h2",
    "a1",
    "b1",
    "c1",
    "d1",
    "e1",
    "f1",
    "g1",
    "h1"
];
const $6eb582f9081eb7e5$var$BITS = {
    NORMAL: 1,
    CAPTURE: 2,
    BIG_PAWN: 4,
    EP_CAPTURE: 8,
    PROMOTION: 16,
    KSIDE_CASTLE: 32,
    QSIDE_CASTLE: 64
};
/*
 * NOTES ABOUT 0x88 MOVE GENERATION ALGORITHM
 * ----------------------------------------------------------------------------
 * From https://github.com/jhlywa/chess.js/issues/230
 *
 * A lot of people are confused when they first see the internal representation
 * of chess.js. It uses the 0x88 Move Generation Algorithm which internally
 * stores the board as an 8x16 array. This is purely for efficiency but has a
 * couple of interesting benefits:
 *
 * 1. 0x88 offers a very inexpensive "off the board" check. Bitwise AND (&) any
 *    square with 0x88, if the result is non-zero then the square is off the
 *    board. For example, assuming a knight square A8 (0 in 0x88 notation),
 *    there are 8 possible directions in which the knight can move. These
 *    directions are relative to the 8x16 board and are stored in the
 *    PIECE_OFFSETS map. One possible move is A8 - 18 (up one square, and two
 *    squares to the left - which is off the board). 0 - 18 = -18 & 0x88 = 0x88
 *    (because of two-complement representation of -18). The non-zero result
 *    means the square is off the board and the move is illegal. Take the
 *    opposite move (from A8 to C7), 0 + 18 = 18 & 0x88 = 0. A result of zero
 *    means the square is on the board.
 *
 * 2. The relative distance (or difference) between two squares on a 8x16 board
 *    is unique and can be used to inexpensively determine if a piece on a
 *    square can attack any other arbitrary square. For example, let's see if a
 *    pawn on E7 can attack E2. The difference between E7 (20) - E2 (100) is
 *    -80. We add 119 to make the ATTACKS array index non-negative (because the
 *    worst case difference is A8 - H1 = -119). The ATTACKS array contains a
 *    bitmask of pieces that can attack from that distance and direction.
 *    ATTACKS[-80 + 119=39] gives us 24 or 0b11000 in binary. Look at the
 *    PIECE_MASKS map to determine the mask for a given piece type. In our pawn
 *    example, we would check to see if 24 & 0x1 is non-zero, which it is
 *    not. So, naturally, a pawn on E7 can't attack a piece on E2. However, a
 *    rook can since 24 & 0x8 is non-zero. The only thing left to check is that
 *    there are no blocking pieces between E7 and E2. That's where the RAYS
 *    array comes in. It provides an offset (in this case 16) to add to E7 (20)
 *    to check for blocking pieces. E7 (20) + 16 = E6 (36) + 16 = E5 (52) etc.
 */ // prettier-ignore
// eslint-disable-next-line
const $6eb582f9081eb7e5$var$Ox88 = {
    a8: 0,
    b8: 1,
    c8: 2,
    d8: 3,
    e8: 4,
    f8: 5,
    g8: 6,
    h8: 7,
    a7: 16,
    b7: 17,
    c7: 18,
    d7: 19,
    e7: 20,
    f7: 21,
    g7: 22,
    h7: 23,
    a6: 32,
    b6: 33,
    c6: 34,
    d6: 35,
    e6: 36,
    f6: 37,
    g6: 38,
    h6: 39,
    a5: 48,
    b5: 49,
    c5: 50,
    d5: 51,
    e5: 52,
    f5: 53,
    g5: 54,
    h5: 55,
    a4: 64,
    b4: 65,
    c4: 66,
    d4: 67,
    e4: 68,
    f4: 69,
    g4: 70,
    h4: 71,
    a3: 80,
    b3: 81,
    c3: 82,
    d3: 83,
    e3: 84,
    f3: 85,
    g3: 86,
    h3: 87,
    a2: 96,
    b2: 97,
    c2: 98,
    d2: 99,
    e2: 100,
    f2: 101,
    g2: 102,
    h2: 103,
    a1: 112,
    b1: 113,
    c1: 114,
    d1: 115,
    e1: 116,
    f1: 117,
    g1: 118,
    h1: 119
};
const $6eb582f9081eb7e5$var$PAWN_OFFSETS = {
    b: [
        16,
        32,
        17,
        15
    ],
    w: [
        -16,
        -32,
        -17,
        -15
    ]
};
const $6eb582f9081eb7e5$var$PIECE_OFFSETS = {
    n: [
        -18,
        -33,
        -31,
        -14,
        18,
        33,
        31,
        14
    ],
    b: [
        -17,
        -15,
        17,
        15
    ],
    r: [
        -16,
        1,
        16,
        -1
    ],
    q: [
        -17,
        -16,
        -15,
        1,
        17,
        16,
        15,
        -1
    ],
    k: [
        -17,
        -16,
        -15,
        1,
        17,
        16,
        15,
        -1
    ]
};
// prettier-ignore
const $6eb582f9081eb7e5$var$ATTACKS = [
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    24,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    2,
    24,
    2,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    53,
    56,
    53,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    24,
    24,
    24,
    24,
    24,
    56,
    0,
    56,
    24,
    24,
    24,
    24,
    24,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    53,
    56,
    53,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    2,
    24,
    2,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    24,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    20,
    0,
    0,
    20,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    20
];
// prettier-ignore
const $6eb582f9081eb7e5$var$RAYS = [
    17,
    0,
    0,
    0,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    0,
    0,
    0,
    15,
    0,
    0,
    17,
    0,
    0,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    17,
    0,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    0,
    0,
    0,
    16,
    0,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    0,
    0,
    16,
    0,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    0,
    16,
    0,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    17,
    16,
    15,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    -16,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    -16,
    0,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    -16,
    0,
    0,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    -17,
    0,
    0,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    0,
    -17,
    0,
    0,
    0,
    0,
    -15,
    0,
    0,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    0,
    0,
    -17,
    0,
    0,
    -15,
    0,
    0,
    0,
    0,
    0,
    0,
    -16,
    0,
    0,
    0,
    0,
    0,
    0,
    -17
];
const $6eb582f9081eb7e5$var$PIECE_MASKS = {
    p: 0x1,
    n: 0x2,
    b: 0x4,
    r: 0x8,
    q: 0x10,
    k: 0x20
};
const $6eb582f9081eb7e5$var$SYMBOLS = "pnbrqkPNBRQK";
const $6eb582f9081eb7e5$var$PROMOTIONS = [
    $6eb582f9081eb7e5$export$ce32bc8c2a29bae6,
    $6eb582f9081eb7e5$export$54a167f801c5dba3,
    $6eb582f9081eb7e5$export$68d4c913908dc245,
    $6eb582f9081eb7e5$export$36a8946792f13ec9
];
const $6eb582f9081eb7e5$var$RANK_1 = 7;
const $6eb582f9081eb7e5$var$RANK_2 = 6;
/*
 * const RANK_3 = 5
 * const RANK_4 = 4
 * const RANK_5 = 3
 * const RANK_6 = 2
 */ const $6eb582f9081eb7e5$var$RANK_7 = 1;
const $6eb582f9081eb7e5$var$RANK_8 = 0;
const $6eb582f9081eb7e5$var$SIDES = {
    [$6eb582f9081eb7e5$export$42387107bb0d6206]: $6eb582f9081eb7e5$var$BITS.KSIDE_CASTLE,
    [$6eb582f9081eb7e5$export$36a8946792f13ec9]: $6eb582f9081eb7e5$var$BITS.QSIDE_CASTLE
};
const $6eb582f9081eb7e5$var$ROOKS = {
    w: [
        {
            square: $6eb582f9081eb7e5$var$Ox88.a1,
            flag: $6eb582f9081eb7e5$var$BITS.QSIDE_CASTLE
        },
        {
            square: $6eb582f9081eb7e5$var$Ox88.h1,
            flag: $6eb582f9081eb7e5$var$BITS.KSIDE_CASTLE
        }
    ],
    b: [
        {
            square: $6eb582f9081eb7e5$var$Ox88.a8,
            flag: $6eb582f9081eb7e5$var$BITS.QSIDE_CASTLE
        },
        {
            square: $6eb582f9081eb7e5$var$Ox88.h8,
            flag: $6eb582f9081eb7e5$var$BITS.KSIDE_CASTLE
        }
    ]
};
const $6eb582f9081eb7e5$var$SECOND_RANK = {
    b: $6eb582f9081eb7e5$var$RANK_7,
    w: $6eb582f9081eb7e5$var$RANK_2
};
const $6eb582f9081eb7e5$var$TERMINATION_MARKERS = [
    "1-0",
    "0-1",
    "1/2-1/2",
    "*"
];
// Extracts the zero-based rank of an 0x88 square.
function $6eb582f9081eb7e5$var$rank(square) {
    return square >> 4;
}
// Extracts the zero-based file of an 0x88 square.
function $6eb582f9081eb7e5$var$file(square) {
    return square & 0xf;
}
function $6eb582f9081eb7e5$var$isDigit(c) {
    return "0123456789".indexOf(c) !== -1;
}
// Converts a 0x88 square to algebraic notation.
function $6eb582f9081eb7e5$var$algebraic(square) {
    const f = $6eb582f9081eb7e5$var$file(square);
    const r = $6eb582f9081eb7e5$var$rank(square);
    return "abcdefgh".substring(f, f + 1) + "87654321".substring(r, r + 1);
}
function $6eb582f9081eb7e5$var$swapColor(color) {
    return color === $6eb582f9081eb7e5$export$29814851e0aa981f ? $6eb582f9081eb7e5$export$7a91b0fde7ec420f : $6eb582f9081eb7e5$export$29814851e0aa981f;
}
function $6eb582f9081eb7e5$export$d9e02ca3a6185312(fen) {
    // 1st criterion: 6 space-seperated fields?
    const tokens = fen.split(/\s+/);
    if (tokens.length !== 6) return {
        ok: false,
        error: "Invalid FEN: must contain six space-delimited fields"
    };
    // 2nd criterion: move number field is a integer value > 0?
    const moveNumber = parseInt(tokens[5], 10);
    if (isNaN(moveNumber) || moveNumber <= 0) return {
        ok: false,
        error: "Invalid FEN: move number must be a positive integer"
    };
    // 3rd criterion: half move counter is an integer >= 0?
    const halfMoves = parseInt(tokens[4], 10);
    if (isNaN(halfMoves) || halfMoves < 0) return {
        ok: false,
        error: "Invalid FEN: half move counter number must be a non-negative integer"
    };
    // 4th criterion: 4th field is a valid e.p.-string?
    if (!/^(-|[abcdefgh][36])$/.test(tokens[3])) return {
        ok: false,
        error: "Invalid FEN: en-passant square is invalid"
    };
    // 5th criterion: 3th field is a valid castle-string?
    if (/[^kKqQ-]/.test(tokens[2])) return {
        ok: false,
        error: "Invalid FEN: castling availability is invalid"
    };
    // 6th criterion: 2nd field is "w" (white) or "b" (black)?
    if (!/^(w|b)$/.test(tokens[1])) return {
        ok: false,
        error: "Invalid FEN: side-to-move is invalid"
    };
    // 7th criterion: 1st field contains 8 rows?
    const rows = tokens[0].split("/");
    if (rows.length !== 8) return {
        ok: false,
        error: "Invalid FEN: piece data does not contain 8 '/'-delimited rows"
    };
    // 8th criterion: every row is valid?
    for(let i = 0; i < rows.length; i++){
        // check for right sum of fields AND not two numbers in succession
        let sumFields = 0;
        let previousWasNumber = false;
        for(let k = 0; k < rows[i].length; k++)if ($6eb582f9081eb7e5$var$isDigit(rows[i][k])) {
            if (previousWasNumber) return {
                ok: false,
                error: "Invalid FEN: piece data is invalid (consecutive number)"
            };
            sumFields += parseInt(rows[i][k], 10);
            previousWasNumber = true;
        } else {
            if (!/^[prnbqkPRNBQK]$/.test(rows[i][k])) return {
                ok: false,
                error: "Invalid FEN: piece data is invalid (invalid piece)"
            };
            sumFields += 1;
            previousWasNumber = false;
        }
        if (sumFields !== 8) return {
            ok: false,
            error: "Invalid FEN: piece data is invalid (too many squares in rank)"
        };
    }
    if (tokens[3][1] == "3" && tokens[1] == "w" || tokens[3][1] == "6" && tokens[1] == "b") return {
        ok: false,
        error: "Invalid FEN: illegal en-passant square"
    };
    const kings = [
        {
            color: "white",
            regex: /K/g
        },
        {
            color: "black",
            regex: /k/g
        }
    ];
    for (const { color: color, regex: regex } of kings){
        if (!regex.test(tokens[0])) return {
            ok: false,
            error: `Invalid FEN: missing ${color} king`
        };
        if ((tokens[0].match(regex) || []).length > 1) return {
            ok: false,
            error: `Invalid FEN: too many ${color} kings`
        };
    }
    return {
        ok: true
    };
}
// this function is used to uniquely identify ambiguous moves
function $6eb582f9081eb7e5$var$getDisambiguator(move, moves) {
    const from = move.from;
    const to = move.to;
    const piece = move.piece;
    let ambiguities = 0;
    let sameRank = 0;
    let sameFile = 0;
    for(let i = 0, len = moves.length; i < len; i++){
        const ambigFrom = moves[i].from;
        const ambigTo = moves[i].to;
        const ambigPiece = moves[i].piece;
        /*
         * if a move of the same piece type ends on the same to square, we'll need
         * to add a disambiguator to the algebraic notation
         */ if (piece === ambigPiece && from !== ambigFrom && to === ambigTo) {
            ambiguities++;
            if ($6eb582f9081eb7e5$var$rank(from) === $6eb582f9081eb7e5$var$rank(ambigFrom)) sameRank++;
            if ($6eb582f9081eb7e5$var$file(from) === $6eb582f9081eb7e5$var$file(ambigFrom)) sameFile++;
        }
    }
    if (ambiguities > 0) {
        if (sameRank > 0 && sameFile > 0) /*
             * if there exists a similar moving piece on the same rank and file as
             * the move in question, use the square as the disambiguator
             */ return $6eb582f9081eb7e5$var$algebraic(from);
        else if (sameFile > 0) /*
             * if the moving piece rests on the same file, use the rank symbol as the
             * disambiguator
             */ return $6eb582f9081eb7e5$var$algebraic(from).charAt(1);
        else // else use the file symbol
        return $6eb582f9081eb7e5$var$algebraic(from).charAt(0);
    }
    return "";
}
function $6eb582f9081eb7e5$var$addMove(moves, color, from, to, piece, captured, flags = $6eb582f9081eb7e5$var$BITS.NORMAL) {
    const r = $6eb582f9081eb7e5$var$rank(to);
    if (piece === $6eb582f9081eb7e5$export$4c32fd1f222ff2b0 && (r === $6eb582f9081eb7e5$var$RANK_1 || r === $6eb582f9081eb7e5$var$RANK_8)) for(let i = 0; i < $6eb582f9081eb7e5$var$PROMOTIONS.length; i++){
        const promotion = $6eb582f9081eb7e5$var$PROMOTIONS[i];
        moves.push({
            color: color,
            from: from,
            to: to,
            piece: piece,
            captured: captured,
            promotion: promotion,
            flags: flags | $6eb582f9081eb7e5$var$BITS.PROMOTION
        });
    }
    else moves.push({
        color: color,
        from: from,
        to: to,
        piece: piece,
        captured: captured,
        flags: flags
    });
}
function $6eb582f9081eb7e5$var$inferPieceType(san) {
    let pieceType = san.charAt(0);
    if (pieceType >= "a" && pieceType <= "h") {
        const matches = san.match(/[a-h]\d.*[a-h]\d/);
        if (matches) return undefined;
        return $6eb582f9081eb7e5$export$4c32fd1f222ff2b0;
    }
    pieceType = pieceType.toLowerCase();
    if (pieceType === "o") return $6eb582f9081eb7e5$export$42387107bb0d6206;
    return pieceType;
}
// parses all of the decorators out of a SAN string
function $6eb582f9081eb7e5$var$strippedSan(move) {
    return move.replace(/=/, "").replace(/[+#]?[?!]*$/, "");
}
class $6eb582f9081eb7e5$export$a4d6ea685c300d39 {
    _board = new Array(128);
    _turn = $6eb582f9081eb7e5$export$29814851e0aa981f;
    _header = {};
    _kings = {
        w: $6eb582f9081eb7e5$var$EMPTY,
        b: $6eb582f9081eb7e5$var$EMPTY
    };
    _epSquare = -1;
    _halfMoves = 0;
    _moveNumber = 0;
    _history = [];
    _comments = {};
    _castling = {
        w: 0,
        b: 0
    };
    constructor(fen = $6eb582f9081eb7e5$export$1264a6620073cfaa){
        this.load(fen);
    }
    clear(keepHeaders = false) {
        this._board = new Array(128);
        this._kings = {
            w: $6eb582f9081eb7e5$var$EMPTY,
            b: $6eb582f9081eb7e5$var$EMPTY
        };
        this._turn = $6eb582f9081eb7e5$export$29814851e0aa981f;
        this._castling = {
            w: 0,
            b: 0
        };
        this._epSquare = $6eb582f9081eb7e5$var$EMPTY;
        this._halfMoves = 0;
        this._moveNumber = 1;
        this._history = [];
        this._comments = {};
        this._header = keepHeaders ? this._header : {};
        this._updateSetup(this.fen());
    }
    removeHeader(key) {
        if (key in this._header) delete this._header[key];
    }
    load(fen, keepHeaders = false) {
        let tokens = fen.split(/\s+/);
        // append commonly omitted fen tokens
        if (tokens.length >= 2 && tokens.length < 6) {
            const adjustments = [
                "-",
                "-",
                "0",
                "1"
            ];
            fen = tokens.concat(adjustments.slice(-(6 - tokens.length))).join(" ");
        }
        tokens = fen.split(/\s+/);
        const { ok: ok, error: error } = $6eb582f9081eb7e5$export$d9e02ca3a6185312(fen);
        if (!ok) throw new Error(error);
        const position = tokens[0];
        let square = 0;
        this.clear(keepHeaders);
        for(let i = 0; i < position.length; i++){
            const piece = position.charAt(i);
            if (piece === "/") square += 8;
            else if ($6eb582f9081eb7e5$var$isDigit(piece)) square += parseInt(piece, 10);
            else {
                const color = piece < "a" ? $6eb582f9081eb7e5$export$29814851e0aa981f : $6eb582f9081eb7e5$export$7a91b0fde7ec420f;
                this.put({
                    type: piece.toLowerCase(),
                    color: color
                }, $6eb582f9081eb7e5$var$algebraic(square));
                square++;
            }
        }
        this._turn = tokens[1];
        if (tokens[2].indexOf("K") > -1) this._castling.w |= $6eb582f9081eb7e5$var$BITS.KSIDE_CASTLE;
        if (tokens[2].indexOf("Q") > -1) this._castling.w |= $6eb582f9081eb7e5$var$BITS.QSIDE_CASTLE;
        if (tokens[2].indexOf("k") > -1) this._castling.b |= $6eb582f9081eb7e5$var$BITS.KSIDE_CASTLE;
        if (tokens[2].indexOf("q") > -1) this._castling.b |= $6eb582f9081eb7e5$var$BITS.QSIDE_CASTLE;
        this._epSquare = tokens[3] === "-" ? $6eb582f9081eb7e5$var$EMPTY : $6eb582f9081eb7e5$var$Ox88[tokens[3]];
        this._halfMoves = parseInt(tokens[4], 10);
        this._moveNumber = parseInt(tokens[5], 10);
        this._updateSetup(this.fen());
    }
    fen() {
        let empty = 0;
        let fen = "";
        for(let i = $6eb582f9081eb7e5$var$Ox88.a8; i <= $6eb582f9081eb7e5$var$Ox88.h1; i++){
            if (this._board[i]) {
                if (empty > 0) {
                    fen += empty;
                    empty = 0;
                }
                const { color: color, type: piece } = this._board[i];
                fen += color === $6eb582f9081eb7e5$export$29814851e0aa981f ? piece.toUpperCase() : piece.toLowerCase();
            } else empty++;
            if (i + 1 & 0x88) {
                if (empty > 0) fen += empty;
                if (i !== $6eb582f9081eb7e5$var$Ox88.h1) fen += "/";
                empty = 0;
                i += 8;
            }
        }
        let castling = "";
        if (this._castling[$6eb582f9081eb7e5$export$29814851e0aa981f] & $6eb582f9081eb7e5$var$BITS.KSIDE_CASTLE) castling += "K";
        if (this._castling[$6eb582f9081eb7e5$export$29814851e0aa981f] & $6eb582f9081eb7e5$var$BITS.QSIDE_CASTLE) castling += "Q";
        if (this._castling[$6eb582f9081eb7e5$export$7a91b0fde7ec420f] & $6eb582f9081eb7e5$var$BITS.KSIDE_CASTLE) castling += "k";
        if (this._castling[$6eb582f9081eb7e5$export$7a91b0fde7ec420f] & $6eb582f9081eb7e5$var$BITS.QSIDE_CASTLE) castling += "q";
        // do we have an empty castling flag?
        castling = castling || "-";
        let epSquare = "-";
        /*
         * only print the ep square if en passant is a valid move (pawn is present
         * and ep capture is not pinned)
         */ if (this._epSquare !== $6eb582f9081eb7e5$var$EMPTY) {
            const bigPawnSquare = this._epSquare + (this._turn === $6eb582f9081eb7e5$export$29814851e0aa981f ? 16 : -16);
            const squares = [
                bigPawnSquare + 1,
                bigPawnSquare - 1
            ];
            for (const square of squares){
                // is the square off the board?
                if (square & 0x88) continue;
                const color = this._turn;
                // is there a pawn that can capture the epSquare?
                if (this._board[square]?.color === color && this._board[square]?.type === $6eb582f9081eb7e5$export$4c32fd1f222ff2b0) {
                    // if the pawn makes an ep capture, does it leave it's king in check?
                    this._makeMove({
                        color: color,
                        from: square,
                        to: this._epSquare,
                        piece: $6eb582f9081eb7e5$export$4c32fd1f222ff2b0,
                        captured: $6eb582f9081eb7e5$export$4c32fd1f222ff2b0,
                        flags: $6eb582f9081eb7e5$var$BITS.EP_CAPTURE
                    });
                    const isLegal = !this._isKingAttacked(color);
                    this._undoMove();
                    // if ep is legal, break and set the ep square in the FEN output
                    if (isLegal) {
                        epSquare = $6eb582f9081eb7e5$var$algebraic(this._epSquare);
                        break;
                    }
                }
            }
        }
        return [
            fen,
            this._turn,
            castling,
            epSquare,
            this._halfMoves,
            this._moveNumber
        ].join(" ");
    }
    /*
     * Called when the initial board setup is changed with put() or remove().
     * modifies the SetUp and FEN properties of the header object. If the FEN
     * is equal to the default position, the SetUp and FEN are deleted the setup
     * is only updated if history.length is zero, ie moves haven't been made.
     */ _updateSetup(fen) {
        if (this._history.length > 0) return;
        if (fen !== $6eb582f9081eb7e5$export$1264a6620073cfaa) {
            this._header["SetUp"] = "1";
            this._header["FEN"] = fen;
        } else {
            delete this._header["SetUp"];
            delete this._header["FEN"];
        }
    }
    reset() {
        this.load($6eb582f9081eb7e5$export$1264a6620073cfaa);
    }
    get(square) {
        return this._board[$6eb582f9081eb7e5$var$Ox88[square]] || false;
    }
    put({ type: type, color: color }, square) {
        // check for piece
        if ($6eb582f9081eb7e5$var$SYMBOLS.indexOf(type.toLowerCase()) === -1) return false;
        // check for valid square
        if (!(square in $6eb582f9081eb7e5$var$Ox88)) return false;
        const sq = $6eb582f9081eb7e5$var$Ox88[square];
        // don't let the user place more than one king
        if (type == $6eb582f9081eb7e5$export$42387107bb0d6206 && !(this._kings[color] == $6eb582f9081eb7e5$var$EMPTY || this._kings[color] == sq)) return false;
        this._board[sq] = {
            type: type,
            color: color
        };
        if (type === $6eb582f9081eb7e5$export$42387107bb0d6206) this._kings[color] = sq;
        this._updateCastlingRights();
        this._updateEnPassantSquare();
        this._updateSetup(this.fen());
        return true;
    }
    remove(square) {
        const piece = this.get(square);
        delete this._board[$6eb582f9081eb7e5$var$Ox88[square]];
        if (piece && piece.type === $6eb582f9081eb7e5$export$42387107bb0d6206) this._kings[piece.color] = $6eb582f9081eb7e5$var$EMPTY;
        this._updateCastlingRights();
        this._updateEnPassantSquare();
        this._updateSetup(this.fen());
        return piece;
    }
    _updateCastlingRights() {
        const whiteKingInPlace = this._board[$6eb582f9081eb7e5$var$Ox88.e1]?.type === $6eb582f9081eb7e5$export$42387107bb0d6206 && this._board[$6eb582f9081eb7e5$var$Ox88.e1]?.color === $6eb582f9081eb7e5$export$29814851e0aa981f;
        const blackKingInPlace = this._board[$6eb582f9081eb7e5$var$Ox88.e8]?.type === $6eb582f9081eb7e5$export$42387107bb0d6206 && this._board[$6eb582f9081eb7e5$var$Ox88.e8]?.color === $6eb582f9081eb7e5$export$7a91b0fde7ec420f;
        if (!whiteKingInPlace || this._board[$6eb582f9081eb7e5$var$Ox88.a1]?.type !== $6eb582f9081eb7e5$export$68d4c913908dc245 || this._board[$6eb582f9081eb7e5$var$Ox88.a1]?.color !== $6eb582f9081eb7e5$export$29814851e0aa981f) this._castling.w &= ~$6eb582f9081eb7e5$var$BITS.QSIDE_CASTLE;
        if (!whiteKingInPlace || this._board[$6eb582f9081eb7e5$var$Ox88.h1]?.type !== $6eb582f9081eb7e5$export$68d4c913908dc245 || this._board[$6eb582f9081eb7e5$var$Ox88.h1]?.color !== $6eb582f9081eb7e5$export$29814851e0aa981f) this._castling.w &= ~$6eb582f9081eb7e5$var$BITS.KSIDE_CASTLE;
        if (!blackKingInPlace || this._board[$6eb582f9081eb7e5$var$Ox88.a8]?.type !== $6eb582f9081eb7e5$export$68d4c913908dc245 || this._board[$6eb582f9081eb7e5$var$Ox88.a8]?.color !== $6eb582f9081eb7e5$export$7a91b0fde7ec420f) this._castling.b &= ~$6eb582f9081eb7e5$var$BITS.QSIDE_CASTLE;
        if (!blackKingInPlace || this._board[$6eb582f9081eb7e5$var$Ox88.h8]?.type !== $6eb582f9081eb7e5$export$68d4c913908dc245 || this._board[$6eb582f9081eb7e5$var$Ox88.h8]?.color !== $6eb582f9081eb7e5$export$7a91b0fde7ec420f) this._castling.b &= ~$6eb582f9081eb7e5$var$BITS.KSIDE_CASTLE;
    }
    _updateEnPassantSquare() {
        if (this._epSquare === $6eb582f9081eb7e5$var$EMPTY) return;
        const startSquare = this._epSquare + (this._turn === $6eb582f9081eb7e5$export$29814851e0aa981f ? -16 : 16);
        const currentSquare = this._epSquare + (this._turn === $6eb582f9081eb7e5$export$29814851e0aa981f ? 16 : -16);
        const attackers = [
            currentSquare + 1,
            currentSquare - 1
        ];
        if (this._board[startSquare] !== null || this._board[this._epSquare] !== null || this._board[currentSquare]?.color !== $6eb582f9081eb7e5$var$swapColor(this._turn) || this._board[currentSquare]?.type !== $6eb582f9081eb7e5$export$4c32fd1f222ff2b0) {
            this._epSquare = $6eb582f9081eb7e5$var$EMPTY;
            return;
        }
        const canCapture = (square)=>!(square & 0x88) && this._board[square]?.color === this._turn && this._board[square]?.type === $6eb582f9081eb7e5$export$4c32fd1f222ff2b0;
        if (!attackers.some(canCapture)) this._epSquare = $6eb582f9081eb7e5$var$EMPTY;
    }
    _attacked(color, square) {
        for(let i = $6eb582f9081eb7e5$var$Ox88.a8; i <= $6eb582f9081eb7e5$var$Ox88.h1; i++){
            // did we run off the end of the board
            if (i & 0x88) {
                i += 7;
                continue;
            }
            // if empty square or wrong color
            if (this._board[i] === undefined || this._board[i].color !== color) continue;
            const piece = this._board[i];
            const difference = i - square;
            // skip - to/from square are the same
            if (difference === 0) continue;
            const index = difference + 119;
            if ($6eb582f9081eb7e5$var$ATTACKS[index] & $6eb582f9081eb7e5$var$PIECE_MASKS[piece.type]) {
                if (piece.type === $6eb582f9081eb7e5$export$4c32fd1f222ff2b0) {
                    if (difference > 0) {
                        if (piece.color === $6eb582f9081eb7e5$export$29814851e0aa981f) return true;
                    } else {
                        if (piece.color === $6eb582f9081eb7e5$export$7a91b0fde7ec420f) return true;
                    }
                    continue;
                }
                // if the piece is a knight or a king
                if (piece.type === "n" || piece.type === "k") return true;
                const offset = $6eb582f9081eb7e5$var$RAYS[index];
                let j = i + offset;
                let blocked = false;
                while(j !== square){
                    if (this._board[j] != null) {
                        blocked = true;
                        break;
                    }
                    j += offset;
                }
                if (!blocked) return true;
            }
        }
        return false;
    }
    _isKingAttacked(color) {
        const square = this._kings[color];
        return square === -1 ? false : this._attacked($6eb582f9081eb7e5$var$swapColor(color), square);
    }
    isAttacked(square, attackedBy) {
        return this._attacked(attackedBy, $6eb582f9081eb7e5$var$Ox88[square]);
    }
    isCheck() {
        return this._isKingAttacked(this._turn);
    }
    inCheck() {
        return this.isCheck();
    }
    isCheckmate() {
        return this.isCheck() && this._moves().length === 0;
    }
    isStalemate() {
        return !this.isCheck() && this._moves().length === 0;
    }
    isInsufficientMaterial() {
        /*
         * k.b. vs k.b. (of opposite colors) with mate in 1:
         * 8/8/8/8/1b6/8/B1k5/K7 b - - 0 1
         *
         * k.b. vs k.n. with mate in 1:
         * 8/8/8/8/1n6/8/B7/K1k5 b - - 2 1
         */ const pieces = {
            b: 0,
            n: 0,
            r: 0,
            q: 0,
            k: 0,
            p: 0
        };
        const bishops = [];
        let numPieces = 0;
        let squareColor = 0;
        for(let i = $6eb582f9081eb7e5$var$Ox88.a8; i <= $6eb582f9081eb7e5$var$Ox88.h1; i++){
            squareColor = (squareColor + 1) % 2;
            if (i & 0x88) {
                i += 7;
                continue;
            }
            const piece = this._board[i];
            if (piece) {
                pieces[piece.type] = piece.type in pieces ? pieces[piece.type] + 1 : 1;
                if (piece.type === $6eb582f9081eb7e5$export$54a167f801c5dba3) bishops.push(squareColor);
                numPieces++;
            }
        }
        // k vs. k
        if (numPieces === 2) return true;
        else if (// k vs. kn .... or .... k vs. kb
        numPieces === 3 && (pieces[$6eb582f9081eb7e5$export$54a167f801c5dba3] === 1 || pieces[$6eb582f9081eb7e5$export$ce32bc8c2a29bae6] === 1)) return true;
        else if (numPieces === pieces[$6eb582f9081eb7e5$export$54a167f801c5dba3] + 2) {
            // kb vs. kb where any number of bishops are all on the same color
            let sum = 0;
            const len = bishops.length;
            for(let i = 0; i < len; i++)sum += bishops[i];
            if (sum === 0 || sum === len) return true;
        }
        return false;
    }
    isThreefoldRepetition() {
        const moves = [];
        const positions = {};
        let repetition = false;
        while(true){
            const move = this._undoMove();
            if (!move) break;
            moves.push(move);
        }
        while(true){
            /*
             * remove the last two fields in the FEN string, they're not needed when
             * checking for draw by rep
             */ const fen = this.fen().split(" ").slice(0, 4).join(" ");
            // has the position occurred three or move times
            positions[fen] = fen in positions ? positions[fen] + 1 : 1;
            if (positions[fen] >= 3) repetition = true;
            const move = moves.pop();
            if (!move) break;
            else this._makeMove(move);
        }
        return repetition;
    }
    isDraw() {
        return this._halfMoves >= 100 || // 50 moves per side = 100 half moves
        this.isStalemate() || this.isInsufficientMaterial() || this.isThreefoldRepetition();
    }
    isGameOver() {
        return this.isCheckmate() || this.isStalemate() || this.isDraw();
    }
    moves({ verbose: verbose = false, square: square, piece: piece } = {}) {
        const moves = this._moves({
            square: square,
            piece: piece
        });
        if (verbose) return moves.map((move)=>this._makePretty(move));
        else return moves.map((move)=>this._moveToSan(move, moves));
    }
    _moves({ legal: legal = true, piece: piece, square: square } = {}) {
        const forSquare = square ? square.toLowerCase() : undefined;
        const forPiece = piece?.toLowerCase();
        const moves = [];
        const us = this._turn;
        const them = $6eb582f9081eb7e5$var$swapColor(us);
        let firstSquare = $6eb582f9081eb7e5$var$Ox88.a8;
        let lastSquare = $6eb582f9081eb7e5$var$Ox88.h1;
        let singleSquare = false;
        // are we generating moves for a single square?
        if (forSquare) {
            // illegal square, return empty moves
            if (!(forSquare in $6eb582f9081eb7e5$var$Ox88)) return [];
            else {
                firstSquare = lastSquare = $6eb582f9081eb7e5$var$Ox88[forSquare];
                singleSquare = true;
            }
        }
        for(let from = firstSquare; from <= lastSquare; from++){
            // did we run off the end of the board
            if (from & 0x88) {
                from += 7;
                continue;
            }
            // empty square or opponent, skip
            if (!this._board[from] || this._board[from].color === them) continue;
            const { type: type } = this._board[from];
            let to;
            if (type === $6eb582f9081eb7e5$export$4c32fd1f222ff2b0) {
                if (forPiece && forPiece !== type) continue;
                // single square, non-capturing
                to = from + $6eb582f9081eb7e5$var$PAWN_OFFSETS[us][0];
                if (!this._board[to]) {
                    $6eb582f9081eb7e5$var$addMove(moves, us, from, to, $6eb582f9081eb7e5$export$4c32fd1f222ff2b0);
                    // double square
                    to = from + $6eb582f9081eb7e5$var$PAWN_OFFSETS[us][1];
                    if ($6eb582f9081eb7e5$var$SECOND_RANK[us] === $6eb582f9081eb7e5$var$rank(from) && !this._board[to]) $6eb582f9081eb7e5$var$addMove(moves, us, from, to, $6eb582f9081eb7e5$export$4c32fd1f222ff2b0, undefined, $6eb582f9081eb7e5$var$BITS.BIG_PAWN);
                }
                // pawn captures
                for(let j = 2; j < 4; j++){
                    to = from + $6eb582f9081eb7e5$var$PAWN_OFFSETS[us][j];
                    if (to & 0x88) continue;
                    if (this._board[to]?.color === them) $6eb582f9081eb7e5$var$addMove(moves, us, from, to, $6eb582f9081eb7e5$export$4c32fd1f222ff2b0, this._board[to].type, $6eb582f9081eb7e5$var$BITS.CAPTURE);
                    else if (to === this._epSquare) $6eb582f9081eb7e5$var$addMove(moves, us, from, to, $6eb582f9081eb7e5$export$4c32fd1f222ff2b0, $6eb582f9081eb7e5$export$4c32fd1f222ff2b0, $6eb582f9081eb7e5$var$BITS.EP_CAPTURE);
                }
            } else {
                if (forPiece && forPiece !== type) continue;
                for(let j = 0, len = $6eb582f9081eb7e5$var$PIECE_OFFSETS[type].length; j < len; j++){
                    const offset = $6eb582f9081eb7e5$var$PIECE_OFFSETS[type][j];
                    to = from;
                    while(true){
                        to += offset;
                        if (to & 0x88) break;
                        if (!this._board[to]) $6eb582f9081eb7e5$var$addMove(moves, us, from, to, type);
                        else {
                            // own color, stop loop
                            if (this._board[to].color === us) break;
                            $6eb582f9081eb7e5$var$addMove(moves, us, from, to, type, this._board[to].type, $6eb582f9081eb7e5$var$BITS.CAPTURE);
                            break;
                        }
                        /* break, if knight or king */ if (type === $6eb582f9081eb7e5$export$ce32bc8c2a29bae6 || type === $6eb582f9081eb7e5$export$42387107bb0d6206) break;
                    }
                }
            }
        }
        /*
         * check for castling if we're:
         *   a) generating all moves, or
         *   b) doing single square move generation on the king's square
         */ if (forPiece === undefined || forPiece === $6eb582f9081eb7e5$export$42387107bb0d6206) {
            if (!singleSquare || lastSquare === this._kings[us]) {
                // king-side castling
                if (this._castling[us] & $6eb582f9081eb7e5$var$BITS.KSIDE_CASTLE) {
                    const castlingFrom = this._kings[us];
                    const castlingTo = castlingFrom + 2;
                    if (!this._board[castlingFrom + 1] && !this._board[castlingTo] && !this._attacked(them, this._kings[us]) && !this._attacked(them, castlingFrom + 1) && !this._attacked(them, castlingTo)) $6eb582f9081eb7e5$var$addMove(moves, us, this._kings[us], castlingTo, $6eb582f9081eb7e5$export$42387107bb0d6206, undefined, $6eb582f9081eb7e5$var$BITS.KSIDE_CASTLE);
                }
                // queen-side castling
                if (this._castling[us] & $6eb582f9081eb7e5$var$BITS.QSIDE_CASTLE) {
                    const castlingFrom = this._kings[us];
                    const castlingTo = castlingFrom - 2;
                    if (!this._board[castlingFrom - 1] && !this._board[castlingFrom - 2] && !this._board[castlingFrom - 3] && !this._attacked(them, this._kings[us]) && !this._attacked(them, castlingFrom - 1) && !this._attacked(them, castlingTo)) $6eb582f9081eb7e5$var$addMove(moves, us, this._kings[us], castlingTo, $6eb582f9081eb7e5$export$42387107bb0d6206, undefined, $6eb582f9081eb7e5$var$BITS.QSIDE_CASTLE);
                }
            }
        }
        /*
         * return all pseudo-legal moves (this includes moves that allow the king
         * to be captured)
         */ if (!legal || this._kings[us] === -1) return moves;
        // filter out illegal moves
        const legalMoves = [];
        for(let i = 0, len = moves.length; i < len; i++){
            this._makeMove(moves[i]);
            if (!this._isKingAttacked(us)) legalMoves.push(moves[i]);
            this._undoMove();
        }
        return legalMoves;
    }
    move(move, { strict: strict = false } = {}) {
        /*
         * The move function can be called with in the following parameters:
         *
         * .move('Nxb7')       <- argument is a case-sensitive SAN string
         *
         * .move({ from: 'h7', <- argument is a move object
         *         to :'h8',
         *         promotion: 'q' })
         *
         *
         * An optional strict argument may be supplied to tell chess.js to
         * strictly follow the SAN specification.
         */ let moveObj = null;
        if (typeof move === "string") moveObj = this._moveFromSan(move, strict);
        else if (typeof move === "object") {
            const moves = this._moves();
            // convert the pretty move object to an ugly move object
            for(let i = 0, len = moves.length; i < len; i++)if (move.from === $6eb582f9081eb7e5$var$algebraic(moves[i].from) && move.to === $6eb582f9081eb7e5$var$algebraic(moves[i].to) && (!("promotion" in moves[i]) || move.promotion === moves[i].promotion)) {
                moveObj = moves[i];
                break;
            }
        }
        // failed to find move
        if (!moveObj) {
            if (typeof move === "string") throw new Error(`Invalid move: ${move}`);
            else throw new Error(`Invalid move: ${JSON.stringify(move)}`);
        }
        /*
         * need to make a copy of move because we can't generate SAN after the move
         * is made
         */ const prettyMove = this._makePretty(moveObj);
        this._makeMove(moveObj);
        return prettyMove;
    }
    _push(move) {
        this._history.push({
            move: move,
            kings: {
                b: this._kings.b,
                w: this._kings.w
            },
            turn: this._turn,
            castling: {
                b: this._castling.b,
                w: this._castling.w
            },
            epSquare: this._epSquare,
            halfMoves: this._halfMoves,
            moveNumber: this._moveNumber
        });
    }
    _makeMove(move) {
        const us = this._turn;
        const them = $6eb582f9081eb7e5$var$swapColor(us);
        this._push(move);
        this._board[move.to] = this._board[move.from];
        delete this._board[move.from];
        // if ep capture, remove the captured pawn
        if (move.flags & $6eb582f9081eb7e5$var$BITS.EP_CAPTURE) {
            if (this._turn === $6eb582f9081eb7e5$export$7a91b0fde7ec420f) delete this._board[move.to - 16];
            else delete this._board[move.to + 16];
        }
        // if pawn promotion, replace with new piece
        if (move.promotion) this._board[move.to] = {
            type: move.promotion,
            color: us
        };
        // if we moved the king
        if (this._board[move.to].type === $6eb582f9081eb7e5$export$42387107bb0d6206) {
            this._kings[us] = move.to;
            // if we castled, move the rook next to the king
            if (move.flags & $6eb582f9081eb7e5$var$BITS.KSIDE_CASTLE) {
                const castlingTo = move.to - 1;
                const castlingFrom = move.to + 1;
                this._board[castlingTo] = this._board[castlingFrom];
                delete this._board[castlingFrom];
            } else if (move.flags & $6eb582f9081eb7e5$var$BITS.QSIDE_CASTLE) {
                const castlingTo = move.to + 1;
                const castlingFrom = move.to - 2;
                this._board[castlingTo] = this._board[castlingFrom];
                delete this._board[castlingFrom];
            }
            // turn off castling
            this._castling[us] = 0;
        }
        // turn off castling if we move a rook
        if (this._castling[us]) {
            for(let i = 0, len = $6eb582f9081eb7e5$var$ROOKS[us].length; i < len; i++)if (move.from === $6eb582f9081eb7e5$var$ROOKS[us][i].square && this._castling[us] & $6eb582f9081eb7e5$var$ROOKS[us][i].flag) {
                this._castling[us] ^= $6eb582f9081eb7e5$var$ROOKS[us][i].flag;
                break;
            }
        }
        // turn off castling if we capture a rook
        if (this._castling[them]) {
            for(let i = 0, len = $6eb582f9081eb7e5$var$ROOKS[them].length; i < len; i++)if (move.to === $6eb582f9081eb7e5$var$ROOKS[them][i].square && this._castling[them] & $6eb582f9081eb7e5$var$ROOKS[them][i].flag) {
                this._castling[them] ^= $6eb582f9081eb7e5$var$ROOKS[them][i].flag;
                break;
            }
        }
        // if big pawn move, update the en passant square
        if (move.flags & $6eb582f9081eb7e5$var$BITS.BIG_PAWN) {
            if (us === $6eb582f9081eb7e5$export$7a91b0fde7ec420f) this._epSquare = move.to - 16;
            else this._epSquare = move.to + 16;
        } else this._epSquare = $6eb582f9081eb7e5$var$EMPTY;
        // reset the 50 move counter if a pawn is moved or a piece is captured
        if (move.piece === $6eb582f9081eb7e5$export$4c32fd1f222ff2b0) this._halfMoves = 0;
        else if (move.flags & ($6eb582f9081eb7e5$var$BITS.CAPTURE | $6eb582f9081eb7e5$var$BITS.EP_CAPTURE)) this._halfMoves = 0;
        else this._halfMoves++;
        if (us === $6eb582f9081eb7e5$export$7a91b0fde7ec420f) this._moveNumber++;
        this._turn = them;
    }
    undo() {
        const move = this._undoMove();
        return move ? this._makePretty(move) : null;
    }
    _undoMove() {
        const old = this._history.pop();
        if (old === undefined) return null;
        const move = old.move;
        this._kings = old.kings;
        this._turn = old.turn;
        this._castling = old.castling;
        this._epSquare = old.epSquare;
        this._halfMoves = old.halfMoves;
        this._moveNumber = old.moveNumber;
        const us = this._turn;
        const them = $6eb582f9081eb7e5$var$swapColor(us);
        this._board[move.from] = this._board[move.to];
        this._board[move.from].type = move.piece; // to undo any promotions
        delete this._board[move.to];
        if (move.captured) {
            if (move.flags & $6eb582f9081eb7e5$var$BITS.EP_CAPTURE) {
                // en passant capture
                let index;
                if (us === $6eb582f9081eb7e5$export$7a91b0fde7ec420f) index = move.to - 16;
                else index = move.to + 16;
                this._board[index] = {
                    type: $6eb582f9081eb7e5$export$4c32fd1f222ff2b0,
                    color: them
                };
            } else // regular capture
            this._board[move.to] = {
                type: move.captured,
                color: them
            };
        }
        if (move.flags & ($6eb582f9081eb7e5$var$BITS.KSIDE_CASTLE | $6eb582f9081eb7e5$var$BITS.QSIDE_CASTLE)) {
            let castlingTo, castlingFrom;
            if (move.flags & $6eb582f9081eb7e5$var$BITS.KSIDE_CASTLE) {
                castlingTo = move.to + 1;
                castlingFrom = move.to - 1;
            } else {
                castlingTo = move.to - 2;
                castlingFrom = move.to + 1;
            }
            this._board[castlingTo] = this._board[castlingFrom];
            delete this._board[castlingFrom];
        }
        return move;
    }
    pgn({ newline: newline = "\n", maxWidth: maxWidth = 0 } = {}) {
        /*
         * using the specification from http://www.chessclub.com/help/PGN-spec
         * example for html usage: .pgn({ max_width: 72, newline_char: "<br />" })
         */ const result = [];
        let headerExists = false;
        /* add the PGN header information */ for(const i in this._header){
            /*
             * TODO: order of enumerated properties in header object is not
             * guaranteed, see ECMA-262 spec (section 12.6.4)
             */ result.push("[" + i + ' "' + this._header[i] + '"]' + newline);
            headerExists = true;
        }
        if (headerExists && this._history.length) result.push(newline);
        const appendComment = (moveString)=>{
            const comment = this._comments[this.fen()];
            if (typeof comment !== "undefined") {
                const delimiter = moveString.length > 0 ? " " : "";
                moveString = `${moveString}${delimiter}{${comment}}`;
            }
            return moveString;
        };
        // pop all of history onto reversed_history
        const reversedHistory = [];
        while(this._history.length > 0)reversedHistory.push(this._undoMove());
        const moves = [];
        let moveString = "";
        // special case of a commented starting position with no moves
        if (reversedHistory.length === 0) moves.push(appendComment(""));
        // build the list of moves.  a move_string looks like: "3. e3 e6"
        while(reversedHistory.length > 0){
            moveString = appendComment(moveString);
            const move = reversedHistory.pop();
            // make TypeScript stop complaining about move being undefined
            if (!move) break;
            // if the position started with black to move, start PGN with #. ...
            if (!this._history.length && move.color === "b") {
                const prefix = `${this._moveNumber}. ...`;
                // is there a comment preceding the first move?
                moveString = moveString ? `${moveString} ${prefix}` : prefix;
            } else if (move.color === "w") {
                // store the previous generated move_string if we have one
                if (moveString.length) moves.push(moveString);
                moveString = this._moveNumber + ".";
            }
            moveString = moveString + " " + this._moveToSan(move, this._moves({
                legal: true
            }));
            this._makeMove(move);
        }
        // are there any other leftover moves?
        if (moveString.length) moves.push(appendComment(moveString));
        // is there a result?
        if (typeof this._header.Result !== "undefined") moves.push(this._header.Result);
        /*
         * history should be back to what it was before we started generating PGN,
         * so join together moves
         */ if (maxWidth === 0) return result.join("") + moves.join(" ");
        // TODO (jah): huh?
        const strip = function() {
            if (result.length > 0 && result[result.length - 1] === " ") {
                result.pop();
                return true;
            }
            return false;
        };
        // NB: this does not preserve comment whitespace.
        const wrapComment = function(width, move) {
            for (const token of move.split(" ")){
                if (!token) continue;
                if (width + token.length > maxWidth) {
                    while(strip())width--;
                    result.push(newline);
                    width = 0;
                }
                result.push(token);
                width += token.length;
                result.push(" ");
                width++;
            }
            if (strip()) width--;
            return width;
        };
        // wrap the PGN output at max_width
        let currentWidth = 0;
        for(let i = 0; i < moves.length; i++){
            if (currentWidth + moves[i].length > maxWidth) {
                if (moves[i].includes("{")) {
                    currentWidth = wrapComment(currentWidth, moves[i]);
                    continue;
                }
            }
            // if the current move will push past max_width
            if (currentWidth + moves[i].length > maxWidth && i !== 0) {
                // don't end the line with whitespace
                if (result[result.length - 1] === " ") result.pop();
                result.push(newline);
                currentWidth = 0;
            } else if (i !== 0) {
                result.push(" ");
                currentWidth++;
            }
            result.push(moves[i]);
            currentWidth += moves[i].length;
        }
        return result.join("");
    }
    header(...args) {
        for(let i = 0; i < args.length; i += 2)if (typeof args[i] === "string" && typeof args[i + 1] === "string") this._header[args[i]] = args[i + 1];
        return this._header;
    }
    loadPgn(pgn, { strict: strict = false, newlineChar: newlineChar = "\r?\n" } = {}) {
        function mask(str) {
            return str.replace(/\\/g, "\\");
        }
        function parsePgnHeader(header) {
            const headerObj = {};
            const headers = header.split(new RegExp(mask(newlineChar)));
            let key = "";
            let value = "";
            for(let i = 0; i < headers.length; i++){
                const regex = /^\s*\[\s*([A-Za-z]+)\s*"(.*)"\s*\]\s*$/;
                key = headers[i].replace(regex, "$1");
                value = headers[i].replace(regex, "$2");
                if (key.trim().length > 0) headerObj[key] = value;
            }
            return headerObj;
        }
        // strip whitespace from head/tail of PGN block
        pgn = pgn.trim();
        /*
         * RegExp to split header. Takes advantage of the fact that header and movetext
         * will always have a blank line between them (ie, two newline_char's). Handles
         * case where movetext is empty by matching newlineChar until end of string is
         * matched - effectively trimming from the end extra newlineChar.
         *
         * With default newline_char, will equal:
         * /^(\[((?:\r?\n)|.)*\])((?:\s*\r?\n){2}|(?:\s*\r?\n)*$)/
         */ const headerRegex = new RegExp("^(\\[((?:" + mask(newlineChar) + ")|.)*\\])" + "((?:\\s*" + mask(newlineChar) + "){2}|(?:\\s*" + mask(newlineChar) + ")*$)");
        // If no header given, begin with moves.
        const headerRegexResults = headerRegex.exec(pgn);
        const headerString = headerRegexResults ? headerRegexResults.length >= 2 ? headerRegexResults[1] : "" : "";
        // Put the board in the starting position
        this.reset();
        // parse PGN header
        const headers = parsePgnHeader(headerString);
        let fen = "";
        for(const key in headers){
            // check to see user is including fen (possibly with wrong tag case)
            if (key.toLowerCase() === "fen") fen = headers[key];
            this.header(key, headers[key]);
        }
        /*
         * the permissive parser should attempt to load a fen tag, even if it's the
         * wrong case and doesn't include a corresponding [SetUp "1"] tag
         */ if (!strict) {
            if (fen) this.load(fen, true);
        } else /*
             * strict parser - load the starting position indicated by [Setup '1']
             * and [FEN position]
             */ if (headers["SetUp"] === "1") {
            if (!("FEN" in headers)) throw new Error("Invalid PGN: FEN tag must be supplied with SetUp tag");
            // second argument to load: don't clear the headers
            this.load(headers["FEN"], true);
        }
        /*
         * NB: the regexes below that delete move numbers, recursive annotations,
         * and numeric annotation glyphs may also match text in comments. To
         * prevent this, we transform comments by hex-encoding them in place and
         * decoding them again after the other tokens have been deleted.
         *
         * While the spec states that PGN files should be ASCII encoded, we use
         * {en,de}codeURIComponent here to support arbitrary UTF8 as a convenience
         * for modern users
         */ function toHex(s) {
            return Array.from(s).map(function(c) {
                /*
                 * encodeURI doesn't transform most ASCII characters, so we handle
                 * these ourselves
                 */ return c.charCodeAt(0) < 128 ? c.charCodeAt(0).toString(16) : encodeURIComponent(c).replace(/%/g, "").toLowerCase();
            }).join("");
        }
        function fromHex(s) {
            return s.length == 0 ? "" : decodeURIComponent("%" + (s.match(/.{1,2}/g) || []).join("%"));
        }
        const encodeComment = function(s) {
            s = s.replace(new RegExp(mask(newlineChar), "g"), " ");
            return `{${toHex(s.slice(1, s.length - 1))}}`;
        };
        const decodeComment = function(s) {
            if (s.startsWith("{") && s.endsWith("}")) return fromHex(s.slice(1, s.length - 1));
        };
        // delete header to get the moves
        let ms = pgn.replace(headerString, "").replace(// encode comments so they don't get deleted below
        new RegExp(`({[^}]*})+?|;([^${mask(newlineChar)}]*)`, "g"), function(_match, bracket, semicolon) {
            return bracket !== undefined ? encodeComment(bracket) : " " + encodeComment(`{${semicolon.slice(1)}}`);
        }).replace(new RegExp(mask(newlineChar), "g"), " ");
        // delete recursive annotation variations
        const ravRegex = /(\([^()]+\))+?/g;
        while(ravRegex.test(ms))ms = ms.replace(ravRegex, "");
        // delete move numbers
        ms = ms.replace(/\d+\.(\.\.)?/g, "");
        // delete ... indicating black to move
        ms = ms.replace(/\.\.\./g, "");
        /* delete numeric annotation glyphs */ ms = ms.replace(/\$\d+/g, "");
        // trim and get array of moves
        let moves = ms.trim().split(new RegExp(/\s+/));
        // delete empty entries
        moves = moves.filter((move)=>move !== "");
        let result = "";
        for(let halfMove = 0; halfMove < moves.length; halfMove++){
            const comment = decodeComment(moves[halfMove]);
            if (comment !== undefined) {
                this._comments[this.fen()] = comment;
                continue;
            }
            const move = this._moveFromSan(moves[halfMove], strict);
            // invalid move
            if (move == null) {
                // was the move an end of game marker
                if ($6eb582f9081eb7e5$var$TERMINATION_MARKERS.indexOf(moves[halfMove]) > -1) result = moves[halfMove];
                else throw new Error(`Invalid move in PGN: ${moves[halfMove]}`);
            } else {
                // reset the end of game marker if making a valid move
                result = "";
                this._makeMove(move);
            }
        }
        /*
         * Per section 8.2.6 of the PGN spec, the Result tag pair must match match
         * the termination marker. Only do this when headers are present, but the
         * result tag is missing
         */ if (result && Object.keys(this._header).length && !this._header["Result"]) this.header("Result", result);
    }
    /*
     * Convert a move from 0x88 coordinates to Standard Algebraic Notation
     * (SAN)
     *
     * @param {boolean} strict Use the strict SAN parser. It will throw errors
     * on overly disambiguated moves (see below):
     *
     * r1bqkbnr/ppp2ppp/2n5/1B1pP3/4P3/8/PPPP2PP/RNBQK1NR b KQkq - 2 4
     * 4. ... Nge7 is overly disambiguated because the knight on c6 is pinned
     * 4. ... Ne7 is technically the valid SAN
     */ _moveToSan(move, moves) {
        let output = "";
        if (move.flags & $6eb582f9081eb7e5$var$BITS.KSIDE_CASTLE) output = "O-O";
        else if (move.flags & $6eb582f9081eb7e5$var$BITS.QSIDE_CASTLE) output = "O-O-O";
        else {
            if (move.piece !== $6eb582f9081eb7e5$export$4c32fd1f222ff2b0) {
                const disambiguator = $6eb582f9081eb7e5$var$getDisambiguator(move, moves);
                output += move.piece.toUpperCase() + disambiguator;
            }
            if (move.flags & ($6eb582f9081eb7e5$var$BITS.CAPTURE | $6eb582f9081eb7e5$var$BITS.EP_CAPTURE)) {
                if (move.piece === $6eb582f9081eb7e5$export$4c32fd1f222ff2b0) output += $6eb582f9081eb7e5$var$algebraic(move.from)[0];
                output += "x";
            }
            output += $6eb582f9081eb7e5$var$algebraic(move.to);
            if (move.promotion) output += "=" + move.promotion.toUpperCase();
        }
        this._makeMove(move);
        if (this.isCheck()) {
            if (this.isCheckmate()) output += "#";
            else output += "+";
        }
        this._undoMove();
        return output;
    }
    // convert a move from Standard Algebraic Notation (SAN) to 0x88 coordinates
    _moveFromSan(move, strict = false) {
        // strip off any move decorations: e.g Nf3+?! becomes Nf3
        const cleanMove = $6eb582f9081eb7e5$var$strippedSan(move);
        let pieceType = $6eb582f9081eb7e5$var$inferPieceType(cleanMove);
        let moves = this._moves({
            legal: true,
            piece: pieceType
        });
        // strict parser
        for(let i = 0, len = moves.length; i < len; i++){
            if (cleanMove === $6eb582f9081eb7e5$var$strippedSan(this._moveToSan(moves[i], moves))) return moves[i];
        }
        // the strict parser failed
        if (strict) return null;
        let piece = undefined;
        let matches = undefined;
        let from = undefined;
        let to = undefined;
        let promotion = undefined;
        /*
         * The default permissive (non-strict) parser allows the user to parse
         * non-standard chess notations. This parser is only run after the strict
         * Standard Algebraic Notation (SAN) parser has failed.
         *
         * When running the permissive parser, we'll run a regex to grab the piece, the
         * to/from square, and an optional promotion piece. This regex will
         * parse common non-standard notation like: Pe2-e4, Rc1c4, Qf3xf7,
         * f7f8q, b1c3
         *
         * NOTE: Some positions and moves may be ambiguous when using the permissive
         * parser. For example, in this position: 6k1/8/8/B7/8/8/8/BN4K1 w - - 0 1,
         * the move b1c3 may be interpreted as Nc3 or B1c3 (a disambiguated bishop
         * move). In these cases, the permissive parser will default to the most
         * basic interpretation (which is b1c3 parsing to Nc3).
         */ let overlyDisambiguated = false;
        matches = cleanMove.match(/([pnbrqkPNBRQK])?([a-h][1-8])x?-?([a-h][1-8])([qrbnQRBN])?/);
        if (matches) {
            piece = matches[1];
            from = matches[2];
            to = matches[3];
            promotion = matches[4];
            if (from.length == 1) overlyDisambiguated = true;
        } else {
            /*
             * The [a-h]?[1-8]? portion of the regex below handles moves that may be
             * overly disambiguated (e.g. Nge7 is unnecessary and non-standard when
             * there is one legal knight move to e7). In this case, the value of
             * 'from' variable will be a rank or file, not a square.
             */ matches = cleanMove.match(/([pnbrqkPNBRQK])?([a-h]?[1-8]?)x?-?([a-h][1-8])([qrbnQRBN])?/);
            if (matches) {
                piece = matches[1];
                from = matches[2];
                to = matches[3];
                promotion = matches[4];
                if (from.length == 1) overlyDisambiguated = true;
            }
        }
        pieceType = $6eb582f9081eb7e5$var$inferPieceType(cleanMove);
        moves = this._moves({
            legal: true,
            piece: piece ? piece : pieceType
        });
        if (!to) return null;
        for(let i = 0, len = moves.length; i < len; i++){
            if (!from) {
                // if there is no from square, it could be just 'x' missing from a capture
                if (cleanMove === $6eb582f9081eb7e5$var$strippedSan(this._moveToSan(moves[i], moves)).replace("x", "")) return moves[i];
            // hand-compare move properties with the results from our permissive regex
            } else if ((!piece || piece.toLowerCase() == moves[i].piece) && $6eb582f9081eb7e5$var$Ox88[from] == moves[i].from && $6eb582f9081eb7e5$var$Ox88[to] == moves[i].to && (!promotion || promotion.toLowerCase() == moves[i].promotion)) return moves[i];
            else if (overlyDisambiguated) {
                /*
                 * SPECIAL CASE: we parsed a move string that may have an unneeded
                 * rank/file disambiguator (e.g. Nge7).  The 'from' variable will
                 */ const square = $6eb582f9081eb7e5$var$algebraic(moves[i].from);
                if ((!piece || piece.toLowerCase() == moves[i].piece) && $6eb582f9081eb7e5$var$Ox88[to] == moves[i].to && (from == square[0] || from == square[1]) && (!promotion || promotion.toLowerCase() == moves[i].promotion)) return moves[i];
            }
        }
        return null;
    }
    ascii() {
        let s = "   +------------------------+\n";
        for(let i = $6eb582f9081eb7e5$var$Ox88.a8; i <= $6eb582f9081eb7e5$var$Ox88.h1; i++){
            // display the rank
            if ($6eb582f9081eb7e5$var$file(i) === 0) s += " " + "87654321"[$6eb582f9081eb7e5$var$rank(i)] + " |";
            if (this._board[i]) {
                const piece = this._board[i].type;
                const color = this._board[i].color;
                const symbol = color === $6eb582f9081eb7e5$export$29814851e0aa981f ? piece.toUpperCase() : piece.toLowerCase();
                s += " " + symbol + " ";
            } else s += " . ";
            if (i + 1 & 0x88) {
                s += "|\n";
                i += 8;
            }
        }
        s += "   +------------------------+\n";
        s += "     a  b  c  d  e  f  g  h";
        return s;
    }
    perft(depth) {
        const moves = this._moves({
            legal: false
        });
        let nodes = 0;
        const color = this._turn;
        for(let i = 0, len = moves.length; i < len; i++){
            this._makeMove(moves[i]);
            if (!this._isKingAttacked(color)) {
                if (depth - 1 > 0) nodes += this.perft(depth - 1);
                else nodes++;
            }
            this._undoMove();
        }
        return nodes;
    }
    // pretty = external move object
    _makePretty(uglyMove) {
        const { color: color, piece: piece, from: from, to: to, flags: flags, captured: captured, promotion: promotion } = uglyMove;
        let prettyFlags = "";
        for(const flag in $6eb582f9081eb7e5$var$BITS)if ($6eb582f9081eb7e5$var$BITS[flag] & flags) prettyFlags += $6eb582f9081eb7e5$var$FLAGS[flag];
        const fromAlgebraic = $6eb582f9081eb7e5$var$algebraic(from);
        const toAlgebraic = $6eb582f9081eb7e5$var$algebraic(to);
        const move = {
            color: color,
            piece: piece,
            from: fromAlgebraic,
            to: toAlgebraic,
            san: this._moveToSan(uglyMove, this._moves({
                legal: true
            })),
            flags: prettyFlags,
            lan: fromAlgebraic + toAlgebraic,
            before: this.fen(),
            after: ""
        };
        // generate the FEN for the 'after' key
        this._makeMove(uglyMove);
        move.after = this.fen();
        this._undoMove();
        if (captured) move.captured = captured;
        if (promotion) {
            move.promotion = promotion;
            move.lan += promotion;
        }
        return move;
    }
    turn() {
        return this._turn;
    }
    board() {
        const output = [];
        let row = [];
        for(let i = $6eb582f9081eb7e5$var$Ox88.a8; i <= $6eb582f9081eb7e5$var$Ox88.h1; i++){
            if (this._board[i] == null) row.push(null);
            else row.push({
                square: $6eb582f9081eb7e5$var$algebraic(i),
                type: this._board[i].type,
                color: this._board[i].color
            });
            if (i + 1 & 0x88) {
                output.push(row);
                row = [];
                i += 8;
            }
        }
        return output;
    }
    squareColor(square) {
        if (square in $6eb582f9081eb7e5$var$Ox88) {
            const sq = $6eb582f9081eb7e5$var$Ox88[square];
            return ($6eb582f9081eb7e5$var$rank(sq) + $6eb582f9081eb7e5$var$file(sq)) % 2 === 0 ? "light" : "dark";
        }
        return null;
    }
    history({ verbose: verbose = false } = {}) {
        const reversedHistory = [];
        const moveHistory = [];
        while(this._history.length > 0)reversedHistory.push(this._undoMove());
        while(true){
            const move = reversedHistory.pop();
            if (!move) break;
            if (verbose) moveHistory.push(this._makePretty(move));
            else moveHistory.push(this._moveToSan(move, this._moves()));
            this._makeMove(move);
        }
        return moveHistory;
    }
    _pruneComments() {
        const reversedHistory = [];
        const currentComments = {};
        const copyComment = (fen)=>{
            if (fen in this._comments) currentComments[fen] = this._comments[fen];
        };
        while(this._history.length > 0)reversedHistory.push(this._undoMove());
        copyComment(this.fen());
        while(true){
            const move = reversedHistory.pop();
            if (!move) break;
            this._makeMove(move);
            copyComment(this.fen());
        }
        this._comments = currentComments;
    }
    getComment() {
        return this._comments[this.fen()];
    }
    setComment(comment) {
        this._comments[this.fen()] = comment.replace("{", "[").replace("}", "]");
    }
    deleteComment() {
        const comment = this._comments[this.fen()];
        delete this._comments[this.fen()];
        return comment;
    }
    getComments() {
        this._pruneComments();
        return Object.keys(this._comments).map((fen)=>{
            return {
                fen: fen,
                comment: this._comments[fen]
            };
        });
    }
    deleteComments() {
        this._pruneComments();
        return Object.keys(this._comments).map((fen)=>{
            const comment = this._comments[fen];
            delete this._comments[fen];
            return {
                fen: fen,
                comment: comment
            };
        });
    }
    setCastlingRights(color, rights) {
        for (const side of [
            $6eb582f9081eb7e5$export$42387107bb0d6206,
            $6eb582f9081eb7e5$export$36a8946792f13ec9
        ])if (rights[side] !== undefined) {
            if (rights[side]) this._castling[color] |= $6eb582f9081eb7e5$var$SIDES[side];
            else this._castling[color] &= ~$6eb582f9081eb7e5$var$SIDES[side];
        }
        this._updateCastlingRights();
        const result = this.getCastlingRights(color);
        return (rights[$6eb582f9081eb7e5$export$42387107bb0d6206] === undefined || rights[$6eb582f9081eb7e5$export$42387107bb0d6206] === result[$6eb582f9081eb7e5$export$42387107bb0d6206]) && (rights[$6eb582f9081eb7e5$export$36a8946792f13ec9] === undefined || rights[$6eb582f9081eb7e5$export$36a8946792f13ec9] === result[$6eb582f9081eb7e5$export$36a8946792f13ec9]);
    }
    getCastlingRights(color) {
        return {
            [$6eb582f9081eb7e5$export$42387107bb0d6206]: (this._castling[color] & $6eb582f9081eb7e5$var$SIDES[$6eb582f9081eb7e5$export$42387107bb0d6206]) !== 0,
            [$6eb582f9081eb7e5$export$36a8946792f13ec9]: (this._castling[color] & $6eb582f9081eb7e5$var$SIDES[$6eb582f9081eb7e5$export$36a8946792f13ec9]) !== 0
        };
    }
    moveNumber() {
        return this._moveNumber;
    }
}



const $236ba31c448bdb87$export$45f641c0a85ed846 = "abcdefgh";
let $236ba31c448bdb87$var$squares = [];
let $236ba31c448bdb87$var$files = [
    ...$236ba31c448bdb87$export$45f641c0a85ed846
];
$236ba31c448bdb87$var$files.forEach((f)=>{
    for(let i = 1; i <= 8; i++)$236ba31c448bdb87$var$squares.push(f + i);
});
const $236ba31c448bdb87$export$5fc67852ab417150 = $236ba31c448bdb87$var$squares;
function $236ba31c448bdb87$export$ef42e39072fd379(move) {
    let uci = move.from + move.to;
    if (move.promotion) uci += move.promotion;
    return uci;
}
function $236ba31c448bdb87$export$a23e9f71e3b927c7(fen) {
    let chess = new (0, $6eb582f9081eb7e5$export$a4d6ea685c300d39)(fen);
    let moves = chess.moves({
        verbose: true
    }) //, legal: false})
    ;
    let defenders = Array(64).fill(0);
    moves.forEach((move, i)=>{
        let index = $236ba31c448bdb87$export$5fc67852ab417150.indexOf(move.to);
        defenders[index] += 1;
    });
    $236ba31c448bdb87$export$5fc67852ab417150.forEach((square, i)=>{
        if (chess.get(square) && chess.get(square).color == chess.turn()) defenders[i] += 1;
    });
    return defenders;
}
function $236ba31c448bdb87$export$def19b3072191111(fen) {
    let tokens = fen.split(" ");
    tokens[1] = tokens[1] == "w" ? "b" : "w";
    // fix for en passant
    tokens[3] = "-";
    let newFen = tokens.join(" ");
    return newFen;
}
function $236ba31c448bdb87$export$51b6663f33fc7508(fen) {
    let chess = new (0, $6eb582f9081eb7e5$export$a4d6ea685c300d39)(fen);
    let moves = chess.moves({
        verbose: true
    });
    let dests = {};
    moves.forEach((m, i)=>{
        if (dests[m.from]) dests[m.from].push(m.to);
        else dests[m.from] = [
            m.to
        ];
    });
    // console.log('all possible moves', dests)
    return dests;
}
function $236ba31c448bdb87$export$f784c029d2bce31b(chess, piece) {
    let res = [];
    chess.board().map((rank, r)=>{
        rank.map((p, f)=>{
            if (p && p.type == piece.type && p.color == piece.color) res.push($236ba31c448bdb87$export$45f641c0a85ed846[f] + (8 - r));
        });
    });
    return res;
}







var $b058e0cf7a9c3e39$exports = {};
// javascript-astar 0.4.1
// http://github.com/bgrins/javascript-astar
// Freely distributable under the MIT License.
// Implements the astar search algorithm in javascript using a Binary Heap.
// Includes Binary Heap (with modifications) from Marijn Haverbeke.
// http://eloquentjavascript.net/appendix2.html
(function(definition) {
    /* global module, define */ if (typeof $b058e0cf7a9c3e39$exports === "object") $b058e0cf7a9c3e39$exports = definition();
    else if (typeof define === "function" && define.amd) define([], definition);
    else {
        var exports = definition();
        window.astar = exports.astar;
        window.Graph = exports.Graph;
    }
})(function() {
    function pathTo(node) {
        var curr = node, path = [];
        while(curr.parent){
            path.unshift(curr);
            curr = curr.parent;
        }
        return path;
    }
    function getHeap() {
        return new BinaryHeap(function(node) {
            return node.f;
        });
    }
    var astar = {
        /**
    * Perform an A* Search on a graph given a start and end node.
    * @param {Graph} graph
    * @param {GridNode} start
    * @param {GridNode} end
    * @param {Object} [options]
    * @param {bool} [options.closest] Specifies whether to return the
               path to the closest node if the target is unreachable.
    * @param {Function} [options.heuristic] Heuristic function (see
    *          astar.heuristics).
    */ search: function(graph, start, end, options) {
            graph.cleanDirty();
            options = options || {};
            var heuristic = options.heuristic || astar.heuristics.manhattan, closest = options.closest || false;
            var openHeap = getHeap(), closestNode = start; // set the start node to be the closest if required
            start.h = heuristic(start, end);
            openHeap.push(start);
            while(openHeap.size() > 0){
                // Grab the lowest f(x) to process next.  Heap keeps this sorted for us.
                var currentNode = openHeap.pop();
                // End case -- result has been found, return the traced path.
                if (currentNode === end) return pathTo(currentNode);
                // Normal case -- move currentNode from open to closed, process each of its neighbors.
                currentNode.closed = true;
                // Find all neighbors for the current node.
                var neighbors = graph.neighbors(currentNode);
                for(var i = 0, il = neighbors.length; i < il; ++i){
                    var neighbor = neighbors[i];
                    if (neighbor.closed || neighbor.isWall()) continue;
                    // The g score is the shortest distance from start to current node.
                    // We need to check if the path we have arrived at this neighbor is the shortest one we have seen yet.
                    var gScore = currentNode.g + neighbor.getCost(currentNode), beenVisited = neighbor.visited;
                    if (!beenVisited || gScore < neighbor.g) {
                        // Found an optimal (so far) path to this node.  Take score for node to see how good it is.
                        neighbor.visited = true;
                        neighbor.parent = currentNode;
                        neighbor.h = neighbor.h || heuristic(neighbor, end);
                        neighbor.g = gScore;
                        neighbor.f = neighbor.g + neighbor.h;
                        graph.markDirty(neighbor);
                        if (closest) // If the neighbour is closer than the current closestNode or if it's equally close but has
                        // a cheaper path than the current closest node then it becomes the closest node
                        {
                            if (neighbor.h < closestNode.h || neighbor.h === closestNode.h && neighbor.g < closestNode.g) closestNode = neighbor;
                        }
                        if (!beenVisited) // Pushing to heap will put it in proper place based on the 'f' value.
                        openHeap.push(neighbor);
                        else // Already seen the node, but since it has been rescored we need to reorder it in the heap
                        openHeap.rescoreElement(neighbor);
                    }
                }
            }
            if (closest) return pathTo(closestNode);
            // No result was found - empty array signifies failure to find path.
            return [];
        },
        // See list of heuristics: http://theory.stanford.edu/~amitp/GameProgramming/Heuristics.html
        heuristics: {
            manhattan: function(pos0, pos1) {
                var d1 = Math.abs(pos1.x - pos0.x);
                var d2 = Math.abs(pos1.y - pos0.y);
                return d1 + d2;
            },
            diagonal: function(pos0, pos1) {
                var D = 1;
                var D2 = Math.sqrt(2);
                var d1 = Math.abs(pos1.x - pos0.x);
                var d2 = Math.abs(pos1.y - pos0.y);
                return D * (d1 + d2) + (D2 - 2 * D) * Math.min(d1, d2);
            }
        },
        cleanNode: function(node) {
            node.f = 0;
            node.g = 0;
            node.h = 0;
            node.visited = false;
            node.closed = false;
            node.parent = null;
        }
    };
    /**
* A graph memory structure
* @param {Array} gridIn 2D array of input weights
* @param {Object} [options]
* @param {bool} [options.diagonal] Specifies whether diagonal moves are allowed
*/ function Graph(gridIn, options) {
        options = options || {};
        this.nodes = [];
        this.diagonal = !!options.diagonal;
        this.grid = [];
        for(var x = 0; x < gridIn.length; x++){
            this.grid[x] = [];
            for(var y = 0, row = gridIn[x]; y < row.length; y++){
                var node = new GridNode(x, y, row[y]);
                this.grid[x][y] = node;
                this.nodes.push(node);
            }
        }
        this.init();
    }
    Graph.prototype.init = function() {
        this.dirtyNodes = [];
        for(var i = 0; i < this.nodes.length; i++)astar.cleanNode(this.nodes[i]);
    };
    Graph.prototype.cleanDirty = function() {
        for(var i = 0; i < this.dirtyNodes.length; i++)astar.cleanNode(this.dirtyNodes[i]);
        this.dirtyNodes = [];
    };
    Graph.prototype.markDirty = function(node) {
        this.dirtyNodes.push(node);
    };
    Graph.prototype.neighbors = function(node) {
        var ret = [], x = node.x, y = node.y, grid = this.grid;
        // West
        if (grid[x - 1] && grid[x - 1][y]) ret.push(grid[x - 1][y]);
        // East
        if (grid[x + 1] && grid[x + 1][y]) ret.push(grid[x + 1][y]);
        // South
        if (grid[x] && grid[x][y - 1]) ret.push(grid[x][y - 1]);
        // North
        if (grid[x] && grid[x][y + 1]) ret.push(grid[x][y + 1]);
        if (this.diagonal) {
            // Southwest
            if (grid[x - 1] && grid[x - 1][y - 1]) ret.push(grid[x - 1][y - 1]);
            // Southeast
            if (grid[x + 1] && grid[x + 1][y - 1]) ret.push(grid[x + 1][y - 1]);
            // Northwest
            if (grid[x - 1] && grid[x - 1][y + 1]) ret.push(grid[x - 1][y + 1]);
            // Northeast
            if (grid[x + 1] && grid[x + 1][y + 1]) ret.push(grid[x + 1][y + 1]);
        }
        return ret;
    };
    Graph.prototype.toString = function() {
        var graphString = [], nodes = this.grid, rowDebug, row, y, l;
        for(var x = 0, len = nodes.length; x < len; x++){
            rowDebug = [];
            row = nodes[x];
            for(y = 0, l = row.length; y < l; y++)rowDebug.push(row[y].weight);
            graphString.push(rowDebug.join(" "));
        }
        return graphString.join("\n");
    };
    function GridNode(x, y, weight) {
        this.x = x;
        this.y = y;
        this.weight = weight;
    }
    GridNode.prototype.toString = function() {
        return "[" + this.x + " " + this.y + "]";
    };
    GridNode.prototype.getCost = function(fromNeighbor) {
        // Take diagonal weight into consideration.
        if (fromNeighbor && fromNeighbor.x != this.x && fromNeighbor.y != this.y) return this.weight * 1.41421;
        return this.weight;
    };
    GridNode.prototype.isWall = function() {
        return this.weight === 0;
    };
    function BinaryHeap(scoreFunction) {
        this.content = [];
        this.scoreFunction = scoreFunction;
    }
    BinaryHeap.prototype = {
        push: function(element) {
            // Add the new element to the end of the array.
            this.content.push(element);
            // Allow it to sink down.
            this.sinkDown(this.content.length - 1);
        },
        pop: function() {
            // Store the first element so we can return it later.
            var result = this.content[0];
            // Get the element at the end of the array.
            var end = this.content.pop();
            // If there are any elements left, put the end element at the
            // start, and let it bubble up.
            if (this.content.length > 0) {
                this.content[0] = end;
                this.bubbleUp(0);
            }
            return result;
        },
        remove: function(node) {
            var i = this.content.indexOf(node);
            // When it is found, the process seen in 'pop' is repeated
            // to fill up the hole.
            var end = this.content.pop();
            if (i !== this.content.length - 1) {
                this.content[i] = end;
                if (this.scoreFunction(end) < this.scoreFunction(node)) this.sinkDown(i);
                else this.bubbleUp(i);
            }
        },
        size: function() {
            return this.content.length;
        },
        rescoreElement: function(node) {
            this.sinkDown(this.content.indexOf(node));
        },
        sinkDown: function(n) {
            // Fetch the element that has to be sunk.
            var element = this.content[n];
            // When at 0, an element can not sink any further.
            while(n > 0){
                // Compute the parent element's index, and fetch it.
                var parentN = (n + 1 >> 1) - 1, parent = this.content[parentN];
                // Swap the elements if the parent is greater.
                if (this.scoreFunction(element) < this.scoreFunction(parent)) {
                    this.content[parentN] = element;
                    this.content[n] = parent;
                    // Update 'n' to continue at the new position.
                    n = parentN;
                } else break;
            }
        },
        bubbleUp: function(n) {
            // Look up the target element and its score.
            var length = this.content.length, element = this.content[n], elemScore = this.scoreFunction(element);
            while(true){
                // Compute the indices of the child elements.
                var child2N = n + 1 << 1, child1N = child2N - 1;
                // This is used to store the new position of the element, if any.
                var swap = null, child1Score;
                // If the first child exists (is inside the array)...
                if (child1N < length) {
                    // Look it up and compute its score.
                    var child1 = this.content[child1N];
                    child1Score = this.scoreFunction(child1);
                    // If the score is less than our element's, we need to swap.
                    if (child1Score < elemScore) swap = child1N;
                }
                // Do the same checks for the other child.
                if (child2N < length) {
                    var child2 = this.content[child2N], child2Score = this.scoreFunction(child2);
                    if (child2Score < (swap === null ? elemScore : child1Score)) swap = child2N;
                }
                // If the element needs to be moved, swap it, and continue.
                if (swap !== null) {
                    this.content[n] = this.content[swap];
                    this.content[swap] = element;
                    n = swap;
                } else break;
            }
        }
    };
    return {
        astar: astar,
        Graph: Graph
    };
});


function $d5ffb40ab7d69c90$export$7dc676b6dd72d281(chess) {
    const dests = new Map();
    (0, $236ba31c448bdb87$export$5fc67852ab417150).forEach((s)=>{
        const ms = chess.moves({
            square: s,
            verbose: true
        });
        if (ms.length) dests.set(s, ms.map((m)=>m.to));
    });
    console.log("all moves", dests);
    return dests;
}
function $d5ffb40ab7d69c90$export$4282caeda4cf6c97(chess) {
    return chess.turn() === "w" ? "white" : "black";
}
function $d5ffb40ab7d69c90$export$5b50b356a8724b72(chess, ground) {
    return (orig, dest)=>{
        chess.move({
            from: orig,
            to: dest
        });
        $d5ffb40ab7d69c90$export$8aee836dd884f091(chess, ground);
    };
}
function $d5ffb40ab7d69c90$export$8aee836dd884f091(chess, ground) {
    ground.set({
        fen: chess.fen(),
        check: chess.isCheck(),
        turnColor: $d5ffb40ab7d69c90$export$4282caeda4cf6c97(chess),
        movable: {
            color: $d5ffb40ab7d69c90$export$4282caeda4cf6c97(chess),
            dests: $d5ffb40ab7d69c90$export$7dc676b6dd72d281(chess)
        }
    });
    let hist = chess.history({
        verbose: true
    });
    if (hist.length) {
        let last = hist.pop();
        ground.set({
            lastMove: [
                last.from,
                last.to
            ]
        });
    }
}
function $d5ffb40ab7d69c90$export$dfb56f6b9abe10bc(from, to) {
    let graph = new (0, $b058e0cf7a9c3e39$exports.Graph)(new Array(8).fill(new Array(8).fill(1)), {
        diagonal: true
    });
    console.log("finding path", from, to, graph);
    let start = graph.grid[from.charCodeAt(0) - 97][from.charCodeAt(1) - 49];
    let end = graph.grid[to.charCodeAt(0) - 97][to.charCodeAt(1) - 49];
    let path = (0, $b058e0cf7a9c3e39$exports.astar).search(graph, start, end, {
        heuristic: (0, $b058e0cf7a9c3e39$exports.astar).heuristics.diagonal
    });
    path.unshift(start);
    console.log("found path", path);
    return path;
}




var $61fb775615801b9d$exports = {};
"use strict";
/**
 * An implementation of rfc6749#section-4.1 and rfc7636.
 */ var $61fb775615801b9d$var$__extends = $61fb775615801b9d$exports && $61fb775615801b9d$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $61fb775615801b9d$var$__assign = $61fb775615801b9d$exports && $61fb775615801b9d$exports.__assign || function() {
    $61fb775615801b9d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $61fb775615801b9d$var$__assign.apply(this, arguments);
};
var $61fb775615801b9d$var$__awaiter = $61fb775615801b9d$exports && $61fb775615801b9d$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $61fb775615801b9d$var$__generator = $61fb775615801b9d$exports && $61fb775615801b9d$exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $61fb775615801b9d$var$__spreadArrays = $61fb775615801b9d$exports && $61fb775615801b9d$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($61fb775615801b9d$exports, "__esModule", {
    value: true
});
/**
 * A list of OAuth2AuthCodePKCE errors.
 */ // To "namespace" all errors.
var $61fb775615801b9d$var$ErrorOAuth2 = /** @class */ function() {
    function ErrorOAuth2() {}
    ErrorOAuth2.prototype.toString = function() {
        return "ErrorOAuth2";
    };
    return ErrorOAuth2;
}();
$61fb775615801b9d$exports.ErrorOAuth2 = $61fb775615801b9d$var$ErrorOAuth2;
// For really unknown errors.
var $61fb775615801b9d$var$ErrorUnknown = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorUnknown, _super);
    function ErrorUnknown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorUnknown.prototype.toString = function() {
        return "ErrorUnknown";
    };
    return ErrorUnknown;
}($61fb775615801b9d$var$ErrorOAuth2);
$61fb775615801b9d$exports.ErrorUnknown = $61fb775615801b9d$var$ErrorUnknown;
// Some generic, internal errors that can happen.
var $61fb775615801b9d$var$ErrorNoAuthCode = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorNoAuthCode, _super);
    function ErrorNoAuthCode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorNoAuthCode.prototype.toString = function() {
        return "ErrorNoAuthCode";
    };
    return ErrorNoAuthCode;
}($61fb775615801b9d$var$ErrorOAuth2);
$61fb775615801b9d$exports.ErrorNoAuthCode = $61fb775615801b9d$var$ErrorNoAuthCode;
var $61fb775615801b9d$var$ErrorInvalidReturnedStateParam = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorInvalidReturnedStateParam, _super);
    function ErrorInvalidReturnedStateParam() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidReturnedStateParam.prototype.toString = function() {
        return "ErrorInvalidReturnedStateParam";
    };
    return ErrorInvalidReturnedStateParam;
}($61fb775615801b9d$var$ErrorOAuth2);
$61fb775615801b9d$exports.ErrorInvalidReturnedStateParam = $61fb775615801b9d$var$ErrorInvalidReturnedStateParam;
var $61fb775615801b9d$var$ErrorInvalidJson = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorInvalidJson, _super);
    function ErrorInvalidJson() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidJson.prototype.toString = function() {
        return "ErrorInvalidJson";
    };
    return ErrorInvalidJson;
}($61fb775615801b9d$var$ErrorOAuth2);
$61fb775615801b9d$exports.ErrorInvalidJson = $61fb775615801b9d$var$ErrorInvalidJson;
// Errors that occur across many endpoints
var $61fb775615801b9d$var$ErrorInvalidScope = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorInvalidScope, _super);
    function ErrorInvalidScope() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidScope.prototype.toString = function() {
        return "ErrorInvalidScope";
    };
    return ErrorInvalidScope;
}($61fb775615801b9d$var$ErrorOAuth2);
$61fb775615801b9d$exports.ErrorInvalidScope = $61fb775615801b9d$var$ErrorInvalidScope;
var $61fb775615801b9d$var$ErrorInvalidRequest = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorInvalidRequest, _super);
    function ErrorInvalidRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidRequest.prototype.toString = function() {
        return "ErrorInvalidRequest";
    };
    return ErrorInvalidRequest;
}($61fb775615801b9d$var$ErrorOAuth2);
$61fb775615801b9d$exports.ErrorInvalidRequest = $61fb775615801b9d$var$ErrorInvalidRequest;
var $61fb775615801b9d$var$ErrorInvalidToken = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorInvalidToken, _super);
    function ErrorInvalidToken() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidToken.prototype.toString = function() {
        return "ErrorInvalidToken";
    };
    return ErrorInvalidToken;
}($61fb775615801b9d$var$ErrorOAuth2);
$61fb775615801b9d$exports.ErrorInvalidToken = $61fb775615801b9d$var$ErrorInvalidToken;
/**
 * Possible authorization grant errors given by the redirection from the
 * authorization server.
 */ var $61fb775615801b9d$var$ErrorAuthenticationGrant = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorAuthenticationGrant, _super);
    function ErrorAuthenticationGrant() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorAuthenticationGrant.prototype.toString = function() {
        return "ErrorAuthenticationGrant";
    };
    return ErrorAuthenticationGrant;
}($61fb775615801b9d$var$ErrorOAuth2);
$61fb775615801b9d$exports.ErrorAuthenticationGrant = $61fb775615801b9d$var$ErrorAuthenticationGrant;
var $61fb775615801b9d$var$ErrorUnauthorizedClient = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorUnauthorizedClient, _super);
    function ErrorUnauthorizedClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorUnauthorizedClient.prototype.toString = function() {
        return "ErrorUnauthorizedClient";
    };
    return ErrorUnauthorizedClient;
}($61fb775615801b9d$var$ErrorAuthenticationGrant);
$61fb775615801b9d$exports.ErrorUnauthorizedClient = $61fb775615801b9d$var$ErrorUnauthorizedClient;
var $61fb775615801b9d$var$ErrorAccessDenied = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorAccessDenied, _super);
    function ErrorAccessDenied() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorAccessDenied.prototype.toString = function() {
        return "ErrorAccessDenied";
    };
    return ErrorAccessDenied;
}($61fb775615801b9d$var$ErrorAuthenticationGrant);
$61fb775615801b9d$exports.ErrorAccessDenied = $61fb775615801b9d$var$ErrorAccessDenied;
var $61fb775615801b9d$var$ErrorUnsupportedResponseType = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorUnsupportedResponseType, _super);
    function ErrorUnsupportedResponseType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorUnsupportedResponseType.prototype.toString = function() {
        return "ErrorUnsupportedResponseType";
    };
    return ErrorUnsupportedResponseType;
}($61fb775615801b9d$var$ErrorAuthenticationGrant);
$61fb775615801b9d$exports.ErrorUnsupportedResponseType = $61fb775615801b9d$var$ErrorUnsupportedResponseType;
var $61fb775615801b9d$var$ErrorServerError = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorServerError, _super);
    function ErrorServerError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorServerError.prototype.toString = function() {
        return "ErrorServerError";
    };
    return ErrorServerError;
}($61fb775615801b9d$var$ErrorAuthenticationGrant);
$61fb775615801b9d$exports.ErrorServerError = $61fb775615801b9d$var$ErrorServerError;
var $61fb775615801b9d$var$ErrorTemporarilyUnavailable = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorTemporarilyUnavailable, _super);
    function ErrorTemporarilyUnavailable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorTemporarilyUnavailable.prototype.toString = function() {
        return "ErrorTemporarilyUnavailable";
    };
    return ErrorTemporarilyUnavailable;
}($61fb775615801b9d$var$ErrorAuthenticationGrant);
$61fb775615801b9d$exports.ErrorTemporarilyUnavailable = $61fb775615801b9d$var$ErrorTemporarilyUnavailable;
/**
 * A list of possible access token response errors.
 */ var $61fb775615801b9d$var$ErrorAccessTokenResponse = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorAccessTokenResponse, _super);
    function ErrorAccessTokenResponse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorAccessTokenResponse.prototype.toString = function() {
        return "ErrorAccessTokenResponse";
    };
    return ErrorAccessTokenResponse;
}($61fb775615801b9d$var$ErrorOAuth2);
$61fb775615801b9d$exports.ErrorAccessTokenResponse = $61fb775615801b9d$var$ErrorAccessTokenResponse;
var $61fb775615801b9d$var$ErrorInvalidClient = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorInvalidClient, _super);
    function ErrorInvalidClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidClient.prototype.toString = function() {
        return "ErrorInvalidClient";
    };
    return ErrorInvalidClient;
}($61fb775615801b9d$var$ErrorAccessTokenResponse);
$61fb775615801b9d$exports.ErrorInvalidClient = $61fb775615801b9d$var$ErrorInvalidClient;
var $61fb775615801b9d$var$ErrorInvalidGrant = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorInvalidGrant, _super);
    function ErrorInvalidGrant() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorInvalidGrant.prototype.toString = function() {
        return "ErrorInvalidGrant";
    };
    return ErrorInvalidGrant;
}($61fb775615801b9d$var$ErrorAccessTokenResponse);
$61fb775615801b9d$exports.ErrorInvalidGrant = $61fb775615801b9d$var$ErrorInvalidGrant;
var $61fb775615801b9d$var$ErrorUnsupportedGrantType = /** @class */ function(_super) {
    $61fb775615801b9d$var$__extends(ErrorUnsupportedGrantType, _super);
    function ErrorUnsupportedGrantType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorUnsupportedGrantType.prototype.toString = function() {
        return "ErrorUnsupportedGrantType";
    };
    return ErrorUnsupportedGrantType;
}($61fb775615801b9d$var$ErrorAccessTokenResponse);
$61fb775615801b9d$exports.ErrorUnsupportedGrantType = $61fb775615801b9d$var$ErrorUnsupportedGrantType;
/**
 * WWW-Authenticate error object structure for less error prone handling.
 */ var $61fb775615801b9d$var$ErrorWWWAuthenticate = /** @class */ function() {
    function ErrorWWWAuthenticate() {
        this.realm = "";
        this.error = "";
    }
    return ErrorWWWAuthenticate;
}();
$61fb775615801b9d$exports.ErrorWWWAuthenticate = $61fb775615801b9d$var$ErrorWWWAuthenticate;
$61fb775615801b9d$exports.RawErrorToErrorClassMap = {
    invalid_request: $61fb775615801b9d$var$ErrorInvalidRequest,
    invalid_grant: $61fb775615801b9d$var$ErrorInvalidGrant,
    unauthorized_client: $61fb775615801b9d$var$ErrorUnauthorizedClient,
    access_denied: $61fb775615801b9d$var$ErrorAccessDenied,
    unsupported_response_type: $61fb775615801b9d$var$ErrorUnsupportedResponseType,
    invalid_scope: $61fb775615801b9d$var$ErrorInvalidScope,
    server_error: $61fb775615801b9d$var$ErrorServerError,
    temporarily_unavailable: $61fb775615801b9d$var$ErrorTemporarilyUnavailable,
    invalid_client: $61fb775615801b9d$var$ErrorInvalidClient,
    unsupported_grant_type: $61fb775615801b9d$var$ErrorUnsupportedGrantType,
    invalid_json: $61fb775615801b9d$var$ErrorInvalidJson,
    invalid_token: $61fb775615801b9d$var$ErrorInvalidToken
};
/**
 * Translate the raw error strings returned from the server into error classes.
 */ function $61fb775615801b9d$var$toErrorClass(rawError) {
    return new ($61fb775615801b9d$exports.RawErrorToErrorClassMap[rawError] || $61fb775615801b9d$var$ErrorUnknown)();
}
$61fb775615801b9d$exports.toErrorClass = $61fb775615801b9d$var$toErrorClass;
/**
 * A convience function to turn, for example, `Bearer realm="bity.com",
 * error="invalid_client"` into `{ realm: "bity.com", error: "invalid_client"
 * }`.
 */ function $61fb775615801b9d$var$fromWWWAuthenticateHeaderStringToObject(a) {
    var obj = a.slice(7).replace(/"/g, "").split(", ").map(function(tokens) {
        var _a;
        var _b = tokens.split("="), k = _b[0], v = _b[1];
        return _a = {}, _a[k] = v, _a;
    }).reduce(function(a, c) {
        return $61fb775615801b9d$var$__assign($61fb775615801b9d$var$__assign({}, a), c);
    }, {});
    return {
        realm: obj.realm,
        error: obj.error
    };
}
$61fb775615801b9d$exports.fromWWWAuthenticateHeaderStringToObject = $61fb775615801b9d$var$fromWWWAuthenticateHeaderStringToObject;
/**
 * HTTP headers that we need to access.
 */ var $61fb775615801b9d$var$HEADER_AUTHORIZATION = "Authorization";
var $61fb775615801b9d$var$HEADER_WWW_AUTHENTICATE = "WWW-Authenticate";
/**
 * To store the OAuth client's data between websites due to redirection.
 */ $61fb775615801b9d$exports.LOCALSTORAGE_ID = "oauth2authcodepkce";
$61fb775615801b9d$exports.LOCALSTORAGE_STATE = $61fb775615801b9d$exports.LOCALSTORAGE_ID + "-state";
/**
 * The maximum length for a code verifier for the best security we can offer.
 * Please note the NOTE section of RFC 7636 § 4.1 - the length must be >= 43,
 * but <= 128, **after** base64 url encoding. This means 32 code verifier bytes
 * encoded will be 43 bytes, or 96 bytes encoded will be 128 bytes. So 96 bytes
 * is the highest valid value that can be used.
 */ $61fb775615801b9d$exports.RECOMMENDED_CODE_VERIFIER_LENGTH = 96;
/**
 * A sensible length for the state's length, for anti-csrf.
 */ $61fb775615801b9d$exports.RECOMMENDED_STATE_LENGTH = 32;
/**
 * Character set to generate code verifier defined in rfc7636.
 */ var $61fb775615801b9d$var$PKCE_CHARSET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
/**
 * OAuth 2.0 client that ONLY supports authorization code flow, with PKCE.
 *
 * Many applications structure their OAuth usage in different ways. This class
 * aims to provide both flexible and easy ways to use this configuration of
 * OAuth.
 *
 * See `example.ts` for how you'd typically use this.
 *
 * For others, review this class's methods.
 */ var $61fb775615801b9d$var$OAuth2AuthCodePKCE = /** @class */ function() {
    function OAuth2AuthCodePKCE(config) {
        this.state = {};
        this.config = config;
        this.recoverState();
        return this;
    }
    /**
     * Attach the OAuth logic to all fetch requests and translate errors (either
     * returned as json or through the WWW-Authenticate header) into nice error
     * classes.
     */ OAuth2AuthCodePKCE.prototype.decorateFetchHTTPClient = function(fetch1) {
        var _this = this;
        return function(url, config) {
            var rest = [];
            for(var _i = 2; _i < arguments.length; _i++)rest[_i - 2] = arguments[_i];
            if (!_this.state.isHTTPDecoratorActive) return fetch1.apply(void 0, $61fb775615801b9d$var$__spreadArrays([
                url,
                config
            ], rest));
            return _this.getAccessToken().then(function(_a) {
                var token = _a.token;
                var configNew = Object.assign({}, config);
                if (!configNew.headers) configNew.headers = {};
                configNew.headers[$61fb775615801b9d$var$HEADER_AUTHORIZATION] = "Bearer " + token.value;
                return fetch1.apply(void 0, $61fb775615801b9d$var$__spreadArrays([
                    url,
                    configNew
                ], rest));
            }).then(function(res) {
                if (res.ok) return res;
                if (!res.headers.has($61fb775615801b9d$var$HEADER_WWW_AUTHENTICATE.toLowerCase())) return res;
                var error = $61fb775615801b9d$var$toErrorClass($61fb775615801b9d$var$fromWWWAuthenticateHeaderStringToObject(res.headers.get($61fb775615801b9d$var$HEADER_WWW_AUTHENTICATE.toLowerCase())).error);
                if (error instanceof $61fb775615801b9d$var$ErrorInvalidToken) _this.config.onAccessTokenExpiry(function() {
                    return _this.exchangeRefreshTokenForAccessToken();
                });
                return Promise.reject(error);
            });
        };
    };
    /**
     * If there is an error, it will be passed back as a rejected Promise.
     * If there is no code, the user should be redirected via
     * [fetchAuthorizationCode].
     */ OAuth2AuthCodePKCE.prototype.isReturningFromAuthServer = function() {
        var error = OAuth2AuthCodePKCE.extractParamFromUrl(location.href, "error");
        if (error) return Promise.reject($61fb775615801b9d$var$toErrorClass(error));
        var code = OAuth2AuthCodePKCE.extractParamFromUrl(location.href, "code");
        if (!code) return Promise.resolve(false);
        var state = JSON.parse(localStorage.getItem($61fb775615801b9d$exports.LOCALSTORAGE_STATE) || "{}");
        var stateQueryParam = OAuth2AuthCodePKCE.extractParamFromUrl(location.href, "state");
        if (stateQueryParam !== state.stateQueryParam) {
            console.warn("state query string parameter doesn't match the one sent! Possible malicious activity somewhere.");
            return Promise.reject(new $61fb775615801b9d$var$ErrorInvalidReturnedStateParam());
        }
        state.authorizationCode = code;
        state.hasAuthCodeBeenExchangedForAccessToken = false;
        localStorage.setItem($61fb775615801b9d$exports.LOCALSTORAGE_STATE, JSON.stringify(state));
        this.setState(state);
        return Promise.resolve(true);
    };
    /**
     * Fetch an authorization grant via redirection. In a sense this function
     * doesn't return because of the redirect behavior (uses `location.replace`).
     *
     * @param oneTimeParams A way to specify "one time" used query string
     * parameters during the authorization code fetching process, usually for
     * values which need to change at run-time.
     */ OAuth2AuthCodePKCE.prototype.fetchAuthorizationCode = function(oneTimeParams) {
        return $61fb775615801b9d$var$__awaiter(this, void 0, void 0, function() {
            var _a, clientId, extraAuthorizationParams, redirectUrl, scopes, _b, codeChallenge, codeVerifier, stateQueryParam, url, extraParameters;
            return $61fb775615801b9d$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        this.assertStateAndConfigArePresent();
                        _a = this.config, clientId = _a.clientId, extraAuthorizationParams = _a.extraAuthorizationParams, redirectUrl = _a.redirectUrl, scopes = _a.scopes;
                        return [
                            4 /*yield*/ ,
                            OAuth2AuthCodePKCE.generatePKCECodes()
                        ];
                    case 1:
                        _b = _c.sent(), codeChallenge = _b.codeChallenge, codeVerifier = _b.codeVerifier;
                        stateQueryParam = OAuth2AuthCodePKCE.generateRandomState($61fb775615801b9d$exports.RECOMMENDED_STATE_LENGTH);
                        this.state = $61fb775615801b9d$var$__assign($61fb775615801b9d$var$__assign({}, this.state), {
                            codeChallenge: codeChallenge,
                            codeVerifier: codeVerifier,
                            stateQueryParam: stateQueryParam,
                            isHTTPDecoratorActive: true
                        });
                        localStorage.setItem($61fb775615801b9d$exports.LOCALSTORAGE_STATE, JSON.stringify(this.state));
                        url = this.config.authorizationUrl + "?response_type=code&" + ("client_id=" + encodeURIComponent(clientId) + "&") + ("redirect_uri=" + encodeURIComponent(redirectUrl) + "&") + ("scope=" + encodeURIComponent(scopes.join(" ")) + "&") + ("state=" + stateQueryParam + "&") + ("code_challenge=" + encodeURIComponent(codeChallenge) + "&") + "code_challenge_method=S256";
                        if (extraAuthorizationParams || oneTimeParams) {
                            extraParameters = $61fb775615801b9d$var$__assign($61fb775615801b9d$var$__assign({}, extraAuthorizationParams), oneTimeParams);
                            url = url + "&" + OAuth2AuthCodePKCE.objectToQueryString(extraParameters);
                        }
                        location.replace(url);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Tries to get the current access token. If there is none
     * it will fetch another one. If it is expired, it will fire
     * [onAccessTokenExpiry] but it's up to the user to call the refresh token
     * function. This is because sometimes not using the refresh token facilities
     * is easier.
     */ OAuth2AuthCodePKCE.prototype.getAccessToken = function() {
        var _this = this;
        this.assertStateAndConfigArePresent();
        var onAccessTokenExpiry = this.config.onAccessTokenExpiry;
        var _a = this.state, accessToken = _a.accessToken, authorizationCode = _a.authorizationCode, explicitlyExposedTokens = _a.explicitlyExposedTokens, hasAuthCodeBeenExchangedForAccessToken = _a.hasAuthCodeBeenExchangedForAccessToken, refreshToken = _a.refreshToken, scopes = _a.scopes;
        if (!authorizationCode) return Promise.reject(new $61fb775615801b9d$var$ErrorNoAuthCode());
        if (this.authCodeForAccessTokenRequest) return this.authCodeForAccessTokenRequest;
        if (!this.isAuthorized() || !hasAuthCodeBeenExchangedForAccessToken) {
            this.authCodeForAccessTokenRequest = this.exchangeAuthCodeForAccessToken();
            return this.authCodeForAccessTokenRequest;
        }
        // Depending on the server (and config), refreshToken may not be available.
        if (refreshToken && this.isAccessTokenExpired()) return onAccessTokenExpiry(function() {
            return _this.exchangeRefreshTokenForAccessToken();
        });
        return Promise.resolve({
            token: accessToken,
            explicitlyExposedTokens: explicitlyExposedTokens,
            scopes: scopes,
            refreshToken: refreshToken
        });
    };
    /**
     * Refresh an access token from the remote service.
     */ OAuth2AuthCodePKCE.prototype.exchangeRefreshTokenForAccessToken = function() {
        var _this = this;
        var _a;
        this.assertStateAndConfigArePresent();
        var _b = this.config, extraRefreshParams = _b.extraRefreshParams, clientId = _b.clientId, tokenUrl = _b.tokenUrl;
        var refreshToken = this.state.refreshToken;
        if (!refreshToken) console.warn("No refresh token is present.");
        var url = tokenUrl;
        var body = "grant_type=refresh_token&" + ("refresh_token=" + ((_a = refreshToken) === null || _a === void 0 ? void 0 : _a.value) + "&") + ("client_id=" + clientId);
        if (extraRefreshParams) body = url + "&" + OAuth2AuthCodePKCE.objectToQueryString(extraRefreshParams);
        return fetch(url, {
            method: "POST",
            body: body,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function(res) {
            return res.status >= 400 ? res.json().then(function(data) {
                return Promise.reject(data);
            }) : res.json();
        }).then(function(json) {
            var access_token = json.access_token, expires_in = json.expires_in, refresh_token = json.refresh_token, scope = json.scope;
            var explicitlyExposedTokens = _this.config.explicitlyExposedTokens;
            var scopes = [];
            var tokensToExpose = {};
            var accessToken = {
                value: access_token,
                expiry: new Date(Date.now() + parseInt(expires_in) * 1000).toString()
            };
            _this.state.accessToken = accessToken;
            if (refresh_token) {
                var refreshToken_1 = {
                    value: refresh_token
                };
                _this.state.refreshToken = refreshToken_1;
            }
            if (explicitlyExposedTokens) {
                tokensToExpose = Object.fromEntries(explicitlyExposedTokens.map(function(tokenName) {
                    return [
                        tokenName,
                        json[tokenName]
                    ];
                }).filter(function(_a) {
                    var _ = _a[0], tokenValue = _a[1];
                    return tokenValue !== undefined;
                }));
                _this.state.explicitlyExposedTokens = tokensToExpose;
            }
            if (scope) {
                // Multiple scopes are passed and delimited by spaces,
                // despite using the singular name "scope".
                scopes = scope.split(" ");
                _this.state.scopes = scopes;
            }
            localStorage.setItem($61fb775615801b9d$exports.LOCALSTORAGE_STATE, JSON.stringify(_this.state));
            var accessContext = {
                token: accessToken,
                scopes: scopes
            };
            if (explicitlyExposedTokens) accessContext.explicitlyExposedTokens = tokensToExpose;
            return accessContext;
        }).catch(function(data) {
            var onInvalidGrant = _this.config.onInvalidGrant;
            var error = data.error || "There was a network error.";
            switch(error){
                case "invalid_grant":
                    onInvalidGrant(function() {
                        return _this.fetchAuthorizationCode();
                    });
                    break;
                default:
                    break;
            }
            return Promise.reject($61fb775615801b9d$var$toErrorClass(error));
        });
    };
    /**
     * Get the scopes that were granted by the authorization server.
     */ OAuth2AuthCodePKCE.prototype.getGrantedScopes = function() {
        return this.state.scopes;
    };
    /**
     * Signals if OAuth HTTP decorating should be active or not.
     */ OAuth2AuthCodePKCE.prototype.isHTTPDecoratorActive = function(isActive) {
        this.state.isHTTPDecoratorActive = isActive;
        localStorage.setItem($61fb775615801b9d$exports.LOCALSTORAGE_STATE, JSON.stringify(this.state));
    };
    /**
     * Tells if the client is authorized or not. This means the client has at
     * least once successfully fetched an access token. The access token could be
     * expired.
     */ OAuth2AuthCodePKCE.prototype.isAuthorized = function() {
        return !!this.state.accessToken;
    };
    /**
     * Checks to see if the access token has expired.
     */ OAuth2AuthCodePKCE.prototype.isAccessTokenExpired = function() {
        var accessToken = this.state.accessToken;
        return Boolean(accessToken && new Date() >= new Date(accessToken.expiry));
    };
    /**
     * Resets the state of the client. Equivalent to "logging out" the user.
     */ OAuth2AuthCodePKCE.prototype.reset = function() {
        this.setState({});
        this.authCodeForAccessTokenRequest = undefined;
    };
    /**
     * If the state or config are missing, it means the client is in a bad state.
     * This should never happen, but the check is there just in case.
     */ OAuth2AuthCodePKCE.prototype.assertStateAndConfigArePresent = function() {
        if (!this.state || !this.config) {
            console.error("state:", this.state, "config:", this.config);
            throw new Error("state or config is not set.");
        }
    };
    /**
     * Fetch an access token from the remote service. You may pass a custom
     * authorization grant code for any reason, but this is non-standard usage.
     */ OAuth2AuthCodePKCE.prototype.exchangeAuthCodeForAccessToken = function(codeOverride) {
        var _this = this;
        this.assertStateAndConfigArePresent();
        var _a = this.state, _b = _a.authorizationCode, authorizationCode = _b === void 0 ? codeOverride : _b, _c = _a.codeVerifier, codeVerifier = _c === void 0 ? "" : _c;
        var _d = this.config, clientId = _d.clientId, onInvalidGrant = _d.onInvalidGrant, redirectUrl = _d.redirectUrl;
        if (!codeVerifier) console.warn("No code verifier is being sent.");
        else if (!authorizationCode) console.warn("No authorization grant code is being passed.");
        var url = this.config.tokenUrl;
        var body = "grant_type=authorization_code&" + ("code=" + encodeURIComponent(authorizationCode || "") + "&") + ("redirect_uri=" + encodeURIComponent(redirectUrl) + "&") + ("client_id=" + encodeURIComponent(clientId) + "&") + ("code_verifier=" + codeVerifier);
        return fetch(url, {
            method: "POST",
            body: body,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function(res) {
            var jsonPromise = res.json().catch(function(_) {
                return {
                    error: "invalid_json"
                };
            });
            if (!res.ok) return jsonPromise.then(function(_a) {
                var error = _a.error;
                switch(error){
                    case "invalid_grant":
                        onInvalidGrant(function() {
                            return _this.fetchAuthorizationCode();
                        });
                        break;
                    default:
                        break;
                }
                return Promise.reject($61fb775615801b9d$var$toErrorClass(error));
            });
            return jsonPromise.then(function(json) {
                var access_token = json.access_token, expires_in = json.expires_in, refresh_token = json.refresh_token, scope = json.scope;
                var explicitlyExposedTokens = _this.config.explicitlyExposedTokens;
                var scopes = [];
                var tokensToExpose = {};
                _this.state.hasAuthCodeBeenExchangedForAccessToken = true;
                _this.authCodeForAccessTokenRequest = undefined;
                var accessToken = {
                    value: access_token,
                    expiry: new Date(Date.now() + parseInt(expires_in) * 1000).toString()
                };
                _this.state.accessToken = accessToken;
                if (refresh_token) {
                    var refreshToken = {
                        value: refresh_token
                    };
                    _this.state.refreshToken = refreshToken;
                }
                if (explicitlyExposedTokens) {
                    tokensToExpose = Object.fromEntries(explicitlyExposedTokens.map(function(tokenName) {
                        return [
                            tokenName,
                            json[tokenName]
                        ];
                    }).filter(function(_a) {
                        var _ = _a[0], tokenValue = _a[1];
                        return tokenValue !== undefined;
                    }));
                    _this.state.explicitlyExposedTokens = tokensToExpose;
                }
                if (scope) {
                    // Multiple scopes are passed and delimited by spaces,
                    // despite using the singular name "scope".
                    scopes = scope.split(" ");
                    _this.state.scopes = scopes;
                }
                localStorage.setItem($61fb775615801b9d$exports.LOCALSTORAGE_STATE, JSON.stringify(_this.state));
                var accessContext = {
                    token: accessToken,
                    scopes: scopes
                };
                if (explicitlyExposedTokens) accessContext.explicitlyExposedTokens = tokensToExpose;
                return accessContext;
            });
        });
    };
    OAuth2AuthCodePKCE.prototype.recoverState = function() {
        this.state = JSON.parse(localStorage.getItem($61fb775615801b9d$exports.LOCALSTORAGE_STATE) || "{}");
        return this;
    };
    OAuth2AuthCodePKCE.prototype.setState = function(state) {
        this.state = state;
        localStorage.setItem($61fb775615801b9d$exports.LOCALSTORAGE_STATE, JSON.stringify(state));
        return this;
    };
    /**
     * Implements *base64url-encode* (RFC 4648 § 5) without padding, which is NOT
     * the same as regular base64 encoding.
     */ OAuth2AuthCodePKCE.base64urlEncode = function(value) {
        var base64 = btoa(value);
        base64 = base64.replace(/\+/g, "-");
        base64 = base64.replace(/\//g, "_");
        base64 = base64.replace(/=/g, "");
        return base64;
    };
    /**
     * Extracts a query string parameter.
     */ OAuth2AuthCodePKCE.extractParamFromUrl = function(url, param) {
        var queryString = url.split("?");
        if (queryString.length < 2) return "";
        // Account for hash URLs that SPAs usually use.
        queryString = queryString[1].split("#");
        var parts = queryString[0].split("&").reduce(function(a, s) {
            return a.concat(s.split("="));
        }, []);
        if (parts.length < 2) return "";
        var paramIdx = parts.indexOf(param);
        return decodeURIComponent(paramIdx >= 0 ? parts[paramIdx + 1] : "");
    };
    /**
     * Converts the keys and values of an object to a url query string
     */ OAuth2AuthCodePKCE.objectToQueryString = function(dict) {
        return Object.entries(dict).map(function(_a) {
            var key = _a[0], val = _a[1];
            return key + "=" + encodeURIComponent(val);
        }).join("&");
    };
    /**
     * Generates a code_verifier and code_challenge, as specified in rfc7636.
     */ OAuth2AuthCodePKCE.generatePKCECodes = function() {
        var output = new Uint32Array($61fb775615801b9d$exports.RECOMMENDED_CODE_VERIFIER_LENGTH);
        crypto.getRandomValues(output);
        var codeVerifier = OAuth2AuthCodePKCE.base64urlEncode(Array.from(output).map(function(num) {
            return $61fb775615801b9d$var$PKCE_CHARSET[num % $61fb775615801b9d$var$PKCE_CHARSET.length];
        }).join(""));
        return crypto.subtle.digest("SHA-256", new TextEncoder().encode(codeVerifier)).then(function(buffer) {
            var hash = new Uint8Array(buffer);
            var binary = "";
            var hashLength = hash.byteLength;
            for(var i = 0; i < hashLength; i++)binary += String.fromCharCode(hash[i]);
            return binary;
        }).then(OAuth2AuthCodePKCE.base64urlEncode).then(function(codeChallenge) {
            return {
                codeChallenge: codeChallenge,
                codeVerifier: codeVerifier
            };
        });
    };
    /**
     * Generates random state to be passed for anti-csrf.
     */ OAuth2AuthCodePKCE.generateRandomState = function(lengthOfState) {
        var output = new Uint32Array(lengthOfState);
        crypto.getRandomValues(output);
        return Array.from(output).map(function(num) {
            return $61fb775615801b9d$var$PKCE_CHARSET[num % $61fb775615801b9d$var$PKCE_CHARSET.length];
        }).join("");
    };
    return OAuth2AuthCodePKCE;
}();
$61fb775615801b9d$exports.OAuth2AuthCodePKCE = $61fb775615801b9d$var$OAuth2AuthCodePKCE;


// ND-JSON response streamer
// See https://lichess.org/api#section/Introduction/Streaming-with-ND-JSON
const $c18e048c96a42e94$export$e45226161c660403 = (name, response, handler)=>{
    const stream = response.body.getReader();
    const matcher = /\r?\n/;
    const decoder = new TextDecoder();
    let buf = "";
    const process = (json)=>{
        const msg = JSON.parse(json);
        console.log(name, msg);
        handler(msg);
    };
    const loop = ()=>stream.read().then(({ done: done, value: value })=>{
            if (done) {
                if (buf.length > 0) process(buf);
                return;
            } else {
                const chunk = decoder.decode(value, {
                    stream: true
                });
                buf += chunk;
                const parts = buf.split(matcher);
                buf = parts.pop() || "";
                for (const i of parts.filter((p)=>p))process(i);
                return loop();
            }
        });
    return {
        closePromise: loop(),
        close: ()=>stream.cancel()
    };
};


const $c88ba0be6ebdc294$export$f478a3382b69e867 = "https://lichess.org";
const $c88ba0be6ebdc294$export$54a06e3f4a159ad8 = [
    "board:play"
];
const $c88ba0be6ebdc294$export$e80e8b1bea817f73 = "launchchess-client";
const $c88ba0be6ebdc294$export$e360011a2b524b1a = `${location.protocol}//${location.host}${location.pathname}`;
const $c88ba0be6ebdc294$export$334c29725a78c21d = (state, actions)=>({
        oauth: new (0, $61fb775615801b9d$exports.OAuth2AuthCodePKCE)({
            authorizationUrl: `${$c88ba0be6ebdc294$export$f478a3382b69e867}/oauth`,
            tokenUrl: `${$c88ba0be6ebdc294$export$f478a3382b69e867}/api/token`,
            clientId: $c88ba0be6ebdc294$export$e80e8b1bea817f73,
            scopes: $c88ba0be6ebdc294$export$54a06e3f4a159ad8,
            redirectUrl: $c88ba0be6ebdc294$export$e360011a2b524b1a,
            onAccessTokenExpiry: (refreshAccessToken)=>refreshAccessToken(),
            onInvalidGrant: console.warn
        }),
        // me?: Me,
        init: async ()=>{
            try {
                const accessContext = await state.auth.oauth.getAccessToken();
                if (accessContext) await state.auth.authenticate();
            } catch (err) {
                console.error(err);
            }
            if (!state.loggedIn()) try {
                const hasAuthCode = await state.auth.oauth.isReturningFromAuthServer();
                if (hasAuthCode) await state.auth.authenticate();
            } catch (err) {
                console.error(err);
            }
        },
        login: async ()=>{
            await state.auth.oauth.fetchAuthorizationCode();
        },
        logout: async ()=>{
            if (state.loggedIn()) await state.user.httpClient(`${$c88ba0be6ebdc294$export$f478a3382b69e867}/api/token`, {
                method: "DELETE"
            });
            localStorage.clear();
            state.user = {};
        },
        authenticate: async ()=>{
            const httpClient = state.auth.oauth.decorateFetchHTTPClient(window.fetch);
            const res = await httpClient(`${$c88ba0be6ebdc294$export$f478a3382b69e867}/api/account`);
            if (res.error) throw res.error;
            const profile = await res.json();
            const me = {
                username: profile.username,
                profile: profile,
                httpClient: httpClient
            };
            state.user = me;
            state.loggedIn(true);
            localStorage.setItem("me", JSON.stringify(me));
            console.log("Authenticated as", me.username, actions);
            await actions.getGames();
            (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).redraw();
        },
        openStream: async (path, config, handler)=>{
            const stream = await state.auth.fetchResponse(path, config);
            return (0, $c18e048c96a42e94$export$e45226161c660403)(`STREAM ${path}`, stream, handler);
        },
        fetchBody: async (path, config = {})=>{
            const res = await state.auth.fetchResponse(path, config);
            const body = await res.json();
            return body;
        },
        fetchResponse: async (path, config = {})=>{
            const res = await (state.user.httpClient || window.fetch)(`${$c88ba0be6ebdc294$export$f478a3382b69e867}${path}`, config);
            if (res.error || !res.ok) {
                const err = `${res.error} ${res.status} ${res.statusText}`;
                alert(err);
                throw err;
            }
            return res;
        }
    });


const $22788da0e2196326$export$2fb70d5e506c6bc2 = (state, actions)=>({
        login: async (token)=>{
            console.log("logging in");
            state.auth.login();
            console.log("logged in as: ", state.user.username);
            state.loggedIn(true);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.param("redirect")) (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.set((0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.param("redirect"));
            else if ((0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.get() == "/login") (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.set("/");
            // m.redraw()
            state.user.profile = await state.auth.fetchBody("/oauth/profile");
            state.user.username = state.user.profile.username;
        },
        logout: ()=>{
            console.log("logging out");
            state.auth.logout();
            state.user.username = null;
            state.loggedIn(false);
            window.localStorage.setItem("CREDENTIALS_FLUSH", Date.now().toString());
            window.localStorage.removeItem("CREDENTIALS_FLUSH");
        // m.redraw()
        },
        initAuth: async ()=>{
            if (localStorage.getItem("me")) {
                state.user = JSON.parse(localStorage.getItem("me"));
                console.log("loaded user from localstorage", state.user);
            }
            state.auth = (0, $c88ba0be6ebdc294$export$334c29725a78c21d)(state, actions);
            await state.auth.init();
            console.log("auth inited");
        }
    });



var $c6ddc35a8c0d5f38$exports = {};
"use strict";

$c6ddc35a8c0d5f38$exports = (parcelRequire("f1bNS"));


const $a01e4d144b50218c$export$d02631cccf789723 = (start, end)=>Array.apply(0, Array(end - 1)).map((element, index)=>index + start);
const $a01e4d144b50218c$export$7254cc27399e90bd = ()=>({
        auth: null,
        loggedIn: $c6ddc35a8c0d5f38$exports(false),
        user: {
            username: null,
            profile: null
        },
        theme: "dark",
        input: null,
        output: null,
        inputName: null,
        outputName: null,
        inputs: $c6ddc35a8c0d5f38$exports([]),
        outputs: $c6ddc35a8c0d5f38$exports([]),
        deviceId: null,
        deviceName: null,
        deviceType: null,
        connected: false,
        top: $a01e4d144b50218c$export$d02631cccf789723(91, 10),
        header: null,
        layout: null,
        changeLayout: null,
        game: null,
        games: $c6ddc35a8c0d5f38$exports([]),
        stream: null,
        opponent: null,
        chess: new (0, $6eb582f9081eb7e5$export$a4d6ea685c300d39)(),
        ground: null,
        color: "w",
        selectedSquare: null,
        selectedPiece: null,
        invert: $c6ddc35a8c0d5f38$exports(false),
        grid: true,
        pieces: true,
        influence: false,
        history: $c6ddc35a8c0d5f38$exports(1),
        animationDuration: 400,
        animations: [],
        colors: (0, $9066c94fd6c8e22f$export$56d196d2844d1ca1)
    });
const $a01e4d144b50218c$export$b52183d5cfb26dc9 = (state, actions)=>({
        incrementHistory: ()=>{
            state.history(state.history() + 1);
            actions.lightBoard();
        },
        decrementHistory: ()=>{
            state.history(Math.max(0, state.history() - 1));
            actions.lightBoard();
        },
        send: (type, message)=>{
            try {
                state.output.send(type, message);
            } catch (error) {
                console.debug("failed to send message", error);
            }
        },
        sendSysex: (header, message)=>{
            try {
                state.output.sendSysex(header, message);
            } catch (error) {
                console.debug("failed to send sysex", error);
            }
        },
        lightMatrix: ()=>null,
        lightGame: ()=>null,
        clearAnimations: ()=>null,
        clear: ()=>null,
        highlightAvailableMoves: ()=>null
    });
const $a01e4d144b50218c$export$81ce9b7e86ec18db = (state, actions)=>({
        onmove: (orig, dest)=>{
            let move = {
                from: orig,
                to: dest
            };
            let piece = state.chess.get(move.from);
            if (piece.type == "p" && (piece.color == "w" && move.to.charAt(1) == 8 || piece.color == "b" && move.to.charAt(1) == 1)) {
                console.log("promotion! Auto promote to Queen");
                move.promotion = "q";
            }
            state.chess.move(move);
            console.log("moved", move, piece, state.chess.ascii());
            state.ground.set({
                fen: state.chess.fen()
            });
            actions.lightBoard(true);
            (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).redraw();
            // send to lichess api
            let move_uci = (0, $236ba31c448bdb87$export$ef42e39072fd379)(move);
            let body = state.auth.fetchBody("/api/board/game/" + (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.param("id") + "/move/" + move_uci, {
                method: "post"
            });
            console.log("played move", move_uci, body);
        }
    });



const $9066c94fd6c8e22f$export$9dae6f82820323cf = 144;
const $9066c94fd6c8e22f$export$d265beb1ee5d4530 = 176;
const $9066c94fd6c8e22f$export$c6f17c29808f1b66 = [
    0,
    32,
    41
];
const $9066c94fd6c8e22f$export$4b04cd3b2feae9ab = {
    LaunchpadX: [
        2,
        12
    ],
    LaunchpadMk2: [
        2,
        24
    ],
    LaunchpadPro: [
        2,
        16
    ],
    LaunchpadMini: [
        2,
        14
    ],
    LaunchpadMiniMk3: [
        2,
        13
    ],
    LaunchpadS: [
        32,
        0
    ]
};
const $9066c94fd6c8e22f$export$776a922db93662cb = {
    "Launchpad MK2 MIDI 1": "LaunchpadMk2",
    "Launchpad MK2": "LaunchpadMk2",
    "Launchpad X MIDI 2": "LaunchpadX",
    "Launchpad X LPX MIDI In": "LaunchpadX",
    "Launchpad X LPX MIDI Out": "LaunchpadX",
    "MIDIIN2 (LPX MIDI)": "LaunchpadX",
    "MIDIOUT2 (LPX MIDI)": "LaunchpadX",
    "Launchpad Mini In": "LaunchpadMini",
    "Launchpad Mini Out": "LaunchpadMini",
    "LPMiniMK3 MIDI In": "LaunchpadMiniMk3",
    "LPMiniMK3 MIDI Out": "LaunchpadMiniMk3"
};
const $9066c94fd6c8e22f$export$56d196d2844d1ca1 = {
    p: 13,
    r: 9,
    n: 45,
    b: 37,
    q: 53,
    k: 49,
    white: 3,
    dim_white: 1,
    black: 0,
    movable: 21,
    moved: 89,
    check: 5,
    brown: 83
};
const $9066c94fd6c8e22f$export$a17043daf8ba543f = (state, actions)=>({
        nToLaunch: (n)=>{
            /** Convert a 0-63 chess square into a Launchpad MIDI number
     * @param {int} n - 0-63, chess square
     */ if (state.invert()) n = 63 - n;
            return 11 + (n >> 3) * 10 + n % 8;
        },
        launchToN: (l)=>{
            /** Convert a Launchpad MIDI number into 0-63 for chess squares.
     * @param {int} l - Launchpad MIDI number
     */ if ((l - 11) % 10 == 8) // fix for LaunchpadMk2 sending side buttons as NOTE_ON
            return null;
            const n = Math.floor((l - 11) / 10) * 8 + (l - 11) % 10;
            return state.invert() ? 63 - n : n;
        },
        squareToN: (sq)=>{
            return (Number(sq[1]) - 1) * 8 + sq.charCodeAt(0) - 97;
        },
        nToSquare: (n)=>{
            return String.fromCharCode(97 + n % 8, 49 + (n >> 3));
        },
        toggleLive: (mode)=>{
            if (mode === true) state.connected = true;
            else if (mode === false) state.connected = false;
            else state.connected = !state.connected;
            actions.sendSysex($9066c94fd6c8e22f$export$c6f17c29808f1b66, [
                ...state.header,
                state.changeLayout,
                state.connected ? state.layout[1] : state.layout[0]
            ]);
        },
        clear: ()=>{
            for(var i = 0; i < 64; i++)actions.send($9066c94fd6c8e22f$export$9dae6f82820323cf, [
                actions.nToLaunch(i),
                0
            ]);
            state.top.forEach((b, i)=>{
                actions.send($9066c94fd6c8e22f$export$d265beb1ee5d4530, [
                    b,
                    0
                ]);
            });
        },
        grid: ()=>{
            for(let y = 0; y < 8; y++)for(let x = 0; x < 8; x++)actions.send($9066c94fd6c8e22f$export$9dae6f82820323cf, [
                11 + x + y * 10,
                (x + y) % 2 == 0 ? 0 : 1
            ]);
        },
        lightMatrix: (m)=>{
            for(let y = 0; y < 8; y++)for(let x = 0; x < 8; x++)actions.send($9066c94fd6c8e22f$export$9dae6f82820323cf, [
                11 + x + y * 10,
                m[x + y * 8]
            ]);
        },
        lightGame: (animate = false)=>{
            const board = state.chess.board();
            for(let i = 0; i < 64; i++){
                let piece;
                let color = 0;
                const l = actions.nToLaunch(i);
                if (board[63 - i >> 3][i % 8]) {
                    piece = board[63 - i >> 3][i % 8];
                    // console.log('piece at i', i, piece)
                    if (state.pieces) {
                        color = $9066c94fd6c8e22f$export$56d196d2844d1ca1[piece.type];
                        if (piece.color == "b") color += 2;
                    } else if (state.grid) color = (i + (i >> 3)) % 2 == 0 ? 0 : 1;
                } else {
                    piece = null;
                    if (state.grid) color = (i + (i >> 3)) % 2 == 0 ? 0 : 1;
                }
                // console.log(i, piece, l)
                // console.log(NOTE_ON, l, c)
                actions.send($9066c94fd6c8e22f$export$9dae6f82820323cf, [
                    l,
                    color
                ]);
            }
            let history = state.chess.history();
            for(let i = 0; i < Math.min(history.length, state.history()); i++)actions.highlightMove(i, animate);
        },
        highlightMove: (index, animate = false)=>{
            let lastMove = state.chess.history({
                verbose: true
            }).reverse()[index];
            if (lastMove) {
                console.log("lastmove ", lastMove);
                let from_square = lastMove.from;
                let to_square = lastMove.to;
                console.log("highlighting", lastMove, from_square, to_square);
                let path = (0, $d5ffb40ab7d69c90$export$dfb56f6b9abe10bc)(from_square, to_square);
                // Add an extra final square to the animation list
                // so the piece holds on the final square before restarting
                path.push(path[path.length - 1]);
                let piece = lastMove.piece;
                let color = $9066c94fd6c8e22f$export$56d196d2844d1ca1[piece];
                if (lastMove.color == "b") color += 2;
                if (animate) actions.animatePath(path, color, 0);
                if (state.chess.isCheck()) actions.highlightCheck();
                if (state.chess.isCheckmate()) actions.highlightCheckmate();
            }
        },
        animatePath: (path, color, step)=>{
            // console.log('animating path', path, step)
            let current = path.splice(step, 1)[0];
            path.forEach((square, i)=>{
                actions.send($9066c94fd6c8e22f$export$9dae6f82820323cf | 2, [
                    actions.nToLaunch(square.y * 8 + square.x),
                    $9066c94fd6c8e22f$export$56d196d2844d1ca1.moved
                ]);
            });
            actions.send($9066c94fd6c8e22f$export$9dae6f82820323cf | 2, [
                actions.nToLaunch(current.y * 8 + current.x),
                color
            ]);
            path.splice(step, 0, current);
            // console.log('path', path.length)
            state.animations.push(setTimeout(actions.animatePath, state.animationDuration, path, color, (step + 1) % path.length));
        },
        clearAnimations: ()=>{
            state.animations.forEach((a, i)=>{
                clearTimeout(a);
            });
        },
        highlightCheck: ()=>{
            let k = (0, $236ba31c448bdb87$export$f784c029d2bce31b)(state.chess, {
                type: "k",
                color: state.chess.turn()
            })[0];
            console.log("check!", k);
            actions.send($9066c94fd6c8e22f$export$9dae6f82820323cf | 1, [
                actions.nToLaunch(actions.squareToN(k)),
                $9066c94fd6c8e22f$export$56d196d2844d1ca1.check
            ]);
        },
        highlightCheckmate: ()=>{
            let k = (0, $236ba31c448bdb87$export$f784c029d2bce31b)(state.chess, {
                type: "k",
                color: state.chess.turn()
            })[0];
            console.log("mate!", k);
            actions.send($9066c94fd6c8e22f$export$9dae6f82820323cf, [
                actions.nToLaunch(actions.squareToN(k)),
                $9066c94fd6c8e22f$export$56d196d2844d1ca1.check
            ]);
        },
        highlightAvailableMoves: (square)=>{
            let s = actions.nToLaunch(actions.squareToN(square));
            console.log("highlighting", square, s, actions.squareToN(square));
            actions.send($9066c94fd6c8e22f$export$9dae6f82820323cf | 1, [
                s,
                $9066c94fd6c8e22f$export$56d196d2844d1ca1.movable
            ]);
            let piece_moves = state.chess.moves({
                square: square,
                verbose: true
            });
            console.log("possible moves", piece_moves);
            piece_moves.forEach((p, i)=>{
                // console.log(p)
                if (state.chess.get(p.to)) // piece at square. flash green
                // console.log('capture', actions.nToLaunch(actions.squareToN(p.to)))
                actions.send($9066c94fd6c8e22f$export$9dae6f82820323cf | 1, [
                    actions.nToLaunch(actions.squareToN(p.to)),
                    $9066c94fd6c8e22f$export$56d196d2844d1ca1.movable
                ]);
                else // console.log('regular move', p.to, actions.squareToN(p.to), actions.nToLaunch(actions.squareToN(p.to)))
                actions.send($9066c94fd6c8e22f$export$9dae6f82820323cf | 2, [
                    actions.nToLaunch(actions.squareToN(p.to)),
                    $9066c94fd6c8e22f$export$56d196d2844d1ca1.movable
                ]);
            });
        }
    });
const $9066c94fd6c8e22f$export$726be47e50c912d1 = (state, actions)=>{
    state.header = [
        2,
        12
    ];
    state.changeLayout = 14;
    state.layout = [
        0,
        1
    ];
    return {
        ...$9066c94fd6c8e22f$export$a17043daf8ba543f(state, actions)
    };
};
const $9066c94fd6c8e22f$export$fef6b4cfd4f0cac0 = (state, actions)=>{
    state.header = [
        2,
        16
    ];
    state.changeLayout = 44;
    state.layout = [
        0,
        3
    ];
    return {
        ...$9066c94fd6c8e22f$export$a17043daf8ba543f(state, actions)
    };
};
const $9066c94fd6c8e22f$export$e078d1c822b6d179 = (state, actions)=>{
    state.header = [
        2,
        13
    ];
    state.changeLayout = 14;
    state.layout = [
        0,
        1
    ];
    return {
        ...$9066c94fd6c8e22f$export$cb572084ac15dab5(state, actions)
    };
};
const $9066c94fd6c8e22f$export$cb572084ac15dab5 = (state, actions)=>{
    state.top = (0, $a01e4d144b50218c$export$d02631cccf789723)(104, 9);
    state.header = [
        2,
        24
    ];
    state.changeLayout = 34;
    state.layout = [
        0,
        0
    ];
    return {
        ...$9066c94fd6c8e22f$export$a17043daf8ba543f(state, actions)
    };
};
const $9066c94fd6c8e22f$export$ceb4afcefeff8d = (state, actions)=>{
    state.changeLayout = 14;
    state.layout = [
        0,
        1
    ];
    return {
        ...$9066c94fd6c8e22f$export$a17043daf8ba543f(state, actions)
    };
};
const $9066c94fd6c8e22f$export$20e6038b255aa41 = (state, actions)=>({
        ...$9066c94fd6c8e22f$export$a17043daf8ba543f(state, actions),
        nToLaunch: (n)=>{
            /** Convert a 0-63 chess square into a Launchpad MIDI number
     * @param {int} n - 0-63, chess square
     */ if (state.invert()) return 8 - n % 8 + (n >> 3) * 16;
            else return 112 + n % 8 - (n >> 3) * 16;
        },
        launchToN: (l)=>{
            /** Convert a Launchpad MIDI number into 0-63 for chess squares.
     * The original Launchpad uses a different grid numbering system than mk2+ Launchpads
     * @param {int} l - Launchpad MIDI number
     */ if (state.invert()) return Math.floor(l / 16) * 8 + 7 - (l % 8 >> 3);
            else return (7 - Math.floor(l / 16)) * 8 + (l % 8 >> 3);
        },
        toggleLive: (mode)=>{
            if (mode === true) state.connected = true;
            else if (mode === false) state.connected = false;
            else state.connected = !state.connected;
            actions.send($9066c94fd6c8e22f$export$d265beb1ee5d4530, [
                0,
                state.connected ? 1 : 2
            ]);
        },
        lightMatrix: (m)=>{
            for(let y = 0; y < 8; y++)for(let x = 0; x < 8; x++)actions.send($9066c94fd6c8e22f$export$9dae6f82820323cf, [
                actions.nToLaunch(x + y * 8),
                m[x + y * 8]
            ]);
        }
    });
const $9066c94fd6c8e22f$export$4586496351d727fb = {
    Launchpad: $9066c94fd6c8e22f$export$20e6038b255aa41,
    LaunchpadS: $9066c94fd6c8e22f$export$20e6038b255aa41,
    LaunchpadMk2: $9066c94fd6c8e22f$export$cb572084ac15dab5,
    LaunchpadX: $9066c94fd6c8e22f$export$726be47e50c912d1,
    LaunchpadMini: $9066c94fd6c8e22f$export$e078d1c822b6d179,
    LaunchpadMiniMk3: $9066c94fd6c8e22f$export$ceb4afcefeff8d,
    LaunchpadPro: $9066c94fd6c8e22f$export$fef6b4cfd4f0cac0
};


var $6ff984c8b6ecdbd9$exports = {};
"use strict";
var $1e857081292cf176$exports = {};
$1e857081292cf176$exports = {};


var $6ff984c8b6ecdbd9$var$ndjsonStream = function(response) {
    // For cancellation
    var is_reader, cancellationRequest = false;
    return new ReadableStream({
        start: function(controller) {
            var reader = response.getReader();
            is_reader = reader;
            var decoder = new TextDecoder();
            var data_buf = "";
            reader.read().then(function processResult(result) {
                if (result.done) {
                    if (cancellationRequest) // Immediately exit
                    return;
                    data_buf = data_buf.trim();
                    if (data_buf.length !== 0) try {
                        var data_l = JSON.parse(data_buf);
                        controller.enqueue(data_l);
                    } catch (e) {
                        controller.error(e);
                        return;
                    }
                    controller.close();
                    return;
                }
                var data = decoder.decode(result.value, {
                    stream: true
                });
                data_buf += data;
                var lines = data_buf.split("\n");
                for(var i = 0; i < lines.length - 1; ++i){
                    var l = lines[i].trim();
                    if (l.length > 0) try {
                        var data_line = JSON.parse(l);
                        controller.enqueue(data_line);
                    } catch (e) {
                        controller.error(e);
                        cancellationRequest = true;
                        reader.cancel();
                        return;
                    }
                }
                data_buf = lines[lines.length - 1];
                return reader.read().then(processResult);
            });
        },
        cancel: function(reason) {
            console.log("Cancel registered due to ", reason);
            cancellationRequest = true;
            is_reader.cancel();
        }
    });
};
$6ff984c8b6ecdbd9$exports = $1e857081292cf176$exports.ndjsonStream = $6ff984c8b6ecdbd9$var$ndjsonStream;



var $134912d8b38e370d$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $134912d8b38e370d$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $134912d8b38e370d$exports));
try {
    regeneratorRuntime = $134912d8b38e370d$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $134912d8b38e370d$var$runtime;
    else Function("r", "regeneratorRuntime = r")($134912d8b38e370d$var$runtime);
}


const $65dd0e8440d320eb$export$df8cbc0f1f104ed7 = (endpoint, config = {})=>{
    var res;
    return fetch(endpoint, config) // make a fetch request to a NDJSON stream service
    .then((response)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($6ff984c8b6ecdbd9$exports)))(response.body) //ndjsonStream parses the response.body
        ;
    });
};
function $65dd0e8440d320eb$export$9903e0d29be3ee54(endpoint, token, callback) {
    $65dd0e8440d320eb$export$df8cbc0f1f104ed7(endpoint, {
        headers: {
            Authorization: token.token_type + " " + token.access_token
        }
    }).then((exampleStream)=>{
        const reader = exampleStream.getReader();
        let read;
        reader.read().then(read = (result)=>{
            if (result.done) return;
            // console.log( result.value )
            callback(result.value);
            reader.read().then(read);
        });
    });
}
function $65dd0e8440d320eb$export$47fdd40111eda34c() {
    var nd = "";
    return {
        oninit: (vnode)=>{
            $65dd0e8440d320eb$export$df8cbc0f1f104ed7(vnode.attrs.endpoint, {
                headers: {
                    Authorization: vnode.attrs.token.token_type + " " + vnode.attrs.token.access_token
                }
            }).then((exampleStream)=>{
                const reader = exampleStream.getReader();
                let read;
                reader.read().then(read = (result)=>{
                    if (result.done) return;
                    console.log(result.value);
                    nd = JSON.stringify(result.value);
                    // m.redraw()
                    vnode.attrs.callback(result.value);
                    reader.read().then(read);
                });
            });
            console.log("nd", nd);
        },
        view: (vnode)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("", vnode.attrs, vnode.children);
        }
    };
}


const $a0433e89bac4710b$export$7333953c775d26f6 = "https://lichess.org/api/";
const $a0433e89bac4710b$export$3c6d453abf5a879b = "Launchpad X MIDI 2";




const $cae4a8b830b22bcf$export$74a0f09caf74d623 = [
    5,
    121,
    9,
    11,
    15,
    1,
    23,
    37,
    45,
    49,
    69
];
const $cae4a8b830b22bcf$export$683788d28fb74d54 = (state, actions)=>({
        lightBoard: (animate = false)=>{
            actions.clearAnimations();
            if (state.chess) {
                if (state.influence) actions.showInfluence();
                else actions.lightGame(animate);
            } else if (state.grid) actions.grid();
            actions.send((0, $9066c94fd6c8e22f$export$d265beb1ee5d4530), [
                state.top[0],
                Math.min(state.history() + 1, 3)
            ]);
            actions.send((0, $9066c94fd6c8e22f$export$d265beb1ee5d4530), [
                state.top[1],
                Math.min(state.history(), 3)
            ]);
            actions.send((0, $9066c94fd6c8e22f$export$d265beb1ee5d4530), [
                state.top[2],
                67
            ]);
            actions.send((0, $9066c94fd6c8e22f$export$d265beb1ee5d4530), [
                state.top[4],
                state.invert() ? (0, $9066c94fd6c8e22f$export$56d196d2844d1ca1).brown : 3
            ]);
            actions.send((0, $9066c94fd6c8e22f$export$d265beb1ee5d4530), [
                state.top[5],
                state.grid ? (0, $9066c94fd6c8e22f$export$56d196d2844d1ca1).white : (0, $9066c94fd6c8e22f$export$56d196d2844d1ca1).dim_white
            ]);
            actions.send((0, $9066c94fd6c8e22f$export$d265beb1ee5d4530), [
                state.top[6],
                state.pieces ? (0, $9066c94fd6c8e22f$export$56d196d2844d1ca1).q : 82
            ]);
            // actions.send(CONTROL_CHANGE, [state.top[7], state.influence ? 5 : 7])
            actions.send((0, $9066c94fd6c8e22f$export$d265beb1ee5d4530), [
                state.top[state.top.length - 1],
                state.chess.turn() == "w" ? 3 : (0, $9066c94fd6c8e22f$export$56d196d2844d1ca1).brown
            ]);
        },
        togglePieces: (mode = null)=>{
            state.pieces = mode ? mode : !state.pieces;
            state.ground.set({
                drawable: {
                    visible: false
                }
            });
            actions.lightBoard();
        },
        flipBoard: ()=>{
            state.invert(!state.invert());
            actions.lightBoard();
            // if (ground)
            state.ground.toggleOrientation();
        // m.redraw()
        },
        showInfluence: ()=>{
            let fen = state.chess.fen();
            let defenders = (0, $236ba31c448bdb87$export$a23e9f71e3b927c7)(fen);
            let attackers = (0, $236ba31c448bdb87$export$a23e9f71e3b927c7)((0, $236ba31c448bdb87$export$def19b3072191111)(fen));
            console.log(fen, defenders, attackers);
            let heatMap = defenders.map((s, i)=>{
                return s - attackers[i];
            });
            console.log("heatmap", heatMap);
            let colorMap = heatMap.map((v, i)=>{
                let c = Math.min(v + 5, 9);
                return $cae4a8b830b22bcf$export$74a0f09caf74d623[state.chess.turn() == state.color ? c : 10 - c];
            });
            if (state.invert() != (state.color == "b")) colorMap.reverse();
            // reverse ranks
            colorMap = colorMap.map((s, i)=>{
                return colorMap[(7 - Math.floor(i / 8)) * 8 + i % 8];
            });
            console.log("colorMap", colorMap);
            actions.lightMatrix(colorMap);
        },
        newGame: ()=>{
            state.chess = new (0, $6eb582f9081eb7e5$export$a4d6ea685c300d39)();
            (0, $d5ffb40ab7d69c90$export$8aee836dd884f091)(state.chess, state.ground);
        },
        onInput: (message)=>{
            message = message.data;
            console.log("input", message);
            if (message[2]) {
                const s = actions.launchToN(message[1]);
                if (s === null) return;
                const square = actions.nToSquare(s);
                console.log("touched", s);
                const legal_moves = state.chess.moves({
                    verbose: true
                });
                console.log("legal moves", legal_moves);
                if (state.selectedSquare && actions.squareToN(state.selectedSquare) == s) {
                    // clear selected piece
                    actions.lightBoard();
                    state.selectedSquare = null;
                    state.ground.selectSquare(null);
                } else if (state.chess.get(square) && state.chess.get(square).color == state.chess.turn()) {
                    if (state.selectedSquare) {
                        // clear other selected piece
                        actions.lightBoard();
                        state.selectedSquare = null;
                        state.ground.selectSquare(null);
                    }
                    console.log("checking", square, state.chess.get(square));
                    if (state.chess.get(square) && state.chess.get(square).color == state.chess.turn()) {
                        // select piece
                        state.selectedSquare = square;
                        state.selectedPiece = state.chess.get(square);
                        state.ground.selectSquare(state.selectedSquare);
                        actions.highlightAvailableMoves(state.selectedSquare);
                    }
                } else if (state.chess.history().length && s == actions.squareToN(state.chess.history({
                    verbose: true
                }).pop().to)) {
                    console.log("clear animations and resend current position");
                    actions.lightBoard();
                }
                if (state.selectedSquare) {
                    // move selected to square
                    const move = {
                        from: state.selectedSquare,
                        to: square
                    };
                    console.log("checking if ", move, " is legal");
                    const squares = state.chess.moves({
                        square: state.selectedSquare,
                        verbose: true
                    }).map((legal_move)=>legal_move.to);
                    if (squares.includes(move.to)) actions.makeMove(move);
                    else console.log("illegal move", move);
                }
            }
        },
        onCC: (message)=>{
            message = message.data;
            if (message[2]) {
                console.log("cc", message);
                switch(message[1]){
                    case state.top[0]:
                        // up arrow
                        // increase history
                        actions.incrementHistory();
                        break;
                    case state.top[1]:
                        // down arrow
                        // decreace history
                        actions.decrementHistory();
                        break;
                    case state.top[2]:
                        // left arrow
                        // undo move
                        actions.takeback();
                        break;
                    case state.top[4]:
                        // Session button
                        // flip board
                        actions.flipBoard();
                        (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).redraw();
                        break;
                    case state.top[5]:
                        // Custom button
                        // Toggle grid
                        state.grid = !state.grid;
                        actions.lightBoard();
                        break;
                    case state.top[6]:
                        // Note button
                        // Toggle pieces
                        state.pieces = !state.pieces;
                        actions.lightBoard();
                        break;
                    case state.top[7]:
                        // Custom Midi
                        // toggle square influence / game
                        actions.toggleInfluence();
                        break;
                }
            }
        },
        toggleInfluence: ()=>{
            state.influence = !state.influence;
            actions.lightBoard();
        },
        streamGame: ()=>{
            if (!state.loggedIn()) {
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.set("/login");
                console.log("not logged in. Redirecting to login page");
            } else {
                console.log("streaming game", (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.param("id"), state.loggedIn());
                state.auth.openStream("/api/board/game/stream/" + (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.param("id"), {}, (v)=>{
                    console.log("calling back", v);
                    if (v.type == "gameFull") {
                        state.game = v;
                        // TODO: change to Stream()
                        // m.redraw()
                        console.log("loading game", v.state.moves);
                        console.log("loaded?", state.chess.loadPgn(v.state.moves, {
                            sloppy: true
                        }));
                        if (v.black.id == state.user.profile.id && !state.invert()) {
                            // if playing black, and not already inverted, flip board
                            actions.flipBoard();
                            state.color = "b";
                        } else state.color = "w";
                    } else if (v.type == "gameState") {
                        console.log("move played", v.moves);
                        console.log("loaded?", state.chess.loadPgn(v.moves, {
                            sloppy: true
                        }));
                    }
                    let turn = state.chess.turn() == "w" ? "white" : "black";
                    console.log("updated. turn is", turn);
                    (0, $d5ffb40ab7d69c90$export$8aee836dd884f091)(state.chess, state.ground);
                    actions.lightBoard(true);
                });
            }
        },
        newGame: ()=>{
            state.chess = new (0, $6eb582f9081eb7e5$export$a4d6ea685c300d39)();
            console.log("new game", state.chess.ascii());
            (0, $d5ffb40ab7d69c90$export$8aee836dd884f091)(state.chess, state.ground);
            state.ground.selectSquare(null);
            actions.lightBoard();
        },
        makeMove: (move)=>{
            state.ground.move(move.from, move.to);
            state.ground.selectSquare(null);
        },
        onmove: (orig, dest)=>{
            let move = {
                from: orig,
                to: dest
            };
            let piece = state.chess.get(move.from);
            if (piece.type == "p" && (piece.color == "w" && move.to.charAt(1) == 8 || piece.color == "b" && move.to.charAt(1) == 1)) {
                console.log("promotion! Auto promote to Queen");
                move.promotion = "q";
            }
            state.chess.move(move);
            console.log("moved", move, piece, state.chess.ascii());
            state.ground.set({
                fen: state.chess.fen()
            });
            actions.lightBoard(true);
            (0, $d5ffb40ab7d69c90$export$5b50b356a8724b72)(state.chess, state.ground)(orig, dest);
        },
        afterInit: ()=>{
            actions.initMidi(actions.onInput, actions.onCC, ()=>{
                actions.lightBoard();
            });
        },
        takeback: ()=>{
            state.chess.undo();
            state.selectedPiece, state.selectedSquare = null;
            state.ground.set({
                fen: state.chess.fen()
            });
            actions.lightBoard();
            (0, $d5ffb40ab7d69c90$export$8aee836dd884f091)(state.chess, state.ground);
        }
    });



const $bb75f90500322e40$export$21a94553ffa41578 = (state, actions)=>{
    return {
        oninit: (vnode)=>{
            if (state.loggedIn()) {
                console.log("already logged in. Not sure how we got here.");
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.set("/");
            }
        },
        view: (vnode)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("", {
                onclick: actions.login
            }, (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("i", {}, "Login with lichess"));
        }
    };
};







const $f00dad157732f88c$export$8f45430ccf837300 = [
    "white",
    "black"
];
const $f00dad157732f88c$export$3a444357c5f65f65 = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h"
];
const $f00dad157732f88c$export$d8e4e3952f325c95 = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8"
];


const $dbbfaf35dad95b1f$export$978f7ef4c67d166e = [
    ...$f00dad157732f88c$export$d8e4e3952f325c95
].reverse();
const $dbbfaf35dad95b1f$export$ade7a30951d0bc54 = Array.prototype.concat(...$f00dad157732f88c$export$3a444357c5f65f65.map((c)=>$f00dad157732f88c$export$d8e4e3952f325c95.map((r)=>c + r)));
const $dbbfaf35dad95b1f$export$fe9f8b727818c0ae = (pos)=>$dbbfaf35dad95b1f$export$ade7a30951d0bc54[8 * pos[0] + pos[1]];
const $dbbfaf35dad95b1f$export$e2878eba51f22d11 = (k)=>[
        k.charCodeAt(0) - 97,
        k.charCodeAt(1) - 49
    ];
const $dbbfaf35dad95b1f$export$ab796e79c29e0864 = (uci)=>{
    if (!uci) return undefined;
    if (uci[1] === "@") return [
        uci.slice(2, 4)
    ];
    return [
        uci.slice(0, 2),
        uci.slice(2, 4)
    ];
};
const $dbbfaf35dad95b1f$export$26773b74d67e09c2 = $dbbfaf35dad95b1f$export$ade7a30951d0bc54.map($dbbfaf35dad95b1f$export$e2878eba51f22d11);
function $dbbfaf35dad95b1f$export$7c73462e0d25e514(f) {
    let v;
    const ret = ()=>{
        if (v === undefined) v = f();
        return v;
    };
    ret.clear = ()=>{
        v = undefined;
    };
    return ret;
}
const $dbbfaf35dad95b1f$export$9dc4ecf953986f04 = ()=>{
    let startAt;
    return {
        start () {
            startAt = performance.now();
        },
        cancel () {
            startAt = undefined;
        },
        stop () {
            if (!startAt) return 0;
            const time = performance.now() - startAt;
            startAt = undefined;
            return time;
        }
    };
};
const $dbbfaf35dad95b1f$export$a27c3a1c44ba515b = (c)=>c === "white" ? "black" : "white";
const $dbbfaf35dad95b1f$export$e4884e1734dcd545 = (pos1, pos2)=>{
    const dx = pos1[0] - pos2[0], dy = pos1[1] - pos2[1];
    return dx * dx + dy * dy;
};
const $dbbfaf35dad95b1f$export$e329b1a538c004fa = (p1, p2)=>p1.role === p2.role && p1.color === p2.color;
const $dbbfaf35dad95b1f$export$2135ad75550a2ff4 = (bounds)=>(pos, asWhite)=>[
            (asWhite ? pos[0] : 7 - pos[0]) * bounds.width / 8,
            (asWhite ? 7 - pos[1] : pos[1]) * bounds.height / 8
        ];
const $dbbfaf35dad95b1f$export$d73ee8ef04f5226a = (el, pos)=>{
    el.style.transform = `translate(${pos[0]}px,${pos[1]}px)`;
};
const $dbbfaf35dad95b1f$export$f8afaca97e230dc6 = (el, pos, scale = 1)=>{
    el.style.transform = `translate(${pos[0]}px,${pos[1]}px) scale(${scale})`;
};
const $dbbfaf35dad95b1f$export$8cb512849e51eaf5 = (el, v)=>{
    el.style.visibility = v ? "visible" : "hidden";
};
const $dbbfaf35dad95b1f$export$33052595192f7117 = (e)=>{
    var _a;
    if (e.clientX || e.clientX === 0) return [
        e.clientX,
        e.clientY
    ];
    if ((_a = e.targetTouches) === null || _a === void 0 ? void 0 : _a[0]) return [
        e.targetTouches[0].clientX,
        e.targetTouches[0].clientY
    ];
    return; // touchend has no position!
};
const $dbbfaf35dad95b1f$export$947a472b5b3020ba = (e)=>e.buttons === 2 || e.button === 2;
const $dbbfaf35dad95b1f$export$3d7cd8ed57263b30 = (tagName, className)=>{
    const el = document.createElement(tagName);
    if (className) el.className = className;
    return el;
};
function $dbbfaf35dad95b1f$export$1c17f680299a31f7(key, asWhite, bounds) {
    const pos = $dbbfaf35dad95b1f$export$e2878eba51f22d11(key);
    if (!asWhite) {
        pos[0] = 7 - pos[0];
        pos[1] = 7 - pos[1];
    }
    return [
        bounds.left + bounds.width * pos[0] / 8 + bounds.width / 16,
        bounds.top + bounds.height * (7 - pos[1]) / 8 + bounds.height / 16
    ];
}



const $9edb68138fa5ce8d$var$diff = (a, b)=>Math.abs(a - b);
const $9edb68138fa5ce8d$var$pawn = (color)=>(x1, y1, x2, y2)=>$9edb68138fa5ce8d$var$diff(x1, x2) < 2 && (color === "white" ? y2 === y1 + 1 || y1 <= 1 && y2 === y1 + 2 && x1 === x2 : y2 === y1 - 1 || y1 >= 6 && y2 === y1 - 2 && x1 === x2);
const $9edb68138fa5ce8d$export$5584fb45fd3a6d08 = (x1, y1, x2, y2)=>{
    const xd = $9edb68138fa5ce8d$var$diff(x1, x2);
    const yd = $9edb68138fa5ce8d$var$diff(y1, y2);
    return xd === 1 && yd === 2 || xd === 2 && yd === 1;
};
const $9edb68138fa5ce8d$var$bishop = (x1, y1, x2, y2)=>{
    return $9edb68138fa5ce8d$var$diff(x1, x2) === $9edb68138fa5ce8d$var$diff(y1, y2);
};
const $9edb68138fa5ce8d$var$rook = (x1, y1, x2, y2)=>{
    return x1 === x2 || y1 === y2;
};
const $9edb68138fa5ce8d$export$b9d1aa6d9cf991c6 = (x1, y1, x2, y2)=>{
    return $9edb68138fa5ce8d$var$bishop(x1, y1, x2, y2) || $9edb68138fa5ce8d$var$rook(x1, y1, x2, y2);
};
const $9edb68138fa5ce8d$var$king = (color, rookFiles, canCastle)=>(x1, y1, x2, y2)=>$9edb68138fa5ce8d$var$diff(x1, x2) < 2 && $9edb68138fa5ce8d$var$diff(y1, y2) < 2 || canCastle && y1 === y2 && y1 === (color === "white" ? 0 : 7) && (x1 === 4 && (x2 === 2 && rookFiles.includes(0) || x2 === 6 && rookFiles.includes(7)) || rookFiles.includes(x2));
function $9edb68138fa5ce8d$var$rookFilesOf(pieces, color) {
    const backrank = color === "white" ? "1" : "8";
    const files = [];
    for (const [key, piece] of pieces)if (key[1] === backrank && piece.color === color && piece.role === "rook") files.push($dbbfaf35dad95b1f$export$e2878eba51f22d11(key)[0]);
    return files;
}
function $9edb68138fa5ce8d$export$99ff1a176ab1ff90(pieces, key, canCastle) {
    const piece = pieces.get(key);
    if (!piece) return [];
    const pos = $dbbfaf35dad95b1f$export$e2878eba51f22d11(key), r = piece.role, mobility = r === "pawn" ? $9edb68138fa5ce8d$var$pawn(piece.color) : r === "knight" ? $9edb68138fa5ce8d$export$5584fb45fd3a6d08 : r === "bishop" ? $9edb68138fa5ce8d$var$bishop : r === "rook" ? $9edb68138fa5ce8d$var$rook : r === "queen" ? $9edb68138fa5ce8d$export$b9d1aa6d9cf991c6 : $9edb68138fa5ce8d$var$king(piece.color, $9edb68138fa5ce8d$var$rookFilesOf(pieces, piece.color), canCastle);
    return $dbbfaf35dad95b1f$export$26773b74d67e09c2.filter((pos2)=>(pos[0] !== pos2[0] || pos[1] !== pos2[1]) && mobility(pos[0], pos[1], pos2[0], pos2[1])).map($dbbfaf35dad95b1f$export$fe9f8b727818c0ae);
}


function $80f8b45278b0164a$export$6511920ae9f0cd34(f, ...args) {
    if (f) setTimeout(()=>f(...args), 1);
}
function $80f8b45278b0164a$export$e798007c48b456cd(state) {
    state.orientation = (0, $dbbfaf35dad95b1f$export$a27c3a1c44ba515b)(state.orientation);
    state.animation.current = state.draggable.current = state.selected = undefined;
}
function $80f8b45278b0164a$export$aad8462122ac592b(state) {
    state.lastMove = undefined;
    $80f8b45278b0164a$export$fe412c270a34f415(state);
    $80f8b45278b0164a$export$f92a111f74a3f7c7(state);
    $80f8b45278b0164a$export$9e6f418e5ea6b92c(state);
}
function $80f8b45278b0164a$export$20a063d1402ff7ff(state, pieces) {
    for (const [key, piece] of pieces)if (piece) state.pieces.set(key, piece);
    else state.pieces.delete(key);
}
function $80f8b45278b0164a$export$6503933b06013bb6(state, color) {
    state.check = undefined;
    if (color === true) color = state.turnColor;
    if (color) {
        for (const [k, p] of state.pieces)if (p.role === "king" && p.color === color) state.check = k;
    }
}
function $80f8b45278b0164a$var$setPremove(state, orig, dest, meta) {
    $80f8b45278b0164a$export$9e6f418e5ea6b92c(state);
    state.premovable.current = [
        orig,
        dest
    ];
    $80f8b45278b0164a$export$6511920ae9f0cd34(state.premovable.events.set, orig, dest, meta);
}
function $80f8b45278b0164a$export$f92a111f74a3f7c7(state) {
    if (state.premovable.current) {
        state.premovable.current = undefined;
        $80f8b45278b0164a$export$6511920ae9f0cd34(state.premovable.events.unset);
    }
}
function $80f8b45278b0164a$var$setPredrop(state, role, key) {
    $80f8b45278b0164a$export$f92a111f74a3f7c7(state);
    state.predroppable.current = {
        role: role,
        key: key
    };
    $80f8b45278b0164a$export$6511920ae9f0cd34(state.predroppable.events.set, role, key);
}
function $80f8b45278b0164a$export$9e6f418e5ea6b92c(state) {
    const pd = state.predroppable;
    if (pd.current) {
        pd.current = undefined;
        $80f8b45278b0164a$export$6511920ae9f0cd34(pd.events.unset);
    }
}
function $80f8b45278b0164a$var$tryAutoCastle(state, orig, dest) {
    if (!state.autoCastle) return false;
    const king = state.pieces.get(orig);
    if (!king || king.role !== "king") return false;
    const origPos = (0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(orig);
    const destPos = (0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(dest);
    if (origPos[1] !== 0 && origPos[1] !== 7 || origPos[1] !== destPos[1]) return false;
    if (origPos[0] === 4 && !state.pieces.has(dest)) {
        if (destPos[0] === 6) dest = (0, $dbbfaf35dad95b1f$export$fe9f8b727818c0ae)([
            7,
            destPos[1]
        ]);
        else if (destPos[0] === 2) dest = (0, $dbbfaf35dad95b1f$export$fe9f8b727818c0ae)([
            0,
            destPos[1]
        ]);
    }
    const rook = state.pieces.get(dest);
    if (!rook || rook.color !== king.color || rook.role !== "rook") return false;
    state.pieces.delete(orig);
    state.pieces.delete(dest);
    if (origPos[0] < destPos[0]) {
        state.pieces.set((0, $dbbfaf35dad95b1f$export$fe9f8b727818c0ae)([
            6,
            destPos[1]
        ]), king);
        state.pieces.set((0, $dbbfaf35dad95b1f$export$fe9f8b727818c0ae)([
            5,
            destPos[1]
        ]), rook);
    } else {
        state.pieces.set((0, $dbbfaf35dad95b1f$export$fe9f8b727818c0ae)([
            2,
            destPos[1]
        ]), king);
        state.pieces.set((0, $dbbfaf35dad95b1f$export$fe9f8b727818c0ae)([
            3,
            destPos[1]
        ]), rook);
    }
    return true;
}
function $80f8b45278b0164a$export$13f6ca6271343510(state, orig, dest) {
    const origPiece = state.pieces.get(orig), destPiece = state.pieces.get(dest);
    if (orig === dest || !origPiece) return false;
    const captured = destPiece && destPiece.color !== origPiece.color ? destPiece : undefined;
    if (dest === state.selected) $80f8b45278b0164a$export$fe412c270a34f415(state);
    $80f8b45278b0164a$export$6511920ae9f0cd34(state.events.move, orig, dest, captured);
    if (!$80f8b45278b0164a$var$tryAutoCastle(state, orig, dest)) {
        state.pieces.set(dest, origPiece);
        state.pieces.delete(orig);
    }
    state.lastMove = [
        orig,
        dest
    ];
    state.check = undefined;
    $80f8b45278b0164a$export$6511920ae9f0cd34(state.events.change);
    return captured || true;
}
function $80f8b45278b0164a$export$13886f9573facc29(state, piece, key, force) {
    if (state.pieces.has(key)) {
        if (force) state.pieces.delete(key);
        else return false;
    }
    $80f8b45278b0164a$export$6511920ae9f0cd34(state.events.dropNewPiece, piece, key);
    state.pieces.set(key, piece);
    state.lastMove = [
        key
    ];
    state.check = undefined;
    $80f8b45278b0164a$export$6511920ae9f0cd34(state.events.change);
    state.movable.dests = undefined;
    state.turnColor = (0, $dbbfaf35dad95b1f$export$a27c3a1c44ba515b)(state.turnColor);
    return true;
}
function $80f8b45278b0164a$var$baseUserMove(state, orig, dest) {
    const result = $80f8b45278b0164a$export$13f6ca6271343510(state, orig, dest);
    if (result) {
        state.movable.dests = undefined;
        state.turnColor = (0, $dbbfaf35dad95b1f$export$a27c3a1c44ba515b)(state.turnColor);
        state.animation.current = undefined;
    }
    return result;
}
function $80f8b45278b0164a$export$843c446e2e718822(state, orig, dest) {
    if ($80f8b45278b0164a$export$a4ef2b0c3fa55ad2(state, orig, dest)) {
        const result = $80f8b45278b0164a$var$baseUserMove(state, orig, dest);
        if (result) {
            const holdTime = state.hold.stop();
            $80f8b45278b0164a$export$fe412c270a34f415(state);
            const metadata = {
                premove: false,
                ctrlKey: state.stats.ctrlKey,
                holdTime: holdTime
            };
            if (result !== true) metadata.captured = result;
            $80f8b45278b0164a$export$6511920ae9f0cd34(state.movable.events.after, orig, dest, metadata);
            return true;
        }
    } else if ($80f8b45278b0164a$var$canPremove(state, orig, dest)) {
        $80f8b45278b0164a$var$setPremove(state, orig, dest, {
            ctrlKey: state.stats.ctrlKey
        });
        $80f8b45278b0164a$export$fe412c270a34f415(state);
        return true;
    }
    $80f8b45278b0164a$export$fe412c270a34f415(state);
    return false;
}
function $80f8b45278b0164a$export$b2b9f46b948033b0(state, orig, dest, force) {
    const piece = state.pieces.get(orig);
    if (piece && ($80f8b45278b0164a$var$canDrop(state, orig, dest) || force)) {
        state.pieces.delete(orig);
        $80f8b45278b0164a$export$13886f9573facc29(state, piece, dest, force);
        $80f8b45278b0164a$export$6511920ae9f0cd34(state.movable.events.afterNewPiece, piece.role, dest, {
            premove: false,
            predrop: false
        });
    } else if (piece && $80f8b45278b0164a$var$canPredrop(state, orig, dest)) $80f8b45278b0164a$var$setPredrop(state, piece.role, dest);
    else {
        $80f8b45278b0164a$export$f92a111f74a3f7c7(state);
        $80f8b45278b0164a$export$9e6f418e5ea6b92c(state);
    }
    state.pieces.delete(orig);
    $80f8b45278b0164a$export$fe412c270a34f415(state);
}
function $80f8b45278b0164a$export$6073914ea697a63e(state, key, force) {
    $80f8b45278b0164a$export$6511920ae9f0cd34(state.events.select, key);
    if (state.selected) {
        if (state.selected === key && !state.draggable.enabled) {
            $80f8b45278b0164a$export$fe412c270a34f415(state);
            state.hold.cancel();
            return;
        } else if ((state.selectable.enabled || force) && state.selected !== key) {
            if ($80f8b45278b0164a$export$843c446e2e718822(state, state.selected, key)) {
                state.stats.dragged = false;
                return;
            }
        }
    }
    if ((state.selectable.enabled || state.draggable.enabled) && ($80f8b45278b0164a$var$isMovable(state, key) || $80f8b45278b0164a$var$isPremovable(state, key))) {
        $80f8b45278b0164a$export$5a4818cec1656a71(state, key);
        state.hold.start();
    }
}
function $80f8b45278b0164a$export$5a4818cec1656a71(state, key) {
    state.selected = key;
    if ($80f8b45278b0164a$var$isPremovable(state, key)) // calculate chess premoves if custom premoves are not passed
    {
        if (!state.premovable.customDests) state.premovable.dests = (0, $9edb68138fa5ce8d$export$99ff1a176ab1ff90)(state.pieces, key, state.premovable.castle);
    } else state.premovable.dests = undefined;
}
function $80f8b45278b0164a$export$fe412c270a34f415(state) {
    state.selected = undefined;
    state.premovable.dests = undefined;
    state.hold.cancel();
}
function $80f8b45278b0164a$var$isMovable(state, orig) {
    const piece = state.pieces.get(orig);
    return !!piece && (state.movable.color === "both" || state.movable.color === piece.color && state.turnColor === piece.color);
}
const $80f8b45278b0164a$export$a4ef2b0c3fa55ad2 = (state, orig, dest)=>{
    var _a, _b;
    return orig !== dest && $80f8b45278b0164a$var$isMovable(state, orig) && (state.movable.free || !!((_b = (_a = state.movable.dests) === null || _a === void 0 ? void 0 : _a.get(orig)) === null || _b === void 0 ? void 0 : _b.includes(dest)));
};
function $80f8b45278b0164a$var$canDrop(state, orig, dest) {
    const piece = state.pieces.get(orig);
    return !!piece && (orig === dest || !state.pieces.has(dest)) && (state.movable.color === "both" || state.movable.color === piece.color && state.turnColor === piece.color);
}
function $80f8b45278b0164a$var$isPremovable(state, orig) {
    const piece = state.pieces.get(orig);
    return !!piece && state.premovable.enabled && state.movable.color === piece.color && state.turnColor !== piece.color;
}
function $80f8b45278b0164a$var$canPremove(state, orig, dest) {
    var _a, _b;
    const validPremoves = (_b = (_a = state.premovable.customDests) === null || _a === void 0 ? void 0 : _a.get(orig)) !== null && _b !== void 0 ? _b : (0, $9edb68138fa5ce8d$export$99ff1a176ab1ff90)(state.pieces, orig, state.premovable.castle);
    return orig !== dest && $80f8b45278b0164a$var$isPremovable(state, orig) && validPremoves.includes(dest);
}
function $80f8b45278b0164a$var$canPredrop(state, orig, dest) {
    const piece = state.pieces.get(orig);
    const destPiece = state.pieces.get(dest);
    return !!piece && (!destPiece || destPiece.color !== state.movable.color) && state.predroppable.enabled && (piece.role !== "pawn" || dest[1] !== "1" && dest[1] !== "8") && state.movable.color === piece.color && state.turnColor !== piece.color;
}
function $80f8b45278b0164a$export$fe8f97248bbe2d04(state, orig) {
    const piece = state.pieces.get(orig);
    return !!piece && state.draggable.enabled && (state.movable.color === "both" || state.movable.color === piece.color && (state.turnColor === piece.color || state.premovable.enabled));
}
function $80f8b45278b0164a$export$d04320a93cdae73d(state) {
    const move = state.premovable.current;
    if (!move) return false;
    const orig = move[0], dest = move[1];
    let success = false;
    if ($80f8b45278b0164a$export$a4ef2b0c3fa55ad2(state, orig, dest)) {
        const result = $80f8b45278b0164a$var$baseUserMove(state, orig, dest);
        if (result) {
            const metadata = {
                premove: true
            };
            if (result !== true) metadata.captured = result;
            $80f8b45278b0164a$export$6511920ae9f0cd34(state.movable.events.after, orig, dest, metadata);
            success = true;
        }
    }
    $80f8b45278b0164a$export$f92a111f74a3f7c7(state);
    return success;
}
function $80f8b45278b0164a$export$8efa9460c0cedd9e(state, validate) {
    const drop = state.predroppable.current;
    let success = false;
    if (!drop) return false;
    if (validate(drop)) {
        const piece = {
            role: drop.role,
            color: state.movable.color
        };
        if ($80f8b45278b0164a$export$13886f9573facc29(state, piece, drop.key)) {
            $80f8b45278b0164a$export$6511920ae9f0cd34(state.movable.events.afterNewPiece, drop.role, drop.key, {
                premove: false,
                predrop: true
            });
            success = true;
        }
    }
    $80f8b45278b0164a$export$9e6f418e5ea6b92c(state);
    return success;
}
function $80f8b45278b0164a$export$e47a3d6268102bb5(state) {
    $80f8b45278b0164a$export$f92a111f74a3f7c7(state);
    $80f8b45278b0164a$export$9e6f418e5ea6b92c(state);
    $80f8b45278b0164a$export$fe412c270a34f415(state);
}
function $80f8b45278b0164a$export$fa6813432f753b0d(state) {
    state.movable.color = state.movable.dests = state.animation.current = undefined;
    $80f8b45278b0164a$export$e47a3d6268102bb5(state);
}
function $80f8b45278b0164a$export$102bdd581884418b(pos, asWhite, bounds) {
    let file = Math.floor(8 * (pos[0] - bounds.left) / bounds.width);
    if (!asWhite) file = 7 - file;
    let rank = 7 - Math.floor(8 * (pos[1] - bounds.top) / bounds.height);
    if (!asWhite) rank = 7 - rank;
    return file >= 0 && file < 8 && rank >= 0 && rank < 8 ? (0, $dbbfaf35dad95b1f$export$fe9f8b727818c0ae)([
        file,
        rank
    ]) : undefined;
}
function $80f8b45278b0164a$export$6ee499125a88eb43(orig, pos, asWhite, bounds) {
    const origPos = (0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(orig);
    const validSnapPos = (0, $dbbfaf35dad95b1f$export$26773b74d67e09c2).filter((pos2)=>(0, $9edb68138fa5ce8d$export$b9d1aa6d9cf991c6)(origPos[0], origPos[1], pos2[0], pos2[1]) || (0, $9edb68138fa5ce8d$export$5584fb45fd3a6d08)(origPos[0], origPos[1], pos2[0], pos2[1]));
    const validSnapCenters = validSnapPos.map((pos2)=>(0, $dbbfaf35dad95b1f$export$1c17f680299a31f7)((0, $dbbfaf35dad95b1f$export$fe9f8b727818c0ae)(pos2), asWhite, bounds));
    const validSnapDistances = validSnapCenters.map((pos2)=>(0, $dbbfaf35dad95b1f$export$e4884e1734dcd545)(pos, pos2));
    const [, closestSnapIndex] = validSnapDistances.reduce((a, b, index)=>a[0] < b ? a : [
            b,
            index
        ], [
        validSnapDistances[0],
        0
    ]);
    return (0, $dbbfaf35dad95b1f$export$fe9f8b727818c0ae)(validSnapPos[closestSnapIndex]);
}
const $80f8b45278b0164a$export$970133fdf67d86cb = (s)=>s.orientation === "white";




const $f37f4d2e14067e5f$export$59ff82fc918bd7e3 = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR";
const $f37f4d2e14067e5f$var$roles = {
    p: "pawn",
    r: "rook",
    n: "knight",
    b: "bishop",
    q: "queen",
    k: "king"
};
const $f37f4d2e14067e5f$var$letters = {
    pawn: "p",
    rook: "r",
    knight: "n",
    bishop: "b",
    queen: "q",
    king: "k"
};
function $f37f4d2e14067e5f$export$aafa59e2e03f2942(fen) {
    if (fen === "start") fen = $f37f4d2e14067e5f$export$59ff82fc918bd7e3;
    const pieces = new Map();
    let row = 7, col = 0;
    for (const c of fen)switch(c){
        case " ":
        case "[":
            return pieces;
        case "/":
            --row;
            if (row < 0) return pieces;
            col = 0;
            break;
        case "~":
            {
                const piece = pieces.get((0, $dbbfaf35dad95b1f$export$fe9f8b727818c0ae)([
                    col - 1,
                    row
                ]));
                if (piece) piece.promoted = true;
                break;
            }
        default:
            {
                const nb = c.charCodeAt(0);
                if (nb < 57) col += nb - 48;
                else {
                    const role = c.toLowerCase();
                    pieces.set((0, $dbbfaf35dad95b1f$export$fe9f8b727818c0ae)([
                        col,
                        row
                    ]), {
                        role: $f37f4d2e14067e5f$var$roles[role],
                        color: c === role ? "black" : "white"
                    });
                    ++col;
                }
            }
    }
    return pieces;
}
function $f37f4d2e14067e5f$export$68d8715fc104d294(pieces) {
    return (0, $dbbfaf35dad95b1f$export$978f7ef4c67d166e).map((y)=>$f00dad157732f88c$export$3a444357c5f65f65.map((x)=>{
            const piece = pieces.get(x + y);
            if (piece) {
                let p = $f37f4d2e14067e5f$var$letters[piece.role];
                if (piece.color === "white") p = p.toUpperCase();
                if (piece.promoted) p += "~";
                return p;
            } else return "1";
        }).join("")).join("/").replace(/1{2,}/g, (s)=>s.length.toString());
}




function $fe7eac34876cd925$export$d771543c4ed87064(state, config) {
    if (config.animation) {
        $fe7eac34876cd925$var$deepMerge(state.animation, config.animation);
        // no need for such short animations
        if ((state.animation.duration || 0) < 70) state.animation.enabled = false;
    }
}
function $fe7eac34876cd925$export$8d21e34596265fa2(state, config) {
    var _a, _b, _c;
    // don't merge destinations and autoShapes. Just override.
    if ((_a = config.movable) === null || _a === void 0 ? void 0 : _a.dests) state.movable.dests = undefined;
    if ((_b = config.drawable) === null || _b === void 0 ? void 0 : _b.autoShapes) state.drawable.autoShapes = [];
    $fe7eac34876cd925$var$deepMerge(state, config);
    // if a fen was provided, replace the pieces
    if (config.fen) {
        state.pieces = (0, $f37f4d2e14067e5f$export$aafa59e2e03f2942)(config.fen);
        state.drawable.shapes = ((_c = config.drawable) === null || _c === void 0 ? void 0 : _c.shapes) || [];
    }
    // apply config values that could be undefined yet meaningful
    if ("check" in config) (0, $80f8b45278b0164a$export$6503933b06013bb6)(state, config.check || false);
    if ("lastMove" in config && !config.lastMove) state.lastMove = undefined;
    else if (config.lastMove) state.lastMove = config.lastMove;
    // fix move/premove dests
    if (state.selected) (0, $80f8b45278b0164a$export$5a4818cec1656a71)(state, state.selected);
    $fe7eac34876cd925$export$d771543c4ed87064(state, config);
    if (!state.movable.rookCastle && state.movable.dests) {
        const rank = state.movable.color === "white" ? "1" : "8", kingStartPos = "e" + rank, dests = state.movable.dests.get(kingStartPos), king = state.pieces.get(kingStartPos);
        if (!dests || !king || king.role !== "king") return;
        state.movable.dests.set(kingStartPos, dests.filter((d)=>!(d === "a" + rank && dests.includes("c" + rank)) && !(d === "h" + rank && dests.includes("g" + rank))));
    }
}
function $fe7eac34876cd925$var$deepMerge(base, extend) {
    for(const key in extend)if (Object.prototype.hasOwnProperty.call(extend, key)) {
        if (Object.prototype.hasOwnProperty.call(base, key) && $fe7eac34876cd925$var$isPlainObject(base[key]) && $fe7eac34876cd925$var$isPlainObject(extend[key])) $fe7eac34876cd925$var$deepMerge(base[key], extend[key]);
        else base[key] = extend[key];
    }
}
function $fe7eac34876cd925$var$isPlainObject(o) {
    if (typeof o !== "object" || o === null) return false;
    const proto = Object.getPrototypeOf(o);
    return proto === Object.prototype || proto === null;
}



const $b81ba4ea6c3c4676$export$bd46b8ab3689edc4 = (mutation, state)=>state.animation.enabled ? $b81ba4ea6c3c4676$var$animate(mutation, state) : $b81ba4ea6c3c4676$export$b3890eb0ae9dca99(mutation, state);
function $b81ba4ea6c3c4676$export$b3890eb0ae9dca99(mutation, state) {
    const result = mutation(state);
    state.dom.redraw();
    return result;
}
const $b81ba4ea6c3c4676$var$makePiece = (key, piece)=>({
        key: key,
        pos: $dbbfaf35dad95b1f$export$e2878eba51f22d11(key),
        piece: piece
    });
const $b81ba4ea6c3c4676$var$closer = (piece, pieces)=>pieces.sort((p1, p2)=>$dbbfaf35dad95b1f$export$e4884e1734dcd545(piece.pos, p1.pos) - $dbbfaf35dad95b1f$export$e4884e1734dcd545(piece.pos, p2.pos))[0];
function $b81ba4ea6c3c4676$var$computePlan(prevPieces, current) {
    const anims = new Map(), animedOrigs = [], fadings = new Map(), missings = [], news = [], prePieces = new Map();
    let curP, preP, vector;
    for (const [k, p] of prevPieces)prePieces.set(k, $b81ba4ea6c3c4676$var$makePiece(k, p));
    for (const key of $dbbfaf35dad95b1f$export$ade7a30951d0bc54){
        curP = current.pieces.get(key);
        preP = prePieces.get(key);
        if (curP) {
            if (preP) {
                if (!$dbbfaf35dad95b1f$export$e329b1a538c004fa(curP, preP.piece)) {
                    missings.push(preP);
                    news.push($b81ba4ea6c3c4676$var$makePiece(key, curP));
                }
            } else news.push($b81ba4ea6c3c4676$var$makePiece(key, curP));
        } else if (preP) missings.push(preP);
    }
    for (const newP of news){
        preP = $b81ba4ea6c3c4676$var$closer(newP, missings.filter((p)=>$dbbfaf35dad95b1f$export$e329b1a538c004fa(newP.piece, p.piece)));
        if (preP) {
            vector = [
                preP.pos[0] - newP.pos[0],
                preP.pos[1] - newP.pos[1]
            ];
            anims.set(newP.key, vector.concat(vector));
            animedOrigs.push(preP.key);
        }
    }
    for (const p of missings)if (!animedOrigs.includes(p.key)) fadings.set(p.key, p.piece);
    return {
        anims: anims,
        fadings: fadings
    };
}
function $b81ba4ea6c3c4676$var$step(state, now) {
    const cur = state.animation.current;
    if (cur === undefined) {
        // animation was canceled :(
        if (!state.dom.destroyed) state.dom.redrawNow();
        return;
    }
    const rest = 1 - (now - cur.start) * cur.frequency;
    if (rest <= 0) {
        state.animation.current = undefined;
        state.dom.redrawNow();
    } else {
        const ease = $b81ba4ea6c3c4676$var$easing(rest);
        for (const cfg of cur.plan.anims.values()){
            cfg[2] = cfg[0] * ease;
            cfg[3] = cfg[1] * ease;
        }
        state.dom.redrawNow(true); // optimisation: don't render SVG changes during animations
        requestAnimationFrame((now = performance.now())=>$b81ba4ea6c3c4676$var$step(state, now));
    }
}
function $b81ba4ea6c3c4676$var$animate(mutation, state) {
    // clone state before mutating it
    const prevPieces = new Map(state.pieces);
    const result = mutation(state);
    const plan = $b81ba4ea6c3c4676$var$computePlan(prevPieces, state);
    if (plan.anims.size || plan.fadings.size) {
        const alreadyRunning = state.animation.current && state.animation.current.start;
        state.animation.current = {
            start: performance.now(),
            frequency: 1 / state.animation.duration,
            plan: plan
        };
        if (!alreadyRunning) $b81ba4ea6c3c4676$var$step(state, performance.now());
    } else // don't animate, just render right away
    state.dom.redraw();
    return result;
}
// https://gist.github.com/gre/1650294
const $b81ba4ea6c3c4676$var$easing = (t)=>t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;






const $7a42cea72ae7e4e6$var$brushes = [
    "green",
    "red",
    "blue",
    "yellow"
];
function $7a42cea72ae7e4e6$export$b3571188c770cc5a(state, e) {
    // support one finger touch only
    if (e.touches && e.touches.length > 1) return;
    e.stopPropagation();
    e.preventDefault();
    e.ctrlKey ? (0, $80f8b45278b0164a$export$fe412c270a34f415)(state) : (0, $80f8b45278b0164a$export$e47a3d6268102bb5)(state);
    const pos = (0, $dbbfaf35dad95b1f$export$33052595192f7117)(e), orig = (0, $80f8b45278b0164a$export$102bdd581884418b)(pos, (0, $80f8b45278b0164a$export$970133fdf67d86cb)(state), state.dom.bounds());
    if (!orig) return;
    state.drawable.current = {
        orig: orig,
        pos: pos,
        brush: $7a42cea72ae7e4e6$var$eventBrush(e),
        snapToValidMove: state.drawable.defaultSnapToValidMove
    };
    $7a42cea72ae7e4e6$export$816e7b21815d9cf9(state);
}
function $7a42cea72ae7e4e6$export$816e7b21815d9cf9(state) {
    requestAnimationFrame(()=>{
        const cur = state.drawable.current;
        if (cur) {
            const keyAtDomPos = (0, $80f8b45278b0164a$export$102bdd581884418b)(cur.pos, (0, $80f8b45278b0164a$export$970133fdf67d86cb)(state), state.dom.bounds());
            if (!keyAtDomPos) cur.snapToValidMove = false;
            const mouseSq = cur.snapToValidMove ? (0, $80f8b45278b0164a$export$6ee499125a88eb43)(cur.orig, cur.pos, (0, $80f8b45278b0164a$export$970133fdf67d86cb)(state), state.dom.bounds()) : keyAtDomPos;
            if (mouseSq !== cur.mouseSq) {
                cur.mouseSq = mouseSq;
                cur.dest = mouseSq !== cur.orig ? mouseSq : undefined;
                state.dom.redrawNow();
            }
            $7a42cea72ae7e4e6$export$816e7b21815d9cf9(state);
        }
    });
}
function $7a42cea72ae7e4e6$export$d947e5f4f4c48d48(state, e) {
    if (state.drawable.current) state.drawable.current.pos = (0, $dbbfaf35dad95b1f$export$33052595192f7117)(e);
}
function $7a42cea72ae7e4e6$export$bd5df0f255a350f8(state) {
    const cur = state.drawable.current;
    if (cur) {
        if (cur.mouseSq) $7a42cea72ae7e4e6$var$addShape(state.drawable, cur);
        $7a42cea72ae7e4e6$export$70b61ad426ddbe54(state);
    }
}
function $7a42cea72ae7e4e6$export$70b61ad426ddbe54(state) {
    if (state.drawable.current) {
        state.drawable.current = undefined;
        state.dom.redraw();
    }
}
function $7a42cea72ae7e4e6$export$42ffd38884aecdac(state) {
    if (state.drawable.shapes.length) {
        state.drawable.shapes = [];
        state.dom.redraw();
        $7a42cea72ae7e4e6$var$onChange(state.drawable);
    }
}
function $7a42cea72ae7e4e6$var$eventBrush(e) {
    var _a;
    const modA = (e.shiftKey || e.ctrlKey) && (0, $dbbfaf35dad95b1f$export$947a472b5b3020ba)(e);
    const modB = e.altKey || e.metaKey || ((_a = e.getModifierState) === null || _a === void 0 ? void 0 : _a.call(e, "AltGraph"));
    return $7a42cea72ae7e4e6$var$brushes[(modA ? 1 : 0) + (modB ? 2 : 0)];
}
function $7a42cea72ae7e4e6$var$addShape(drawable, cur) {
    const sameShape = (s)=>s.orig === cur.orig && s.dest === cur.dest;
    const similar = drawable.shapes.find(sameShape);
    if (similar) drawable.shapes = drawable.shapes.filter((s)=>!sameShape(s));
    if (!similar || similar.brush !== cur.brush) drawable.shapes.push({
        orig: cur.orig,
        dest: cur.dest,
        brush: cur.brush
    });
    $7a42cea72ae7e4e6$var$onChange(drawable);
}
function $7a42cea72ae7e4e6$var$onChange(drawable) {
    if (drawable.onChange) drawable.onChange(drawable.shapes);
}



function $84ee20f15ef980fb$export$b3571188c770cc5a(s, e) {
    if (!(s.trustAllEvents || e.isTrusted)) return; // only trust when trustAllEvents is enabled
    if (e.button !== undefined && e.button !== 0) return; // only touch or left click
    if (e.touches && e.touches.length > 1) return; // support one finger touch only
    const bounds = s.dom.bounds(), position = $dbbfaf35dad95b1f$export$33052595192f7117(e), orig = $80f8b45278b0164a$export$102bdd581884418b(position, $80f8b45278b0164a$export$970133fdf67d86cb(s), bounds);
    if (!orig) return;
    const piece = s.pieces.get(orig);
    const previouslySelected = s.selected;
    if (!previouslySelected && s.drawable.enabled && (s.drawable.eraseOnClick || !piece || piece.color !== s.turnColor)) (0, $7a42cea72ae7e4e6$export$42ffd38884aecdac)(s);
    // Prevent touch scroll and create no corresponding mouse event, if there
    // is an intent to interact with the board.
    if (e.cancelable !== false && (!e.touches || s.blockTouchScroll || piece || previouslySelected || $84ee20f15ef980fb$var$pieceCloseTo(s, position))) e.preventDefault();
    else if (e.touches) return; // Handle only corresponding mouse event https://github.com/lichess-org/chessground/pull/268
    const hadPremove = !!s.premovable.current;
    const hadPredrop = !!s.predroppable.current;
    s.stats.ctrlKey = e.ctrlKey;
    if (s.selected && $80f8b45278b0164a$export$a4ef2b0c3fa55ad2(s, s.selected, orig)) (0, $b81ba4ea6c3c4676$export$bd46b8ab3689edc4)((state)=>$80f8b45278b0164a$export$6073914ea697a63e(state, orig), s);
    else $80f8b45278b0164a$export$6073914ea697a63e(s, orig);
    const stillSelected = s.selected === orig;
    const element = $84ee20f15ef980fb$var$pieceElementByKey(s, orig);
    if (piece && element && stillSelected && $80f8b45278b0164a$export$fe8f97248bbe2d04(s, orig)) {
        s.draggable.current = {
            orig: orig,
            piece: piece,
            origPos: position,
            pos: position,
            started: s.draggable.autoDistance && s.stats.dragged,
            element: element,
            previouslySelected: previouslySelected,
            originTarget: e.target,
            keyHasChanged: false
        };
        element.cgDragging = true;
        element.classList.add("dragging");
        // place ghost
        const ghost = s.dom.elements.ghost;
        if (ghost) {
            ghost.className = `ghost ${piece.color} ${piece.role}`;
            $dbbfaf35dad95b1f$export$d73ee8ef04f5226a(ghost, $dbbfaf35dad95b1f$export$2135ad75550a2ff4(bounds)($dbbfaf35dad95b1f$export$e2878eba51f22d11(orig), $80f8b45278b0164a$export$970133fdf67d86cb(s)));
            $dbbfaf35dad95b1f$export$8cb512849e51eaf5(ghost, true);
        }
        $84ee20f15ef980fb$var$processDrag(s);
    } else {
        if (hadPremove) $80f8b45278b0164a$export$f92a111f74a3f7c7(s);
        if (hadPredrop) $80f8b45278b0164a$export$9e6f418e5ea6b92c(s);
    }
    s.dom.redraw();
}
function $84ee20f15ef980fb$var$pieceCloseTo(s, pos) {
    const asWhite = $80f8b45278b0164a$export$970133fdf67d86cb(s), bounds = s.dom.bounds(), radiusSq = Math.pow(bounds.width / 8, 2);
    for (const key of s.pieces.keys()){
        const center = $dbbfaf35dad95b1f$export$1c17f680299a31f7(key, asWhite, bounds);
        if ($dbbfaf35dad95b1f$export$e4884e1734dcd545(center, pos) <= radiusSq) return true;
    }
    return false;
}
function $84ee20f15ef980fb$export$65771a6862d302e4(s, piece, e, force) {
    const key = "a0";
    s.pieces.set(key, piece);
    s.dom.redraw();
    const position = $dbbfaf35dad95b1f$export$33052595192f7117(e);
    s.draggable.current = {
        orig: key,
        piece: piece,
        origPos: position,
        pos: position,
        started: true,
        element: ()=>$84ee20f15ef980fb$var$pieceElementByKey(s, key),
        originTarget: e.target,
        newPiece: true,
        force: !!force,
        keyHasChanged: false
    };
    $84ee20f15ef980fb$var$processDrag(s);
}
function $84ee20f15ef980fb$var$processDrag(s) {
    requestAnimationFrame(()=>{
        var _a;
        const cur = s.draggable.current;
        if (!cur) return;
        // cancel animations while dragging
        if ((_a = s.animation.current) === null || _a === void 0 ? void 0 : _a.plan.anims.has(cur.orig)) s.animation.current = undefined;
        // if moving piece is gone, cancel
        const origPiece = s.pieces.get(cur.orig);
        if (!origPiece || !$dbbfaf35dad95b1f$export$e329b1a538c004fa(origPiece, cur.piece)) $84ee20f15ef980fb$export$70b61ad426ddbe54(s);
        else {
            if (!cur.started && $dbbfaf35dad95b1f$export$e4884e1734dcd545(cur.pos, cur.origPos) >= Math.pow(s.draggable.distance, 2)) cur.started = true;
            if (cur.started) {
                // support lazy elements
                if (typeof cur.element === "function") {
                    const found = cur.element();
                    if (!found) return;
                    found.cgDragging = true;
                    found.classList.add("dragging");
                    cur.element = found;
                }
                const bounds = s.dom.bounds();
                $dbbfaf35dad95b1f$export$d73ee8ef04f5226a(cur.element, [
                    cur.pos[0] - bounds.left - bounds.width / 16,
                    cur.pos[1] - bounds.top - bounds.height / 16
                ]);
                cur.keyHasChanged || (cur.keyHasChanged = cur.orig !== $80f8b45278b0164a$export$102bdd581884418b(cur.pos, $80f8b45278b0164a$export$970133fdf67d86cb(s), bounds));
            }
        }
        $84ee20f15ef980fb$var$processDrag(s);
    });
}
function $84ee20f15ef980fb$export$d947e5f4f4c48d48(s, e) {
    // support one finger touch only
    if (s.draggable.current && (!e.touches || e.touches.length < 2)) s.draggable.current.pos = $dbbfaf35dad95b1f$export$33052595192f7117(e);
}
function $84ee20f15ef980fb$export$bd5df0f255a350f8(s, e) {
    const cur = s.draggable.current;
    if (!cur) return;
    // create no corresponding mouse event
    if (e.type === "touchend" && e.cancelable !== false) e.preventDefault();
    // comparing with the origin target is an easy way to test that the end event
    // has the same touch origin
    if (e.type === "touchend" && cur.originTarget !== e.target && !cur.newPiece) {
        s.draggable.current = undefined;
        return;
    }
    $80f8b45278b0164a$export$f92a111f74a3f7c7(s);
    $80f8b45278b0164a$export$9e6f418e5ea6b92c(s);
    // touchend has no position; so use the last touchmove position instead
    const eventPos = $dbbfaf35dad95b1f$export$33052595192f7117(e) || cur.pos;
    const dest = $80f8b45278b0164a$export$102bdd581884418b(eventPos, $80f8b45278b0164a$export$970133fdf67d86cb(s), s.dom.bounds());
    if (dest && cur.started && cur.orig !== dest) {
        if (cur.newPiece) $80f8b45278b0164a$export$b2b9f46b948033b0(s, cur.orig, dest, cur.force);
        else {
            s.stats.ctrlKey = e.ctrlKey;
            if ($80f8b45278b0164a$export$843c446e2e718822(s, cur.orig, dest)) s.stats.dragged = true;
        }
    } else if (cur.newPiece) s.pieces.delete(cur.orig);
    else if (s.draggable.deleteOnDropOff && !dest) {
        s.pieces.delete(cur.orig);
        $80f8b45278b0164a$export$6511920ae9f0cd34(s.events.change);
    }
    if ((cur.orig === cur.previouslySelected || cur.keyHasChanged) && (cur.orig === dest || !dest)) $80f8b45278b0164a$export$fe412c270a34f415(s);
    else if (!s.selectable.enabled) $80f8b45278b0164a$export$fe412c270a34f415(s);
    $84ee20f15ef980fb$var$removeDragElements(s);
    s.draggable.current = undefined;
    s.dom.redraw();
}
function $84ee20f15ef980fb$export$70b61ad426ddbe54(s) {
    const cur = s.draggable.current;
    if (cur) {
        if (cur.newPiece) s.pieces.delete(cur.orig);
        s.draggable.current = undefined;
        $80f8b45278b0164a$export$fe412c270a34f415(s);
        $84ee20f15ef980fb$var$removeDragElements(s);
        s.dom.redraw();
    }
}
function $84ee20f15ef980fb$var$removeDragElements(s) {
    const e = s.dom.elements;
    if (e.ghost) $dbbfaf35dad95b1f$export$8cb512849e51eaf5(e.ghost, false);
}
function $84ee20f15ef980fb$var$pieceElementByKey(s, key) {
    let el = s.dom.elements.board.firstChild;
    while(el){
        if (el.cgKey === key && el.tagName === "PIECE") return el;
        el = el.nextSibling;
    }
    return;
}


function $edda395882a62460$export$4971bcc2704b21ab(state, keys) {
    state.exploding = {
        stage: 1,
        keys: keys
    };
    state.dom.redraw();
    setTimeout(()=>{
        $edda395882a62460$var$setStage(state, 2);
        setTimeout(()=>$edda395882a62460$var$setStage(state, undefined), 120);
    }, 120);
}
function $edda395882a62460$var$setStage(state, stage) {
    if (state.exploding) {
        if (stage) state.exploding.stage = stage;
        else state.exploding = undefined;
        state.dom.redraw();
    }
}


function $77723e179126bec6$export$b3571188c770cc5a(state, redrawAll) {
    function toggleOrientation() {
        $80f8b45278b0164a$export$e798007c48b456cd(state);
        redrawAll();
    }
    return {
        set (config) {
            if (config.orientation && config.orientation !== state.orientation) toggleOrientation();
            (0, $fe7eac34876cd925$export$d771543c4ed87064)(state, config);
            (config.fen ? (0, $b81ba4ea6c3c4676$export$bd46b8ab3689edc4) : (0, $b81ba4ea6c3c4676$export$b3890eb0ae9dca99))((state)=>(0, $fe7eac34876cd925$export$8d21e34596265fa2)(state, config), state);
        },
        state: state,
        getFen: ()=>(0, $f37f4d2e14067e5f$export$68d8715fc104d294)(state.pieces),
        toggleOrientation: toggleOrientation,
        setPieces (pieces) {
            (0, $b81ba4ea6c3c4676$export$bd46b8ab3689edc4)((state)=>$80f8b45278b0164a$export$20a063d1402ff7ff(state, pieces), state);
        },
        selectSquare (key, force) {
            if (key) (0, $b81ba4ea6c3c4676$export$bd46b8ab3689edc4)((state)=>$80f8b45278b0164a$export$6073914ea697a63e(state, key, force), state);
            else if (state.selected) {
                $80f8b45278b0164a$export$fe412c270a34f415(state);
                state.dom.redraw();
            }
        },
        move (orig, dest) {
            (0, $b81ba4ea6c3c4676$export$bd46b8ab3689edc4)((state)=>$80f8b45278b0164a$export$13f6ca6271343510(state, orig, dest), state);
        },
        newPiece (piece, key) {
            (0, $b81ba4ea6c3c4676$export$bd46b8ab3689edc4)((state)=>$80f8b45278b0164a$export$13886f9573facc29(state, piece, key), state);
        },
        playPremove () {
            if (state.premovable.current) {
                if ((0, $b81ba4ea6c3c4676$export$bd46b8ab3689edc4)($80f8b45278b0164a$export$d04320a93cdae73d, state)) return true;
                // if the premove couldn't be played, redraw to clear it up
                state.dom.redraw();
            }
            return false;
        },
        playPredrop (validate) {
            if (state.predroppable.current) {
                const result = $80f8b45278b0164a$export$8efa9460c0cedd9e(state, validate);
                state.dom.redraw();
                return result;
            }
            return false;
        },
        cancelPremove () {
            (0, $b81ba4ea6c3c4676$export$b3890eb0ae9dca99)($80f8b45278b0164a$export$f92a111f74a3f7c7, state);
        },
        cancelPredrop () {
            (0, $b81ba4ea6c3c4676$export$b3890eb0ae9dca99)($80f8b45278b0164a$export$9e6f418e5ea6b92c, state);
        },
        cancelMove () {
            (0, $b81ba4ea6c3c4676$export$b3890eb0ae9dca99)((state)=>{
                $80f8b45278b0164a$export$e47a3d6268102bb5(state);
                (0, $84ee20f15ef980fb$export$70b61ad426ddbe54)(state);
            }, state);
        },
        stop () {
            (0, $b81ba4ea6c3c4676$export$b3890eb0ae9dca99)((state)=>{
                $80f8b45278b0164a$export$fa6813432f753b0d(state);
                (0, $84ee20f15ef980fb$export$70b61ad426ddbe54)(state);
            }, state);
        },
        explode (keys) {
            (0, $edda395882a62460$export$4971bcc2704b21ab)(state, keys);
        },
        setAutoShapes (shapes) {
            (0, $b81ba4ea6c3c4676$export$b3890eb0ae9dca99)((state)=>state.drawable.autoShapes = shapes, state);
        },
        setShapes (shapes) {
            (0, $b81ba4ea6c3c4676$export$b3890eb0ae9dca99)((state)=>state.drawable.shapes = shapes, state);
        },
        getKeyAtDomPos (pos) {
            return $80f8b45278b0164a$export$102bdd581884418b(pos, $80f8b45278b0164a$export$970133fdf67d86cb(state), state.dom.bounds());
        },
        redrawAll: redrawAll,
        dragNewPiece (piece, event, force) {
            (0, $84ee20f15ef980fb$export$65771a6862d302e4)(state, piece, event, force);
        },
        destroy () {
            $80f8b45278b0164a$export$fa6813432f753b0d(state);
            state.dom.unbind && state.dom.unbind();
            state.dom.destroyed = true;
        }
    };
}





function $7b1d28100d027626$export$ebe90cb607ad99e() {
    return {
        pieces: $f37f4d2e14067e5f$export$aafa59e2e03f2942($f37f4d2e14067e5f$export$59ff82fc918bd7e3),
        orientation: "white",
        turnColor: "white",
        coordinates: true,
        ranksPosition: "right",
        autoCastle: true,
        viewOnly: false,
        disableContextMenu: false,
        addPieceZIndex: false,
        blockTouchScroll: false,
        pieceKey: false,
        trustAllEvents: false,
        highlight: {
            lastMove: true,
            check: true
        },
        animation: {
            enabled: true,
            duration: 200
        },
        movable: {
            free: true,
            color: "both",
            showDests: true,
            events: {},
            rookCastle: true
        },
        premovable: {
            enabled: true,
            showDests: true,
            castle: true,
            events: {}
        },
        predroppable: {
            enabled: false,
            events: {}
        },
        draggable: {
            enabled: true,
            distance: 3,
            autoDistance: true,
            showGhost: true,
            deleteOnDropOff: false
        },
        dropmode: {
            active: false
        },
        selectable: {
            enabled: true
        },
        stats: {
            // on touchscreen, default to "tap-tap" moves
            // instead of drag
            dragged: !("ontouchstart" in window)
        },
        events: {},
        drawable: {
            enabled: true,
            visible: true,
            defaultSnapToValidMove: true,
            eraseOnClick: true,
            shapes: [],
            autoShapes: [],
            brushes: {
                green: {
                    key: "g",
                    color: "#15781B",
                    opacity: 1,
                    lineWidth: 10
                },
                red: {
                    key: "r",
                    color: "#882020",
                    opacity: 1,
                    lineWidth: 10
                },
                blue: {
                    key: "b",
                    color: "#003088",
                    opacity: 1,
                    lineWidth: 10
                },
                yellow: {
                    key: "y",
                    color: "#e68f00",
                    opacity: 1,
                    lineWidth: 10
                },
                paleBlue: {
                    key: "pb",
                    color: "#003088",
                    opacity: 0.4,
                    lineWidth: 15
                },
                paleGreen: {
                    key: "pg",
                    color: "#15781B",
                    opacity: 0.4,
                    lineWidth: 15
                },
                paleRed: {
                    key: "pr",
                    color: "#882020",
                    opacity: 0.4,
                    lineWidth: 15
                },
                paleGrey: {
                    key: "pgr",
                    color: "#4a4a4a",
                    opacity: 0.35,
                    lineWidth: 15
                },
                purple: {
                    key: "purp",
                    color: "#68217a",
                    opacity: 0.65,
                    lineWidth: 10
                },
                pink: {
                    key: "pink",
                    color: "#ee2080",
                    opacity: 0.5,
                    lineWidth: 10
                },
                hilite: {
                    key: "hilite",
                    color: "#fff",
                    opacity: 1,
                    lineWidth: 1
                }
            },
            prevSvgHash: ""
        },
        hold: (0, $dbbfaf35dad95b1f$export$9dc4ecf953986f04)()
    };
}





function $3eabe156c0ff4c04$export$a529cedf94de8dc() {
    const defs = $3eabe156c0ff4c04$export$c8a8987d4410bf2d("defs");
    const filter = $3eabe156c0ff4c04$export$74da2cba014bdc09($3eabe156c0ff4c04$export$c8a8987d4410bf2d("filter"), {
        id: "cg-filter-blur"
    });
    filter.appendChild($3eabe156c0ff4c04$export$74da2cba014bdc09($3eabe156c0ff4c04$export$c8a8987d4410bf2d("feGaussianBlur"), {
        stdDeviation: "0.022"
    }));
    defs.appendChild(filter);
    return defs;
}
function $3eabe156c0ff4c04$export$fb80b1b7d7777ee5(state, shapesEl, customsEl) {
    var _a;
    const d = state.drawable, curD = d.current, cur = curD && curD.mouseSq ? curD : undefined, dests = new Map(), bounds = state.dom.bounds(), nonPieceAutoShapes = d.autoShapes.filter((autoShape)=>!autoShape.piece);
    for (const s of d.shapes.concat(nonPieceAutoShapes).concat(cur ? [
        cur
    ] : [])){
        if (!s.dest) continue;
        const sources = (_a = dests.get(s.dest)) !== null && _a !== void 0 ? _a : new Set(), from = $3eabe156c0ff4c04$var$pos2user($3eabe156c0ff4c04$var$orient((0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(s.orig), state.orientation), bounds), to = $3eabe156c0ff4c04$var$pos2user($3eabe156c0ff4c04$var$orient((0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(s.dest), state.orientation), bounds);
        sources.add($3eabe156c0ff4c04$var$moveAngle(from, to));
        dests.set(s.dest, sources);
    }
    const shapes = d.shapes.concat(nonPieceAutoShapes).map((s)=>{
        return {
            shape: s,
            current: false,
            hash: $3eabe156c0ff4c04$var$shapeHash(s, $3eabe156c0ff4c04$var$isShort(s.dest, dests), false, bounds)
        };
    });
    if (cur) shapes.push({
        shape: cur,
        current: true,
        hash: $3eabe156c0ff4c04$var$shapeHash(cur, $3eabe156c0ff4c04$var$isShort(cur.dest, dests), true, bounds)
    });
    const fullHash = shapes.map((sc)=>sc.hash).join(";");
    if (fullHash === state.drawable.prevSvgHash) return;
    state.drawable.prevSvgHash = fullHash;
    /*
      -- DOM hierarchy --
      <svg class="cg-shapes">      (<= svg)
        <defs>
          ...(for brushes)...
        </defs>
        <g>
          ...(for arrows and circles)...
        </g>
      </svg>
      <svg class="cg-custom-svgs"> (<= customSvg)
        <g>
          ...(for custom svgs)...
        </g>
      </svg>
    */ const defsEl = shapesEl.querySelector("defs");
    $3eabe156c0ff4c04$var$syncDefs(d, shapes, defsEl);
    $3eabe156c0ff4c04$var$syncShapes(shapes, shapesEl.querySelector("g"), customsEl.querySelector("g"), (s)=>$3eabe156c0ff4c04$var$renderShape(state, s, d.brushes, dests, bounds));
}
// append only. Don't try to update/remove.
function $3eabe156c0ff4c04$var$syncDefs(d, shapes, defsEl) {
    var _a;
    const brushes = new Map();
    let brush;
    for (const s of shapes.filter((s)=>s.shape.dest && s.shape.brush)){
        brush = $3eabe156c0ff4c04$var$makeCustomBrush(d.brushes[s.shape.brush], s.shape.modifiers);
        if ((_a = s.shape.modifiers) === null || _a === void 0 ? void 0 : _a.hilite) brushes.set("hilite", d.brushes["hilite"]);
        brushes.set(brush.key, brush);
    }
    const keysInDom = new Set();
    let el = defsEl.firstElementChild;
    while(el){
        keysInDom.add(el.getAttribute("cgKey"));
        el = el.nextElementSibling;
    }
    for (const [key, brush] of brushes.entries())if (!keysInDom.has(key)) defsEl.appendChild($3eabe156c0ff4c04$var$renderMarker(brush));
}
function $3eabe156c0ff4c04$var$syncShapes(syncables, shapes, customs, renderShape) {
    const hashesInDom = new Map();
    for (const sc of syncables)hashesInDom.set(sc.hash, false);
    for (const root of [
        shapes,
        customs
    ]){
        const toRemove = [];
        let el = root.firstElementChild, elHash;
        while(el){
            elHash = el.getAttribute("cgHash");
            if (hashesInDom.has(elHash)) hashesInDom.set(elHash, true);
            else toRemove.push(el);
            el = el.nextElementSibling;
        }
        for (const el of toRemove)root.removeChild(el);
    }
    // insert shapes that are not yet in dom
    for (const sc of syncables.filter((s)=>!hashesInDom.get(s.hash))){
        for (const svg of renderShape(sc))if (svg.isCustom) customs.appendChild(svg.el);
        else shapes.appendChild(svg.el);
    }
}
function $3eabe156c0ff4c04$var$shapeHash({ orig: orig, dest: dest, brush: brush, piece: piece, modifiers: modifiers, customSvg: customSvg, label: label }, shorten, current, bounds) {
    var _a, _b;
    // a shape and an overlay svg share a lifetime and have the same cgHash attribute
    return [
        bounds.width,
        bounds.height,
        current,
        orig,
        dest,
        brush,
        shorten && "-",
        piece && $3eabe156c0ff4c04$var$pieceHash(piece),
        modifiers && $3eabe156c0ff4c04$var$modifiersHash(modifiers),
        customSvg && `custom-${$3eabe156c0ff4c04$var$textHash(customSvg.html)},${(_b = (_a = customSvg.center) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : "o"}`,
        label && `label-${$3eabe156c0ff4c04$var$textHash(label.text)}`
    ].filter((x)=>x).join(",");
}
function $3eabe156c0ff4c04$var$pieceHash(piece) {
    return [
        piece.color,
        piece.role,
        piece.scale
    ].filter((x)=>x).join(",");
}
function $3eabe156c0ff4c04$var$modifiersHash(m) {
    return [
        m.lineWidth,
        m.hilite && "*"
    ].filter((x)=>x).join(",");
}
function $3eabe156c0ff4c04$var$textHash(s) {
    // Rolling hash with base 31 (cf. https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript)
    let h = 0;
    for(let i = 0; i < s.length; i++)h = (h << 5) - h + s.charCodeAt(i) >>> 0;
    return h.toString();
}
function $3eabe156c0ff4c04$var$renderShape(state, { shape: shape, current: current, hash: hash }, brushes, dests, bounds) {
    var _a, _b;
    const from = $3eabe156c0ff4c04$var$pos2user($3eabe156c0ff4c04$var$orient((0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(shape.orig), state.orientation), bounds), to = shape.dest ? $3eabe156c0ff4c04$var$pos2user($3eabe156c0ff4c04$var$orient((0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(shape.dest), state.orientation), bounds) : from, brush = shape.brush && $3eabe156c0ff4c04$var$makeCustomBrush(brushes[shape.brush], shape.modifiers), slots = dests.get(shape.dest), svgs = [];
    if (brush) {
        const el = $3eabe156c0ff4c04$export$74da2cba014bdc09($3eabe156c0ff4c04$export$c8a8987d4410bf2d("g"), {
            cgHash: hash
        });
        svgs.push({
            el: el
        });
        if (from[0] !== to[0] || from[1] !== to[1]) el.appendChild($3eabe156c0ff4c04$var$renderArrow(shape, brush, from, to, current, $3eabe156c0ff4c04$var$isShort(shape.dest, dests)));
        else el.appendChild($3eabe156c0ff4c04$var$renderCircle(brushes[shape.brush], from, current, bounds));
    }
    if (shape.label) {
        const label = shape.label;
        (_a = label.fill) !== null && _a !== void 0 ? _a : label.fill = shape.brush && brushes[shape.brush].color;
        const corner = shape.brush ? undefined : "tr";
        svgs.push({
            el: $3eabe156c0ff4c04$var$renderLabel(label, hash, from, to, slots, corner),
            isCustom: true
        });
    }
    if (shape.customSvg) {
        const on = (_b = shape.customSvg.center) !== null && _b !== void 0 ? _b : "orig";
        const [x, y] = on === "label" ? $3eabe156c0ff4c04$var$labelCoords(from, to, slots).map((c)=>c - 0.5) : on === "dest" ? to : from;
        const el = $3eabe156c0ff4c04$export$74da2cba014bdc09($3eabe156c0ff4c04$export$c8a8987d4410bf2d("g"), {
            transform: `translate(${x},${y})`,
            cgHash: hash
        });
        el.innerHTML = `<svg width="1" height="1" viewBox="0 0 100 100">${shape.customSvg.html}</svg>`;
        svgs.push({
            el: el,
            isCustom: true
        });
    }
    return svgs;
}
function $3eabe156c0ff4c04$var$renderCircle(brush, at, current, bounds) {
    const widths = $3eabe156c0ff4c04$var$circleWidth(), radius = (bounds.width + bounds.height) / (4 * Math.max(bounds.width, bounds.height));
    return $3eabe156c0ff4c04$export$74da2cba014bdc09($3eabe156c0ff4c04$export$c8a8987d4410bf2d("circle"), {
        stroke: brush.color,
        "stroke-width": widths[current ? 0 : 1],
        fill: "none",
        opacity: $3eabe156c0ff4c04$var$opacity(brush, current),
        cx: at[0],
        cy: at[1],
        r: radius - widths[1] / 2
    });
}
function $3eabe156c0ff4c04$var$renderArrow(s, brush, from, to, current, shorten) {
    var _a;
    function renderLine(isHilite) {
        var _a;
        const m = $3eabe156c0ff4c04$var$arrowMargin(shorten && !current), dx = to[0] - from[0], dy = to[1] - from[1], angle = Math.atan2(dy, dx), xo = Math.cos(angle) * m, yo = Math.sin(angle) * m;
        return $3eabe156c0ff4c04$export$74da2cba014bdc09($3eabe156c0ff4c04$export$c8a8987d4410bf2d("line"), {
            stroke: isHilite ? "white" : brush.color,
            "stroke-width": $3eabe156c0ff4c04$var$lineWidth(brush, current) + (isHilite ? 0.04 : 0),
            "stroke-linecap": "round",
            "marker-end": `url(#arrowhead-${isHilite ? "hilite" : brush.key})`,
            opacity: ((_a = s.modifiers) === null || _a === void 0 ? void 0 : _a.hilite) ? 1 : $3eabe156c0ff4c04$var$opacity(brush, current),
            x1: from[0],
            y1: from[1],
            x2: to[0] - xo,
            y2: to[1] - yo
        });
    }
    if (!((_a = s.modifiers) === null || _a === void 0 ? void 0 : _a.hilite)) return renderLine(false);
    const g = $3eabe156c0ff4c04$export$c8a8987d4410bf2d("g");
    const blurred = $3eabe156c0ff4c04$export$74da2cba014bdc09($3eabe156c0ff4c04$export$c8a8987d4410bf2d("g"), {
        filter: "url(#cg-filter-blur)"
    });
    blurred.appendChild($3eabe156c0ff4c04$var$filterBox(from, to));
    blurred.appendChild(renderLine(true));
    g.appendChild(blurred);
    g.appendChild(renderLine(false));
    return g;
}
function $3eabe156c0ff4c04$var$renderMarker(brush) {
    const marker = $3eabe156c0ff4c04$export$74da2cba014bdc09($3eabe156c0ff4c04$export$c8a8987d4410bf2d("marker"), {
        id: "arrowhead-" + brush.key,
        orient: "auto",
        overflow: "visible",
        markerWidth: 4,
        markerHeight: 4,
        refX: brush.key === "hilite" ? 1.86 : 2.05,
        refY: 2
    });
    marker.appendChild($3eabe156c0ff4c04$export$74da2cba014bdc09($3eabe156c0ff4c04$export$c8a8987d4410bf2d("path"), {
        d: "M0,0 V4 L3,2 Z",
        fill: brush.color
    }));
    marker.setAttribute("cgKey", brush.key);
    return marker;
}
function $3eabe156c0ff4c04$var$renderLabel(label, hash, from, to, slots, corner) {
    var _a;
    const labelSize = 0.4, fontSize = labelSize * 0.75 ** label.text.length, at = $3eabe156c0ff4c04$var$labelCoords(from, to, slots), cornerOff = corner === "tr" ? 0.4 : 0, g = $3eabe156c0ff4c04$export$74da2cba014bdc09($3eabe156c0ff4c04$export$c8a8987d4410bf2d("g"), {
        transform: `translate(${at[0] + cornerOff},${at[1] - cornerOff})`,
        cgHash: hash
    });
    g.appendChild($3eabe156c0ff4c04$export$74da2cba014bdc09($3eabe156c0ff4c04$export$c8a8987d4410bf2d("circle"), {
        r: labelSize / 2,
        "fill-opacity": corner ? 1.0 : 0.8,
        "stroke-opacity": corner ? 1.0 : 0.7,
        "stroke-width": 0.03,
        fill: (_a = label.fill) !== null && _a !== void 0 ? _a : "#666",
        stroke: "white"
    }));
    const labelEl = $3eabe156c0ff4c04$export$74da2cba014bdc09($3eabe156c0ff4c04$export$c8a8987d4410bf2d("text"), {
        "font-size": fontSize,
        "font-family": "Noto Sans",
        "text-anchor": "middle",
        fill: "white",
        y: 0.13 * 0.75 ** label.text.length
    });
    labelEl.innerHTML = label.text;
    g.appendChild(labelEl);
    return g;
}
function $3eabe156c0ff4c04$var$orient(pos, color) {
    return color === "white" ? pos : [
        7 - pos[0],
        7 - pos[1]
    ];
}
function $3eabe156c0ff4c04$var$isShort(dest, dests) {
    return true === (dest && dests.has(dest) && dests.get(dest).size > 1);
}
function $3eabe156c0ff4c04$export$c8a8987d4410bf2d(tagName) {
    return document.createElementNS("http://www.w3.org/2000/svg", tagName);
}
function $3eabe156c0ff4c04$export$74da2cba014bdc09(el, attrs) {
    for(const key in attrs)if (Object.prototype.hasOwnProperty.call(attrs, key)) el.setAttribute(key, attrs[key]);
    return el;
}
function $3eabe156c0ff4c04$var$makeCustomBrush(base, modifiers) {
    return !modifiers ? base : {
        color: base.color,
        opacity: Math.round(base.opacity * 10) / 10,
        lineWidth: Math.round(modifiers.lineWidth || base.lineWidth),
        key: [
            base.key,
            modifiers.lineWidth
        ].filter((x)=>x).join("")
    };
}
function $3eabe156c0ff4c04$var$circleWidth() {
    return [
        3 / 64,
        4 / 64
    ];
}
function $3eabe156c0ff4c04$var$lineWidth(brush, current) {
    return (brush.lineWidth || 10) * (current ? 0.85 : 1) / 64;
}
function $3eabe156c0ff4c04$var$opacity(brush, current) {
    return (brush.opacity || 1) * (current ? 0.9 : 1);
}
function $3eabe156c0ff4c04$var$arrowMargin(shorten) {
    return (shorten ? 20 : 10) / 64;
}
function $3eabe156c0ff4c04$var$pos2user(pos, bounds) {
    const xScale = Math.min(1, bounds.width / bounds.height);
    const yScale = Math.min(1, bounds.height / bounds.width);
    return [
        (pos[0] - 3.5) * xScale,
        (3.5 - pos[1]) * yScale
    ];
}
function $3eabe156c0ff4c04$var$filterBox(from, to) {
    // lines/arrows are considered to be one dimensional for the purposes of SVG filters,
    // so we add a transparent bounding box to ensure they apply to the 2nd dimension
    const box = {
        from: [
            Math.floor(Math.min(from[0], to[0])),
            Math.floor(Math.min(from[1], to[1]))
        ],
        to: [
            Math.ceil(Math.max(from[0], to[0])),
            Math.ceil(Math.max(from[1], to[1]))
        ]
    };
    return $3eabe156c0ff4c04$export$74da2cba014bdc09($3eabe156c0ff4c04$export$c8a8987d4410bf2d("rect"), {
        x: box.from[0],
        y: box.from[1],
        width: box.to[0] - box.from[0],
        height: box.to[1] - box.from[1],
        fill: "none",
        stroke: "none"
    });
}
function $3eabe156c0ff4c04$var$moveAngle(from, to, asSlot = true) {
    const angle = Math.atan2(to[1] - from[1], to[0] - from[0]) + Math.PI;
    return asSlot ? (Math.round(angle * 8 / Math.PI) + 16) % 16 : angle;
}
function $3eabe156c0ff4c04$var$dist(from, to) {
    return Math.sqrt([
        from[0] - to[0],
        from[1] - to[1]
    ].reduce((acc, x)=>acc + x * x, 0));
}
/*
 try to place label at the junction of the destination shaft and arrowhead. if there's more than
 1 arrow pointing to a square, the arrow shortens by 10 / 64 units so the label must move as well.
 
 if the angle between two incoming arrows is pi / 8, such as when an adjacent knight and bishop
 attack the same square, the knight's label is slid further down the shaft by an amount equal to
 our label size to avoid collision
*/ function $3eabe156c0ff4c04$var$labelCoords(from, to, slots) {
    let mag = $3eabe156c0ff4c04$var$dist(from, to);
    //if (mag === 0) return [from[0], from[1]];
    const angle = $3eabe156c0ff4c04$var$moveAngle(from, to, false);
    if (slots) {
        mag -= 33 / 64; // reduce by arrowhead length
        if (slots.size > 1) {
            mag -= 10 / 64; // reduce by shortening factor
            const slot = $3eabe156c0ff4c04$var$moveAngle(from, to);
            if (slots.has((slot + 1) % 16) || slots.has((slot + 15) % 16)) {
                if (slot & 1) mag -= 0.4;
            }
        }
    }
    return [
        from[0] - Math.cos(angle) * mag,
        from[1] - Math.sin(angle) * mag
    ].map((c)=>c + 0.5);
}


function $0a27377e74afbcfd$export$79188534738a92bf(element, s) {
    // .cg-wrap (element passed to Chessground)
    //   cg-container
    //     cg-board
    //     svg.cg-shapes
    //       defs
    //       g
    //     svg.cg-custom-svgs
    //       g
    //     cg-auto-pieces
    //     coords.ranks
    //     coords.files
    //     piece.ghost
    element.innerHTML = "";
    // ensure the cg-wrap class is set
    // so bounds calculation can use the CSS width/height values
    // add that class yourself to the element before calling chessground
    // for a slight performance improvement! (avoids recomputing style)
    element.classList.add("cg-wrap");
    for (const c of (0, $f00dad157732f88c$export$8f45430ccf837300))element.classList.toggle("orientation-" + c, s.orientation === c);
    element.classList.toggle("manipulable", !s.viewOnly);
    const container = (0, $dbbfaf35dad95b1f$export$3d7cd8ed57263b30)("cg-container");
    element.appendChild(container);
    const board = (0, $dbbfaf35dad95b1f$export$3d7cd8ed57263b30)("cg-board");
    container.appendChild(board);
    let svg;
    let customSvg;
    let autoPieces;
    if (s.drawable.visible) {
        svg = (0, $3eabe156c0ff4c04$export$74da2cba014bdc09)((0, $3eabe156c0ff4c04$export$c8a8987d4410bf2d)("svg"), {
            class: "cg-shapes",
            viewBox: "-4 -4 8 8",
            preserveAspectRatio: "xMidYMid slice"
        });
        svg.appendChild((0, $3eabe156c0ff4c04$export$a529cedf94de8dc)());
        svg.appendChild((0, $3eabe156c0ff4c04$export$c8a8987d4410bf2d)("g"));
        customSvg = (0, $3eabe156c0ff4c04$export$74da2cba014bdc09)((0, $3eabe156c0ff4c04$export$c8a8987d4410bf2d)("svg"), {
            class: "cg-custom-svgs",
            viewBox: "-3.5 -3.5 8 8",
            preserveAspectRatio: "xMidYMid slice"
        });
        customSvg.appendChild((0, $3eabe156c0ff4c04$export$c8a8987d4410bf2d)("g"));
        autoPieces = (0, $dbbfaf35dad95b1f$export$3d7cd8ed57263b30)("cg-auto-pieces");
        container.appendChild(svg);
        container.appendChild(customSvg);
        container.appendChild(autoPieces);
    }
    if (s.coordinates) {
        const orientClass = s.orientation === "black" ? " black" : "";
        const ranksPositionClass = s.ranksPosition === "left" ? " left" : "";
        container.appendChild($0a27377e74afbcfd$var$renderCoords((0, $f00dad157732f88c$export$d8e4e3952f325c95), "ranks" + orientClass + ranksPositionClass));
        container.appendChild($0a27377e74afbcfd$var$renderCoords((0, $f00dad157732f88c$export$3a444357c5f65f65), "files" + orientClass));
    }
    let ghost;
    if (s.draggable.enabled && s.draggable.showGhost) {
        ghost = (0, $dbbfaf35dad95b1f$export$3d7cd8ed57263b30)("piece", "ghost");
        (0, $dbbfaf35dad95b1f$export$8cb512849e51eaf5)(ghost, false);
        container.appendChild(ghost);
    }
    return {
        board: board,
        container: container,
        wrap: element,
        ghost: ghost,
        svg: svg,
        customSvg: customSvg,
        autoPieces: autoPieces
    };
}
function $0a27377e74afbcfd$var$renderCoords(elems, className) {
    const el = (0, $dbbfaf35dad95b1f$export$3d7cd8ed57263b30)("coords", className);
    let f;
    for (const elem of elems){
        f = (0, $dbbfaf35dad95b1f$export$3d7cd8ed57263b30)("coord");
        f.textContent = elem;
        el.appendChild(f);
    }
    return el;
}







function $de1bc8749e875bbb$export$af7814416196c9de(s, piece) {
    s.dropmode = {
        active: true,
        piece: piece
    };
    (0, $84ee20f15ef980fb$export$70b61ad426ddbe54)(s);
}
function $de1bc8749e875bbb$export$3bf31ae3228aa49e(s) {
    s.dropmode = {
        active: false
    };
}
function $de1bc8749e875bbb$export$663103110d94aac9(s, e) {
    if (!s.dropmode.active) return;
    $80f8b45278b0164a$export$f92a111f74a3f7c7(s);
    $80f8b45278b0164a$export$9e6f418e5ea6b92c(s);
    const piece = s.dropmode.piece;
    if (piece) {
        s.pieces.set("a0", piece);
        const position = $dbbfaf35dad95b1f$export$33052595192f7117(e);
        const dest = position && $80f8b45278b0164a$export$102bdd581884418b(position, $80f8b45278b0164a$export$970133fdf67d86cb(s), s.dom.bounds());
        if (dest) $80f8b45278b0164a$export$b2b9f46b948033b0(s, "a0", dest);
    }
    s.dom.redraw();
}



function $2d15ce003fd0519b$export$fc48d2ed06541843(s, onResize) {
    const boardEl = s.dom.elements.board;
    if ("ResizeObserver" in window) new ResizeObserver(onResize).observe(s.dom.elements.wrap);
    if (s.disableContextMenu || s.drawable.enabled) boardEl.addEventListener("contextmenu", (e)=>e.preventDefault());
    if (s.viewOnly) return;
    // Cannot be passive, because we prevent touch scrolling and dragging of
    // selected elements.
    const onStart = $2d15ce003fd0519b$var$startDragOrDraw(s);
    boardEl.addEventListener("touchstart", onStart, {
        passive: false
    });
    boardEl.addEventListener("mousedown", onStart, {
        passive: false
    });
}
function $2d15ce003fd0519b$export$fdc77453278b0fa9(s, onResize) {
    const unbinds = [];
    // Old versions of Edge and Safari do not support ResizeObserver. Send
    // chessground.resize if a user action has changed the bounds of the board.
    if (!("ResizeObserver" in window)) unbinds.push($2d15ce003fd0519b$var$unbindable(document.body, "chessground.resize", onResize));
    if (!s.viewOnly) {
        const onmove = $2d15ce003fd0519b$var$dragOrDraw(s, $84ee20f15ef980fb$export$d947e5f4f4c48d48, $7a42cea72ae7e4e6$export$d947e5f4f4c48d48);
        const onend = $2d15ce003fd0519b$var$dragOrDraw(s, $84ee20f15ef980fb$export$bd5df0f255a350f8, $7a42cea72ae7e4e6$export$bd5df0f255a350f8);
        for (const ev of [
            "touchmove",
            "mousemove"
        ])unbinds.push($2d15ce003fd0519b$var$unbindable(document, ev, onmove));
        for (const ev of [
            "touchend",
            "mouseup"
        ])unbinds.push($2d15ce003fd0519b$var$unbindable(document, ev, onend));
        const onScroll = ()=>s.dom.bounds.clear();
        unbinds.push($2d15ce003fd0519b$var$unbindable(document, "scroll", onScroll, {
            capture: true,
            passive: true
        }));
        unbinds.push($2d15ce003fd0519b$var$unbindable(window, "resize", onScroll, {
            passive: true
        }));
    }
    return ()=>unbinds.forEach((f)=>f());
}
function $2d15ce003fd0519b$var$unbindable(el, eventName, callback, options) {
    el.addEventListener(eventName, callback, options);
    return ()=>el.removeEventListener(eventName, callback, options);
}
const $2d15ce003fd0519b$var$startDragOrDraw = (s)=>(e)=>{
        if (s.draggable.current) $84ee20f15ef980fb$export$70b61ad426ddbe54(s);
        else if (s.drawable.current) $7a42cea72ae7e4e6$export$70b61ad426ddbe54(s);
        else if (e.shiftKey || (0, $dbbfaf35dad95b1f$export$947a472b5b3020ba)(e)) {
            if (s.drawable.enabled) $7a42cea72ae7e4e6$export$b3571188c770cc5a(s, e);
        } else if (!s.viewOnly) {
            if (s.dropmode.active) (0, $de1bc8749e875bbb$export$663103110d94aac9)(s, e);
            else $84ee20f15ef980fb$export$b3571188c770cc5a(s, e);
        }
    };
const $2d15ce003fd0519b$var$dragOrDraw = (s, withDrag, withDraw)=>(e)=>{
        if (s.drawable.current) {
            if (s.drawable.enabled) withDraw(s, e);
        } else if (!s.viewOnly) withDrag(s, e);
    };




function $c28505726f0fb896$export$b3890eb0ae9dca99(s) {
    const asWhite = (0, $80f8b45278b0164a$export$970133fdf67d86cb)(s), posToTranslate = (0, $dbbfaf35dad95b1f$export$2135ad75550a2ff4)(s.dom.bounds()), boardEl = s.dom.elements.board, pieces = s.pieces, curAnim = s.animation.current, anims = curAnim ? curAnim.plan.anims : new Map(), fadings = curAnim ? curAnim.plan.fadings : new Map(), curDrag = s.draggable.current, squares = $c28505726f0fb896$var$computeSquareClasses(s), samePieces = new Set(), sameSquares = new Set(), movedPieces = new Map(), movedSquares = new Map(); // by class name
    let k, el, pieceAtKey, elPieceName, anim, fading, pMvdset, pMvd, sMvdset, sMvd;
    // walk over all board dom elements, apply animations and flag moved pieces
    el = boardEl.firstChild;
    while(el){
        k = el.cgKey;
        if ($c28505726f0fb896$var$isPieceNode(el)) {
            pieceAtKey = pieces.get(k);
            anim = anims.get(k);
            fading = fadings.get(k);
            elPieceName = el.cgPiece;
            // if piece not being dragged anymore, remove dragging style
            if (el.cgDragging && (!curDrag || curDrag.orig !== k)) {
                el.classList.remove("dragging");
                (0, $dbbfaf35dad95b1f$export$d73ee8ef04f5226a)(el, posToTranslate((0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(k), asWhite));
                el.cgDragging = false;
            }
            // remove fading class if it still remains
            if (!fading && el.cgFading) {
                el.cgFading = false;
                el.classList.remove("fading");
            }
            // there is now a piece at this dom key
            if (pieceAtKey) {
                // continue animation if already animating and same piece
                // (otherwise it could animate a captured piece)
                if (anim && el.cgAnimating && elPieceName === $c28505726f0fb896$var$pieceNameOf(pieceAtKey)) {
                    const pos = (0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(k);
                    pos[0] += anim[2];
                    pos[1] += anim[3];
                    el.classList.add("anim");
                    (0, $dbbfaf35dad95b1f$export$d73ee8ef04f5226a)(el, posToTranslate(pos, asWhite));
                } else if (el.cgAnimating) {
                    el.cgAnimating = false;
                    el.classList.remove("anim");
                    (0, $dbbfaf35dad95b1f$export$d73ee8ef04f5226a)(el, posToTranslate((0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(k), asWhite));
                    if (s.addPieceZIndex) el.style.zIndex = $c28505726f0fb896$var$posZIndex((0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(k), asWhite);
                }
                // same piece: flag as same
                if (elPieceName === $c28505726f0fb896$var$pieceNameOf(pieceAtKey) && (!fading || !el.cgFading)) samePieces.add(k);
                else if (fading && elPieceName === $c28505726f0fb896$var$pieceNameOf(fading)) {
                    el.classList.add("fading");
                    el.cgFading = true;
                } else $c28505726f0fb896$var$appendValue(movedPieces, elPieceName, el);
            } else $c28505726f0fb896$var$appendValue(movedPieces, elPieceName, el);
        } else if ($c28505726f0fb896$var$isSquareNode(el)) {
            const cn = el.className;
            if (squares.get(k) === cn) sameSquares.add(k);
            else $c28505726f0fb896$var$appendValue(movedSquares, cn, el);
        }
        el = el.nextSibling;
    }
    // walk over all squares in current set, apply dom changes to moved squares
    // or append new squares
    for (const [sk, className] of squares)if (!sameSquares.has(sk)) {
        sMvdset = movedSquares.get(className);
        sMvd = sMvdset && sMvdset.pop();
        const translation = posToTranslate((0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(sk), asWhite);
        if (sMvd) {
            sMvd.cgKey = sk;
            (0, $dbbfaf35dad95b1f$export$d73ee8ef04f5226a)(sMvd, translation);
        } else {
            const squareNode = (0, $dbbfaf35dad95b1f$export$3d7cd8ed57263b30)("square", className);
            squareNode.cgKey = sk;
            (0, $dbbfaf35dad95b1f$export$d73ee8ef04f5226a)(squareNode, translation);
            boardEl.insertBefore(squareNode, boardEl.firstChild);
        }
    }
    // walk over all pieces in current set, apply dom changes to moved pieces
    // or append new pieces
    for (const [k, p] of pieces){
        anim = anims.get(k);
        if (!samePieces.has(k)) {
            pMvdset = movedPieces.get($c28505726f0fb896$var$pieceNameOf(p));
            pMvd = pMvdset && pMvdset.pop();
            // a same piece was moved
            if (pMvd) {
                // apply dom changes
                pMvd.cgKey = k;
                if (pMvd.cgFading) {
                    pMvd.classList.remove("fading");
                    pMvd.cgFading = false;
                }
                const pos = (0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(k);
                if (s.addPieceZIndex) pMvd.style.zIndex = $c28505726f0fb896$var$posZIndex(pos, asWhite);
                if (anim) {
                    pMvd.cgAnimating = true;
                    pMvd.classList.add("anim");
                    pos[0] += anim[2];
                    pos[1] += anim[3];
                }
                (0, $dbbfaf35dad95b1f$export$d73ee8ef04f5226a)(pMvd, posToTranslate(pos, asWhite));
            } else {
                const pieceName = $c28505726f0fb896$var$pieceNameOf(p), pieceNode = (0, $dbbfaf35dad95b1f$export$3d7cd8ed57263b30)("piece", pieceName), pos = (0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(k);
                pieceNode.cgPiece = pieceName;
                pieceNode.cgKey = k;
                if (anim) {
                    pieceNode.cgAnimating = true;
                    pos[0] += anim[2];
                    pos[1] += anim[3];
                }
                (0, $dbbfaf35dad95b1f$export$d73ee8ef04f5226a)(pieceNode, posToTranslate(pos, asWhite));
                if (s.addPieceZIndex) pieceNode.style.zIndex = $c28505726f0fb896$var$posZIndex(pos, asWhite);
                boardEl.appendChild(pieceNode);
            }
        }
    }
    // remove any element that remains in the moved sets
    for (const nodes of movedPieces.values())$c28505726f0fb896$var$removeNodes(s, nodes);
    for (const nodes of movedSquares.values())$c28505726f0fb896$var$removeNodes(s, nodes);
}
function $c28505726f0fb896$export$d62f185fd39aa98c(s) {
    const asWhite = (0, $80f8b45278b0164a$export$970133fdf67d86cb)(s), posToTranslate = (0, $dbbfaf35dad95b1f$export$2135ad75550a2ff4)(s.dom.bounds());
    let el = s.dom.elements.board.firstChild;
    while(el){
        if ($c28505726f0fb896$var$isPieceNode(el) && !el.cgAnimating || $c28505726f0fb896$var$isSquareNode(el)) (0, $dbbfaf35dad95b1f$export$d73ee8ef04f5226a)(el, posToTranslate((0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(el.cgKey), asWhite));
        el = el.nextSibling;
    }
}
function $c28505726f0fb896$export$f4467a4f41373bc7(s) {
    var _a, _b;
    const bounds = s.dom.elements.wrap.getBoundingClientRect();
    const container = s.dom.elements.container;
    const ratio = bounds.height / bounds.width;
    const width = Math.floor(bounds.width * window.devicePixelRatio / 8) * 8 / window.devicePixelRatio;
    const height = width * ratio;
    container.style.width = width + "px";
    container.style.height = height + "px";
    s.dom.bounds.clear();
    (_a = s.addDimensionsCssVarsTo) === null || _a === void 0 || _a.style.setProperty("--cg-width", width + "px");
    (_b = s.addDimensionsCssVarsTo) === null || _b === void 0 || _b.style.setProperty("--cg-height", height + "px");
}
const $c28505726f0fb896$var$isPieceNode = (el)=>el.tagName === "PIECE";
const $c28505726f0fb896$var$isSquareNode = (el)=>el.tagName === "SQUARE";
function $c28505726f0fb896$var$removeNodes(s, nodes) {
    for (const node of nodes)s.dom.elements.board.removeChild(node);
}
function $c28505726f0fb896$var$posZIndex(pos, asWhite) {
    const minZ = 3;
    const rank = pos[1];
    const z = asWhite ? minZ + 7 - rank : minZ + rank;
    return `${z}`;
}
const $c28505726f0fb896$var$pieceNameOf = (piece)=>`${piece.color} ${piece.role}`;
function $c28505726f0fb896$var$computeSquareClasses(s) {
    var _a, _b, _c;
    const squares = new Map();
    if (s.lastMove && s.highlight.lastMove) for (const k of s.lastMove)$c28505726f0fb896$var$addSquare(squares, k, "last-move");
    if (s.check && s.highlight.check) $c28505726f0fb896$var$addSquare(squares, s.check, "check");
    if (s.selected) {
        $c28505726f0fb896$var$addSquare(squares, s.selected, "selected");
        if (s.movable.showDests) {
            const dests = (_a = s.movable.dests) === null || _a === void 0 ? void 0 : _a.get(s.selected);
            if (dests) for (const k of dests)$c28505726f0fb896$var$addSquare(squares, k, "move-dest" + (s.pieces.has(k) ? " oc" : ""));
            const pDests = (_c = (_b = s.premovable.customDests) === null || _b === void 0 ? void 0 : _b.get(s.selected)) !== null && _c !== void 0 ? _c : s.premovable.dests;
            if (pDests) for (const k of pDests)$c28505726f0fb896$var$addSquare(squares, k, "premove-dest" + (s.pieces.has(k) ? " oc" : ""));
        }
    }
    const premove = s.premovable.current;
    if (premove) for (const k of premove)$c28505726f0fb896$var$addSquare(squares, k, "current-premove");
    else if (s.predroppable.current) $c28505726f0fb896$var$addSquare(squares, s.predroppable.current.key, "current-premove");
    const o = s.exploding;
    if (o) for (const k of o.keys)$c28505726f0fb896$var$addSquare(squares, k, "exploding" + o.stage);
    if (s.highlight.custom) s.highlight.custom.forEach((v, k)=>{
        $c28505726f0fb896$var$addSquare(squares, k, v);
    });
    return squares;
}
function $c28505726f0fb896$var$addSquare(squares, key, klass) {
    const classes = squares.get(key);
    if (classes) squares.set(key, `${classes} ${klass}`);
    else squares.set(key, klass);
}
function $c28505726f0fb896$var$appendValue(map, key, value) {
    const arr = map.get(key);
    if (arr) arr.push(value);
    else map.set(key, [
        value
    ]);
}




// append and remove only. No updates.
function $f6a46b1a152048c7$export$eb48cb918245ce33(shapes, root, renderShape) {
    const hashesInDom = new Map(), toRemove = [];
    for (const sc of shapes)hashesInDom.set(sc.hash, false);
    let el = root.firstElementChild, elHash;
    while(el){
        elHash = el.getAttribute("cgHash");
        // found a shape element that's here to stay
        if (hashesInDom.has(elHash)) hashesInDom.set(elHash, true);
        else toRemove.push(el);
        el = el.nextElementSibling;
    }
    // remove old shapes
    for (const el of toRemove)root.removeChild(el);
    // insert shapes that are not yet in dom
    for (const sc of shapes)if (!hashesInDom.get(sc.hash)) root.appendChild(renderShape(sc));
}


function $df86554080128aa6$export$b3890eb0ae9dca99(state, autoPieceEl) {
    const autoPieces = state.drawable.autoShapes.filter((autoShape)=>autoShape.piece);
    const autoPieceShapes = autoPieces.map((s)=>{
        return {
            shape: s,
            hash: $df86554080128aa6$var$hash(s),
            current: false
        };
    });
    (0, $f6a46b1a152048c7$export$eb48cb918245ce33)(autoPieceShapes, autoPieceEl, (shape)=>$df86554080128aa6$var$renderShape(state, shape, state.dom.bounds()));
}
function $df86554080128aa6$export$d62f185fd39aa98c(state) {
    var _a;
    const asWhite = (0, $80f8b45278b0164a$export$970133fdf67d86cb)(state), posToTranslate = (0, $dbbfaf35dad95b1f$export$2135ad75550a2ff4)(state.dom.bounds());
    let el = (_a = state.dom.elements.autoPieces) === null || _a === void 0 ? void 0 : _a.firstChild;
    while(el){
        (0, $dbbfaf35dad95b1f$export$f8afaca97e230dc6)(el, posToTranslate((0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(el.cgKey), asWhite), el.cgScale);
        el = el.nextSibling;
    }
}
function $df86554080128aa6$var$renderShape(state, { shape: shape, hash: hash }, bounds) {
    var _a, _b, _c;
    const orig = shape.orig;
    const role = (_a = shape.piece) === null || _a === void 0 ? void 0 : _a.role;
    const color = (_b = shape.piece) === null || _b === void 0 ? void 0 : _b.color;
    const scale = (_c = shape.piece) === null || _c === void 0 ? void 0 : _c.scale;
    const pieceEl = (0, $dbbfaf35dad95b1f$export$3d7cd8ed57263b30)("piece", `${role} ${color}`);
    pieceEl.setAttribute("cgHash", hash);
    pieceEl.cgKey = orig;
    pieceEl.cgScale = scale;
    (0, $dbbfaf35dad95b1f$export$f8afaca97e230dc6)(pieceEl, (0, $dbbfaf35dad95b1f$export$2135ad75550a2ff4)(bounds)((0, $dbbfaf35dad95b1f$export$e2878eba51f22d11)(orig), (0, $80f8b45278b0164a$export$970133fdf67d86cb)(state)), scale);
    return pieceEl;
}
const $df86554080128aa6$var$hash = (autoPiece)=>{
    var _a, _b, _c;
    return [
        autoPiece.orig,
        (_a = autoPiece.piece) === null || _a === void 0 ? void 0 : _a.role,
        (_b = autoPiece.piece) === null || _b === void 0 ? void 0 : _b.color,
        (_c = autoPiece.piece) === null || _c === void 0 ? void 0 : _c.scale
    ].join(",");
};




function $ea2d34c1974d7d8b$export$7e59435764664c61({ el: el, config: config }) {
    return $ea2d34c1974d7d8b$export$6aaf0e4db08ad996(el, config);
}
function $ea2d34c1974d7d8b$export$6aaf0e4db08ad996(element, config) {
    const maybeState = (0, $7b1d28100d027626$export$ebe90cb607ad99e)();
    (0, $fe7eac34876cd925$export$8d21e34596265fa2)(maybeState, config || {});
    function redrawAll() {
        const prevUnbind = "dom" in maybeState ? maybeState.dom.unbind : undefined;
        // compute bounds from existing board element if possible
        // this allows non-square boards from CSS to be handled (for 3D)
        const elements = (0, $0a27377e74afbcfd$export$79188534738a92bf)(element, maybeState), bounds = $dbbfaf35dad95b1f$export$7c73462e0d25e514(()=>elements.board.getBoundingClientRect()), redrawNow = (skipSvg)=>{
            (0, $c28505726f0fb896$export$b3890eb0ae9dca99)(state);
            if (elements.autoPieces) $df86554080128aa6$export$b3890eb0ae9dca99(state, elements.autoPieces);
            if (!skipSvg && elements.svg) $3eabe156c0ff4c04$export$fb80b1b7d7777ee5(state, elements.svg, elements.customSvg);
        }, onResize = ()=>{
            (0, $c28505726f0fb896$export$f4467a4f41373bc7)(state);
            (0, $c28505726f0fb896$export$d62f185fd39aa98c)(state);
            if (elements.autoPieces) $df86554080128aa6$export$d62f185fd39aa98c(state);
        };
        const state = maybeState;
        state.dom = {
            elements: elements,
            bounds: bounds,
            redraw: $ea2d34c1974d7d8b$var$debounceRedraw(redrawNow),
            redrawNow: redrawNow,
            unbind: prevUnbind
        };
        state.drawable.prevSvgHash = "";
        (0, $c28505726f0fb896$export$f4467a4f41373bc7)(state);
        redrawNow(false);
        $2d15ce003fd0519b$export$fc48d2ed06541843(state, onResize);
        if (!prevUnbind) state.dom.unbind = $2d15ce003fd0519b$export$fdc77453278b0fa9(state, onResize);
        state.events.insert && state.events.insert(elements);
        return state;
    }
    return (0, $77723e179126bec6$export$b3571188c770cc5a)(redrawAll(), redrawAll);
}
function $ea2d34c1974d7d8b$var$debounceRedraw(redrawNow) {
    let redrawing = false;
    return ()=>{
        if (redrawing) return;
        redrawing = true;
        requestAnimationFrame(()=>{
            redrawNow();
            redrawing = false;
        });
    };
}








const $497352f3986651c5$export$dc537a3a3893548e = (state, actions)=>({
        oncreate: (vnode)=>{
            state.ground = new (0, $ea2d34c1974d7d8b$export$6aaf0e4db08ad996)(vnode.dom, vnode.attrs.config);
        },
        view: (vnode)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".board", {
                class: vnode.attrs.class,
                onclick: vnode.attrs.onclick
            })
    });






var $3fb93ee33dbcb2eb$exports = {};
$3fb93ee33dbcb2eb$exports = new URL("lichess-logo.b7315f1b.svg", import.meta.url).toString();


var $ba7e2aeed18d820e$exports = {};
$ba7e2aeed18d820e$exports = new URL("lichess-logo-white.06acad04.svg", import.meta.url).toString();


const $6ed1fb4f245a8c05$export$d0d76c231f6d55bd = (state, actions)=>({
        getGames: async ()=>{
            state.stream = await state.auth.openStream("/api/stream/event", {}, (msg)=>{
                console.log("got game stream msg", msg);
                switch(msg.type){
                    case "gameStart":
                        let games = state.games();
                        games.push(msg.game);
                        state.games(games);
                        if (games.length == 1) {
                            console.log("one active game. loading now!");
                            state.game = games[0];
                        }
                        break;
                    case "gameFinish":
                        state.games(state.games().filter((g)=>g.gameId != msg.game.gameId));
                        break;
                    case "challenge":
                        break;
                    case "challengeCanceled":
                        break;
                    case "challengeDeclined":
                        break;
                }
            });
        }
    });
const $6ed1fb4f245a8c05$export$e5446db5f37b1855 = (state, game)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(game.isMyTurn ? ".gamethumb.myturn" : ".gamethumb", {}, [
        game.opponent.username,
        (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))((0, $497352f3986651c5$export$dc537a3a3893548e), {
            class: "thumb",
            config: {
                fen: game.fen,
                viewOnly: true,
                orientation: game.color,
                lastMove: [
                    game.lastMove.slice(0, 2),
                    game.lastMove.slice(2)
                ]
            },
            onclick: (e)=>{
                console.log("game clicked", game);
                state.game = game;
                state.opponent = game.opponent;
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.set("/online", {
                    id: game.gameId
                });
            }
        })
    ]);
const $6ed1fb4f245a8c05$export$93fd0e768dbd3f80 = (state, actions)=>{
    let listener;
    return {
        listener: null,
        oninit: (vnode)=>{
            if (!state.loggedIn()) (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.set("/login");
            state.invert(false);
            let games = state.games();
            console.log("games", games);
            state.games(games);
            if (state.input) {
                listener = state.input.addListener("noteon", "all", (message)=>{
                    console.log("connector got message", message);
                    let n = actions.launchToN(message.data[1]);
                    /* n is 0-63, but represented bottom to top.
        We need to invert the row to make it read top to bottom, left to right. */ let g = n % 8 + (7 - Math.floor(n / 8)) * 8;
                    console.log("selected game", g);
                    if (g < games.length) (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.set("/online", {
                        id: games[g].gameId
                    });
                });
                games.map((g, i)=>{
                    let note = g.isMyTurn ? (0, $9066c94fd6c8e22f$export$9dae6f82820323cf) | 2 : (0, $9066c94fd6c8e22f$export$9dae6f82820323cf);
                    /* Invert the row to get buttons to go top to bottom. */ let n = i % 8 + 8 * (7 - Math.floor(i / 8));
                    let l = actions.nToLaunch(n);
                    console.log("sending", g, i, l);
                    actions.send(note, [
                        l,
                        g.color == "white" ? 15 : 83
                    ]);
                });
                actions.clearAnimations();
                actions.clear();
                actions.send((0, $9066c94fd6c8e22f$export$9dae6f82820323cf), [
                    state.top[state.top.length - 1],
                    (0, $9066c94fd6c8e22f$export$56d196d2844d1ca1)["q"]
                ]);
            }
            if (games.length == 1) {
                console.log("one active game. loading now!");
                state.game = games[0];
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.set("/online", {
                    id: state.game.gameId
                });
            }
        },
        onremove: (vnode)=>{
            if (state.input) state.input.removeListener(listener);
        },
        view: (vnode)=>[
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".toolbar", {}, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("i.material-icons", {
                        onclick: actions.getGames
                    }, "refresh"),
                    (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("a.inline", {
                        href: "https://lichess.org/?any#ai",
                        target: "_blank"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("i.material-icons", {
                        title: "create new game on Lichess.com"
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("img.svgicon", {
                        src: state.theme == "dark" ? (0, (/*@__PURE__*/$parcel$interopDefault($ba7e2aeed18d820e$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($3fb93ee33dbcb2eb$exports)))
                    })))
                ]),
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".selector", {}, [
                    state.games().map((g)=>{
                        return $6ed1fb4f245a8c05$export$e5446db5f37b1855(state, g);
                    })
                ])
            ]
    };
};
let $6ed1fb4f245a8c05$var$config = {
    movable: {
        color: "both",
        free: false
    }
};
const $6ed1fb4f245a8c05$export$985739bfa5723e08 = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".board", {
        oninit: (vnode)=>{
            console.log("game loading", vnode.attrs, state.chess.ascii());
            actions.streamGame();
            actions.afterInit();
        },
        oncreate: (vnode)=>{
            state.ground = (0, $ea2d34c1974d7d8b$export$6aaf0e4db08ad996)(vnode.dom, {
                ...$6ed1fb4f245a8c05$var$config,
                ...vnode.attrs.config
            });
            state.ground.set({
                fen: state.chess.fen(),
                orientation: state.invert() ? "black" : "white",
                movable: {
                    dests: (0, $d5ffb40ab7d69c90$export$7dc676b6dd72d281)(state.chess)
                },
                events: {
                    select: (key)=>{
                        console.log("chessground selected", key);
                        if (state.chess.get(key) && state.chess.get(key).color == state.chess.turn()) {
                            // clear previous selection
                            actions.lightBoard();
                            state.selectedSquare = key;
                            state.selectedPiece = state.chess.get(key);
                            actions.highlightAvailableMoves(key);
                        }
                    },
                    move: (orig, dest)=>{
                        actions.onmove(orig, dest);
                    }
                }
            });
        }
    });
const $6ed1fb4f245a8c05$export$6996ecd26284460f = (state, actions)=>({
        view: (vnode)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".gamePage", {}, [
                (0, $ef84d931ff2e086e$export$4c260019440d418f)(state, actions),
                $6ed1fb4f245a8c05$export$985739bfa5723e08(state, actions)
            ])
    });
const $6ed1fb4f245a8c05$export$2616165974278734 = (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".me", {}, state.user.username);
const $6ed1fb4f245a8c05$export$414a9ba52728302b = (state)=>state.opponent ? (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".opponent", {}, JSON.stringify(state.opponent)) : null;
const $6ed1fb4f245a8c05$export$a22305df274c15ec = (state, actions)=>({
        oninit: (vnode)=>{
            if (!state.loggedIn()) {
                console.log("not logged in. Redirecting to login");
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.set("/login");
            }
        },
        view: (vnode)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".gamePage", {}, [
                (0, $ef84d931ff2e086e$export$69d4e78a69e95731)(state, actions),
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".top_user", {}, state.invert() != (state.color == "b") ? $6ed1fb4f245a8c05$export$2616165974278734(state) : $6ed1fb4f245a8c05$export$414a9ba52728302b(state)),
                $6ed1fb4f245a8c05$export$985739bfa5723e08(state, actions),
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".bottom_user", {}, state.invert() != (state.color == "b") ? $6ed1fb4f245a8c05$export$414a9ba52728302b(state) : $6ed1fb4f245a8c05$export$2616165974278734(state))
            ])
    });







(0, $3895aa91744b6895$exports.defaults).glossary.title = "LaunchChess";
(0, $3895aa91744b6895$exports.defaults).transition = "zoom";
(0, $3895aa91744b6895$exports.defaults).theme.ok = "ui positive button";
(0, $3895aa91744b6895$exports.defaults).theme.cancel = "ui black button";
(0, $3895aa91744b6895$exports.defaults).notifier.delay = 10;
function $325b867be1548751$export$120c0e7b1bef3ec7(state, actions) {
    return {
        view: (vnode)=>{
            return [
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))($325b867be1548751$export$5120f2d0b8d4cab8, {}, state.user.profile),
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("i", {
                    onclick: (e)=>{
                        (0, $3895aa91744b6895$exports.confirm)("Are you sure you want to deauthorize this device?", (affirm)=>{
                            actions.logout();
                            (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.set("/");
                            (0, $3895aa91744b6895$exports.message)("logged out", 3);
                        }, (deny)=>{
                            console.log("That was a close one!");
                        });
                    }
                }, "deauthorize this device")
            ];
        }
    };
}
function $325b867be1548751$export$5120f2d0b8d4cab8() {
    return {
        view: (vnode)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("table.profile", vnode.attrs, Object.keys(vnode.children[0]).map((k, i)=>{
                // console.log(k, i)
                return (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("tr.entry", {}, [
                    (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("td.key", {}, k),
                    // m('td.seperator', {}, ' - '),
                    (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("td.value", {}, JSON.stringify(vnode.children[0][k]))
                ]);
            }));
        }
    };
}




var $kWuxe = parcelRequire("kWuxe");








/* tslint:disable */ var $48fb4da1ea4addfd$export$2e2bcd8739ae039 = {
    "activity": '<polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>',
    "airplay": '<path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon>',
    "alert-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>',
    "alert-octagon": '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>',
    "alert-triangle": '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line>',
    "align-center": '<line x1="18" y1="10" x2="6" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="18" y1="18" x2="6" y2="18"></line>',
    "align-justify": '<line x1="21" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="3" y2="18"></line>',
    "align-left": '<line x1="17" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="17" y1="18" x2="3" y2="18"></line>',
    "align-right": '<line x1="21" y1="10" x2="7" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="7" y2="18"></line>',
    "anchor": '<circle cx="12" cy="5" r="3"></circle><line x1="12" y1="22" x2="12" y2="8"></line><path d="M5 12H2a10 10 0 0 0 20 0h-3"></path>',
    "aperture": '<circle cx="12" cy="12" r="10"></circle><line x1="14.31" y1="8" x2="20.05" y2="17.94"></line><line x1="9.69" y1="8" x2="21.17" y2="8"></line><line x1="7.38" y1="12" x2="13.12" y2="2.06"></line><line x1="9.69" y1="16" x2="3.95" y2="6.06"></line><line x1="14.31" y1="16" x2="2.83" y2="16"></line><line x1="16.62" y1="12" x2="10.88" y2="21.94"></line>',
    "archive": '<polyline points="21 8 21 21 3 21 3 8"></polyline><rect x="1" y="3" width="22" height="5"></rect><line x1="10" y1="12" x2="14" y2="12"></line>',
    "arrow-down-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="8 12 12 16 16 12"></polyline><line x1="12" y1="8" x2="12" y2="16"></line>',
    "arrow-down-left": '<line x1="17" y1="7" x2="7" y2="17"></line><polyline points="17 17 7 17 7 7"></polyline>',
    "arrow-down-right": '<line x1="7" y1="7" x2="17" y2="17"></line><polyline points="17 7 17 17 7 17"></polyline>',
    "arrow-down": '<line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline>',
    "arrow-left-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="12 8 8 12 12 16"></polyline><line x1="16" y1="12" x2="8" y2="12"></line>',
    "arrow-left": '<line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>',
    "arrow-right-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line>',
    "arrow-right": '<line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>',
    "arrow-up-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="16 12 12 8 8 12"></polyline><line x1="12" y1="16" x2="12" y2="8"></line>',
    "arrow-up-left": '<line x1="17" y1="17" x2="7" y2="7"></line><polyline points="7 17 7 7 17 7"></polyline>',
    "arrow-up-right": '<line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline>',
    "arrow-up": '<line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline>',
    "at-sign": '<circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path>',
    "award": '<circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>',
    "bar-chart-2": '<line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line>',
    "bar-chart": '<line x1="12" y1="20" x2="12" y2="10"></line><line x1="18" y1="20" x2="18" y2="4"></line><line x1="6" y1="20" x2="6" y2="16"></line>',
    "battery-charging": '<path d="M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"></path><line x1="23" y1="13" x2="23" y2="11"></line><polyline points="11 6 7 12 13 12 9 18"></polyline>',
    "battery": '<rect x="1" y="6" width="18" height="12" rx="2" ry="2"></rect><line x1="23" y1="13" x2="23" y2="11"></line>',
    "bell-off": '<path d="M13.73 21a2 2 0 0 1-3.46 0"></path><path d="M18.63 13A17.89 17.89 0 0 1 18 8"></path><path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"></path><path d="M18 8a6 6 0 0 0-9.33-5"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
    "bell": '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path>',
    "bluetooth": '<polyline points="6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"></polyline>',
    "bold": '<path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path><path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>',
    "book-open": '<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>',
    "book": '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>',
    "bookmark": '<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>',
    "box": '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
    "briefcase": '<rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>',
    "calendar": '<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line>',
    "camera-off": '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"></path>',
    "camera": '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle>',
    "cast": '<path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path><line x1="2" y1="20" x2="2.01" y2="20"></line>',
    "check-circle": '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>',
    "check-square": '<polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>',
    "check": '<polyline points="20 6 9 17 4 12"></polyline>',
    "chevron-down": '<polyline points="6 9 12 15 18 9"></polyline>',
    "chevron-left": '<polyline points="15 18 9 12 15 6"></polyline>',
    "chevron-right": '<polyline points="9 18 15 12 9 6"></polyline>',
    "chevron-up": '<polyline points="18 15 12 9 6 15"></polyline>',
    "chevrons-down": '<polyline points="7 13 12 18 17 13"></polyline><polyline points="7 6 12 11 17 6"></polyline>',
    "chevrons-left": '<polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline>',
    "chevrons-right": '<polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline>',
    "chevrons-up": '<polyline points="17 11 12 6 7 11"></polyline><polyline points="17 18 12 13 7 18"></polyline>',
    "chrome": '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="21.17" y1="8" x2="12" y2="8"></line><line x1="3.95" y1="6.06" x2="8.54" y2="14"></line><line x1="10.88" y1="21.94" x2="15.46" y2="14"></line>',
    "circle": '<circle cx="12" cy="12" r="10"></circle>',
    "clipboard": '<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>',
    "clock": '<circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>',
    "cloud-drizzle": '<line x1="8" y1="19" x2="8" y2="21"></line><line x1="8" y1="13" x2="8" y2="15"></line><line x1="16" y1="19" x2="16" y2="21"></line><line x1="16" y1="13" x2="16" y2="15"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="12" y1="15" x2="12" y2="17"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>',
    "cloud-lightning": '<path d="M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"></path><polyline points="13 11 9 17 15 17 11 23"></polyline>',
    "cloud-off": '<path d="M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
    "cloud-rain": '<line x1="16" y1="13" x2="16" y2="21"></line><line x1="8" y1="13" x2="8" y2="21"></line><line x1="12" y1="15" x2="12" y2="23"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>',
    "cloud-snow": '<path d="M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"></path><line x1="8" y1="16" x2="8.01" y2="16"></line><line x1="8" y1="20" x2="8.01" y2="20"></line><line x1="12" y1="18" x2="12.01" y2="18"></line><line x1="12" y1="22" x2="12.01" y2="22"></line><line x1="16" y1="16" x2="16.01" y2="16"></line><line x1="16" y1="20" x2="16.01" y2="20"></line>',
    "cloud": '<path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>',
    "code": '<polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline>',
    "codepen": '<polygon points="12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"></polygon><line x1="12" y1="22" x2="12" y2="15.5"></line><polyline points="22 8.5 12 15.5 2 8.5"></polyline><polyline points="2 15.5 12 8.5 22 15.5"></polyline><line x1="12" y1="2" x2="12" y2="8.5"></line>',
    "codesandbox": '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="7.5 4.21 12 6.81 16.5 4.21"></polyline><polyline points="7.5 19.79 7.5 14.6 3 12"></polyline><polyline points="21 12 16.5 14.6 16.5 19.79"></polyline><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
    "coffee": '<path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line>',
    "columns": '<path d="M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"></path>',
    "command": '<path d="M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"></path>',
    "compass": '<circle cx="12" cy="12" r="10"></circle><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>',
    "copy": '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>',
    "corner-down-left": '<polyline points="9 10 4 15 9 20"></polyline><path d="M20 4v7a4 4 0 0 1-4 4H4"></path>',
    "corner-down-right": '<polyline points="15 10 20 15 15 20"></polyline><path d="M4 4v7a4 4 0 0 0 4 4h12"></path>',
    "corner-left-down": '<polyline points="14 15 9 20 4 15"></polyline><path d="M20 4h-7a4 4 0 0 0-4 4v12"></path>',
    "corner-left-up": '<polyline points="14 9 9 4 4 9"></polyline><path d="M20 20h-7a4 4 0 0 1-4-4V4"></path>',
    "corner-right-down": '<polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>',
    "corner-right-up": '<polyline points="10 9 15 4 20 9"></polyline><path d="M4 20h7a4 4 0 0 0 4-4V4"></path>',
    "corner-up-left": '<polyline points="9 14 4 9 9 4"></polyline><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>',
    "corner-up-right": '<polyline points="15 14 20 9 15 4"></polyline><path d="M4 20v-7a4 4 0 0 1 4-4h12"></path>',
    "cpu": '<rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line>',
    "credit-card": '<rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line>',
    "crop": '<path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"></path><path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"></path>',
    "crosshair": '<circle cx="12" cy="12" r="10"></circle><line x1="22" y1="12" x2="18" y2="12"></line><line x1="6" y1="12" x2="2" y2="12"></line><line x1="12" y1="6" x2="12" y2="2"></line><line x1="12" y1="22" x2="12" y2="18"></line>',
    "database": '<ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>',
    "delete": '<path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path><line x1="18" y1="9" x2="12" y2="15"></line><line x1="12" y1="9" x2="18" y2="15"></line>',
    "disc": '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="3"></circle>',
    "divide-circle": '<line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line><circle cx="12" cy="12" r="10"></circle>',
    "divide-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line>',
    "divide": '<circle cx="12" cy="6" r="2"></circle><line x1="5" y1="12" x2="19" y2="12"></line><circle cx="12" cy="18" r="2"></circle>',
    "dollar-sign": '<line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>',
    "download-cloud": '<polyline points="8 17 12 21 16 17"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path>',
    "download": '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line>',
    "dribbble": '<circle cx="12" cy="12" r="10"></circle><path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"></path>',
    "droplet": '<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>',
    "edit-2": '<path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>',
    "edit-3": '<path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>',
    "edit": '<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>',
    "external-link": '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line>',
    "eye-off": '<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
    "eye": '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle>',
    "facebook": '<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>',
    "fast-forward": '<polygon points="13 19 22 12 13 5 13 19"></polygon><polygon points="2 19 11 12 2 5 2 19"></polygon>',
    "feather": '<path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path><line x1="16" y1="8" x2="2" y2="22"></line><line x1="17.5" y1="15" x2="9" y2="15"></line>',
    "figma": '<path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"></path><path d="M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"></path><path d="M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"></path><path d="M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"></path><path d="M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"></path>',
    "file-minus": '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="9" y1="15" x2="15" y2="15"></line>',
    "file-plus": '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line>',
    "file-text": '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>',
    "file": '<path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline>',
    "film": '<rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect><line x1="7" y1="2" x2="7" y2="22"></line><line x1="17" y1="2" x2="17" y2="22"></line><line x1="2" y1="12" x2="22" y2="12"></line><line x1="2" y1="7" x2="7" y2="7"></line><line x1="2" y1="17" x2="7" y2="17"></line><line x1="17" y1="17" x2="22" y2="17"></line><line x1="17" y1="7" x2="22" y2="7"></line>',
    "filter": '<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>',
    "flag": '<path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path><line x1="4" y1="22" x2="4" y2="15"></line>',
    "folder-minus": '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="9" y1="14" x2="15" y2="14"></line>',
    "folder-plus": '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="12" y1="11" x2="12" y2="17"></line><line x1="9" y1="14" x2="15" y2="14"></line>',
    "folder": '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>',
    "framer": '<path d="M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"></path>',
    "frown": '<circle cx="12" cy="12" r="10"></circle><path d="M16 16s-1.5-2-4-2-4 2-4 2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
    "gift": '<polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>',
    "git-branch": '<line x1="6" y1="3" x2="6" y2="15"></line><circle cx="18" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><path d="M18 9a9 9 0 0 1-9 9"></path>',
    "git-commit": '<circle cx="12" cy="12" r="4"></circle><line x1="1.05" y1="12" x2="7" y2="12"></line><line x1="17.01" y1="12" x2="22.96" y2="12"></line>',
    "git-merge": '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M6 21V9a9 9 0 0 0 9 9"></path>',
    "git-pull-request": '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M13 6h3a2 2 0 0 1 2 2v7"></path><line x1="6" y1="9" x2="6" y2="21"></line>',
    "github": '<path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>',
    "gitlab": '<path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"></path>',
    "globe": '<circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>',
    "grid": '<rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect>',
    "hard-drive": '<line x1="22" y1="12" x2="2" y2="12"></line><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path><line x1="6" y1="16" x2="6.01" y2="16"></line><line x1="10" y1="16" x2="10.01" y2="16"></line>',
    "hash": '<line x1="4" y1="9" x2="20" y2="9"></line><line x1="4" y1="15" x2="20" y2="15"></line><line x1="10" y1="3" x2="8" y2="21"></line><line x1="16" y1="3" x2="14" y2="21"></line>',
    "headphones": '<path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>',
    "heart": '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>',
    "help-circle": '<circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line>',
    "hexagon": '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>',
    "home": '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline>',
    "image": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline>',
    "inbox": '<polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>',
    "info": '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>',
    "instagram": '<rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>',
    "italic": '<line x1="19" y1="4" x2="10" y2="4"></line><line x1="14" y1="20" x2="5" y2="20"></line><line x1="15" y1="4" x2="9" y2="20"></line>',
    "key": '<path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>',
    "layers": '<polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline>',
    "layout": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line>',
    "life-buoy": '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line><line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line><line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line><line x1="14.83" y1="9.17" x2="18.36" y2="5.64"></line><line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>',
    "link-2": '<path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"></path><line x1="8" y1="12" x2="16" y2="12"></line>',
    "link": '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>',
    "linkedin": '<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle>',
    "list": '<line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line>',
    "loader": '<line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>',
    "lock": '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path>',
    "log-in": '<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line>',
    "log-out": '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line>',
    "mail": '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>',
    "map-pin": '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>',
    "map": '<polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon><line x1="8" y1="2" x2="8" y2="18"></line><line x1="16" y1="6" x2="16" y2="22"></line>',
    "maximize-2": '<polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line>',
    "maximize": '<path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>',
    "meh": '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="15" x2="16" y2="15"></line><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
    "menu": '<line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line>',
    "message-circle": '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>',
    "message-square": '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>',
    "mic-off": '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>',
    "mic": '<path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>',
    "minimize-2": '<polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line>',
    "minimize": '<path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>',
    "minus-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line>',
    "minus-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line>',
    "minus": '<line x1="5" y1="12" x2="19" y2="12"></line>',
    "monitor": '<rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line>',
    "moon": '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>',
    "more-horizontal": '<circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle>',
    "more-vertical": '<circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle>',
    "mouse-pointer": '<path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"></path><path d="M13 13l6 6"></path>',
    "move": '<polyline points="5 9 2 12 5 15"></polyline><polyline points="9 5 12 2 15 5"></polyline><polyline points="15 19 12 22 9 19"></polyline><polyline points="19 9 22 12 19 15"></polyline><line x1="2" y1="12" x2="22" y2="12"></line><line x1="12" y1="2" x2="12" y2="22"></line>',
    "music": '<path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle>',
    "navigation-2": '<polygon points="12 2 19 21 12 17 5 21 12 2"></polygon>',
    "navigation": '<polygon points="3 11 22 2 13 21 11 13 3 11"></polygon>',
    "octagon": '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>',
    "package": '<line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
    "paperclip": '<path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>',
    "pause-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="10" y1="15" x2="10" y2="9"></line><line x1="14" y1="15" x2="14" y2="9"></line>',
    "pause": '<rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect>',
    "pen-tool": '<path d="M12 19l7-7 3 3-7 7-3-3z"></path><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path><path d="M2 2l7.586 7.586"></path><circle cx="11" cy="11" r="2"></circle>',
    "percent": '<line x1="19" y1="5" x2="5" y2="19"></line><circle cx="6.5" cy="6.5" r="2.5"></circle><circle cx="17.5" cy="17.5" r="2.5"></circle>',
    "phone-call": '<path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
    "phone-forwarded": '<polyline points="19 1 23 5 19 9"></polyline><line x1="15" y1="5" x2="23" y2="5"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
    "phone-incoming": '<polyline points="16 2 16 8 22 8"></polyline><line x1="23" y1="1" x2="16" y2="8"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
    "phone-missed": '<line x1="23" y1="1" x2="17" y2="7"></line><line x1="17" y1="1" x2="23" y2="7"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
    "phone-off": '<path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path><line x1="23" y1="1" x2="1" y2="23"></line>',
    "phone-outgoing": '<polyline points="23 7 23 1 17 1"></polyline><line x1="16" y1="8" x2="23" y2="1"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
    "phone": '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
    "pie-chart": '<path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path>',
    "play-circle": '<circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon>',
    "play": '<polygon points="5 3 19 12 5 21 5 3"></polygon>',
    "plus-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>',
    "plus-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>',
    "plus": '<line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line>',
    "pocket": '<path d="M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"></path><polyline points="8 10 12 14 16 10"></polyline>',
    "power": '<path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path><line x1="12" y1="2" x2="12" y2="12"></line>',
    "printer": '<polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect>',
    "radio": '<circle cx="12" cy="12" r="2"></circle><path d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"></path>',
    "refresh-ccw": '<polyline points="1 4 1 10 7 10"></polyline><polyline points="23 20 23 14 17 14"></polyline><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>',
    "refresh-cw": '<polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>',
    "repeat": '<polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path>',
    "rewind": '<polygon points="11 19 2 12 11 5 11 19"></polygon><polygon points="22 19 13 12 22 5 22 19"></polygon>',
    "rotate-ccw": '<polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>',
    "rotate-cw": '<polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>',
    "rss": '<path d="M4 11a9 9 0 0 1 9 9"></path><path d="M4 4a16 16 0 0 1 16 16"></path><circle cx="5" cy="19" r="1"></circle>',
    "save": '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline>',
    "scissors": '<circle cx="6" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><line x1="20" y1="4" x2="8.12" y2="15.88"></line><line x1="14.47" y1="14.48" x2="20" y2="20"></line><line x1="8.12" y1="8.12" x2="12" y2="12"></line>',
    "search": '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>',
    "send": '<line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>',
    "server": '<rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect><rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect><line x1="6" y1="6" x2="6.01" y2="6"></line><line x1="6" y1="18" x2="6.01" y2="18"></line>',
    "settings": '<circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>',
    "share-2": '<circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>',
    "share": '<path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><polyline points="16 6 12 2 8 6"></polyline><line x1="12" y1="2" x2="12" y2="15"></line>',
    "shield-off": '<path d="M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"></path><path d="M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
    "shield": '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>',
    "shopping-bag": '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path>',
    "shopping-cart": '<circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>',
    "shuffle": '<polyline points="16 3 21 3 21 8"></polyline><line x1="4" y1="20" x2="21" y2="3"></line><polyline points="21 16 21 21 16 21"></polyline><line x1="15" y1="15" x2="21" y2="21"></line><line x1="4" y1="4" x2="9" y2="9"></line>',
    "sidebar": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="3" x2="9" y2="21"></line>',
    "skip-back": '<polygon points="19 20 9 12 19 4 19 20"></polygon><line x1="5" y1="19" x2="5" y2="5"></line>',
    "skip-forward": '<polygon points="5 4 15 12 5 20 5 4"></polygon><line x1="19" y1="5" x2="19" y2="19"></line>',
    "slack": '<path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"></path><path d="M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path><path d="M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"></path><path d="M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"></path><path d="M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"></path><path d="M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"></path><path d="M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"></path><path d="M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"></path>',
    "slash": '<circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>',
    "sliders": '<line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line>',
    "smartphone": '<rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>',
    "smile": '<circle cx="12" cy="12" r="10"></circle><path d="M8 14s1.5 2 4 2 4-2 4-2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
    "speaker": '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><circle cx="12" cy="14" r="4"></circle><line x1="12" y1="6" x2="12.01" y2="6"></line>',
    "square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>',
    "star": '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>',
    "stop-circle": '<circle cx="12" cy="12" r="10"></circle><rect x="9" y="9" width="6" height="6"></rect>',
    "sun": '<circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>',
    "sunrise": '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="2" x2="12" y2="9"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="8 6 12 2 16 6"></polyline>',
    "sunset": '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="9" x2="12" y2="2"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="16 5 12 9 8 5"></polyline>',
    "table": '<path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"></path>',
    "tablet": '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>',
    "tag": '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line>',
    "target": '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>',
    "terminal": '<polyline points="4 17 10 11 4 5"></polyline><line x1="12" y1="19" x2="20" y2="19"></line>',
    "thermometer": '<path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"></path>',
    "thumbs-down": '<path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"></path>',
    "thumbs-up": '<path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>',
    "toggle-left": '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="8" cy="12" r="3"></circle>',
    "toggle-right": '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="16" cy="12" r="3"></circle>',
    "tool": '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>',
    "trash-2": '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>',
    "trash": '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>',
    "trello": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><rect x="7" y="7" width="3" height="9"></rect><rect x="14" y="7" width="3" height="5"></rect>',
    "trending-down": '<polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline><polyline points="17 18 23 18 23 12"></polyline>',
    "trending-up": '<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline>',
    "triangle": '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>',
    "truck": '<rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle>',
    "tv": '<rect x="2" y="7" width="20" height="15" rx="2" ry="2"></rect><polyline points="17 2 12 7 7 2"></polyline>',
    "twitch": '<path d="M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"></path>',
    "twitter": '<path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>',
    "type": '<polyline points="4 7 4 4 20 4 20 7"></polyline><line x1="9" y1="20" x2="15" y2="20"></line><line x1="12" y1="4" x2="12" y2="20"></line>',
    "umbrella": '<path d="M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"></path>',
    "underline": '<path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"></path><line x1="4" y1="21" x2="20" y2="21"></line>',
    "unlock": '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9-1"></path>',
    "upload-cloud": '<polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline>',
    "upload": '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line>',
    "user-check": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline>',
    "user-minus": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="23" y1="11" x2="17" y2="11"></line>',
    "user-plus": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line>',
    "user-x": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="18" y1="8" x2="23" y2="13"></line><line x1="23" y1="8" x2="18" y2="13"></line>',
    "user": '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle>',
    "users": '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>',
    "video-off": '<path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
    "video": '<polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>',
    "voicemail": '<circle cx="5.5" cy="11.5" r="4.5"></circle><circle cx="18.5" cy="11.5" r="4.5"></circle><line x1="5.5" y1="16" x2="18.5" y2="16"></line>',
    "volume-1": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>',
    "volume-2": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>',
    "volume-x": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line>',
    "volume": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>',
    "watch": '<circle cx="12" cy="12" r="7"></circle><polyline points="12 9 12 12 13.5 13.5"></polyline><path d="M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"></path>',
    "wifi-off": '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path><path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path><path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path><path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>',
    "wifi": '<path d="M5 12.55a11 11 0 0 1 14.08 0"></path><path d="M1.42 9a16 16 0 0 1 21.16 0"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>',
    "wind": '<path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"></path>',
    "x-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>',
    "x-octagon": '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>',
    "x-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line>',
    "x": '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>',
    "youtube": '<path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>',
    "zap-off": '<polyline points="12.41 6.75 13 2 10.57 4.92"></polyline><polyline points="18.57 12.91 21 10 15.66 10"></polyline><polyline points="8 8 3 14 12 14 11 22 16 16"></polyline><line x1="1" y1="1" x2="23" y2="23"></line>',
    "zap": '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>',
    "zoom-in": '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line>',
    "zoom-out": '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="8" y1="11" x2="14" y2="11"></line>'
};


var $8b880b011fadfe36$export$f04a61298a47a40f = /** @class */ function() {
    function Icon() {}
    Icon.prototype.view = function(_a) {
        var attrs = _a.attrs;
        var className = attrs.class, intent = attrs.intent, name = attrs.name, onclick = attrs.onclick, size = attrs.size, htmlAttrs = (0, $17f1b9f8ce16014e$export$3c9a16f847548506)(attrs, [
            "class",
            "intent",
            "name",
            "onclick",
            "size"
        ]);
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($fcc1f848a67e05c0$exports)))((0, $e4aeb149e284da0d$export$4dbe3495bda74f11).ICON, "".concat((0, $e4aeb149e284da0d$export$4dbe3495bda74f11).ICON, "-").concat(name), intent && "cui-".concat(intent), size && "cui-".concat(size), onclick && (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).ICON_ACTION, className);
        var svg = (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).trust("<svg viewBox='0 0 24 24'>".concat((0, $48fb4da1ea4addfd$export$2e2bcd8739ae039)[name], "</svg>"));
        return (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("", (0, $17f1b9f8ce16014e$export$18ce0697a983be9b)((0, $17f1b9f8ce16014e$export$18ce0697a983be9b)({}, htmlAttrs), {
            class: classes,
            onclick: onclick
        }), svg);
    };
    return Icon;
}();






var $d8e6351f6bd19e38$export$7f7cbe89f1eacd2 = /** @class */ function() {
    function Spinner() {}
    Spinner.prototype.view = function(_a) {
        var attrs = _a.attrs;
        var active = attrs.active, background = attrs.background, className = attrs.class, fill = attrs.fill, intent = attrs.intent, message = attrs.message, size = attrs.size, otherAttrs = (0, $17f1b9f8ce16014e$export$3c9a16f847548506)(attrs, [
            "active",
            "background",
            "class",
            "fill",
            "intent",
            "message",
            "size"
        ]);
        var content = [
            (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".".concat((0, $e4aeb149e284da0d$export$4dbe3495bda74f11).SPINNER_CONTENT), [
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".".concat((0, $e4aeb149e284da0d$export$4dbe3495bda74f11).SPINNER_ICON)),
                message && (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".".concat((0, $e4aeb149e284da0d$export$4dbe3495bda74f11).SPINNER_MESSAGE), message)
            ])
        ];
        return (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("", (0, $17f1b9f8ce16014e$export$18ce0697a983be9b)((0, $17f1b9f8ce16014e$export$18ce0697a983be9b)({}, otherAttrs), {
            class: (0, (/*@__PURE__*/$parcel$interopDefault($fcc1f848a67e05c0$exports)))((0, $e4aeb149e284da0d$export$4dbe3495bda74f11).SPINNER, active && (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).SPINNER_ACTIVE, background && (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).SPINNER_BG, fill && (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).SPINNER_FILL, intent && "cui-".concat(attrs.intent), size && "cui-".concat(attrs.size), className)
        }), content);
    };
    return Spinner;
}();



function $0e6f230737bfa6ad$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $0e6f230737bfa6ad$export$175e60bb96229ece(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if ($0e6f230737bfa6ad$export$f6e2535fb5126e54(func)) return func.apply(void 0, args);
}
function $0e6f230737bfa6ad$export$211731fc355e9121(el, selector) {
    if (el.matches(selector)) return el;
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector || function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s);
        var i = matches.length;
        while(--i >= 0 && matches.item(i) !== this);
        return i > -1;
    };
    for(; el && el !== document; el = el.parentNode){
        if (el.matches(selector)) return el;
    }
    return null;
}
function $0e6f230737bfa6ad$export$ace028f8da1a6300() {
    var el = document.createElement("div");
    el.style.width = "100px";
    el.style.height = "100px";
    el.style.overflow = "scroll";
    el.style.position = "absolute";
    el.style.top = "-9999px";
    document.body.appendChild(el);
    var scrollbarWidth = el.offsetWidth - el.clientWidth;
    document.body.removeChild(el);
    return scrollbarWidth;
}
function $0e6f230737bfa6ad$export$4d450e1748530b6a(el) {
    return el.scrollHeight > window.innerHeight;
}
function $0e6f230737bfa6ad$export$3c0fcc112e8e7788(element, testElement) {
    return element === testElement || element.contains(testElement);
}
function $0e6f230737bfa6ad$export$8756898546458274(style) {
    if (typeof style === "string") {
        var result = {};
        var attributes = style.replace(/\s/g, "").split(";");
        for(var i = 0; i < attributes.length; i++){
            var entry = attributes[i].split(":");
            result[entry.splice(0, 1)[0]] = entry.join(":");
        }
        return result;
    } else return style;
}
function $0e6f230737bfa6ad$export$2069c0f7afbb4fb9(containerEl, contentLeft, contentRight) {
    if (!containerEl) return;
    var containerPadding = Math.floor(containerEl.clientHeight / 1.6);
    if (contentLeft) {
        var contentLeftEl = contentLeft.dom;
        containerEl.style.paddingLeft = $0e6f230737bfa6ad$var$shouldAddPadding(contentLeftEl) ? "".concat(contentLeftEl.clientWidth + containerPadding, "px") : "";
    } else containerEl.style.paddingLeft = "";
    if (contentRight) {
        var contentRightEl = contentRight.dom;
        containerEl.style.paddingRight = $0e6f230737bfa6ad$var$shouldAddPadding(contentRightEl) ? "".concat(contentRightEl.clientWidth + containerPadding, "px") : "";
    } else containerEl.style.paddingRight = "";
}
function $0e6f230737bfa6ad$var$shouldAddPadding(element) {
    return element && !element.classList.contains((0, $e4aeb149e284da0d$export$4dbe3495bda74f11).ICON) && !element.classList.contains((0, $e4aeb149e284da0d$export$4dbe3495bda74f11).SPINNER) && !element.classList.contains((0, $e4aeb149e284da0d$export$4dbe3495bda74f11).BUTTON_ICON);
}
function $0e6f230737bfa6ad$export$c8733ae29fb53302(item) {
    return item == null || item === "" || item === false;
}


var $5b35d122dacb9815$export$353f5b6fc5456de1 = /** @class */ function() {
    function Button() {}
    Button.prototype.view = function(_a) {
        var attrs = _a.attrs;
        var _b = attrs.align, align = _b === void 0 ? "center" : _b, active = attrs.active, basic = attrs.basic, compact = attrs.compact, className = attrs.class, disabled = attrs.disabled, fluid = attrs.fluid, href = attrs.href, iconLeft = attrs.iconLeft, iconLeftAttrs = attrs.iconLeftAttrs, iconRight = attrs.iconRight, iconRightAttrs = attrs.iconRightAttrs, intent = attrs.intent, loading = attrs.loading, label = attrs.label, onclick = attrs.onclick, outlined = attrs.outlined, rounded = attrs.rounded, size = attrs.size, sublabel = attrs.sublabel, htmlAttrs = (0, $17f1b9f8ce16014e$export$3c9a16f847548506)(attrs, [
            "align",
            "active",
            "basic",
            "compact",
            "class",
            "disabled",
            "fluid",
            "href",
            "iconLeft",
            "iconLeftAttrs",
            "iconRight",
            "iconRightAttrs",
            "intent",
            "loading",
            "label",
            "onclick",
            "outlined",
            "rounded",
            "size",
            "sublabel"
        ]);
        var tag = href ? "a" : "button";
        var isAnchor = tag === "a";
        var classes = (0, (/*@__PURE__*/$parcel$interopDefault($fcc1f848a67e05c0$exports)))((0, $e4aeb149e284da0d$export$4dbe3495bda74f11).BUTTON, align && "".concat((0, $e4aeb149e284da0d$export$4dbe3495bda74f11).ALIGN, "-").concat(align), active && (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).ACTIVE, compact && (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).COMPACT, disabled && (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).DISABLED, fluid && (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).FLUID, loading && (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).LOADING, size && "cui-".concat(size), intent && "cui-".concat(intent), rounded && (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).ROUNDED, basic && (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).BASIC, outlined && (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).OUTLINED, (0, $0e6f230737bfa6ad$export$c8733ae29fb53302)(label) && (0, $0e6f230737bfa6ad$export$c8733ae29fb53302)(sublabel) && (!iconLeft || !iconRight) && (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).BUTTON_ICON, className);
        var content = [
            loading && (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))((0, $d8e6351f6bd19e38$export$7f7cbe89f1eacd2), {
                active: true,
                fill: true
            }),
            iconLeft && (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))((0, $8b880b011fadfe36$export$f04a61298a47a40f), (0, $17f1b9f8ce16014e$export$18ce0697a983be9b)({
                name: iconLeft
            }, iconLeftAttrs)),
            !(0, $0e6f230737bfa6ad$export$c8733ae29fb53302)(sublabel) && (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("span", {
                class: (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).BUTTON_SUBLABEL
            }, sublabel),
            !(0, $0e6f230737bfa6ad$export$c8733ae29fb53302)(label) && (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("span", {
                class: (0, $e4aeb149e284da0d$export$4dbe3495bda74f11).BUTTON_LABEL
            }, label),
            iconRight && (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))((0, $8b880b011fadfe36$export$f04a61298a47a40f), (0, $17f1b9f8ce16014e$export$18ce0697a983be9b)({
                name: iconRight
            }, iconRightAttrs))
        ];
        return (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(tag, (0, $17f1b9f8ce16014e$export$18ce0697a983be9b)((0, $17f1b9f8ce16014e$export$18ce0697a983be9b)({
            type: isAnchor ? undefined : "button",
            role: isAnchor ? "button" : undefined
        }, htmlAttrs), {
            class: classes,
            disabled: disabled,
            // Undefined attrs are not removed on redraw. See https://github.com/MithrilJS/mithril.js/pull/1865#issuecomment-382990558'
            href: disabled ? undefined : href,
            onclick: disabled ? undefined : onclick,
            tabIndex: disabled ? undefined : htmlAttrs.tabIndex
        }), content);
    };
    return Button;
}();






const $d2dce2c3cae33f9c$export$892596cec99bc70e = (color)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("input[type=color]", {
        value: $d2dce2c3cae33f9c$export$812799c9515a950b[color]
    });
const $d2dce2c3cae33f9c$export$9012acaf449cdfcb = (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".colors", {}, [
        Object.keys(state.colors).map((k, n)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("span.color", {}, [
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("p.type", {}, k),
                $d2dce2c3cae33f9c$export$892596cec99bc70e(state.colors[k])
            ]))
    ]);
const $d2dce2c3cae33f9c$export$812799c9515a950b = [
    "#000000",
    "#b3b3b3",
    "#dddddd",
    "#ffffff",
    "#ffb3b3 ",
    "#ff6161",
    "#dd6161",
    "#b36161",
    "#fff3d5",
    "#ffb361",
    "#dd8c61",
    "#b37661",
    "#ffeea1",
    "#ffff61",
    "#dddd61",
    "#b3b361",
    "#ddffa1",
    "#c2ff61",
    "#a1dd61",
    "#81b361",
    "#c2ffb3",
    "#61ff61",
    "#61dd61",
    "#61b361",
    "#c2ffc2",
    "#61ff8c",
    "#61dd76",
    "#61b36b",
    "#c2ffcc",
    "#61ffcc",
    "#61dda1",
    "#61b381",
    "#c2fff3",
    "#61ffe9",
    "#61ddc2",
    "#61b396",
    "#c2f3ff",
    "#61eeff",
    "#61c7dd",
    "#61a1b3",
    "#c2ddff",
    "#61c7ff",
    "#61a1dd",
    "#6181b3",
    "#a18cff",
    "#6161ff",
    "#6161dd",
    "#6161b3",
    "#ccb3ff",
    "#a161ff",
    "#8161dd",
    "#7761B2",
    "#FFB2FE",
    "#FF60FE",
    "#DD60DC",
    "#B360B2",
    "#FEB2D5",
    "#FF60C3",
    "#DD60A0",
    "#B3608D",
    "#FF7760",
    "#E8B360",
    "#DDC360",
    "#A1A161",
    "#60B261",
    "#61B28D",
    "#608CD4",
    "#6060FF",
    "#60B2B3",
    "#8C60F2",
    "#CDB3C3",
    "#8C7780",
    "#FF6060",
    "#F2FFA0",
    "#EEFD60",
    "#CCFE60",
    "#77DC61",
    "#60FFCD",
    "#61E8FE",
    "#61A0FE",
    "#8D61FE",
    "#CD61FD",
    "#EF8CDC",
    "#A17760",
    "#FEA160",
    "#DCF861",
    "#D5FF8C",
    "#60FF60",
    "#B3FEA0",
    "#CDFDD5",
    "#B3FFF6",
    "#CDE4FE",
    "#A1C2F6",
    "#D4C2F8",
    "#F88DFF",
    "#FE61CD",
    "#FEC361",
    "#F3EF60",
    "#E5FE61",
    "#DDCD60",
    "#B2A061",
    "#61BA76",
    "#77C38C",
    "#8080A1",
    "#808CCD",
    "#CCAA81",
    "#DD6161",
    "#F8B3A0",
    "#F8BA77",
    "#FEF28C",
    "#E8F9A0",
    "#D4EF76",
    "#8080A1",
    "#F8F9D4",
    "#DCFDE4",
    "#E9E8FE",
    "#E5D4FF",
    "#B3B3B3",
    "#D5D5D5",
    "#F9FFFF",
    "#E86160",
    "#AA6060",
    "#81F760",
    "#60B261",
    "#F3EF60",
    "#B2A061",
    "#EEC360",
    "#C37761"
];



const $ac5b3dd658baca4b$var$equals = (a, b)=>a.length === b.length && a.every((v, i)=>v === b[i]);
const $ac5b3dd658baca4b$export$b2278035370d6017 = (state, actions)=>({
        connect: (name)=>{
            // search on device name only
            name = name.replace(" Out", "");
            if (state.connected) actions.disconnect();
            state.output = (0, $kWuxe.WebMidi).getOutputByName(name || state.inputName);
            state.outputName = state.output.name;
            state.input = (0, $kWuxe.WebMidi).getInputByName(name || state.outputName);
            state.inputName = state.input.name;
            console.log("connected", state.input);
            if (state.input) {
                // send sysex to see if device is a launchpad
                state.connected = true;
                state.deviceName = name;
                actions.detectDevice(state.input, state.output);
            } else state.connected = false;
        },
        connectInput: (id)=>{
            state.input = (0, $kWuxe.WebMidi).getInputById(id);
            state.inputName = state.input.name;
            console.log("connected", state.input);
            if (state.input) state.connected = true;
            else state.connected = false;
        },
        connectOutput: (id)=>{
            state.output = (0, $kWuxe.WebMidi).getOutputById(id);
            state.outputName = state.output.name;
            console.log("connected", state.output);
            if (state.output) {
                // send sysex to see if device is a launchpad
                state.connected = true;
                let launchpad = (0, $9066c94fd6c8e22f$export$776a922db93662cb)[state.output.name];
                console.log("assigning ", launchpad);
                Object.assign(actions, (0, $9066c94fd6c8e22f$export$4586496351d727fb)[launchpad](state, actions));
                Object.assign((0, $b7ac0cf7b7632c81$export$83b795a96c5728f1), (0, $9066c94fd6c8e22f$export$4586496351d727fb)[launchpad](state, actions));
                actions.toggleLive(state.connected);
            } else state.connected = false;
        },
        disconnect: ()=>{
            if (state.input) {
                if (state.connected) try {
                    actions.toggleLive(false);
                } catch (err) {
                    console.log("error disconnecting", err);
                }
                state.input.removeListener();
                state.input = null;
                state.output = null;
            }
            state.connected = false;
        },
        reloadInputs: ()=>{
            state.inputs((0, $kWuxe.WebMidi).inputs);
            state.outputs((0, $kWuxe.WebMidi).outputs);
            if (!state.connected && state.inputs().length == 1) {
                let name = state.inputs()[0].name;
                console.log("single input: auto connecting", name);
                let launchpad = (0, $9066c94fd6c8e22f$export$776a922db93662cb)[name];
                console.log("auto connecting to ", name, launchpad);
                Object.assign(actions, (0, $9066c94fd6c8e22f$export$4586496351d727fb)[launchpad](state, actions));
                Object.assign((0, $b7ac0cf7b7632c81$export$83b795a96c5728f1), (0, $9066c94fd6c8e22f$export$4586496351d727fb)[launchpad](state, actions));
                actions.connect(name);
                actions.toggleLive(state.connected);
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).redraw();
        },
        initConnector: ()=>{
            try {
                (0, $kWuxe.WebMidi).enable(function(err) {
                    console.debug((0, $kWuxe.WebMidi).inputs);
                    console.debug((0, $kWuxe.WebMidi).outputs);
                    actions.reloadInputs();
                    (0, $kWuxe.WebMidi).addListener("connected", (e)=>{
                        console.log("device connected");
                        actions.reloadInputs();
                    });
                    (0, $kWuxe.WebMidi).addListener("disconnected", (e)=>{
                        console.log("device disconnected", e);
                        if (e.port.name == state.deviceName) {
                            console.log("active device disconnected!");
                            state.connected = false;
                            (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).redraw();
                        }
                        actions.reloadInputs();
                    });
                }, true);
                window.onunload = (e)=>{
                    console.log("unloading");
                    actions.disconnect();
                };
            } catch (err) {
                console.log("error setting up WebMidi", err);
            }
        },
        initMidi: (noteCallback, ccCallback, afterInit)=>{
            console.log((0, $kWuxe.WebMidi).inputs);
            console.log((0, $kWuxe.WebMidi).outputs);
            if (state.input) {
                state.input.removeListener();
                state.input.addListener("noteon", "all", noteCallback);
                state.input.addListener("controlchange", "all", ccCallback);
            // state.input.addListener('midimessage', m => console.log('MIDI', m))
            } else console.log("error, not connected");
            afterInit();
        },
        detectDevice: (input, output)=>{
            input.addListener("sysex", "all", (sysex)=>{
                let data = sysex.data;
                console.log("got sysex message", sysex);
                if ($ac5b3dd658baca4b$var$equals(data.slice(0, 5), [
                    240,
                    126,
                    0,
                    6,
                    2
                ]) && $ac5b3dd658baca4b$var$equals(data.slice(5, 8), (0, $9066c94fd6c8e22f$export$c6f17c29808f1b66))) {
                    console.log("found Novation product");
                    Object.values((0, $9066c94fd6c8e22f$export$4b04cd3b2feae9ab)).map((value)=>{
                        output.sendSysex((0, $9066c94fd6c8e22f$export$c6f17c29808f1b66), [
                            ...value,
                            14
                        ]);
                    });
                }
                if ($ac5b3dd658baca4b$var$equals(data.slice(0, 4), [
                    240,
                    ...(0, $9066c94fd6c8e22f$export$c6f17c29808f1b66)
                ]) && data[6] == 14) {
                    let header = data.slice(4, 6);
                    console.log("identified device!", header);
                    state.header = header;
                    for(const key in 0, $9066c94fd6c8e22f$export$4b04cd3b2feae9ab)if ($ac5b3dd658baca4b$var$equals(header, (0, $9066c94fd6c8e22f$export$4b04cd3b2feae9ab)[key])) {
                        console.log("this is a ", key);
                        state.deviceType = key;
                        Object.assign(actions, (0, $9066c94fd6c8e22f$export$4586496351d727fb)[key](state, actions));
                        Object.assign((0, $b7ac0cf7b7632c81$export$83b795a96c5728f1), (0, $9066c94fd6c8e22f$export$4586496351d727fb)[key](state, actions));
                        input.removeListener("sysex");
                        actions.toggleLive(true);
                    }
                }
            });
            output.sendSysex([
                126,
                127,
                6
            ], [
                1
            ]);
        }
    });
const $ac5b3dd658baca4b$export$b042cfedf6ae225e = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("select", {
        oninput: (e)=>actions.connectInput(e.target.value)
    }, state.inputs().map((c)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("option", {
            value: c.id,
            selected: c.name == state.inputName
        }, c.name);
    }));
const $ac5b3dd658baca4b$export$65f11d6055431773 = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("select", {
        oninput: (e)=>actions.connectOutput(e.target.value)
    }, state.outputs().map((c)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("option", {
            value: c.id,
            selected: c.name == state.outputName
        }, c.name);
    }));
const $ac5b3dd658baca4b$export$4a18af0255371fd1 = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("select", {
        value: state.deviceType,
        oninput: (e)=>{
            let value = e.target.value;
            console.log("selected", e, value);
            state.deviceType = value;
            if (state.connected) {
                Object.assign(actions, (0, $9066c94fd6c8e22f$export$4586496351d727fb)[value](state, actions));
                Object.assign((0, $b7ac0cf7b7632c81$export$83b795a96c5728f1), (0, $9066c94fd6c8e22f$export$4586496351d727fb)[value](state, actions));
                state.input.removeListener("sysex");
                actions.toggleLive(true);
            }
        }
    }, [
        (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("option"),
        Object.keys((0, $9066c94fd6c8e22f$export$4b04cd3b2feae9ab)).map((h)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("option", {
                value: h
            }, h))
    ]);
const $ac5b3dd658baca4b$export$32b0ea48e47b356c = (name, state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))((0, $5b35d122dacb9815$export$353f5b6fc5456de1), {
        label: name,
        class: state.connected && state.inputName == name ? "glow active" : "",
        onclick: (e)=>{
            if (state.connected) actions.disconnect();
            else actions.connect(name);
        }
    }, name);
const $ac5b3dd658baca4b$export$9e282393ab352bcd = (state, actions)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))((0, $5b35d122dacb9815$export$353f5b6fc5456de1), {
        onclick: (e)=>{
            actions.disconnect();
        },
        iconLeft: "zap-off",
        label: "disconnect"
    });
const $ac5b3dd658baca4b$export$f0de1ba241e121fd = (state, actions)=>({
        view: (vnode)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))(".ConnectionPage", {}, [
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("h1", "Connect your Launchpad"),
                (0, $ef84d931ff2e086e$export$b131c49b26d3f427)(state),
                state.inputs().length ? state.inputs().map((i)=>{
                    if (i.name in (0, $9066c94fd6c8e22f$export$776a922db93662cb)) {
                        let matches = Object.keys((0, $9066c94fd6c8e22f$export$776a922db93662cb)).filter((n)=>i.name.includes(n));
                        console.log(`checking ${i.name}`, matches);
                        if (matches.length) return $ac5b3dd658baca4b$export$32b0ea48e47b356c(i.name, state, actions);
                    }
                }) : "no Launchpads detected",
                state.connected ? $ac5b3dd658baca4b$export$9e282393ab352bcd(state, actions) : null,
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("h3", {}, "Input"),
                $ac5b3dd658baca4b$export$b042cfedf6ae225e(state, actions),
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("h3", {}, "Output"),
                $ac5b3dd658baca4b$export$65f11d6055431773(state, actions),
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("h3", {}, "Type"),
                $ac5b3dd658baca4b$export$4a18af0255371fd1(state, actions)
            ])
    });







const $bd2f53e1120bdd66$export$b94310965bed44e6 = (state, actions)=>({
        view: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("#home", {}, [
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("h1#home", {}, "LaunchChess.com"),
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("h4#home", {}, [
                    "Play chess on your ",
                    (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("a", {
                        href: "https://novationmusic.com/en/launch/"
                    }, "Novation Launchpad")
                ]),
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("br"),
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("", {}, [
                    "More details at the project homepage: ",
                    (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("a", {
                        href: "https://quaternion.media/launchchess"
                    }, "quaternion.media/launchchess")
                ]),
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("br"),
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))((0, $ac5b3dd658baca4b$export$f0de1ba241e121fd)(state, actions)),
                (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("br"),
                state.connected ? [
                    "Connected!",
                    (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))("br"),
                    (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))((0, $5b35d122dacb9815$export$353f5b6fc5456de1), {
                        label: "play over the board",
                        onclick: (e)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.set("/otb")
                    }),
                    (0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports)))((0, $5b35d122dacb9815$export$353f5b6fc5456de1), {
                        label: "play over the internet",
                        onclick: (e)=>(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route.set("/games")
                    })
                ] : null
            ])
    });




console.log("launchchess started!");
var $b7ac0cf7b7632c81$var$state = (0, $a01e4d144b50218c$export$7254cc27399e90bd)();
var $b7ac0cf7b7632c81$export$e324594224ef24da = {};
Object.assign($b7ac0cf7b7632c81$export$e324594224ef24da, (0, $a01e4d144b50218c$export$b52183d5cfb26dc9)($b7ac0cf7b7632c81$var$state, $b7ac0cf7b7632c81$export$e324594224ef24da));
Object.assign($b7ac0cf7b7632c81$export$e324594224ef24da, (0, $cae4a8b830b22bcf$export$683788d28fb74d54)($b7ac0cf7b7632c81$var$state, $b7ac0cf7b7632c81$export$e324594224ef24da));
Object.assign($b7ac0cf7b7632c81$export$e324594224ef24da, (0, $ac5b3dd658baca4b$export$b2278035370d6017)($b7ac0cf7b7632c81$var$state, $b7ac0cf7b7632c81$export$e324594224ef24da));
Object.assign($b7ac0cf7b7632c81$export$e324594224ef24da, (0, $6ed1fb4f245a8c05$export$d0d76c231f6d55bd)($b7ac0cf7b7632c81$var$state, $b7ac0cf7b7632c81$export$e324594224ef24da));
Object.assign($b7ac0cf7b7632c81$export$e324594224ef24da, (0, $22788da0e2196326$export$2fb70d5e506c6bc2)($b7ac0cf7b7632c81$var$state, $b7ac0cf7b7632c81$export$e324594224ef24da));
var $b7ac0cf7b7632c81$export$83b795a96c5728f1 = {
    ...$b7ac0cf7b7632c81$export$e324594224ef24da,
    ...(0, $a01e4d144b50218c$export$81ce9b7e86ec18db)($b7ac0cf7b7632c81$var$state, $b7ac0cf7b7632c81$export$e324594224ef24da)
};
$b7ac0cf7b7632c81$export$e324594224ef24da.initConnector();
$b7ac0cf7b7632c81$export$e324594224ef24da.initAuth();
console.log($b7ac0cf7b7632c81$var$state, $b7ac0cf7b7632c81$export$e324594224ef24da);
(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).mount(document.body, (0, $3f934752a4447ac8$export$c84671f46d6a1ca)($b7ac0cf7b7632c81$var$state));
let $b7ac0cf7b7632c81$var$main = document.getElementById("main");
document.body.className += $b7ac0cf7b7632c81$var$state.theme;
(0, (/*@__PURE__*/$parcel$interopDefault($231519b62b676521$exports))).route($b7ac0cf7b7632c81$var$main, "/", {
    "/": (0, $bd2f53e1120bdd66$export$b94310965bed44e6)($b7ac0cf7b7632c81$var$state, $b7ac0cf7b7632c81$export$e324594224ef24da),
    "/connect": (0, $ac5b3dd658baca4b$export$f0de1ba241e121fd)($b7ac0cf7b7632c81$var$state, $b7ac0cf7b7632c81$export$e324594224ef24da),
    "/otb": (0, $6ed1fb4f245a8c05$export$6996ecd26284460f)($b7ac0cf7b7632c81$var$state, $b7ac0cf7b7632c81$export$e324594224ef24da),
    "/games": (0, $6ed1fb4f245a8c05$export$93fd0e768dbd3f80)($b7ac0cf7b7632c81$var$state, $b7ac0cf7b7632c81$export$e324594224ef24da),
    "/online": (0, $6ed1fb4f245a8c05$export$a22305df274c15ec)($b7ac0cf7b7632c81$var$state, $b7ac0cf7b7632c81$export$83b795a96c5728f1),
    "/login": (0, $bb75f90500322e40$export$21a94553ffa41578)($b7ac0cf7b7632c81$var$state, $b7ac0cf7b7632c81$export$e324594224ef24da),
    "/profile": (0, $325b867be1548751$export$120c0e7b1bef3ec7)($b7ac0cf7b7632c81$var$state, $b7ac0cf7b7632c81$export$e324594224ef24da)
});
window.state = $b7ac0cf7b7632c81$var$state;
window.actions = $b7ac0cf7b7632c81$export$e324594224ef24da;


//# sourceMappingURL=index.088750cc.js.map
